// GENERATED by scripts/build-refresh.mjs from research/raw/refresh-*.json.
// Fact refresh overlay applied in enrichments.js: dot-path field changes, rewritten
// analystNotes verified as of September 2026, and unverifiedAsOf markers for numeric
// fields that keep a typed value from the May 2026 research.
export const refresh2026 = {
  "buffalo-bills": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 4.2,
        "new": 8.15,
        "fact": "Forbes NFL list September 2026: $8.15B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 552,
        "new": 617,
        "fact": "Forbes Sept 2026 revenue $617M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2023,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 101,
        "new": 58,
        "fact": "Forbes Sept 2026 operating income $58M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 4,
        "new": 5,
        "fact": "Playoff seasons 2021-2025: 2021, 2022, 2023, 2024, 2025",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_NFL_playoffs"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      },
      {
        "field": "stadium.name",
        "old": "Highmark Stadium",
        "new": "Highmark Stadium (new, opened 2026)",
        "fact": "New $2.1B+ Highmark Stadium in Orchard Park opened June 23, 2026; first regular-season game Sept 17, 2026 vs Detroit",
        "source": "https://www.espn.com/nfl/story/_/id/49953191/nfl-new-stadiums-debut-notable-games"
      },
      {
        "field": "stadium.yearBuilt",
        "old": 1973,
        "new": 2026,
        "fact": "New building replaced the 1973 stadium for the 2026 season",
        "source": "https://en.wikipedia.org/wiki/Highmark_Stadium"
      },
      {
        "field": "stadium.capacity",
        "old": 71608,
        "new": 60108,
        "fact": "Seating capacity 60,108, smallest in the NFL (up to ~63,000-66,000 with standing room depending on event)",
        "source": "https://en.wikipedia.org/wiki/Highmark_Stadium"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "New $1.54B Highmark Stadium under construction in Orchard Park, opening 2026; ~$850M public funding ($600M state + $250M Erie County), $550M private; 30-year lease; state-owned",
        "new": "Completed: new state-owned Highmark Stadium opened June 2026 at a final cost of roughly $2.1-2.2B (above the original $1.54B budget); ~$850M public ($600M state + $250M Erie County) with the Pegulas covering the overruns; 30-year lease",
        "fact": "Final cost reported at $2.1-2.2B, the largest construction project in Western New York history",
        "source": "https://sports.yahoo.com/articles/bills-stadium-details-inside-cost-070002757.html"
      },
      {
        "field": "ownership.institutionalInvestors",
        "old": "Minority stake sale under exploration as of 2024",
        "new": "Arctos Partners bought ~10% (approved Dec 11, 2024) as part of a 20.6% limited-partner sale to 10 new LPs at a ~$5.1B valuation; Pegulas remain controlling owners",
        "fact": "Bills and Dolphins were the first NFL teams to add PE investors under the 2024 rule; NFL approved Dec 11, 2024",
        "source": "https://www.buffalobills.com/news/buffalo-bills-welcome-10-new-limited-partners-to-ownership-group"
      }
    ],
    "analystNotes": "The Bills open the 2026 season in a new $2.1B Highmark Stadium, and Forbes' September 2026 list already prices it in at $8.15B on $617M of revenue. The building holds only 60,108 seats, the smallest in the NFL, so the model is premium density and pricing rather than volume, and the Arctos-led LP sale at roughly $5.1B in December 2024 now looks cheap. Josh Allen's $55M AAV deal runs through 2030 and the team has made the playoffs five straight years, losing the 2025 divisional round in overtime at Denver. The number moves if a full season of new-stadium premium revenue pushes operating income back above $100M.",
    "unverifiedAsOf": {
      "stadium.namingRightsDeal": "May 2026"
    }
  },
  "miami-dolphins": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 7.1,
        "new": 10.4,
        "fact": "Forbes NFL list September 2026: $10.4B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 656,
        "new": 810,
        "fact": "Forbes Sept 2026 revenue $810M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2023,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 63,
        "new": 198,
        "fact": "Forbes Sept 2026 operating income $198M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      },
      {
        "field": "onField.currentFranchiseQB",
        "old": "Tua Tagovailoa — 4yr/$212.4M extension signed July 2024, $53.1M AAV, $167.2M guaranteed",
        "new": "Malik Willis, 3yr/$67.5M signed March 12, 2026, $45M fully guaranteed at signing; Tua Tagovailoa released March 2026 (post-June 1 designation) with an NFL-record $99M dead cap over 2026-27",
        "fact": "Dolphins released Tagovailoa in March 2026 and signed Willis as the presumptive starter",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/dolphins-officially-release-tua-tagovailoa-with-post-june-1-designation"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Tua Tagovailoa",
            "position": "QB",
            "aav": 53.1,
            "contractNote": "4yr/$212.4M (July 2024), runs through 2028"
          }
        ],
        "new": [
          {
            "player": "Malik Willis",
            "position": "QB",
            "aav": 22.5,
            "contractNote": "3yr/$67.5M (March 2026), $45M guaranteed at signing incl. $22.25M signing bonus; runs through 2028"
          }
        ],
        "fact": "Willis signed 3yr/$67.5M with $45M fully guaranteed",
        "source": "https://www.thephinsider.com/nfl-free-agency/116223/nfl-free-agents-2026-miami-dolphins-contract-malik-willis-guaranteed-money-three-years-saalry-cap"
      },
      {
        "field": "media.streamingNotes",
        "old": "Standard NFL package",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source found)",
        "source": null
      }
    ],
    "analystNotes": "Forbes values the Dolphins at $10.4B in September 2026, with the stadium component alone at $2.7B, because Hard Rock Stadium is privately owned, debt free, and books Super Bowls, the Miami Grand Prix and 2026 World Cup matches. The 1% sale to Lin Bin at a $12.5B mark covers the whole Ross platform (team, stadium, F1 race, Miami Open), not the team alone. Miami cut Tua Tagovailoa in March 2026 and absorbed a record $99M dead cap charge, then handed the job to Malik Willis on a 3yr/$67.5M deal, so the football side is a reset. Revenue of $810M and $198M of operating income carry the number until the quarterback answer arrives.",
    "unverifiedAsOf": {}
  },
  "new-england-patriots": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 7.4,
        "new": 10.6,
        "fact": "Forbes NFL list September 2026: $10.6B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 712,
        "new": 784,
        "fact": "Forbes Sept 2026 revenue $784M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2023,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 261,
        "new": 186,
        "fact": "Forbes Sept 2026 operating income $186M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 1,
        "new": 2,
        "fact": "Playoff seasons 2021-2025: 2021, 2025",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_NFL_playoffs"
      },
      {
        "field": "onField.championshipsLast10Years",
        "old": 1,
        "new": 2,
        "fact": "Super Bowl wins for seasons 2016-2025: 2",
        "source": "https://en.wikipedia.org/wiki/List_of_Super_Bowl_champions"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      },
      {
        "field": "onField.currentFranchiseQB",
        "old": "Drake Maye — 4yr/$36.6M rookie contract (2024 draft pick No. 3), fully guaranteed; eligible for extension 2026",
        "new": "Drake Maye, 4yr/$36.6M rookie contract (2024 No. 3 pick), fully guaranteed; 2025 NFL MVP runner-up and Super Bowl LX starter; extension-eligible after the 2026 season, no deal in place",
        "fact": "Maye finished second in 2025 MVP voting; extension eligibility opens after 2026",
        "source": "https://www.boston.com/sports/new-england-patriots/2026/08/05/new-england-patriots-drake-maye-contract-christian-gonzalez/"
      },
      {
        "field": "ownership.institutionalInvestors",
        "old": "Minority stake sold in 2025 at ~$9B implied team valuation (per CNBC report)",
        "new": "Sold 8% of new equity (Dean Metropoulos 5%, Sixth Street 3%) at a $9.0B pre-money valuation, approved Oct 22, 2025 and closed Nov 2025; ~$720M of primary capital stays on the team balance sheet",
        "fact": "Deal announced Sept 25, 2025 and approved Oct 22, 2025 at $9B pre-money",
        "source": "data/transactions.js (verified 2025-2026 NFL transactions)"
      },
      {
        "field": "media.streamingNotes",
        "old": "Standard NFL package",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source found)",
        "source": null
      }
    ],
    "analystNotes": "New England reached Super Bowl LX in February 2026 with Drake Maye on a $9.2M AAV rookie deal, and Forbes marked the team at $10.6B in September 2026 on $784M of revenue. The Kraft Group model still does the work: privately financed Gillette Stadium, Patriot Place, and $186M of operating income, plus $720M of fresh primary capital from the 8% sale to Metropoulos and Sixth Street at $9.0B in October 2025. Maye becomes extension-eligible after the 2026 season and a $60M AAV deal will compress margins. A second Super Bowl run before that contract lands is the upside case.",
    "unverifiedAsOf": {}
  },
  "new-york-jets": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 6.9,
        "new": 10.35,
        "fact": "Forbes NFL list September 2026: $10.35B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 620,
        "new": 716,
        "fact": "Forbes Sept 2026 revenue $716M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2023,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 138,
        "new": 216,
        "fact": "Forbes Sept 2026 operating income $216M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      },
      {
        "field": "onField.currentFranchiseQB",
        "old": "Justin Fields — 2yr/$40M deal signed March 2025, $20M AAV; traded to Kansas City mid-2025-season; franchise QB situation unresolved as of 2026",
        "new": "Geno Smith, acquired from the Raiders in March 2026 for a swap of late-round picks; $26.5M base salary in 2026 ($18.5M guaranteed) with Las Vegas covering $16.2M; named 2026 starter by Aaron Glenn; rookie Cade Klubnik (4th round) is QB2",
        "fact": "Jets traded a 2026 sixth-round pick for Smith and a seventh; Glenn confirmed Smith as the 2026 starter",
        "source": "https://www.espn.com/nfl/story/_/id/48164552/sources-jets-get-their-qb-trade-raiders-geno-smith"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Justin Fields",
            "position": "QB",
            "aav": 20,
            "contractNote": "2yr/$40M (March 2025); traded to Chiefs Nov 2025; Jets carrying dead cap"
          }
        ],
        "new": [
          {
            "player": "Geno Smith",
            "position": "QB",
            "aav": null,
            "contractNote": "2yr/$75M extension signed with Las Vegas (April 2025), runs through 2027; traded to the Jets March 2026 with the Raiders paying $16.2M of his 2026 salary"
          }
        ],
        "fact": "Smith 2026 pay split: Raiders $16.2M, Jets remainder plus $1M raise",
        "source": "https://sports.yahoo.com/articles/jets-agree-geno-smith-contract-141845246.html"
      },
      {
        "field": "media.streamingNotes",
        "old": "Standard NFL package",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source found)",
        "source": null
      }
    ],
    "analystNotes": "The Jets are the purest market premium in the league: $10.35B on Forbes' September 2026 list with no playoff appearance since 2010 and $216M of operating income from a half share of privately financed MetLife Stadium. Forbes assigns $6.8B of the value to the sport itself, so the New York market and stadium add roughly $3.5B on top of a generic NFL franchise. Geno Smith arrived from Las Vegas in March 2026 as a bridge starter with rookie Cade Klubnik behind him, so there is still no franchise quarterback on the books. A real answer at the position is the one thing that would let the Jets close the gap to the Giants at $12B.",
    "unverifiedAsOf": {}
  },
  "baltimore-ravens": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 6.03,
        "new": 8.2,
        "fact": "Forbes NFL list September 2026: $8.2B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 570,
        "new": 656,
        "fact": "Forbes Sept 2026 revenue $656M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2023,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 95,
        "new": 77,
        "fact": "Forbes Sept 2026 operating income $77M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 4,
        "new": 3,
        "fact": "Playoff seasons 2021-2025: 2022, 2023, 2024",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_NFL_playoffs"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "Major renovation (up to ~$489M) under negotiation, with Maryland and Ravens splitting costs; no new build announced",
        "new": "Three-year, roughly $450-489M \"Next Evolution\" renovation of M&T Bank Stadium completed for the 2026 season (Maryland Stadium Authority joint venture); no new build planned",
        "fact": "Ravens announced the renovation complete ahead of the 2026 season",
        "source": "https://www.baltimoreravens.com/news/ravens-renovation-project-mt-bank-stadium-complete-north-plaza-gate-a"
      },
      {
        "field": "stadium.nonGameRevenue",
        "old": "Limited — primarily football and select concerts; $430-489M renovation proposal under negotiation as of 2023-2024",
        "new": "Renovation added the Bud Light Talon open-air music venue, new club spaces and 29 video displays; still primarily football plus concerts",
        "fact": "New open-air venue with music stage added in 2026",
        "source": "https://www.baltimoreravens.com/news/ravens-renovation-project-mt-bank-stadium-complete-north-plaza-gate-a"
      },
      {
        "field": "onField.currentFranchiseQB",
        "old": "Lamar Jackson — 5yr/$260M extension signed May 2023, $52M AAV, $185M guaranteed",
        "new": "Lamar Jackson, 5yr/$260M (May 2023), $52M AAV, runs through 2027; extension talks paused before Week 1 2026 with no in-season deal expected; 2027 cap hit $84.3M",
        "fact": "Ravens and Jackson did not reach an extension before Week 1 2026",
        "source": "https://www.profootballrumors.com/2026/09/ravens-lamar-jackson-will-not-reach-extension-agreement-prior-to-week-1"
      }
    ],
    "analystNotes": "Baltimore sits at $8.2B on Forbes' September 2026 list with $656M of revenue, and the just-completed $450M-plus renovation of M&T Bank Stadium removes the facility discount that hung over the franchise. The open question is Lamar Jackson: his $52M AAV deal runs through 2027 with an $84.3M cap hit that year, and the Ravens paused extension talks before Week 1 2026. The team missed the 2025 playoffs after three straight appearances, and operating income fell to $77M. A third contract for Jackson at $65M-plus per year resets the cost base but also locks in the asset that drives ticket and sponsorship demand.",
    "unverifiedAsOf": {
      "stadium.namingRightsDeal": "May 2026"
    }
  },
  "cincinnati-bengals": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 5.25,
        "new": 8,
        "fact": "Forbes NFL list September 2026: $8B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 498,
        "new": 613,
        "fact": "Forbes Sept 2026 revenue $613M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2023,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 70,
        "new": 71,
        "fact": "Forbes Sept 2026 operating income $71M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 3,
        "new": 2,
        "fact": "Playoff seasons 2021-2025: 2021, 2022",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_NFL_playoffs"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": null,
        "new": "New lease through June 2036 (options to 2046) plus a phased renovation of Paycor Stadium agreed with Hamilton County in 2025: $470M core program, first phase $184.5M (Bengals $120M incl. a $60M NFL loan, county $64.5M) substantially complete for the 2026 season; full program estimated at ~$830M over four years",
        "fact": "Lease finalized 2025; phase one began Feb 2026",
        "source": "https://www.bengals.com/news/bengals-hamilton-county-finalize-new-lease-paycor-stadium-2025"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Joe Burrow",
            "position": "QB",
            "aav": 55,
            "contractNote": "5yr/$275M (Sept 2023), runs through 2028"
          },
          {
            "player": "Ja'Marr Chase",
            "position": "WR",
            "aav": null,
            "contractNote": "Extension expected; one of NFL's top WR assets"
          }
        ],
        "new": [
          {
            "player": "Joe Burrow",
            "position": "QB",
            "aav": 55,
            "contractNote": "5yr/$275M (Sept 2023), runs through 2028"
          },
          {
            "player": "Ja'Marr Chase",
            "position": "WR",
            "aav": 40.25,
            "contractNote": "4yr/$161M extension (March 2025), $73.9M guaranteed, runs through 2029; highest-paid non-QB at signing"
          }
        ],
        "fact": "Chase signed 4yr/$161M in March 2025",
        "source": "https://www.nfl.com/news/bengals-agree-to-terms-with-wrs-ja-marr-chase-tee-higgins-on-four-year-contract-extensions"
      }
    ],
    "analystNotes": "Cincinnati is the NFL's floor at $8.0B on Forbes' September 2026 list, and even the floor has risen 52% since 2024 because the league's national revenue now runs about $453M per team. The 2025 lease deal with Hamilton County keeps the Bengals at Paycor Stadium through at least 2036 and starts a $470M renovation that the team is funding largely with an NFL loan, the first real capital commitment from the Brown family in a generation. Joe Burrow at $55M AAV and Ja'Marr Chase at $40.25M AAV are locked through 2028 and 2029. The team has missed the playoffs three straight years; a return is what separates the Bengals from the rest of the $8B cluster.",
    "unverifiedAsOf": {}
  },
  "cleveland-browns": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 6.02,
        "new": 9,
        "fact": "Forbes NFL list September 2026: $9B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 540,
        "new": 720,
        "fact": "Forbes Sept 2026 revenue $720M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2023,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 80,
        "new": 110,
        "fact": "Forbes Sept 2026 operating income $110M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "New domed stadium planned in Brook Park near Cleveland Hopkins Airport, targeting 2029 opening; Haslams seeking public-private financing; city offered ~$550M toward ~$1.1B proposal",
        "new": "New enclosed Huntington Bank Field in Brook Park under construction: mass excavation began March 2, 2026 and the official groundbreaking was April 30, 2026; ~$2.6B stadium (Haslams ~$1.8B, State of Ohio $600M, Brook Park $245M); ~67,500 seats; opening 2029 with phase one of an adjoining mixed-use district",
        "fact": "Groundbreaking April 30, 2026; cost $2.6B; 2029 opening",
        "source": "https://www.cleveland19.com/2026/04/30/browns-hold-official-groundbreaking-new-brook-park-dome/"
      },
      {
        "field": "ownership.institutionalInvestors",
        "old": null,
        "new": "Arctos Partners bought 3% at a $9.0B valuation (announced and approved May 19, 2026); proceeds help fund the Brook Park stadium",
        "fact": "Arctos 3% at $9B, May 2026",
        "source": "data/transactions.js (verified 2025-2026 NFL transactions)"
      },
      {
        "field": "onField.currentFranchiseQB",
        "old": "Deshaun Watson — 5yr/$230M fully guaranteed signed 2022, $46M AAV; has missed extensive time due to injury and suspension; contract a significant cap liability",
        "new": "Deshaun Watson, named Week 1 2026 starter over Shedeur Sanders by new coach Todd Monken; releasing him now would trigger a record $127M dead cap, a post-June 1 release in March 2027 splits ~$86M over 2027-28; $200M becomes guaranteed if he is on the roster March 13, 2027",
        "fact": "Watson named 2026 starter; contract structure forces a March 2027 decision",
        "source": "https://www.cbssports.com/nfl/news/browns-deshaun-watson-contract-release-2027/"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Deshaun Watson",
            "position": "QB",
            "aav": 46,
            "contractNote": "5yr/$230M (2022), fully guaranteed; runs through 2026; extensive cap dead money exposure"
          }
        ],
        "new": [
          {
            "player": "Deshaun Watson",
            "position": "QB",
            "aav": 46,
            "contractNote": "5yr/$230M (2022), fully guaranteed and restructured repeatedly; final contract year 2026; release expected before March 13, 2027 when $200M would guarantee"
          }
        ],
        "fact": "Contract poison pill dated March 13, 2027",
        "source": "https://www.cbssports.com/nfl/news/browns-deshaun-watson-contract-release-2027/"
      }
    ],
    "analystNotes": "The Browns were priced at $9.0B two independent ways in 2026: Forbes' September list and Arctos' purchase of 3% in May. The value driver is the $2.6B enclosed stadium in Brook Park that broke ground April 30, 2026, with the Haslams putting in roughly $1.8B against $845M of state and local money, opening in 2029 with a mixed-use district around it. Deshaun Watson is still the Week 1 starter in 2026 only because cutting him now costs a record $127M in dead cap; the practical exit is March 2027. A clean quarterback slate in 2027 plus a domed building in 2029 is the re-rating path.",
    "unverifiedAsOf": {
      "stadium.namingRightsDeal": "May 2026"
    }
  },
  "pittsburgh-steelers": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 6.08,
        "new": 8.7,
        "fact": "Forbes NFL list September 2026: $8.7B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 548,
        "new": 653,
        "fact": "Forbes Sept 2026 revenue $653M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2023,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 96,
        "new": 74,
        "fact": "Forbes Sept 2026 operating income $74M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 3,
        "new": 4,
        "fact": "Playoff seasons 2021-2025: 2021, 2023, 2024, 2025",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_NFL_playoffs"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      },
      {
        "field": "onField.currentFranchiseQB",
        "old": "Aaron Rodgers — 1yr/$13.65M base deal signed June 2025 ($19.5M max with incentives); team holds UFA tender for 2026",
        "new": "Aaron Rodgers, re-signed for 2026 on a one-year deal worth up to $25M under new head coach Mike McCarthy; Rodgers, 42, has said 2026 is his final season",
        "fact": "Rodgers returned for 2026 and confirmed he will retire after the season",
        "source": "https://www.cbssports.com/nfl/news/aaron-rodgers-steelers-qb-retiring-after-2026-season/"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Aaron Rodgers",
            "position": "QB",
            "aav": 13.65,
            "contractNote": "1yr/$13.65M base (June 2025), up to $19.5M with incentives; 2026 UFA tender in place"
          }
        ],
        "new": [
          {
            "player": "Aaron Rodgers",
            "position": "QB",
            "aav": null,
            "contractNote": "1yr deal for 2026 worth up to $25M (second Steelers contract); retiring after 2026"
          }
        ],
        "fact": "One-year contract worth up to $25M",
        "source": "https://www.steelers.com/news/steelers-sign-rodgers"
      }
    ],
    "analystNotes": "Pittsburgh carries an $8.7B Forbes mark (September 2026) on $653M of revenue, and Forbes credits $539M to brand, the most of any team outside the top six, which is the Terrible Towel effect in a metro of 2.4M people. The football side is a one-year bridge: Aaron Rodgers returned on a deal worth up to $25M under Mike McCarthy and has said 2026 is his last season, after a 2025 wild card exit that extended the playoff-win drought to nine years. Operating income of $74M is thin for a team with no stadium debt. The quarterback succession decision in spring 2027 is the whole story.",
    "unverifiedAsOf": {}
  },
  "houston-texans": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 6.01,
        "new": 9.65,
        "fact": "Forbes NFL list September 2026: $9.65B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 663,
        "new": 722,
        "fact": "Forbes Sept 2026 revenue $722M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2023,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 195,
        "new": 160,
        "fact": "Forbes Sept 2026 operating income $160M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 2,
        "new": 3,
        "fact": "Playoff seasons 2021-2025: 2023, 2024, 2025",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_NFL_playoffs"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      },
      {
        "field": "stadium.name",
        "old": "NRG Stadium",
        "new": "Reliant Stadium (renamed from NRG Stadium, August 2026)",
        "fact": "NRG Stadium and NRG Park renamed Reliant Stadium and Reliant Park in August 2026 after a temporary \"Houston Stadium\" period for the World Cup",
        "source": "https://www.nrg.com/about/newsroom/2026/r1912.html"
      },
      {
        "field": "stadium.namingRightsDeal",
        "old": {
          "sponsor": "Reliant Energy (NRG Energy 2014-2026, reverting to Reliant)",
          "annualValue_M": 10,
          "totalValue_M": 300,
          "expiryYear": 2032,
          "notes": "Original 30-year, $300M deal signed 2000; stadium renamed back to Reliant Stadium starting 2026 season"
        },
        "new": {
          "sponsor": "Reliant Energy (NRG Energy brand 2014-2026, reverted to Reliant August 2026)",
          "annualValue_M": 10,
          "totalValue_M": 300,
          "expiryYear": 2032,
          "notes": "Original 30-year, $300M deal signed 2000; renamed Reliant Stadium in August 2026 with Harris County Sports & Convention Corp. approval; Texans lease runs through the 2032 season"
        },
        "fact": "Rename approved and effective August 2026",
        "source": "https://abc13.com/post/nrg-stadium-home-houston-texans-rodeo-renamed-reliant-august-2026-company-announces/18893525/"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "As of May 2026, Cal McNair committed to staying at NRG Park site; renovation vs. new build under discussion with Harris County",
        "new": "Texans committed to staying at Reliant Park beyond the 2032 lease expiry with renovations rather than a new build; no demolition or replacement planned",
        "fact": "Team and county pursuing renovation of the 2002 building",
        "source": "https://www.chron.com/sports/texans/article/texans-reliant-stadium-future-2032-lease-22240510.php"
      },
      {
        "field": "onField.currentFranchiseQB",
        "old": "C.J. Stroud",
        "new": "C.J. Stroud, final year of 4yr/$36.3M rookie deal in 2026; $25.9M fully guaranteed fifth-year option for 2027 exercised; extension talks tabled until after the 2026 season",
        "fact": "Texans and Stroud agreed to wait on an extension until after 2026",
        "source": "https://www.espn.com/nfl/story/_/id/49917836/sources-cj-stroud-texans-table-extension-talks"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "C.J. Stroud",
            "position": "QB",
            "aav": 9.1,
            "contractNote": "4-year, $36.3M rookie deal (2023 draft, #2 overall); extension negotiations expected 2025-26"
          }
        ],
        "new": [
          {
            "player": "C.J. Stroud",
            "position": "QB",
            "aav": 9.1,
            "contractNote": "4yr/$36.3M rookie deal (2023 No. 2 pick); $25.9M fifth-year option exercised for 2027; extension deferred to 2027 offseason"
          }
        ],
        "fact": "Fifth-year option exercised; talks deferred",
        "source": "https://www.espn.com/nfl/story/_/id/49917836/sources-cj-stroud-texans-table-extension-talks"
      }
    ],
    "analystNotes": "Houston is the fourth largest U.S. metro and Forbes prices it that way: $9.65B in September 2026, seventh in the league, on $722M of revenue and $160M of operating income. The stadium went back to the Reliant Stadium name in August 2026 and the McNairs have committed to renovating rather than replacing it past the 2032 lease, which caps the upside a new building would bring. C.J. Stroud is playing out his rookie deal with a $25.9M option exercised for 2027 and extension talks pushed to next offseason, so the cost base stays cheap for one more year. Three straight playoff trips and a $70M AAV quarterback contract next spring are the two forces pulling on the number.",
    "unverifiedAsOf": {}
  },
  "indianapolis-colts": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 4.99,
        "new": 8.08,
        "fact": "Forbes NFL list September 2026: $8.08B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 591,
        "new": 626,
        "fact": "Forbes Sept 2026 revenue $626M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2023,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 101,
        "new": 81,
        "fact": "Forbes Sept 2026 operating income $81M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      },
      {
        "field": "onField.currentFranchiseQB",
        "old": "Anthony Richardson",
        "new": "Daniel Jones, re-signed March 2026 on 2yr/$88M (up to $100M), ~$49.4M guaranteed at signing, the largest two-year contract in NFL history; named 2026 starter; Anthony Richardson is the backup after a denied trade request",
        "fact": "Colts re-signed Jones after his 2025 breakout ended with an Achilles injury",
        "source": "https://www.nfl.com/news/colts-qb-daniel-jones-finalizing-two-year-88-million-deal"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Anthony Richardson",
            "position": "QB",
            "aav": 8.5,
            "contractNote": "4-year, $33.99M rookie deal (2023 draft, #4 overall); 5th-year option declined; free agent after 2026"
          }
        ],
        "new": [
          {
            "player": "Daniel Jones",
            "position": "QB",
            "aav": 44,
            "contractNote": "2yr/$88M (March 2026), up to $100M with incentives; ~$49.4M guaranteed at signing; runs through 2027"
          },
          {
            "player": "Anthony Richardson",
            "position": "QB",
            "aav": 8.5,
            "contractNote": "4yr/$33.99M rookie deal (2023 No. 4 pick); 5th-year option declined; expires after 2026; backup to Jones"
          }
        ],
        "fact": "Steichen named Jones the starter; Richardson backup",
        "source": "https://www.colts.com/news/daniel-jones-starting-quarterback-qb1-shane-steichen-anthony-richardson"
      },
      {
        "field": "ownership.ownerBackground",
        "old": "Jim Irsay (d. 2024) inherited franchise from father Robert Irsay in 1997; three daughters now operate as co-owners",
        "new": "Jim Irsay (died May 21, 2025) inherited the franchise from father Robert Irsay in 1997; his three daughters now operate as co-owners",
        "fact": "Correction: Jim Irsay died in May 2025, not 2024",
        "source": "https://en.wikipedia.org/wiki/Jim_Irsay"
      }
    ],
    "analystNotes": "Indianapolis moved from $4.99B to $8.08B on the Forbes list between 2024 and September 2026 without a single playoff game, which shows how much of NFL value is the shared $453M national check rather than anything local. The Irsay daughters made their first big bet in March 2026: Daniel Jones on a two-year, $88M deal, the largest two-year contract in league history, after his 2025 breakout ended with an Achilles tear. The Lucas Oil naming deal expires around now and no renewal has been announced, which is the one open item on the revenue side. Jones staying healthy behind a rebuilt line is what turns a $626M revenue base into playoff gate.",
    "unverifiedAsOf": {
      "stadium.namingRightsDeal": "May 2026"
    }
  },
  "jacksonville-jaguars": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 4.6,
        "new": 8.05,
        "fact": "Forbes NFL list September 2026: $8.05B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 567,
        "new": 591,
        "fact": "Forbes Sept 2026 revenue $591M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2023,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 139,
        "new": 31,
        "fact": "Forbes Sept 2026 operating income $31M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "$1.4B 'Stadium of the Future' renovation (City $625M + Jaguars $625M + $150M maintenance); approved Oct 2024; re-opens 2028; Jaguars playing 2027 home games in Orlando",
        "new": "$1.4B Stadium of the Future renovation ~15% complete and on schedule as of spring 2026; 2026 home capacity reduced to 42,507 during construction; Jaguars play 2027 home games at Camping World Stadium in Orlando; reopens 2028 at 63,000 seats (expandable to 70,000)",
        "fact": "2026 capacity 42,507; Orlando in 2027; 2028 reopening",
        "source": "https://www.nfl.com/news/jaguars-everbank-stadium-renovation-2026-season"
      }
    ],
    "analystNotes": "Jacksonville went 13-4 and won the AFC South in 2025, and Forbes still has it at $8.05B (September 2026), 29th in the league, because the market is the smallest in the NFL and the stadium is mid-renovation. Operating income collapsed to $31M with 2026 home capacity cut to 42,507 and the whole 2027 season moving to Orlando, which is the price of the $1.4B Stadium of the Future that reopens in 2028 at 63,000 seats with Shad Khan covering overruns. Trevor Lawrence's $55M AAV runs through 2029. The 2028 reopening, with premium inventory a 1995 building never had, is the catalyst.",
    "unverifiedAsOf": {
      "stadium.namingRightsDeal": "May 2026"
    }
  },
  "tennessee-titans": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 6.01,
        "new": 8.5,
        "fact": "Forbes NFL list September 2026: $8.5B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 561,
        "new": 607,
        "fact": "Forbes Sept 2026 revenue $607M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2023,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 123,
        "new": 85,
        "fact": "Forbes Sept 2026 operating income $85M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "New enclosed $2.1B Nissan Stadium under construction on East Bank of Cumberland River; on track for Feb 2027 completion; 60,000 seats; largest public stadium subsidy in U.S. history ($1.26B public)",
        "new": "New enclosed $2.1B Nissan Stadium on track for February 2027 completion; roof cable-net system finished Aug 2026 with full enclosure expected by fall 2026; ~60,000 seats; 70% of the building sold via season-ticket carryover; awarded Super Bowl LXIV (2030) in May 2026; 2026 is the last season in the 1999 stadium; $1.26B public funding remains the largest U.S. stadium subsidy",
        "fact": "Construction progress Aug 2026; Feb 2027 opening; Super Bowl LXIV awarded May 2026",
        "source": "https://www.wsmv.com/2026/08/12/its-starting-feel-like-stadium-titans-share-construction-progress-new-nissan-stadium/"
      },
      {
        "field": "onField.currentFranchiseQB",
        "old": "Will Levis",
        "new": "Cam Ward, 2025 No. 1 overall pick, 4yr/$48.7M fully guaranteed rookie deal with fifth-year option; second-year starter under head coach Robert Saleh",
        "fact": "Ward signed a fully guaranteed $48.7M rookie contract in May 2025 and started as a rookie",
        "source": "https://www.espn.com/nfl/story/_/id/45258215/titans-sign-no-1-pick-cam-ward-four-year-rookie-deal"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Will Levis",
            "position": "QB",
            "aav": 2.4,
            "contractNote": "4-year, $9.54M rookie deal (2023 draft, #33 overall 2nd round); 5th-year option available 2027"
          }
        ],
        "new": [
          {
            "player": "Cam Ward",
            "position": "QB",
            "aav": 12.2,
            "contractNote": "4yr/$48.7M rookie deal (May 2025), fully guaranteed, $32.1M signing bonus; runs through 2028 plus 5th-year option"
          }
        ],
        "fact": "Replaces stale Will Levis entry; Ward is the franchise QB",
        "source": "https://www.tennesseetitans.com/news/titans-sign-qb-cam-ward-to-rookie-contract"
      }
    ],
    "analystNotes": "Tennessee is at $8.5B on the September 2026 Forbes list on just $607M of revenue because the market is pricing the building that opens in February 2027: a $2.1B enclosed Nissan Stadium with $1.26B of public money, 70% of it already sold through season-ticket carryover, and Super Bowl LXIV in 2030 awarded in May 2026. Forbes' brand component of $308M is the lowest in the league, so this is a stadium and Nashville-growth story, not a fan-equity story. Cam Ward, the 2025 No. 1 pick, is in year two on a fully guaranteed $48.7M rookie deal. Twelve months of new-building revenue in the FY2027 numbers is the next step change.",
    "unverifiedAsOf": {
      "stadium.namingRightsDeal": "May 2026"
    }
  },
  "denver-broncos": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 6.2,
        "new": 9.4,
        "fact": "Forbes NFL list September 2026: $9.4B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 608,
        "new": 695,
        "fact": "Forbes Sept 2026 revenue $695M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2023,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 114,
        "new": 97,
        "fact": "Forbes Sept 2026 operating income $97M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 0,
        "new": 2,
        "fact": "Playoff seasons 2021-2025: 2024, 2025",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_NFL_playoffs"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "$4B new stadium at Burnham Yard site in Denver advancing; targeting 2031 opening; financing and public subsidy structure TBD",
        "new": "Burnham Yard stadium and mixed-use district still targeting a 2031 opening; updated master-plan renderings released Aug 4, 2026 with four neighborhood districts and transit stops; team acknowledges the project has moved slower than hoped; financing and public-subsidy structure still unresolved",
        "fact": "Aug 2026 renderings; 2031 target; timeline questions",
        "source": "https://www.cbsnews.com/colorado/news/denver-broncos-burnham-yard-stadium-plans-questions/"
      },
      {
        "field": "onField.currentFranchiseQB",
        "old": "Bo Nix",
        "new": "Bo Nix, year three of 4yr/$18.6M rookie deal; extension-eligible January 2027 (Spotrac market value ~$53.4M AAV); led Denver to 14-3 and the AFC No. 1 seed in 2025 before a 10-7 AFC Championship loss to New England",
        "fact": "Nix extension eligibility opens Jan 2027",
        "source": "https://www.espn.com/nfl/story/_/id/49576234/bo-nix-denver-broncos-2026-season-super-bowl-expectations-long-term-contract-extension"
      },
      {
        "field": "media.streamingNotes",
        "old": "",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source found)",
        "source": null
      }
    ],
    "analystNotes": "Denver has doubled from the $4.65B Walton-Penner purchase price in 2022 to $9.4B on Forbes' September 2026 list, and the 2025 season, 14-3 with the AFC's top seed and a 10-7 conference title game loss, finally gave the ownership group an on-field story to sell. Bo Nix is still on a $4.7M AAV rookie deal through 2027 with extension eligibility opening in January 2027, the cheapest elite-tier quarterback window in the league. The Burnham Yard stadium keeps a 2031 target but the team admits it is behind schedule and financing is unresolved. Locking the stadium deal is worth more than any single season.",
    "unverifiedAsOf": {}
  },
  "kansas-city-chiefs": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 4.85,
        "new": 8.8,
        "fact": "Forbes NFL list September 2026: $8.8B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 591,
        "new": 644,
        "fact": "Forbes Sept 2026 revenue $644M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2023,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 115,
        "new": 51,
        "fact": "Forbes Sept 2026 operating income $51M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 5,
        "new": 4,
        "fact": "Playoff seasons 2021-2025: 2021, 2022, 2023, 2024",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_NFL_playoffs"
      },
      {
        "field": "onField.championshipsLast10Years",
        "old": 4,
        "new": 3,
        "fact": "Super Bowl wins for seasons 2016-2025: 3",
        "source": "https://en.wikipedia.org/wiki/List_of_Super_Bowl_champions"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "Dec 2025: Chiefs announced intent to build new $3B stadium in Wyandotte County, Kansas; $1.8B public subsidy (Kansas STAR Bond legislation); target opening 2031",
        "new": "New $3B enclosed stadium near Kansas Speedway in Wyandotte County, Kansas: county approved STAR bonds Feb 2026; most stadium land under team control as of May 2026; first renderings released July 22, 2026 (~70,000 seats, ETFE roof); paired with a $300M Olathe practice facility and $1.2B of ancillary development; target opening for the 2031 season",
        "fact": "STAR bonds approved Feb 2026; renderings July 2026; 2031 opening",
        "source": "https://www.kctv5.com/2026/07/22/espn-insider-drops-first-look-chiefs-new-3-billion-kansas-stadium/"
      },
      {
        "field": "onField.currentFranchiseQB",
        "old": "Patrick Mahomes",
        "new": "Patrick Mahomes, reworked in June 2026 into an 8yr/$504.75M deal through 2033 (up to $522.25M), $397M guaranteed, $64M AAV on new money, the first NFL contract over $500M; returned for Week 1 2026 in a knee brace after a Dec 14, 2025 ACL/LCL tear",
        "fact": "First $500M NFL contract, June 2026",
        "source": "https://www.nfl.com/news/chiefs-add-two-years-to-patrick-mahomes-contract-making-it-first-nfl-deal-valued-at-over-500-million"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Patrick Mahomes",
            "position": "QB",
            "aav": 45,
            "contractNote": "10-year, $450M extension signed July 2020; restructured multiple times; effectively runs through 2031 season"
          }
        ],
        "new": [
          {
            "player": "Patrick Mahomes",
            "position": "QB",
            "aav": 64,
            "contractNote": "8yr/$504.75M through 2033 (June 2026 extension), $397M guaranteed, first four years guaranteed at signing; NFL-record $64M new-money AAV"
          }
        ],
        "fact": "Extension through 2033 signed June 2026",
        "source": "https://www.profootballrumors.com/2026/06/chiefs-patrick-mahomes-sign-extension-through-2033"
      }
    ],
    "analystNotes": "Kansas City is worth $8.8B on Forbes' September 2026 list even after a 6-11 season with Patrick Mahomes lost to a torn ACL in December 2025, the first missed playoffs since 2014. The Chiefs then made Mahomes the first $500M player in June 2026, a $504.75M deal through 2033 at $64M per year, which is why operating income fell to $51M, lowest in the AFC West. The $3B Wyandotte County dome has STAR bonds approved, land secured and renderings out, with a 2031 opening that finally gives a three-time champion of the last decade a modern building. Mahomes healthy in 2026 restores the sport premium; the Kansas stadium restores the stadium premium.",
    "unverifiedAsOf": {
      "stadium.namingRightsDeal": "May 2026"
    }
  },
  "las-vegas-raiders": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 6.7,
        "new": 10.3,
        "fact": "Forbes NFL list September 2026: $10.3B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 779,
        "new": 887,
        "fact": "Forbes Sept 2026 revenue $887M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2023,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 115,
        "new": 191,
        "fact": "Forbes Sept 2026 operating income $191M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      },
      {
        "field": "ownership.ownershipGroup",
        "old": [
          {
            "name": "Mark Davis",
            "role": "majority owner / managing general partner",
            "pct": null
          },
          {
            "name": "Tom Brady",
            "role": "limited partner",
            "pct": null
          },
          {
            "name": "Tom Wagner",
            "role": "limited partner",
            "pct": null
          },
          {
            "name": "Michael Meldman",
            "role": "limited partner",
            "pct": null
          }
        ],
        "new": [
          {
            "name": "Mark Davis",
            "role": "majority owner / managing general partner",
            "pct": null
          },
          {
            "name": "Egon Durban",
            "role": "limited partner (~14.5% combined: 3.5% from Davis in March 2026 plus ~11% via the May 2026 First Football purchase); holds a 10-year right of first refusal on Davis's control stake",
            "pct": null
          },
          {
            "name": "Tom Brady",
            "role": "limited partner",
            "pct": null
          },
          {
            "name": "Tom Wagner",
            "role": "limited partner",
            "pct": null
          },
          {
            "name": "Michael Meldman",
            "role": "limited partner (added ~5.4% in May 2026)",
            "pct": null
          },
          {
            "name": "Michael Dell",
            "role": "limited partner",
            "pct": 5.3
          },
          {
            "name": "Joseph Baratta, Ari Emanuel, Mark Shapiro",
            "role": "limited partners (1.7%, 1.4%, 0.6%)",
            "pct": null
          }
        ],
        "fact": "Two 2026 LP transactions: Durban 3.5% from Davis at $11.1B (approved Mar 31, 2026) and a Durban-led group buying First Football's 25.3% at $9.9B (approved May 19, 2026)",
        "source": "data/transactions.js (verified 2025-2026 NFL transactions)"
      },
      {
        "field": "ownership.institutionalInvestors",
        "old": null,
        "new": "Egon Durban bought 3.5% from Mark Davis at an $11.1B headline mark (approved March 31, 2026; figure includes the 10% league transfer fee) with a right of first refusal on control; a Durban-led group then bought First Football's 25.3% at a $9.9B mark (approved May 19, 2026)",
        "fact": "Durban is the pre-cleared successor to Davis",
        "source": "data/transactions.js (verified 2025-2026 NFL transactions)"
      },
      {
        "field": "onField.currentFranchiseQB",
        "old": "Geno Smith",
        "new": "Kirk Cousins, signed April 2026 ($20M fully guaranteed for 2026, Atlanta paying $8.7M of it; club option for 2027-28 at $80M; up to $172M over five years), named Week 1 2026 starter by Klint Kubiak; Fernando Mendoza, the 2026 No. 1 overall pick (4yr/$57.27M fully guaranteed), is the backup and long-term answer",
        "fact": "Cousins named Week 1 starter over Mendoza",
        "source": "https://www.nfl.com/news/raiders-name-kirk-cousins-starting-fernando-mendoza-officially-backup"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Geno Smith",
            "position": "QB",
            "aav": null,
            "contractNote": "Acquired as bridge starter for 2025 season; franchise QB identity unresolved post-Carr departure"
          }
        ],
        "new": [
          {
            "player": "Kirk Cousins",
            "position": "QB",
            "aav": null,
            "contractNote": "Signed April 2026; $20M guaranteed for 2026 (Falcons cover $8.7M); $10M roster bonus due March 2027; two-year $80M club option"
          },
          {
            "player": "Fernando Mendoza",
            "position": "QB",
            "aav": 14.3,
            "contractNote": "4yr/$57.27M rookie deal (July 2026), fully guaranteed, $38M signing bonus, 5th-year option"
          }
        ],
        "fact": "Mendoza signed $57.27M rookie deal July 2026",
        "source": "https://www.nfl.com/news/raiders-sign-2026-no-1-overall-pick-qb-fernando-mendoza-to-rookie-contract"
      }
    ],
    "analystNotes": "Las Vegas is a $10.3B franchise on Forbes' September 2026 list with $887M of revenue, second in the league, and a $2.8B stadium component from Allegiant Stadium that only Dallas, Miami and the Rams exceed. Two 2026 LP trades put real prices on it: Egon Durban paid an $11.1B mark for 3.5% in March, with a right of first refusal on Mark Davis's control stake, and his group bought First Football's 25.3% at $9.9B in May. The football side is a handoff: Kirk Cousins starts 2026 on a $20M guarantee while No. 1 pick Fernando Mendoza waits on a $57.27M rookie deal. Davis's eventual control sale, already pre-cleared to Durban, is the transaction the whole league is watching.",
    "unverifiedAsOf": {
      "ownership.ownerNetWorth": "May 2026"
    }
  },
  "los-angeles-chargers": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 5.83,
        "new": 8.3,
        "fact": "Forbes NFL list September 2026: $8.3B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 518,
        "new": 623,
        "fact": "Forbes Sept 2026 revenue $623M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2022,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 65,
        "new": 57,
        "fact": "Forbes Sept 2026 operating income $57M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 2,
        "new": 3,
        "fact": "Playoff seasons 2021-2025: 2022, 2024, 2025",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_NFL_playoffs"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      },
      {
        "field": "ownership.ownershipGroup",
        "old": [
          {
            "name": "Spanos family (Dean, Michael, Alexandria)",
            "role": "majority controlling group",
            "pct": null
          },
          {
            "name": "Tom Gores",
            "role": "limited partner 27%",
            "pct": 27
          }
        ],
        "new": [
          {
            "name": "Spanos family (Dean, Michael, Alexandria)",
            "role": "majority controlling group (~61%)",
            "pct": 61
          },
          {
            "name": "Tom Gores",
            "role": "limited partner",
            "pct": 27
          },
          {
            "name": "Arctos Partners",
            "role": "limited partner (passive, approved May 20, 2025)",
            "pct": 8
          }
        ],
        "fact": "Arctos bought 8% in May 2025; Spanos family retains ~61%",
        "source": "data/transactions.js (verified 2025-2026 NFL transactions)"
      },
      {
        "field": "ownership.institutionalInvestors",
        "old": null,
        "new": "Arctos Partners bought a passive 8% stake (approved May 20, 2025; valuation not disclosed, reported \"north of $6B\"); Spanos family retains ~61%, Tom Gores 27%",
        "fact": "Arctos second NFL stake after the Bills",
        "source": "data/transactions.js (verified 2025-2026 NFL transactions)"
      }
    ],
    "analystNotes": "The Chargers are $8.3B on Forbes' September 2026 list, 24th, in the second largest U.S. market, because their SoFi Stadium lease sends naming rights and non-NFL event money to Stan Kroenke's StadCo. Forbes gives them a $755M stadium component against $3.6B for the Rams in the same building. Justin Herbert's $52.5M AAV runs through 2029 and the team has made three playoff trips in four years, all wild card exits. Ownership has become a cap table: Spanos family ~61%, Tom Gores 27%, Arctos 8% since May 2025, and a Gores-led control transfer is the event that would reprice the franchise.",
    "unverifiedAsOf": {}
  },
  "dallas-cowboys": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 10.1,
        "new": 17,
        "fact": "Forbes NFL list September 2026: $17B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 1100,
        "new": 1278,
        "fact": "Forbes Sept 2026 revenue $1278M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2023,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 350,
        "new": 677,
        "fact": "Forbes Sept 2026 operating income $677M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      }
    ],
    "analystNotes": "Dallas is the first $17B franchise on Forbes' September 2026 list, $5B clear of the Giants, on $1.28B of revenue and $677M of operating income that no other team comes within $340M of. Forbes splits the value almost evenly between market ($3.8B), stadium ($3.2B) and brand ($3.3B), so the football component is only 39% of the total, the lowest share in the league. The Cowboys have not made the playoffs since 2023 and have not won a Super Bowl since 1995, and it has not mattered to the number. Dak Prescott's $60M AAV runs through 2028; the AT&T naming deal expiring around 2029 is the next revenue reset.",
    "unverifiedAsOf": {
      "stadium.namingRightsDeal": "May 2026",
      "ownership.ownerNetWorth": "May 2026"
    }
  },
  "new-york-giants": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 7.8,
        "new": 12,
        "fact": "Forbes NFL list September 2026: $12B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 620,
        "new": 769,
        "fact": "Forbes Sept 2026 revenue $769M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2023,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 185,
        "new": 181,
        "fact": "Forbes Sept 2026 operating income $181M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      },
      {
        "field": "ownership.ownershipGroup",
        "old": [
          {
            "name": "John Mara",
            "role": "president, CEO, 50% ownership (Mara family)",
            "pct": 50
          },
          {
            "name": "Steve Tisch",
            "role": "chairman, EVP, 50% ownership (Tisch family)",
            "pct": 50
          }
        ],
        "new": [
          {
            "name": "John Mara",
            "role": "president, CEO (Mara family; ~half of the family-held 90%)",
            "pct": null
          },
          {
            "name": "Steve Tisch",
            "role": "chairman, EVP (Tisch family; ~half of the family-held 90%)",
            "pct": null
          },
          {
            "name": "Julia Koch and family",
            "role": "limited partner (approved Oct 22, 2025 at a $10.3B valuation)",
            "pct": 10
          }
        ],
        "fact": "Koch family bought 10% from the Mara and Tisch families in 2025",
        "source": "data/transactions.js (verified 2025-2026 NFL transactions)"
      },
      {
        "field": "ownership.institutionalInvestors",
        "old": null,
        "new": "Julia Koch and family bought 10% at a $10.3B valuation (announced Sept 3, approved Oct 22, 2025); first outside investment since the Mara family took control in 1925",
        "fact": "Koch 10% at $10.3B",
        "source": "data/transactions.js (verified 2025-2026 NFL transactions)"
      },
      {
        "field": "onField.currentFranchiseQB",
        "old": "No established franchise QB as of 2025; Tommy DeVito re-signed on 1-year/$1.03M deal; team actively seeking franchise solution via draft or trade",
        "new": "Jaxson Dart, 2025 first-round pick, replaced Russell Wilson as starter in Week 4 of 2025 and is the 2026 starter under new head coach John Harbaugh; Jameis Winston is the backup; Wilson has left the team",
        "fact": "Dart named starter Sept 2025; 2026 QB room Dart/Winston/Allen",
        "source": "https://sports.yahoo.com/articles/giants-quarterback-room-projection-2026-211955953.html"
      },
      {
        "field": "onField.starContracts",
        "old": [],
        "new": [
          {
            "player": "Jaxson Dart",
            "position": "QB",
            "aav": null,
            "contractNote": "2025 first-round rookie contract; starter since Week 4 of 2025"
          }
        ],
        "fact": "Replaces empty list; Dart is the franchise QB",
        "source": "https://www.espn.com/nfl/story/_/id/46356208/giants-bench-qb-russell-wilson-start-jaxson-dart"
      }
    ],
    "analystNotes": "The Giants are $12B on Forbes' September 2026 list, second in the league, and the Koch family paid a $10.3B mark for 10% in October 2025, so the private market and Forbes agree within 15%. Forbes' $7.3B sport component is the highest in the NFL, which is what a century of Mara ownership in New York and a debt-light half of MetLife Stadium buys. The football product is a rebuild: Jaxson Dart, a 2025 first-round pick, is the starter under John Harbaugh after one playoff trip in the last five years. Dart becoming a top-ten quarterback is the only lever that moves a number already fully valued on market and stadium.",
    "unverifiedAsOf": {}
  },
  "philadelphia-eagles": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 6.6,
        "new": 10.25,
        "fact": "Forbes NFL list September 2026: $10.25B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 688,
        "new": 713,
        "fact": "Forbes Sept 2026 revenue $713M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2024,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 158,
        "new": 154,
        "fact": "Forbes Sept 2026 operating income $154M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 4,
        "new": 5,
        "fact": "Playoff seasons 2021-2025: 2021, 2022, 2023, 2024, 2025",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_NFL_playoffs"
      },
      {
        "field": "onField.championshipsLast10Years",
        "old": 1,
        "new": 2,
        "fact": "Super Bowl wins for seasons 2016-2025: 2",
        "source": "https://en.wikipedia.org/wiki/List_of_Super_Bowl_champions"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      },
      {
        "field": "ownership.institutionalInvestors",
        "old": null,
        "new": "Sold 8% to two family groups (Susan Kim; Zack Peskowitz and Olivia Peskowitz Suter) at an $8.3B valuation, approved Dec 11, 2024; Lurie retains ~85%",
        "fact": "NFL approved the 8% sale at $8.3B in Dec 2024",
        "source": "https://www.cnbc.com/2024/12/11/nfl-philadelphia-eagles-minority-stake-sale.html"
      }
    ],
    "analystNotes": "Philadelphia won Super Bowl LIX in February 2025, made the playoffs for a fifth straight year in 2025, and sits at $10.25B on Forbes' September 2026 list on $713M of revenue. The December 2024 sale of 8% at $8.3B was the NFL minority record for five months and now looks like a 20% discount to the Forbes mark. Jalen Hurts' $51M AAV runs through 2028 and the Lincoln Financial naming deal through 2032, so both big line items are fixed. Lurie's $185M entry in 1994 is now a 55x return; the next move is whatever a Lincoln Financial Field renovation adds to premium revenue.",
    "unverifiedAsOf": {}
  },
  "washington-commanders": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 6.3,
        "new": 9.8,
        "fact": "Forbes NFL list September 2026: $9.8B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 670,
        "new": 694,
        "fact": "Forbes Sept 2026 revenue $694M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2024,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 149,
        "new": 121,
        "fact": "Forbes Sept 2026 operating income $121M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "New stadium planned at RFK Stadium site in Washington D.C., targeting 2030 opening; pending D.C. Council approvals",
        "new": "$3.7B RFK-site project: D.C. Council gave final approval Sept 17, 2025 (District ~$1B for demolition and site prep, Commanders ~$2.7B for a 65,000-seat domed stadium); federal planning commission cleared preliminary plans April 2026; District master plan for the 180-acre campus submitted Sept 24, 2026; construction bids Nov-Dec 2026 and foundation work spring 2027; opening 2030",
        "fact": "Master plan filed Sept 24, 2026; bids this fall; foundations spring 2027",
        "source": "https://www.axios.com/local/washington-dc/2026/09/24/rfk-stadium-development-commanders"
      },
      {
        "field": "onField.currentFranchiseQB",
        "old": "Jayden Daniels — 4yr/$37.7M fully guaranteed rookie contract (2024 #2 overall pick), $9.4M AAV; extension-eligible after 2025",
        "new": "Jayden Daniels, year three of 4yr/$37.7M fully guaranteed rookie deal (2024 No. 2 pick); extension-eligible after 2026, but a second dislocated left elbow in 2026 has Washington leaning toward the fifth-year option and franchise tag rather than an early extension",
        "fact": "Daniels re-injured his left elbow in 2026",
        "source": "https://sports.yahoo.com/articles/jayden-daniels-injury-might-ominous-181619088.html"
      }
    ],
    "analystNotes": "Josh Harris paid $6.05B in 2023 and Forbes has the Commanders at $9.8B in September 2026, a 62% gain in three years, almost all of it the RFK stadium deal: $3.7B total, final D.C. Council approval in September 2025, master plan filed September 24, 2026, foundations in spring 2027, doors open in 2030. Forbes already assigns $1.35B of stadium value to a building that does not exist, on par with the Eagles' actual one. Jayden Daniels is on a $9.4M AAV rookie deal but a second dislocated elbow in 2026 makes the extension a 2027 question. Getting shovels in the ground on schedule is the whole thesis.",
    "unverifiedAsOf": {}
  },
  "chicago-bears": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 6.4,
        "new": 9.7,
        "fact": "Forbes NFL list September 2026: $9.7B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 627,
        "new": 656,
        "fact": "Forbes Sept 2026 revenue $656M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2024,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 74,
        "new": 73,
        "fact": "Forbes Sept 2026 operating income $73M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 0,
        "new": 1,
        "fact": "Playoff seasons 2021-2025: 2025",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_NFL_playoffs"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "Bears pursuing new domed stadium; Arlington Heights and Hammond, IN remain as final two candidate sites as of May 2026; Illinois House passed property tax relief bill May 2026, awaiting Senate vote",
        "new": "Bears have shifted focus from Arlington Heights to Hammond, Indiana: Indiana enacted a Northwest Indiana Stadium Authority and a ~$1B public tax package on Feb 26, 2026; the Bears said June 5, 2026 they will advance plans on the Hammond site with ~$2B of team money committed; Gov. Braun cites 2029 as the build target; nothing signed, and the team still owns the $197M Arlington Park parcel",
        "fact": "Bears advancing Hammond plans as of June 2026; Indiana package signed Feb 2026",
        "source": "https://indianacapitalchronicle.com/2026/06/05/chicago-bears-say-they-will-advance-stadium-plans-for-northwest-indiana-site/"
      },
      {
        "field": "ownership.ownershipGroup",
        "old": [
          {
            "name": "George H. McCaskey",
            "role": "chairman",
            "pct": null
          },
          {
            "name": "McCaskey family",
            "role": "majority ownership (~80%)",
            "pct": 80
          }
        ],
        "new": [
          {
            "name": "George H. McCaskey",
            "role": "chairman",
            "pct": null
          },
          {
            "name": "McCaskey family",
            "role": "majority ownership (~77% after buying two-thirds of the McKenna estate's 2.35% in 2025)",
            "pct": 77
          },
          {
            "name": "Ryan family",
            "role": "minority (~23%)",
            "pct": 23
          }
        ],
        "fact": "Post-2025 split: McCaskeys 77%, Ryans 23%",
        "source": "data/transactions.js (verified 2025-2026 NFL transactions)"
      },
      {
        "field": "ownership.institutionalInvestors",
        "old": "Minority stake (est. $235M for ~3.8% stake) sold to PE-affiliated group in 2024 as part of NFL's private equity rule expansion",
        "new": "No private-equity investor; the late Andrew McKenna's 2.35% stake was bought by the McCaskey (two-thirds) and Ryan (one-third) families at an $8.9B valuation (approved Sept 24, 2025)",
        "fact": "Corrects the earlier note about a 2024 PE stake; the 2025 deal was intra-ownership",
        "source": "data/transactions.js (verified 2025-2026 NFL transactions)"
      },
      {
        "field": "onField.currentFranchiseQB",
        "old": "Caleb Williams — 4yr/$39.5M fully guaranteed rookie contract (#1 overall pick 2024), ~$9.9M AAV",
        "new": "Caleb Williams, year three of 4yr/$39.5M fully guaranteed rookie deal (2024 No. 1 pick); led Chicago to 11-6 and the 2025 NFC North title; extension-eligible after the 2026 season with the Bears already modeling a deal that could top the $64M Mahomes benchmark",
        "fact": "Extension eligible after 2026; Poles says planning under way",
        "source": "https://chicago.suntimes.com/bears/2026/09/01/money-isnt-everything-with-a-big-contract-in-reach-qb-caleb-williams-wants-to-make-sure-bears-keep-winning"
      }
    ],
    "analystNotes": "The Bears jumped to $9.7B on Forbes' September 2026 list, and Forbes' $7.0B sport component is the second highest in the league, which is what a 2025 NFC North title with Caleb Williams on a $9.9M AAV rookie deal does for an original franchise. The stadium is finally moving: Indiana passed a roughly $1B public package on February 26, 2026, the Bears said in June they will advance the Hammond site with $2B of their own money, and 2029 is the target, all while they still own the Arlington Park land. Operating income of $73M reflects Soldier Field's 62,500 seats and no naming rights. A signed Hammond deal, or an Illinois counter, adds the stadium value Forbes currently caps at $877M.",
    "unverifiedAsOf": {}
  },
  "detroit-lions": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 4.15,
        "new": 8.04,
        "fact": "Forbes NFL list September 2026: $8.04B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 501,
        "new": 617,
        "fact": "Forbes Sept 2026 revenue $617M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2024,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 56,
        "new": 53,
        "fact": "Forbes Sept 2026 operating income $53M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      }
    ],
    "analystNotes": "Detroit has nearly doubled from $4.15B in 2024 to $8.04B on the September 2026 Forbes list, but that puts it 30th of 32, which says the market is still treating the Campbell era as a run rather than a re-rating. Revenue of $617M and $53M of operating income are bottom-five, with Ford Field's naming deal extended through 2036 on undisclosed terms and Jared Goff's $53M AAV running through 2028. The Lions missed the 2025 playoffs after back-to-back trips. A deep January run with a full house of Ford Field premium sales is what moves a mid-size Midwest market above the $8B cluster.",
    "unverifiedAsOf": {
      "stadium.namingRightsDeal": "May 2026"
    }
  },
  "green-bay-packers": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 6.65,
        "new": 8.6,
        "fact": "Forbes NFL list September 2026: $8.6B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 3,
        "new": 4,
        "fact": "Playoff seasons 2021-2025: 2021, 2023, 2024, 2025",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_NFL_playoffs"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      },
      {
        "field": "revenue.estimate",
        "old": 654,
        "new": 753,
        "fact": "Packers FY2026 report (April 2025-March 2026): $753M total revenue, up 4.7%; $453.2M national share; $299.8M local",
        "source": "https://fox11online.com/sports/packers-and-nfl/green-bay-financial-report-fiscal-year-2026-total-revenue-operating-income-network-sale-broadcasting-act-president-ceo-ed-policy"
      },
      {
        "field": "revenue.year",
        "old": 2023,
        "new": 2026,
        "fact": "Fiscal year ended March 2026",
        "source": "https://fox11online.com/sports/packers-and-nfl/green-bay-financial-report-fiscal-year-2026-total-revenue-operating-income-network-sale-broadcasting-act-president-ceo-ed-policy"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 60,
        "new": -1.1,
        "fact": "Packers reported a $1.1M operating loss for FY2026 (Forbes Sept 2026 estimates $73M); total profit $132.5M",
        "source": "https://fox11online.com/sports/packers-and-nfl/green-bay-financial-report-fiscal-year-2026-total-revenue-operating-income-network-sale-broadcasting-act-president-ceo-ed-policy"
      }
    ],
    "analystNotes": "Green Bay's FY2026 report (year to March 2026) shows $753M of revenue, $453.2M of it the national share, and a $1.1M operating loss, while Forbes' September 2026 list carries the team at $8.6B. That gap between accounting profit and asset value is the NFL in one line: the shares are worthless paper, the franchise cannot be sold, and it is still priced off comparable transactions. Four playoff trips in five years with Jordan Love at $55M AAV through 2028 keep the sport component at $5.4B, the lowest in the league because Forbes discounts the non-transferable structure. Nothing here moves on a sale; it moves only as the league's national contracts step up.",
    "unverifiedAsOf": {}
  },
  "minnesota-vikings": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 5.3,
        "new": 8.25,
        "fact": "Forbes NFL list September 2026: $8.25B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 569,
        "new": 640,
        "fact": "Forbes Sept 2026 revenue $640M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2023,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 70,
        "new": 25,
        "fact": "Forbes Sept 2026 operating income $25M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      },
      {
        "field": "onField.currentFranchiseQB",
        "old": "J.J. McCarthy — 4yr/$21.85M fully guaranteed rookie contract (2024 #10 overall pick), ~$5.46M AAV; missed 2024 season with knee injury, expected starter 2025",
        "new": "Kyler Murray, signed a 1yr league-minimum ($1.3M) deal in March 2026 after Arizona released him (Arizona still pays his $36.8M 2026 guarantee); no-tag clause for 2027; named 2026 starter over J.J. McCarthy in August",
        "fact": "Vikings signed Murray for the minimum; O'Connell named him starter in camp",
        "source": "https://www.nfl.com/news/vikings-sign-kyler-murray-one-year-deal-release-cardinals"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "J.J. McCarthy",
            "position": "QB",
            "aav": 5.46,
            "contractNote": "4yr/$21.85M rookie deal (2024), fully guaranteed, 5th-year option; missed 2024 with knee injury"
          }
        ],
        "new": [
          {
            "player": "Kyler Murray",
            "position": "QB",
            "aav": 1.3,
            "contractNote": "1yr/$1.3M (March 2026), no-tag clause, free agent in 2027; Arizona pays $36.8M of 2026 guarantees"
          },
          {
            "player": "J.J. McCarthy",
            "position": "QB",
            "aav": 5.46,
            "contractNote": "4yr/$21.85M rookie deal (2024), fully guaranteed; lost the starting job to Murray Aug 2026; Vikings denied all trade calls"
          }
        ],
        "fact": "McCarthy demoted to QB2 Aug 2026",
        "source": "https://www.espn.com/nfl/story/_/id/49594059/jj-mccarthy-says-vikings-qb-decision-control-wants-remain-minnesota"
      },
      {
        "field": "media.streamingNotes",
        "old": "Standard NFL package",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source found)",
        "source": null
      }
    ],
    "analystNotes": "Minnesota is an $8.25B franchise on Forbes' September 2026 list with $640M of revenue and only $25M of operating income, the lowest in the league, and the quarterback plan has been rewritten twice in eighteen months. Kyler Murray, cut by Arizona in March 2026 with his $36.8M guarantee still on Arizona's books, signed for the $1.3M minimum and beat out J.J. McCarthy for the 2026 job, which means the 2024 first-round pick is now a backup on a guaranteed deal the Vikings refused to trade. U.S. Bank Stadium's indoor economics and the $8.8M-per-year naming deal through 2040 are the durable part. The 2027 quarterback decision, with Murray on a no-tag clause, is the swing factor.",
    "unverifiedAsOf": {}
  },
  "atlanta-falcons": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 5.9,
        "new": 10.1,
        "fact": "Forbes NFL list September 2026: $10.1B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 585,
        "new": 805,
        "fact": "Forbes Sept 2026 revenue $805M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2023,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 94,
        "new": 240,
        "fact": "Forbes Sept 2026 operating income $240M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 1,
        "new": 0,
        "fact": "Playoff seasons 2021-2025: none",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_NFL_playoffs"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      },
      {
        "field": "ownership.institutionalInvestors",
        "old": null,
        "new": "Arctos Partners agreed in Aug 2026 to buy 10% at a blended $10.6B valuation (reported first tranche of 7.5% at just over $10B, remaining 2.5% ~18 months later at ~$11B); NFL vote expected Oct 2026; would be Arctos' fourth NFL stake",
        "fact": "Announced Aug 20, 2026; pending league approval",
        "source": "data/transactions.js (verified 2025-2026 NFL transactions)"
      },
      {
        "field": "onField.currentFranchiseQB",
        "old": "Kirk Cousins",
        "new": "Michael Penix Jr., 2024 No. 8 pick on his rookie deal, returned from a partially torn ACL to start in Week 3 of 2026; Tua Tagovailoa (1yr/$1.215M, signed March 2026 after Miami released him) was the planned Week 1 starter; Kirk Cousins left for the Raiders in April 2026 with Atlanta still paying $8.7M of his 2026 salary",
        "fact": "Penix named starter for Week 3 2026; Cousins gone; Tua on a minimum deal",
        "source": "https://www.atlantafalcons.com/news/michael-penix-jr-starting-qb-thursday-night-football-vs-packers"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Kirk Cousins",
            "position": "QB",
            "aav": 45,
            "contractNote": "4yr/$180M signed 2024; $100M guaranteed"
          }
        ],
        "new": [
          {
            "player": "Michael Penix Jr.",
            "position": "QB",
            "aav": null,
            "contractNote": "2024 first-round rookie deal (No. 8 overall); starter from Week 3 2026 after ACL recovery"
          },
          {
            "player": "Tua Tagovailoa",
            "position": "QB",
            "aav": 1.215,
            "contractNote": "1yr/$1.215M (March 2026)"
          }
        ],
        "fact": "Cousins signed with Las Vegas April 2026",
        "source": "https://www.nfl.com/news/former-falcons-qb-kirk-cousins-signing-with-raiders"
      }
    ],
    "analystNotes": "Atlanta is the NFL's best example of stadium economics outrunning football: $10.1B on Forbes' September 2026 list with a $2.6B stadium component, $805M of revenue and $240M of operating income, second only to Dallas, from a Mercedes-Benz Stadium that leads the league in non-football event gross. Arctos agreed in August 2026 to pay a blended $10.6B mark for 10%, pending an October league vote, which is above Forbes on a team that has not made the playoffs since 2017. The quarterback room is Michael Penix Jr. back from an ACL tear since Week 3 2026 with Tua Tagovailoa on a minimum deal behind him, and Kirk Cousins gone to Las Vegas. A playoff appearance would add sport value to a franchise priced entirely on its building.",
    "unverifiedAsOf": {}
  },
  "carolina-panthers": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 5.13,
        "new": 8.1,
        "fact": "Forbes NFL list September 2026: $8.1B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 574,
        "new": 646,
        "fact": "Forbes Sept 2026 revenue $646M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2023,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 72,
        "new": 88,
        "fact": "Forbes Sept 2026 operating income $88M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 0,
        "new": 1,
        "fact": "Playoff seasons 2021-2025: 2025",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_NFL_playoffs"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      },
      {
        "field": "onField.currentFranchiseQB",
        "old": "Bryce Young",
        "new": "Bryce Young, final year of 4yr/$37.96M rookie deal in 2026; fifth-year option exercised for 2027; no 2026 extension expected, with Carolina waiting until the 2027 offseason",
        "fact": "Panthers waiting until 2027 on a Young extension",
        "source": "https://www.profootballrumors.com/2026/08/no-2026-extension-expected-between-panthers-qb-bryce-young"
      }
    ],
    "analystNotes": "Carolina won the NFC South at 8-9 in 2025 for its first playoff trip since 2017, and Forbes lists the Panthers at $8.1B in September 2026 on $646M of revenue, 3.6x David Tepper's $2.275B entry in 2018. The $800M Bank of America Stadium renovation, 81% publicly funded, is being phased in through 2029, and Charlotte FC shares the building, which keeps the stadium component at $884M with room to grow. Bryce Young plays out his rookie deal in 2026 with the fifth-year option already picked up and no extension until 2027. Whether Young earns a $50M-plus deal or Carolina goes back to the draft decides the next three years of cost.",
    "unverifiedAsOf": {
      "stadium.newStadiumPlans": "May 2026"
    }
  },
  "new-orleans-saints": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 4.4,
        "new": 8.02,
        "fact": "Forbes NFL list September 2026: $8.02B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 587,
        "new": 642,
        "fact": "Forbes Sept 2026 revenue $642M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2023,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 115,
        "new": 165,
        "fact": "Forbes Sept 2026 operating income $165M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 1,
        "new": 0,
        "fact": "Playoff seasons 2021-2025: none",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_NFL_playoffs"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      },
      {
        "field": "onField.currentFranchiseQB",
        "old": "Derek Carr",
        "new": "Tyler Shough, 2025 second-round pick, went 5-4 in nine starts as a rookie and enters 2026 as the unquestioned starter and a team captain; Derek Carr retired in May 2025",
        "fact": "Saints committed to Shough as 2026 starter",
        "source": "https://www.espn.com/nfl/story/_/id/47541318/saints-committed-tyler-shough-starting-qb-2026"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Derek Carr",
            "position": "QB",
            "aav": 37.5,
            "contractNote": "4yr/$150M signed 2023; Carr retired in 2024; large dead cap remains on books"
          }
        ],
        "new": [
          {
            "player": "Tyler Shough",
            "position": "QB",
            "aav": null,
            "contractNote": "2025 second-round rookie deal; 2026 starter and captain"
          }
        ],
        "fact": "Replaces Carr entry (Carr retired May 2025, not 2024)",
        "source": "https://www.espn.com/nfl/story/_/id/47541318/saints-committed-tyler-shough-starting-qb-2026"
      }
    ],
    "analystNotes": "New Orleans is $8.02B on Forbes' September 2026 list, 31st, but it runs one of the better margins in the league at $165M of operating income on $642M of revenue because the Caesars Superdome renovation was paid by the state and the naming rights, not the team. The football side has been reset for free: Derek Carr retired in May 2025, and Tyler Shough, a 2025 second-round pick, went 5-4 as a rookie and owns the 2026 job on a rookie contract. Five straight years without a playoff game and no arm's-length sale since 1985 leave the Forbes number untested by any transaction. A Shough breakout is the cheapest path to a higher sport component in the league.",
    "unverifiedAsOf": {}
  },
  "tampa-bay-buccaneers": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 5.5,
        "new": 9.1,
        "fact": "Forbes NFL list September 2026: $9.1B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 629,
        "new": 657,
        "fact": "Forbes Sept 2026 revenue $657M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2024,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 130,
        "new": 95,
        "fact": "Forbes Sept 2026 operating income $95M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 3,
        "new": 4,
        "fact": "Playoff seasons 2021-2025: 2021, 2022, 2023, 2024",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_NFL_playoffs"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "$1B+ modernization project underway as of 2026",
        "new": "Bucs seeking roughly $1B in Raymond James Stadium upgrades including a sunshade, offering to fund about one-third with two-thirds public; tied to a lease-extension decision due January 2027; talks with the Tampa Sports Authority began spring 2026",
        "fact": "$1B upgrade ask; lease decision Jan 2027",
        "source": "https://www.fox13news.com/news/tampa-bay-buccaneers-raymond-james-stadium-upgrades-2027-lease-decision"
      },
      {
        "field": "onField.currentFranchiseQB",
        "old": "Baker Mayfield",
        "new": "Baker Mayfield, 3yr/$165M extension signed Sept 8, 2026, $55M AAV, runs through 2029",
        "fact": "Extension agreed five days before the 2026 opener",
        "source": "https://www.nfl.com/news/nfl-network-buccaneers-qb-baker-mayfield-agree-to-three-year-contract-extension"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Baker Mayfield",
            "position": "QB",
            "aav": 33.3,
            "contractNote": "3yr/$100M signed 2024; $50M guaranteed"
          }
        ],
        "new": [
          {
            "player": "Baker Mayfield",
            "position": "QB",
            "aav": 55,
            "contractNote": "3yr/$165M extension (Sept 2026), runs through 2029; replaces the 3yr/$100M deal signed 2024"
          }
        ],
        "fact": "Mayfield 3yr/$165M Sept 2026",
        "source": "https://www.nfl.com/news/nfl-network-buccaneers-qb-baker-mayfield-agree-to-three-year-contract-extension"
      }
    ],
    "analystNotes": "Tampa Bay is $9.1B on Forbes' September 2026 list, 47x the Glazers' 1995 expansion fee, and the September 8, 2026 extension for Baker Mayfield, three years and $165M at $55M per year, ends the discount the team carried as a bridge-quarterback franchise. The building is the open item: the Bucs want roughly $1B of Raymond James Stadium upgrades with two-thirds public money and must decide on a lease extension by January 2027, while the Raymond James naming deal runs out after 2027. Four straight playoff trips ended in 2025 when the Panthers took the division. A signed renovation and a renewed naming deal are the two events that lift a stadium component stuck at $1.0B.",
    "unverifiedAsOf": {
      "stadium.namingRightsDeal": "May 2026"
    }
  },
  "arizona-cardinals": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 4.3,
        "new": 8.06,
        "fact": "Forbes NFL list September 2026: $8.06B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 546,
        "new": 600,
        "fact": "Forbes Sept 2026 revenue $600M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2023,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 112,
        "new": 119,
        "fact": "Forbes Sept 2026 operating income $119M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      },
      {
        "field": "onField.currentFranchiseQB",
        "old": "Kyler Murray",
        "new": "Jacoby Brissett, year two of a 2yr/$12.5M deal, Week 1 2026 starter and team captain after a 3,366-yard 2025 fill-in season; Kyler Murray released March 2026 with a post-June 1 designation (~$47.5M dead cap in 2026, $7.2M in 2027); rookie Carson Beck (3rd round, 2026) behind him",
        "fact": "Cardinals released Murray March 2026; Brissett starts 2026",
        "source": "https://www.azcardinals.com/news/cardinals-officially-release-kyler-murray-after-7-seasons"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Kyler Murray",
            "position": "QB",
            "aav": 46.1,
            "contractNote": "5yr/$230.5M extension through 2028 signed 2022; $160M guaranteed; Murray missed 2022 due to ACL injury"
          }
        ],
        "new": [
          {
            "player": "Jacoby Brissett",
            "position": "QB",
            "aav": 6.25,
            "contractNote": "2yr/$12.5M (2025), runs through 2026; 2026 starter"
          }
        ],
        "fact": "Murray removed; ~$55M of dead cap split over 2026-27",
        "source": "https://www.azcardinals.com/news/cardinals-roster-reset-quarterback"
      }
    ],
    "analystNotes": "Arizona is $8.06B on Forbes' September 2026 list, 28th, and the Bidwills just ended the Kyler Murray era by releasing him in March 2026 and absorbing about $55M of dead cap across two years with no trade market for the contract. Jacoby Brissett, who threw for 3,366 yards as the 2025 fill-in on a $6.25M AAV deal, starts a 2026 season that follows a 3-14 finish. State Farm Stadium keeps operating income at a healthy $119M through Super Bowls and neutral-site events, and Phoenix remains one of the fastest growing large metros. The next franchise quarterback, likely from a high 2027 pick, is the only thing that changes the trajectory.",
    "unverifiedAsOf": {
      "stadium.namingRightsDeal": "May 2026"
    }
  },
  "los-angeles-rams": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 7.6,
        "new": 13.5,
        "fact": "Forbes NFL list September 2026: $13.5B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 756,
        "new": 898,
        "fact": "Forbes Sept 2026 revenue $898M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2023,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 125,
        "new": 335,
        "fact": "Forbes Sept 2026 operating income $335M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 2,
        "new": 4,
        "fact": "Playoff seasons 2021-2025: 2021, 2023, 2024, 2025",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_NFL_playoffs"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      },
      {
        "field": "onField.currentFranchiseQB",
        "old": "Matthew Stafford",
        "new": "Matthew Stafford, 2025 NFL MVP (league-leading 4,707 yards and 46 TD); signed a 1yr/$55M extension (up to $60M with incentives) in April 2026 tying him to the Rams through 2027 with $105M remaining",
        "fact": "Stafford extension April 2026",
        "source": "https://www.nfl.com/news/report-rams-qb-matthew-stafford-agree-to-one-year-55-million-contract-extension"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Matthew Stafford",
            "position": "QB",
            "aav": 42,
            "contractNote": "2yr/$84M extension (2023); $80M guaranteed; extension talks progressing as of April 2026"
          }
        ],
        "new": [
          {
            "player": "Matthew Stafford",
            "position": "QB",
            "aav": 55,
            "contractNote": "1yr/$55M extension (April 2026), up to $60M; signed through 2027 with $105M remaining"
          }
        ],
        "fact": "Replaces 2023 deal note",
        "source": "https://www.therams.com/news/matthew-stafford-signs-contract-extension-2026"
      },
      {
        "field": "media.streamingNotes",
        "old": "",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source found)",
        "source": null
      }
    ],
    "analystNotes": "The Rams are $13.5B on Forbes' September 2026 list, third in the league, with a $3.6B stadium component, $898M of revenue and $335M of operating income, because Stan Kroenke owns SoFi Stadium outright and keeps the Chargers' share of it. Matthew Stafford won the 2025 MVP at 37 with 46 touchdowns, took Los Angeles to the NFC title game, and signed a one-year $55M extension in April 2026 that runs through 2027. Kroenke's $750M consolidation in 2010 is now an 18x return, the best in the league over that span. Stafford's succession, not the building, is the only real risk to the number.",
    "unverifiedAsOf": {}
  },
  "san-francisco-49ers": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 6.86,
        "new": 10.5,
        "fact": "Forbes NFL list September 2026: $10.5B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 723,
        "new": 752,
        "fact": "Forbes Sept 2026 revenue $752M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2023,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 115,
        "new": 126,
        "fact": "Forbes Sept 2026 operating income $126M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      },
      {
        "field": "ownership.institutionalInvestors",
        "old": null,
        "new": "Two 2025 LP sales at an $8.6B valuation: the Khosla, Deeter and Griffith families bought 6.2% for $533M (approved May 20, 2025, then an NFL minority record) and Pete Briger Jr. (Fortress) bought 3.2% for ~$275M (approved Oct 22, 2025); Yorks retain ~87.8%",
        "fact": "Two 2025 minority sales at $8.6B",
        "source": "data/transactions.js (verified 2025-2026 NFL transactions)"
      }
    ],
    "analystNotes": "San Francisco is $10.5B on Forbes' September 2026 list, and two 2025 LP sales at $8.6B, 6.2% to the Khosla, Deeter and Griffith families in May and 3.2% to Pete Briger in October, put real money about 18% below that mark with the Yorks still holding 87.8%. Levi's Stadium hosted Super Bowl LX in February 2026 and the naming deal runs at $17M per year through 2043, which underpins $752M of revenue and Silicon Valley's suite demand. Brock Purdy's $53M AAV runs through 2029 and the team went 12-5 in 2025 before a 41-6 divisional loss in Seattle. Four playoff trips in five years keep the sport component at $6.6B; a title is what pushes the Yorks' 1977 entry past a 1,000x return.",
    "unverifiedAsOf": {
      "stadium.namingRightsDeal": "May 2026"
    }
  },
  "seattle-seahawks": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.currentValuation",
        "old": 5.59,
        "new": 9.6,
        "fact": "Forbes NFL list September 2026: $9.6B",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.estimate",
        "old": 624,
        "new": 659,
        "fact": "Forbes Sept 2026 revenue $659M (2025 season)",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.year",
        "old": 2024,
        "new": 2025,
        "fact": "Forbes Sept 2026 list reports 2025-season revenue",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "revenue.operatingIncome",
        "old": 104,
        "new": 130,
        "fact": "Forbes Sept 2026 operating income $130M",
        "source": "data/forbes-breakdown.js (Forbes NFL valuations, September 2026)"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 1,
        "new": 2,
        "fact": "Playoff seasons 2021-2025: 2022, 2025",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_NFL_playoffs"
      },
      {
        "field": "onField.championshipsLast10Years",
        "old": 0,
        "new": 1,
        "fact": "Super Bowl wins for seasons 2016-2025: 1",
        "source": "https://www.espn.com/nfl/game/_/gameId/401772988/seahawks-patriots"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$340M/year from NFL national deal (2023-2033)",
        "new": "~$453M/year national revenue per team (Packers FY2026 report: $14.5B shared league-wide, $453.2M to Green Bay)",
        "fact": "Packers FY2026 annual report (year to March 2026) puts the per-team national share at $453.2M",
        "source": "https://www.nbcsports.com/nfl/profootballtalk/rumor-mill/news/packers-annual-report-reveals-14-5-billion-in-shared-nfl-revenue"
      },
      {
        "field": "ownership.primaryOwner",
        "old": "Jody Allen (trustee of Paul Allen estate)",
        "new": "Khosla family (Neeru Khosla, controlling owner; Vinod Khosla, chair; Neal Khosla, vice chair)",
        "fact": "NFL owners unanimously approved the sale to the Khosla family Aug 26, 2026",
        "source": "https://www.seahawks.com/news/nfl-owners-approve-sale-of-seahawks-to-khosla-family"
      },
      {
        "field": "ownership.ownerBackground",
        "old": "Paul Allen (Microsoft co-founder) purchased team in 1997 for $200M; died October 2018; sister Jody Allen serves as trustee of Vulcan Inc. estate; sale process announced",
        "new": "Vinod Khosla co-founded Sun Microsystems and Khosla Ventures; the family bought the team from the Paul G. Allen estate in 2026 with co-investors including Mark Stevens, Penny Pritzker, Carlyle, Dynasty Equity and Sixth Street; Allen's will required the estate to sell and route proceeds to philanthropy, and the sale launched Feb 18, 2026, ten days after Super Bowl LX",
        "fact": "Estate sale process Feb-Aug 2026",
        "source": "data/transactions.js (verified 2025-2026 NFL transactions)"
      },
      {
        "field": "ownership.acquisitionYear",
        "old": 1997,
        "new": 2026,
        "fact": "Sale approved Aug 26, 2026",
        "source": "data/transactions.js (verified 2025-2026 NFL transactions)"
      },
      {
        "field": "ownership.acquisitionPrice",
        "old": 0.2,
        "new": 9.612,
        "fact": "$9.612B enterprise value, record for an NFL control sale",
        "source": "data/transactions.js (verified 2025-2026 NFL transactions)"
      },
      {
        "field": "ownership.impliedReturn",
        "old": "~28x since 1997 (~12% CAGR); proceeds to philanthropy per estate plan",
        "new": "Purchased Aug 2026 at $9.612B, 13.6x 2025 revenue of $707M and a 43% premium to Forbes' 2025 mark of $6.7B",
        "fact": "From transactions.js",
        "source": "data/transactions.js (verified 2025-2026 NFL transactions)"
      },
      {
        "field": "ownership.ownershipGroup",
        "old": [
          {
            "name": "Jody Allen (Paul Allen Estate / Vulcan Inc.)",
            "role": "trustee/majority",
            "pct": null
          }
        ],
        "new": [
          {
            "name": "Neeru Khosla",
            "role": "controlling owner",
            "pct": null
          },
          {
            "name": "Vinod Khosla",
            "role": "chair",
            "pct": null
          },
          {
            "name": "Neal Khosla",
            "role": "vice chair",
            "pct": null
          },
          {
            "name": "Mark Stevens",
            "role": "limited partner",
            "pct": null
          },
          {
            "name": "Penny Pritzker",
            "role": "limited partner",
            "pct": null
          },
          {
            "name": "Sixth Street",
            "role": "limited partner",
            "pct": 3
          },
          {
            "name": "Carlyle and Dynasty Equity",
            "role": "limited partners (combined)",
            "pct": 3
          }
        ],
        "fact": "Ownership group per the 2026 sale",
        "source": "data/transactions.js (verified 2025-2026 NFL transactions)"
      },
      {
        "field": "ownership.institutionalInvestors",
        "old": null,
        "new": "Sixth Street 3%; Carlyle and Dynasty Equity a combined 3%, all part of the 2026 Khosla purchase",
        "fact": "PE co-investors in the control sale",
        "source": "https://www.sportico.com/business/team-sales/2026/seattle-seahawks-sale-nfl-owners-approve-1234942967/"
      },
      {
        "field": "onField.currentFranchiseQB",
        "old": "Sam Darnold",
        "new": "Sam Darnold, 3yr/$100.5M (2025), earned all $4M of 2025 incentives; $27.5M in 2026 with nothing guaranteed beyond 2026; Super Bowl LX champion; extension talk deferred to spring 2027",
        "fact": "No extension before the 2026 season",
        "source": "https://heavy.com/sports/nfl/seattle-seahawks/sam-darnold-contract-decision-extension/"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Sam Darnold",
            "position": "QB",
            "aav": 33.5,
            "contractNote": "3yr/$100.5M signed 2025; $55M guaranteed; signed after Geno Smith trade to Las Vegas Raiders"
          }
        ],
        "new": [
          {
            "player": "Sam Darnold",
            "position": "QB",
            "aav": 33.5,
            "contractNote": "3yr/$100.5M (2025), $55M guaranteed at signing, no guarantees past 2026; won Super Bowl LX; runs through 2027"
          }
        ],
        "fact": "Contract status Sept 2026",
        "source": "https://www.spotrac.com/nfl/player/_/id/25098/sam-darnold"
      }
    ],
    "analystNotes": "Seattle won Super Bowl LX on February 8, 2026, then sold for $9.612B to the Khosla family in a deal approved August 26, 2026, the highest price ever paid for an NFL control stake and 13.6x 2025 revenue of $707M. Forbes' September 2026 list sits at $9.6B, so the auction, driven by a forced estate sale ten days after the title, set the mark. Sam Darnold delivered the championship on a $33.5M AAV deal with nothing guaranteed past 2026, and Lumen Field's Sounders tenancy and World Cup matches fill the calendar. Darnold's next contract and the Khoslas' plans for the 2002 building are the two open questions on a franchise that just got fully repriced.",
    "unverifiedAsOf": {
      "ownership.ownerNetWorth": "May 2026"
    }
  },
  "boston-celtics": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.acquisitionYear",
        "old": 2024,
        "new": 2025,
        "fact": "Chisholm group sale agreed March 20, 2025 (51% control at $6.1B) per transactions.js; 2024 was the announcement of intent to sell",
        "source": "data/transactions.js"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Jayson Tatum",
            "position": "SF/PF",
            "aav": 63,
            "contractNote": "5yr/$315M supermax (Oct 2023), through 2029-30"
          },
          {
            "player": "Jaylen Brown",
            "position": "SG/SF",
            "aav": 60.8,
            "contractNote": "5yr/$304M supermax (Aug 2023), through 2028-29"
          }
        ],
        "new": [
          {
            "player": "Jayson Tatum",
            "position": "SF/PF",
            "aav": 63,
            "contractNote": "5yr/$315M supermax (Oct 2023), through 2029-30; $58.5M in 2026-27 rising to $71.4M in 2029-30"
          },
          {
            "player": "Paul George",
            "position": "SF",
            "aav": 53,
            "contractNote": "Acquired from Philadelphia July 6, 2026 for Jaylen Brown plus 2028 and 2031 (PHI) first-round picks; $54.1M in 2026-27, $56.6M in 2027-28 (through 2027-28)"
          }
        ],
        "fact": "Jaylen Brown was traded to the 76ers on July 6, 2026 for Paul George and picks; George is on the books at $54.1M/$56.6M",
        "source": "https://en.wikipedia.org/wiki/List_of_2026%E2%80%9327_NBA_season_transactions ; https://www.basketball-reference.com/contracts/BOS.html"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Jayson Tatum — 5yr/$315M supermax extension signed Oct 2023, $63M AAV, runs through 2029-30",
        "new": "Jayson Tatum, 5yr/$315M supermax (Oct 2023), $63M AAV, through 2029-30; Jaylen Brown traded to Philadelphia July 2026 for Paul George",
        "fact": "Brown-for-George swap July 6, 2026",
        "source": "https://www.nba.com/news/nba-offseason-deals-2026"
      }
    ],
    "analystNotes": "Forbes put the Celtics at $6.7B in October 2025 on $458M of revenue, and the March 2025 Chisholm purchase at $6.1B for control remains the cleanest arm's-length comp for a top-tier market that is not New York or Los Angeles. Boston lost in the first round to Philadelphia in seven games in 2026, then swapped Jaylen Brown for Paul George and two first-round picks, cutting the long-dated supermax load while keeping Tatum's deal that climbs to $71.4M by 2029-30. The 2026 season also brought Joe Mazzulla Coach of the Year honors on a roster that still sits at $204M for 2026-27. Whether George's two remaining years plus the recovered picks convert into another Finals run around Tatum is what moves the number from here.",
    "unverifiedAsOf": {
      "arena.namingRightsDeal": "May 2026"
    }
  },
  "brooklyn-nets": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Cam Thomas — emerging franchise player; contract extension expected",
        "new": "Julius Randle, acquired from Minnesota in the July 10, 2026 four-team LaMelo Ball trade; $33.3M in 2026-27, $35.8M in 2027-28",
        "fact": "Randle arrived with the draft rights to No. 28 pick Joshua Jefferson; he is the highest-paid Net for 2026-27",
        "source": "https://en.wikipedia.org/wiki/List_of_2026%E2%80%9327_NBA_season_transactions ; https://www.basketball-reference.com/contracts/BRK.html"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Cam Thomas",
            "position": "SG",
            "aav": 33,
            "contractNote": "Extension expected; primary franchise asset in rebuild"
          }
        ],
        "new": [
          {
            "player": "Julius Randle",
            "position": "PF",
            "aav": 34.6,
            "contractNote": "Acquired from Minnesota July 10, 2026; $33.3M (2026-27) and $35.8M (2027-28)"
          }
        ],
        "fact": "Randle is the only Net above $16M for 2026-27; Nic Claxton was sent to Chicago in the same trade",
        "source": "https://www.basketball-reference.com/contracts/BRK.html"
      }
    ],
    "analystNotes": "Forbes valued the Nets at $5.6B in October 2025 on $402M of revenue, and the number is really a Barclays Center and BSE Global story: the 2024 Koch purchase of 15% at a $6B BSE valuation still prices the bundle above the team-only figure. Brooklyn has not made the playoffs since 2023, and the July 2026 four-team trade that brought Julius Randle at $33.3M while sending Nic Claxton to Chicago is a reset around draft capital rather than a contention move. The arena runs 320-plus events a year, so the franchise value floor is the building and the New York market. A credible young core turning the lottery picks into a playoff team is what would move Brooklyn toward the Knicks-style market premium.",
    "unverifiedAsOf": {}
  },
  "new-york-knicks": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.championshipsLast10Years",
        "old": 0,
        "new": 1,
        "fact": "Knicks beat the Spurs 4-1 in the 2026 NBA Finals (June 3-13, 2026), their third title and first since 1973; Jalen Brunson Finals MVP at 32.6 ppg",
        "source": "https://www.basketball-reference.com/playoffs/2026-nba-finals-knicks-vs-spurs.html"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 3,
        "new": 4,
        "fact": "Playoffs in 2023, 2024, 2025 and 2026 (window 2022-2026); swept Cleveland in the 2026 East finals and Philadelphia in the second round",
        "source": "https://www.basketball-reference.com/playoffs/NBA_2026.html"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Jalen Brunson — 4yr/$156.5M extension signed July 2023, $39.1M AAV, runs through 2026-27",
        "new": "Jalen Brunson, 2026 Finals MVP; $37.7M in 2026-27 rising to $43.3M in 2028-29",
        "fact": "Brunson is under contract through 2028-29 per Basketball-Reference ($37.7M, $40.5M, $43.3M)",
        "source": "https://www.basketball-reference.com/contracts/NYK.html"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Jalen Brunson",
            "position": "PG",
            "aav": 39.1,
            "contractNote": "4yr/$156.5M extension (July 2023), through 2026-27"
          },
          {
            "player": "Karl-Anthony Towns",
            "position": "C",
            "aav": 49.1,
            "contractNote": "3yr/$147.5M signed 2024 after trade from Timberwolves; through 2026-27"
          },
          {
            "player": "OG Anunoby",
            "position": "SF",
            "aav": 36,
            "contractNote": "5yr extension signed 2024; key defensive anchor"
          }
        ],
        "new": [
          {
            "player": "Jalen Brunson",
            "position": "PG",
            "aav": 40.5,
            "contractNote": "2026 Finals MVP; $37.7M (2026-27), $40.5M (2027-28), $43.3M (2028-29)"
          },
          {
            "player": "Karl-Anthony Towns",
            "position": "C",
            "aav": 59,
            "contractNote": "$57.1M (2026-27), $61.0M (2027-28); through 2027-28"
          },
          {
            "player": "OG Anunoby",
            "position": "SF",
            "aav": 45.4,
            "contractNote": "$42.5M (2026-27) rising to $48.4M (2028-29)"
          },
          {
            "player": "Mikal Bridges",
            "position": "SF",
            "aav": 37.5,
            "contractNote": "$33.5M (2026-27) rising to $41.5M (2029-30)"
          }
        ],
        "fact": "Salary figures per Basketball-Reference contracts table; Knicks 2026-27 payroll $230.2M",
        "source": "https://www.basketball-reference.com/contracts/NYK.html"
      },
      {
        "field": "media.localTVDeal",
        "old": "MSG Network (owned by MSG Sports Corp — same entity as the Knicks; vertically integrated); most valuable local NBA TV deal",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (MSG Network still carries the team per Wikipedia 2026-27 season page, but no 2026 rights-fee update found)",
        "source": null
      }
    ],
    "analystNotes": "Forbes ranked the Knicks second in the NBA at $9.75B in October 2025 on $532M of revenue, and that was before the 2026 championship, the franchise's first since 1973, which removes the one argument that always capped the number: no titles. Jalen Brunson's Finals MVP run at 32.6 points a game came on a $37.7M salary that rises only to $43.3M by 2028-29, the most efficient star contract in the league relative to output. The payroll is $230M for 2026-27 with Towns at $57.1M and Anunoby at $42.5M, so the tax bill is real but MSG Network and the Garden absorb it. A repeat, or even a second Finals, would push New York past the Warriors' $11B as the most valuable NBA franchise.",
    "unverifiedAsOf": {}
  },
  "philadelphia-76ers": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "arena.newArenaPlans",
        "old": "Original '76 Place at Market East' arena plan (Center City) abandoned January 2025; new plan is a 50/50 joint venture with Comcast Spectacor to build a new South Philly arena housing both 76ers and Flyers, estimated $1.5B+; would be adjacent to existing stadium complex",
        "new": "New South Philadelphia Arena: 50/50 HBSE and Comcast Spectacor joint venture on the former Spectrum site at Broad and Pattison, fully privately funded (billed as the largest privately funded project in city history); site announced April 2026, first renderings September 8, 2026; construction to start in the first half of 2027 pending regulatory and legislative approval; opening targeted for 2030 for the 76ers, Flyers and Philadelphia's 2030 WNBA expansion team",
        "fact": "Site and renderings released 2026; 2030 opening target; WNBA expansion team joins as third tenant",
        "source": "https://www.inquirer.com/news/philadelphia/sixers-new-arena-philly-flyers-renderings-date-20260908.html ; https://en.wikipedia.org/wiki/New_South_Philadelphia_Arena"
      },
      {
        "field": "arena.name",
        "old": "Wells Fargo Center",
        "new": "Xfinity Mobile Arena",
        "fact": "Arena renamed Xfinity Mobile Arena (already reflected in forbes-proxies.js venue field); 76ers' 2026-27 home per Wikipedia season page",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_Philadelphia_76ers_season"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 3,
        "new": 4,
        "fact": "Playoffs in 2022, 2023, 2024 and 2026; beat Boston 4-3 in the 2026 first round, swept by New York in round two",
        "source": "https://www.basketball-reference.com/playoffs/NBA_2026.html"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Joel Embiid — max extension signed 2024, $64.3M AAV, through 2028-29",
        "new": "Joel Embiid ($58.1M in 2026-27, through 2028-29) and Jaylen Brown, acquired from Boston July 6, 2026 for Paul George and two first-round picks ($57.1M in 2026-27, through 2028-29); LeBron James signed a 2yr/$8M deal July 27, 2026",
        "fact": "Brown-for-George trade and LeBron's two-year, $8M signing with a player option",
        "source": "https://en.wikipedia.org/wiki/List_of_2026%E2%80%9327_NBA_season_transactions ; https://www.espn.com/nba/story/_/id/48957095/2026-nba-free-agency-grades-offseason-signings-deals-contracts-extensions-depth-charts"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Joel Embiid",
            "position": "C",
            "aav": 64.3,
            "contractNote": "3yr/$192.9M max extension (2024), through 2028-29; highest AAV in NBA at signing"
          },
          {
            "player": "Tyrese Maxey",
            "position": "PG",
            "aav": 40.8,
            "contractNote": "5yr/$204M max extension (2024), through 2028-29"
          },
          {
            "player": "Paul George",
            "position": "SF",
            "aav": 53,
            "contractNote": "4yr/$212M signed 2024 (free agent from Clippers), through 2027-28"
          }
        ],
        "new": [
          {
            "player": "Joel Embiid",
            "position": "C",
            "aav": 62.7,
            "contractNote": "$58.1M (2026-27), $62.7M (2027-28), $67.4M (2028-29)"
          },
          {
            "player": "Jaylen Brown",
            "position": "SG/SF",
            "aav": 61,
            "contractNote": "Acquired from Boston July 6, 2026; $57.1M (2026-27), $61.0M (2027-28), $65.0M (2028-29)"
          },
          {
            "player": "Tyrese Maxey",
            "position": "PG",
            "aav": 43.6,
            "contractNote": "$40.8M (2026-27) rising to $46.4M (2028-29)"
          },
          {
            "player": "LeBron James",
            "position": "SF",
            "aav": 4,
            "contractNote": "2yr/$8M signed July 27, 2026 with a player option; $3.9M in 2026-27"
          }
        ],
        "fact": "Paul George traded to Boston; Brown and LeBron added; figures per Basketball-Reference",
        "source": "https://www.basketball-reference.com/contracts/PHI.html"
      }
    ],
    "analystNotes": "Forbes valued the 76ers at $5.45B in October 2025 on $472M of revenue and a $203M operating profit, the best margin in the East outside New York, and the 2026 offseason turned a tenant franchise into a future landlord: HBSE and Comcast Spectacor will co-own the privately funded South Philadelphia arena on the old Spectrum site, with construction slated for 2027 and opening in 2030 alongside a WNBA expansion team. On the court Philadelphia beat Boston in seven in the 2026 first round, then swapped Paul George for Jaylen Brown and added LeBron James on a two-year, $8M deal, putting $156M into Embiid, Brown and Maxey for 2026-27. The number moves on two things: Embiid's availability, and the 2027 legislative approvals that let the arena break ground on time.",
    "unverifiedAsOf": {
      "arena.namingRightsDeal": "May 2026"
    }
  },
  "toronto-raptors": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.ownershipGroup",
        "old": [
          {
            "name": "Rogers Communications",
            "role": "majority shareholder (75%) of MLSE",
            "pct": "75%"
          },
          {
            "name": "Larry Tanenbaum / Kilmer Sports",
            "role": "minority shareholder (25%) of MLSE; option for Rogers to buy by 2026",
            "pct": "25%"
          }
        ],
        "new": [
          {
            "name": "Rogers Communications",
            "role": "majority shareholder (75%) of MLSE",
            "pct": "75%"
          },
          {
            "name": "Kilmer Sports (Larry Tanenbaum 20%, OMERS 5%)",
            "role": "minority shareholder (25%) of MLSE; Rogers option purchase expected to close Q4 2026",
            "pct": "25%"
          }
        ],
        "fact": "Wikipedia's MLSE page (April 2026) lists Kilmer Sports at 25% split Tanenbaum 20% / OMERS 5%, with an editor note that the Rogers buyout is expected to close in Q4 2026; MLSE equity value listed at CA$17.4B (2026) vs CA$12.5B (2024)",
        "source": "https://en.wikipedia.org/wiki/Maple_Leaf_Sports_%26_Entertainment"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Scottie Barnes — 5yr/$225M supermax extension signed July 2024, $45M AAV, effective 2025-26 through 2029-30 (eligible for $270M with performance bonuses)",
        "new": "Scottie Barnes ($41.8M in 2026-27, through 2029-30) plus Kawhi Leonard, reacquired from the Clippers September 14, 2026 for Brandon Ingram, Gradey Dick and five draft picks; Leonard signed a 2yr/$115M extension covering 2027-28 and 2028-29",
        "fact": "Kawhi trade agreed June 30, 2026 but held until September 14 during the NBA's Clippers cap-circumvention investigation; extension per Hoops Rumors",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_Toronto_Raptors_season ; https://www.hoopsrumors.com/2026/07/2026-27-nba-contract-extension-tracker.html"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Scottie Barnes",
            "position": "PF/SF",
            "aav": 45,
            "contractNote": "5yr/$225M supermax (July 2024), effective 2025-26 through 2029-30; could reach $270M with bonuses"
          },
          {
            "player": "RJ Barrett",
            "position": "SG/SF",
            "aav": 24,
            "contractNote": "Acquired from Knicks in 2023 trade; on existing max extension"
          }
        ],
        "new": [
          {
            "player": "Kawhi Leonard",
            "position": "SF",
            "aav": 55.1,
            "contractNote": "Reacquired from LA Clippers Sept 14, 2026; $50.3M (2026-27), then 2yr/$115M extension: $56.1M (2027-28), $58.9M (2028-29, player option)"
          },
          {
            "player": "Scottie Barnes",
            "position": "PF/SF",
            "aav": 46.4,
            "contractNote": "$41.8M (2026-27) rising to $51.0M (2029-30)"
          },
          {
            "player": "Immanuel Quickley",
            "position": "PG",
            "aav": 32.5,
            "contractNote": "$32.5M per year through 2028-29"
          },
          {
            "player": "RJ Barrett",
            "position": "SG/SF",
            "aav": 29.6,
            "contractNote": "$29.6M in 2026-27, expiring"
          }
        ],
        "fact": "Figures per Basketball-Reference; Raptors 2026-27 payroll $205.1M",
        "source": "https://www.basketball-reference.com/contracts/TOR.html"
      },
      {
        "field": "media.localTVDeal",
        "old": "Sportsnet (Rogers Communications regional network — same parent as majority MLSE owner; vertically integrated post-2025); national Canadian broadcast rights via Sportsnet and TSN",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (Wikipedia 2026-27 page lists TSN and Sportsnet; no 2026 Canadian rights renewal terms found)",
        "source": null
      }
    ],
    "analystNotes": "Forbes valued the Raptors at $5.4B in October 2025 on $380M of revenue, and the real asset is the MLSE bundle, now carried at CA$17.4B on the 2026 books versus CA$12.5B when Rogers bought Bell's stake, with Rogers' option on Kilmer Sports' remaining 25% expected to close in the fourth quarter of 2026. Toronto returned to the playoffs in 2026 and lost a seven-game first-round series to Cleveland, then reacquired Kawhi Leonard in September for Brandon Ingram, Gradey Dick and five picks, pairing a $50.3M Leonard with Scottie Barnes at $41.8M. Rogers owning the team, the arena and Sportsnet gives Toronto a closed media loop no US franchise can copy. The 2026 Kilmer closing and a Leonard-Barnes playoff run are what move a Canada-wide franchise past $6B.",
    "unverifiedAsOf": {}
  },
  "chicago-bulls": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 2,
        "new": 1,
        "fact": "Only the 2022 playoffs fall in the 2022-2026 window; Chicago missed the 2026 playoffs",
        "source": "https://www.basketball-reference.com/playoffs/NBA_2026.html"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Zach LaVine — 5yr/$215.2M max signed July 2022, $43M AAV, through 2026-27",
        "new": "Josh Giddey ($25M per year through 2028-29); Zach LaVine was traded to Sacramento in February 2025 and Nic Claxton arrived from Brooklyn in the July 10, 2026 four-team trade",
        "fact": "LaVine is on Sacramento's books at $49.0M for 2026-27; Giddey is Chicago's highest-paid player",
        "source": "https://www.basketball-reference.com/contracts/CHI.html ; https://www.basketball-reference.com/contracts/SAC.html"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Zach LaVine",
            "position": "SG",
            "aav": 43,
            "contractNote": "5yr/$215.2M max (July 2022), through 2026-27; frequent subject of trade speculation"
          },
          {
            "player": "Nikola Vucevic",
            "position": "C",
            "aav": 22,
            "contractNote": "Extended; veteran anchor"
          }
        ],
        "new": [
          {
            "player": "Josh Giddey",
            "position": "PG",
            "aav": 25,
            "contractNote": "$25M per year through 2028-29"
          },
          {
            "player": "Nic Claxton",
            "position": "C",
            "aav": 22,
            "contractNote": "Acquired from Brooklyn July 10, 2026; $23.1M (2026-27), $20.9M (2027-28)"
          },
          {
            "player": "Norman Powell",
            "position": "SG",
            "aav": 22,
            "contractNote": "$21.5M (2026-27), $22.6M (2027-28)"
          }
        ],
        "fact": "Per Basketball-Reference 2026-27 contracts; Vucevic and LaVine no longer on the roster",
        "source": "https://www.basketball-reference.com/contracts/CHI.html"
      }
    ],
    "analystNotes": "Forbes valued the Bulls at $6.0B in October 2025 on $434M of revenue, the highest number in the league for a team with one playoff trip in five years, because the Jordan-era brand and the 50/50 United Center ownership with the Blackhawks carry the valuation regardless of results. Chicago missed the 2026 playoffs, Billy Donovan stepped down in April, and the roster now tops out at Josh Giddey's $25M with Nic Claxton added in July, a $161.5M payroll that leaves real cap room. Chicago Sports Network remains the post-RSN experiment worth watching for every mid-market team. A genuine contender, or clarity on Reinsdorf family succession, is what would move a brand this large toward the Knicks and Lakers tier.",
    "unverifiedAsOf": {}
  },
  "cleveland-cavaliers": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports Ohio (Sinclair Broadcast Group / Diamond Sports Group regional network; RSN industry in flux post-Diamond bankruptcy)",
        "new": "DAZN (multi-year streaming deal announced Sept 1, 2026; all non-national games, $19.99/month or $119.99/season, 15 games free) with the 15 free games simulcast over the air on Gray Media's WOIO/WUAB in Cleveland and statewide on Rock Entertainment Sports Network; team-produced broadcasts replace FanDuel Sports Network Ohio, which shut down after the 2025-26 regular season",
        "fact": "Cavaliers left pay-TV for DAZN plus an over-the-air simulcast after Main Street Sports Group's wind-down",
        "source": "https://www.si.com/nba/cavaliers/onsi/cleveland-cavaliers-announce-new-television-deal-for-2026-27-season-01m1ehwyps9p ; https://www.cleveland19.com/2026/09/15/cleveland-cavaliers-games-return-free-over-the-air-television-19-news/"
      },
      {
        "field": "media.streamingNotes",
        "old": "Standard NBA League Pass; Diamond Sports Group RSN availability subject to ongoing bankruptcy/restructuring",
        "new": "DAZN carries in-market games from 2026-27 (Monthly Pass $19.99, Season Pass $119.99, Ultimate tiers $24.99/$139.99); the NBA asked the 13 former FanDuel teams for one-year or opt-out deals ahead of a league-run local streaming package targeted for 2027-28; NBA League Pass unchanged",
        "fact": "Pricing per SI; league streaming plan per Hoops Rumors",
        "source": "https://www.hoopsrumors.com/2026/04/nba-tells-13-teams-to-look-for-new-regional-tv-deals.html"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 3,
        "new": 4,
        "fact": "Playoffs 2023-2026; reached the 2026 Eastern Conference finals (beat Toronto 4-3 and Detroit 4-3, swept by New York)",
        "source": "https://www.basketball-reference.com/playoffs/NBA_2026.html"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Donovan Mitchell — extension signed 2023, $32.7M AAV; Evan Mobley max extension $53.8M AAV effective 2024-25",
        "new": "Donovan Mitchell, 4yr/$273M max extension signed July 2026 starting 2027-28 (35% of cap, $60.9M to $75.5M, fourth-year player option); Evan Mobley $50.1M in 2026-27 through 2029-30",
        "fact": "Mitchell extension per Hoops Rumors ($275.968M projected) and ESPN ($273M)",
        "source": "https://www.hoopsrumors.com/2026/07/2026-27-nba-contract-extension-tracker.html"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Donovan Mitchell",
            "position": "SG/PG",
            "aav": 32.7,
            "contractNote": "5yr/$163.5M supermax (2023), player option 2027-28; acquired from Jazz in 2022 trade"
          },
          {
            "player": "Evan Mobley",
            "position": "C/PF",
            "aav": 53.8,
            "contractNote": "5yr/$269M max extension (effective 2024-25), through 2028-29; highest-upside young big in the East"
          },
          {
            "player": "Darius Garland",
            "position": "PG",
            "aav": 33,
            "contractNote": "Max extension; through 2026-27"
          }
        ],
        "new": [
          {
            "player": "Donovan Mitchell",
            "position": "SG/PG",
            "aav": 68.2,
            "contractNote": "$50.1M in 2026-27, then 4yr/$273M extension (July 2026) from $60.9M (2027-28) to $75.5M (2030-31), player option on year four"
          },
          {
            "player": "Evan Mobley",
            "position": "C/PF",
            "aav": 55.7,
            "contractNote": "$50.1M (2026-27) rising to $61.2M (2029-30)"
          },
          {
            "player": "James Harden",
            "position": "PG",
            "aav": 32.2,
            "contractNote": "Acquired from LA Clippers in February 2026 for Darius Garland; re-signed 3yr/$97M in Sept 2026: $30.6M, $32.2M, $33.7M"
          },
          {
            "player": "Jarrett Allen",
            "position": "C",
            "aav": 30.2,
            "contractNote": "$28.0M (2026-27) rising to $32.5M (2028-29)"
          }
        ],
        "fact": "Garland traded to the Clippers Feb 2026; Harden acquired and re-signed; figures per Basketball-Reference",
        "source": "https://en.wikipedia.org/wiki/List_of_2025%E2%80%9326_NBA_season_transactions ; https://www.basketball-reference.com/contracts/CLE.html"
      }
    ],
    "analystNotes": "Forbes valued the Cavaliers at $4.8B in October 2025 on $440M of revenue, and Cleveland then went to the 2026 Eastern Conference finals before being swept by the champion Knicks, its fourth straight playoff trip. The July 2026 Mitchell extension at $273M over four years from 2027-28 stacks with Mobley's deal to put two max contracts on a roster that already carries $209M for 2026-27, with James Harden re-signed for three years after the February Garland trade. The media line is the new variable: FanDuel Sports Network Ohio is gone, and the Cavs moved to DAZN at $19.99 a month with 15 games free over the air on Gray stations, a team-produced model built to slot into the league's 2027-28 local streaming package. Whether DAZN subscriptions replace the lost RSN check is the swing factor on Cleveland's local revenue.",
    "unverifiedAsOf": {}
  },
  "detroit-pistons": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports Detroit (Sinclair/Diamond Sports Group regional network; RSN industry in flux post-Diamond bankruptcy)",
        "new": "WMYD (Scripps Sports) over-the-air for 2026-27 after FanDuel Sports Network Detroit shut down at the end of the 2025-26 regular season; Detroit is one of the OTA-only teams among the 13 former FanDuel clubs",
        "fact": "Wikipedia 2026-27 season page lists WMYD (Scripps Sports); Sports Media Watch groups the Pistons with Hawks, Heat and Bucks as OTA-only",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_Detroit_Pistons_season ; https://www.sportsmediawatch.com/2026/08/hornets-magic-new-local-rights-deals-streaming-ota/"
      },
      {
        "field": "media.streamingNotes",
        "old": "Standard NBA League Pass; Diamond Sports Group RSN availability subject to ongoing bankruptcy/restructuring",
        "new": "No pay-TV RSN for 2026-27; NBA asked the 13 former FanDuel teams for one-year or opt-out deals ahead of a league-run local streaming package targeted for 2027-28; NBA League Pass unchanged",
        "fact": "League guidance per Hoops Rumors (April 2026)",
        "source": "https://www.hoopsrumors.com/2026/04/nba-tells-13-teams-to-look-for-new-regional-tv-deals.html"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 0,
        "new": 2,
        "fact": "Playoffs in 2025 and 2026; beat Orlando 4-3 in the 2026 first round, lost 4-3 to Cleveland in round two; won the Central Division in 2025-26",
        "source": "https://www.basketball-reference.com/playoffs/NBA_2026.html"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Cade Cunningham",
            "position": "PG",
            "aav": 44.8,
            "contractNote": "5yr/$224M max extension (summer 2024); franchise cornerstone through 2028-29"
          },
          {
            "player": "Jalen Duren",
            "position": "C",
            "aav": 18,
            "contractNote": "Extension; young anchor in frontcourt"
          }
        ],
        "new": [
          {
            "player": "Cade Cunningham",
            "position": "PG",
            "aav": 55.7,
            "contractNote": "$50.1M (2026-27) rising to $61.2M (2029-30); through 2029-30"
          },
          {
            "player": "Ausar Thompson",
            "position": "SF",
            "aav": 31,
            "contractNote": "5yr/$155M rookie-scale extension signed July 2026, starting 2027-28 ($26.7M to $35.3M through 2031-32)"
          },
          {
            "player": "John Collins",
            "position": "PF",
            "aav": 17,
            "contractNote": "Sign-and-trade from the Clippers July 8, 2026; $17M in 2026-27"
          }
        ],
        "fact": "Cunningham figures and Thompson extension per Basketball-Reference and Hoops Rumors; Duren not among the top contracts on the 2026-27 table",
        "source": "https://www.basketball-reference.com/contracts/DET.html ; https://www.hoopsrumors.com/2026/07/2026-27-nba-contract-extension-tracker.html"
      }
    ],
    "analystNotes": "Forbes valued the Pistons at $3.65B in October 2025, up from the $2.4B floor a year earlier, on $321M of revenue, and the on-court turnaround is now two straight playoff trips including a 2026 second-round loss to Cleveland in seven games after a Central Division title. Cade Cunningham's max deal runs from $50.1M to $61.2M through 2029-30, and Ausar Thompson's 5yr/$155M July 2026 extension locks the second piece, on a payroll of just $153M for 2026-27. The structural problems are unchanged: the Ilitch family owns Little Caesars Arena and its naming and event revenue, and the local TV deal collapsed with FanDuel Sports Network, leaving games on Scripps' WMYD over the air for 2026-27. A Detroit conference finals run and the league's 2027-28 local streaming package are what would close the gap to the $4.5B mid-market peers.",
    "unverifiedAsOf": {}
  },
  "indiana-pacers": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports Indiana / FanDuel Sports Network, ~$12M/yr",
        "new": "FanDuel Sports Network Indiana shut down after the 2025-26 regular season; for 2026-27 the Pacers are expected to sell exclusive in-market rights to DAZN (streaming), with CEO Mel Raines saying the team looked at both over-the-air and direct-to-consumer partners",
        "fact": "Yahoo/Hoops Rumors report DAZN near exclusive local deals with Indiana, Minnesota, Cleveland, San Antonio and Memphis; Pacers deal not formally announced in sources found",
        "source": "https://sports.yahoo.com/articles/pacers-expected-move-local-broadcasts-201055030.html ; https://www.hoopsrumors.com/2026/04/nba-tells-13-teams-to-look-for-new-regional-tv-deals.html"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 3,
        "new": 2,
        "fact": "Playoffs in 2024 and 2025 within the 2022-2026 window; missed the 2026 playoffs after Tyrese Haliburton's Achilles injury in Game 7 of the 2025 Finals",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_Indiana_Pacers_season ; https://www.basketball-reference.com/playoffs/NBA_2026.html"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Tyrese Haliburton — 5yr/$224M max extension (2023), $44.8M AAV, through 2027-28; led Pacers to 2024 Eastern Conference Finals",
        "new": "Tyrese Haliburton, $48.9M in 2026-27 rising to $55.7M in 2028-29; missed 2025-26 after a torn Achilles in Game 7 of the 2025 NBA Finals; Pascal Siakam on the same $48.9M/$52.3M schedule through 2027-28",
        "fact": "Salary schedule per Basketball-Reference; Haliburton injury and 2026 playoff miss per Wikipedia",
        "source": "https://www.basketball-reference.com/contracts/IND.html"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Tyrese Haliburton",
            "position": "PG",
            "aav": 44.8,
            "contractNote": "5yr/$224M max (2023), through 2027-28; 2024 All-Star"
          },
          {
            "player": "Myles Turner",
            "position": "C",
            "aav": 30,
            "contractNote": "4yr/$120M (2024), through 2027-28"
          }
        ],
        "new": [
          {
            "player": "Tyrese Haliburton",
            "position": "PG",
            "aav": 52.3,
            "contractNote": "$48.9M (2026-27), $52.3M (2027-28), $55.7M (2028-29); returned from 2025 Finals Achilles tear"
          },
          {
            "player": "Pascal Siakam",
            "position": "PF",
            "aav": 50.6,
            "contractNote": "$48.9M (2026-27), $52.3M (2027-28)"
          },
          {
            "player": "Ivica Zubac",
            "position": "C",
            "aav": 21.1,
            "contractNote": "$20.3M (2026-27), $21.8M (2027-28); Myles Turner left for Milwaukee in 2025 free agency"
          }
        ],
        "fact": "Turner signed with the Bucks in July 2025; Zubac is Indiana's center per the 2026-27 contract table",
        "source": "https://www.basketball-reference.com/contracts/IND.html ; https://en.wikipedia.org/wiki/List_of_2025%E2%80%9326_NBA_season_transactions"
      }
    ],
    "analystNotes": "Forbes valued the Pacers at $4.2B in October 2025 on $342M of revenue, a number earned by the 2025 Finals run that ended in Game 7 with Tyrese Haliburton's torn Achilles, and 2025-26 showed the cost: Indiana missed the playoffs without him. Haliburton and Pascal Siakam each earn $48.9M in 2026-27 on a $206M payroll, so the franchise is paying contention prices for a gap year. The local TV line is reset to zero after FanDuel Sports Network Indiana shut down, with an exclusive DAZN streaming deal reported as the 2026-27 stopgap before the league's 2027-28 package. Haliburton's return to All-NBA form is the single input that decides whether Indianapolis holds the $4B-plus valuation.",
    "unverifiedAsOf": {}
  },
  "atlanta-hawks": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports Southeast / FanDuel Sports Network, ~$15M/yr",
        "new": "WANF (Gray Media's former Atlanta CBS affiliate, now independent) over the air for 2026-27 after FanDuel Sports Network Southeast shut down at the end of the 2025-26 regular season; Atlanta is one of the OTA-only teams among the 13 former FanDuel clubs",
        "fact": "Sports Media Watch: Hawks games available over the air on WANF for 2026-27",
        "source": "https://www.sportsmediawatch.com/tv-schedules/nba-tv-schedule/atlanta-hawks/ ; https://en.wikipedia.org/wiki/2026%E2%80%9327_Atlanta_Hawks_season"
      },
      {
        "field": "media.streamingNotes",
        "old": "Standard NBA League Pass",
        "new": "No pay-TV RSN for 2026-27; NBA asked the 13 former FanDuel teams for one-year or opt-out deals ahead of a league-run local streaming package targeted for 2027-28; NBA League Pass unchanged",
        "fact": "League guidance per Hoops Rumors (April 2026)",
        "source": "https://www.hoopsrumors.com/2026/04/nba-tells-13-teams-to-look-for-new-regional-tv-deals.html"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Trae Young — 5yr/$215M max extension (2021), $43M AAV, through 2025-26; Jalen Johnson emerging as co-star",
        "new": "Jalen Johnson ($30M per year through 2029-30); Trae Young was traded to Washington on January 9, 2026 for CJ McCollum and Corey Kispert",
        "fact": "Trae Young trade per Wikipedia 2025-26 transactions; Johnson is the highest-paid Hawk for 2026-27",
        "source": "https://en.wikipedia.org/wiki/List_of_2025%E2%80%9326_NBA_season_transactions ; https://www.basketball-reference.com/contracts/ATL.html"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Trae Young",
            "position": "PG",
            "aav": 43,
            "contractNote": "5yr/$215M max (2021), through 2025-26; frequent trade speculation"
          },
          {
            "player": "Jalen Johnson",
            "position": "SF",
            "aav": 32.5,
            "contractNote": "4yr/$130M (2024), through 2027-28; emerging franchise co-star"
          }
        ],
        "new": [
          {
            "player": "Jalen Johnson",
            "position": "SF",
            "aav": 30,
            "contractNote": "$30M per year through 2029-30"
          },
          {
            "player": "Dyson Daniels",
            "position": "SG",
            "aav": 25,
            "contractNote": "$25M per year through 2029-30"
          },
          {
            "player": "CJ McCollum",
            "position": "PG",
            "aav": 21,
            "contractNote": "Acquired from Washington Jan 9, 2026 in the Trae Young trade; $21M in 2026-27, expiring"
          }
        ],
        "fact": "Per Basketball-Reference; Jonathan Kuminga (acquired Feb 2026) is on Minnesota's 2026-27 books, not Atlanta's",
        "source": "https://www.basketball-reference.com/contracts/ATL.html"
      }
    ],
    "analystNotes": "Forbes valued the Hawks at $5.0B in October 2025 on $477M of revenue and a $203M operating profit, numbers that owe more to State Farm Arena's event calendar and the ninth-largest DMA than to the roster. Atlanta traded Trae Young to Washington in January 2026 for CJ McCollum and Corey Kispert, still made the playoffs, and lost to the eventual champion Knicks in six; the core is now Jalen Johnson and Dyson Daniels at $30M and $25M a year through 2029-30 on a lean $198M payroll. The local TV check disappeared with FanDuel Sports Network Southeast, and 2026-27 games air free on WANF, which trades rights fees for reach until the league's 2027-28 streaming package. Attendance and a post-Young identity that wins a series are what move Atlanta from a market-and-building valuation to a basketball one.",
    "unverifiedAsOf": {}
  },
  "charlotte-hornets": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports Southeast / FanDuel Sports Network, ~$13M/yr",
        "new": "One-year over-the-air deal with Cox Media Group (WSOC-TV Channel 9 and TV64) for 2026-27, reported at roughly $7-8M, plus a DAZN direct-to-consumer stream (roughly $1-2M) after FanDuel Sports Network Southeast shut down",
        "fact": "Announced August 2026; 'beam and stream' hybrid model",
        "source": "https://www.hoopsrumors.com/2026/08/hornets-magic-announce-local-tv-broadcast-plans-for-2026-27.html ; https://www.sportsmediawatch.com/2026/08/hornets-magic-new-local-rights-deals-streaming-ota/"
      },
      {
        "field": "media.streamingNotes",
        "old": "Standard NBA League Pass",
        "new": "DAZN direct-to-consumer stream for in-market games from 2026-27 alongside the Cox over-the-air package; one-year structure follows NBA guidance ahead of a league local streaming package targeted for 2027-28; NBA League Pass unchanged",
        "fact": "Per Hoops Rumors and Sports Media Watch",
        "source": "https://www.sportsmediawatch.com/2026/08/hornets-magic-new-local-rights-deals-streaming-ota/"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 1,
        "new": 0,
        "fact": "No playoff appearances 2022-2026; Charlotte reached the 2026 play-in tournament (first since 2022) but did not advance",
        "source": "https://en.wikipedia.org/wiki/2026_NBA_playoffs"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "LaMelo Ball — 5yr/$204M max extension (2023), $40.8M AAV, through 2027-28",
        "new": "LaMelo Ball was traded to Minnesota on July 10, 2026 in a four-team deal that returned Naz Reid, three Minnesota first-round swap rights, a 2033 MIN first-round pick and second-rounders; Naz Reid ($23.3M in 2026-27, through 2029-30) and Coby White ($22.8M) lead the roster",
        "fact": "Ball trade per Wikipedia 2026-27 transactions; salaries per Basketball-Reference",
        "source": "https://en.wikipedia.org/wiki/List_of_2026%E2%80%9327_NBA_season_transactions ; https://www.basketball-reference.com/contracts/CHO.html"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "LaMelo Ball",
            "position": "PG",
            "aav": 40.8,
            "contractNote": "5yr/$204M max (2023), through 2027-28; injury history the primary risk"
          }
        ],
        "new": [
          {
            "player": "Naz Reid",
            "position": "C/PF",
            "aav": 25.9,
            "contractNote": "Acquired from Minnesota July 10, 2026 in the LaMelo Ball trade; $23.3M (2026-27) rising to $28.4M (2029-30)"
          },
          {
            "player": "Coby White",
            "position": "PG",
            "aav": 24.7,
            "contractNote": "Re-signed July 2026; $22.8M (2026-27) rising to $26.5M (2028-29)"
          },
          {
            "player": "Brandon Miller",
            "position": "SF",
            "aav": 15.1,
            "contractNote": "$15.1M in 2026-27 (final rookie-scale year)"
          }
        ],
        "fact": "Per Basketball-Reference 2026-27 contracts",
        "source": "https://www.basketball-reference.com/contracts/CHO.html"
      }
    ],
    "analystNotes": "Forbes valued the Hornets at $3.8B in October 2025 on $328M of revenue, and the 2023 Plotkin and Schnall purchase at $3B looks fine on paper even though the basketball product has not produced a playoff series since 2016. The July 2026 four-team trade sent LaMelo Ball to Minnesota for Naz Reid, three first-round swap rights and a 2033 first, a decision to sell the injury-prone max contract for optionality, leaving Charlotte with a $173M payroll and no player above $23.3M. Local TV reset hard: FanDuel Sports Network Southeast is gone, and the 2026-27 package is a one-year Cox Media Group over-the-air deal at roughly $7-8M plus a DAZN stream at $1-2M, about two-thirds of the old RSN money. A rookie-scale core that converts the Minnesota picks into a playoff team is what moves a fast-growing market past $4B.",
    "unverifiedAsOf": {}
  },
  "miami-heat": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports Sun / FanDuel Sports Network, ~$20M/yr",
        "new": "WPLG Local 10 (Berkshire Hathaway-owned Miami station) over the air for 2026-27, announced June 8, 2026, after FanDuel Sports Network Sun shut down at the end of the 2025-26 regular season; Miami is one of the OTA-only teams among the 13 former FanDuel clubs",
        "fact": "WPLG becomes the Heat's broadcast home; Sports Media Watch lists Miami as OTA-only",
        "source": "https://www.local10.com/sports/local/2026/06/08/wplg-local-10-becomes-the-home-of-the-miami-heat/ ; https://www.sportsmediawatch.com/tv-schedules/nba-tv-schedule/miami-heat/"
      },
      {
        "field": "media.streamingNotes",
        "old": "Standard NBA League Pass",
        "new": "No pay-TV RSN for 2026-27; NBA asked the 13 former FanDuel teams for one-year or opt-out deals ahead of a league-run local streaming package targeted for 2027-28; NBA League Pass unchanged",
        "fact": "League guidance per Hoops Rumors (April 2026)",
        "source": "https://www.hoopsrumors.com/2026/04/nba-tells-13-teams-to-look-for-new-regional-tv-deals.html"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Bam Adebayo — 5yr/$195M (2021), $39M AAV; Jimmy Butler traded to Golden State January 2025",
        "new": "Giannis Antetokounmpo, acquired from Milwaukee July 6, 2026 with Bobby Portis for Tyler Herro, Jaime Jaquez Jr., Kel'el Ware, Kasparas Jakucionis, the No. 13 pick (Nate Ament), 2031 and 2033 first-round picks and a 2030 swap; $58.5M in 2026-27, $62.8M in 2027-28; Bam Adebayo $49.8M through 2028-29",
        "fact": "Giannis trade per Wikipedia 2026-27 transactions and NBA.com; salaries per Basketball-Reference",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_Miami_Heat_season ; https://www.basketball-reference.com/contracts/MIA.html"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Bam Adebayo",
            "position": "C",
            "aav": 39,
            "contractNote": "5yr/$195M (2021), through 2025-26; franchise anchor through transition"
          },
          {
            "player": "Tyler Herro",
            "position": "SG",
            "aav": 32.5,
            "contractNote": "4yr/$130M (2022), through 2025-26"
          }
        ],
        "new": [
          {
            "player": "Giannis Antetokounmpo",
            "position": "PF",
            "aav": 60.6,
            "contractNote": "Acquired from Milwaukee July 6, 2026; $58.5M (2026-27), $62.8M (2027-28); free agency after 2027-28"
          },
          {
            "player": "Bam Adebayo",
            "position": "C",
            "aav": 53.8,
            "contractNote": "$49.8M (2026-27), $53.8M (2027-28), $57.8M (2028-29)"
          },
          {
            "player": "Andrew Wiggins",
            "position": "SF",
            "aav": 21.4,
            "contractNote": "$30.2M in 2026-27, then 2yr/$33.8M extension (2027-29) per Hoops Rumors"
          }
        ],
        "fact": "Herro traded to Milwaukee; figures per Basketball-Reference and the Hoops Rumors extension tracker",
        "source": "https://www.basketball-reference.com/contracts/MIA.html ; https://www.hoopsrumors.com/2026/07/2026-27-nba-contract-extension-tracker.html"
      }
    ],
    "analystNotes": "Forbes valued the Heat at $5.7B in October 2025 on $417M of revenue, a number built on Kaseya Center's rent-free county deal and a Miami brand that had not been to a Finals since 2023, and in July 2026 Pat Riley bought the star: Giannis Antetokounmpo arrived from Milwaukee for Tyler Herro, three young players, the No. 13 pick and two future firsts. Giannis at $58.5M and Bam Adebayo at $49.8M put $210M on the 2026-27 payroll with Giannis eligible for free agency after 2027-28, so the window is two seasons. Local TV moved to WPLG over the air after FanDuel Sports Network Sun closed, which costs rights fees but keeps every game free in market during a title push. A Giannis-era Finals appearance and a long-term extension are what would carry Miami toward the $6.5B-plus tier.",
    "unverifiedAsOf": {}
  },
  "orlando-magic": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports Florida / FanDuel Sports Network, ~$15M/yr",
        "new": "Cox Media Group over-the-air deal for 2026-27 (WRDQ TV 27 primary, select games on WFTV Channel 9, plus Jacksonville stations), reported at about $8M a year, with a DAZN direct-to-consumer stream (roughly $1-2M) after FanDuel Sports Network Florida shut down",
        "fact": "Announced August 2026; Magic and Hornets pioneered the hybrid over-the-air plus streaming model",
        "source": "https://www.hoopsrumors.com/2026/08/hornets-magic-announce-local-tv-broadcast-plans-for-2026-27.html ; https://www.sportsmediawatch.com/2026/08/hornets-magic-new-local-rights-deals-streaming-ota/"
      },
      {
        "field": "media.streamingNotes",
        "old": "Standard NBA League Pass",
        "new": "DAZN direct-to-consumer stream for in-market games from 2026-27 alongside the Cox over-the-air package, ahead of a league local streaming package targeted for 2027-28; NBA League Pass unchanged",
        "fact": "Per Hoops Rumors and Sports Media Watch",
        "source": "https://www.sportsmediawatch.com/2026/08/hornets-magic-new-local-rights-deals-streaming-ota/"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 2,
        "new": 3,
        "fact": "Playoffs in 2024, 2025 and 2026; lost 4-3 to Detroit in the 2026 first round; head coach Jamahl Mosley fired May 4, 2026",
        "source": "https://www.basketball-reference.com/playoffs/NBA_2026.html ; https://en.wikipedia.org/wiki/2026%E2%80%9327_Orlando_Magic_season"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Paolo Banchero",
            "position": "SF",
            "aav": 47.8,
            "contractNote": "5yr/$239M max extension (2025), through 2029-30; 2023 Rookie of the Year"
          },
          {
            "player": "Franz Wagner",
            "position": "SG",
            "aav": 44.8,
            "contractNote": "5yr/$224M (2024), through 2028-29"
          }
        ],
        "new": [
          {
            "player": "Paolo Banchero",
            "position": "SF",
            "aav": 48.1,
            "contractNote": "$41.5M (2026-27) rising to $54.8M (2030-31); through 2030-31"
          },
          {
            "player": "Franz Wagner",
            "position": "SF",
            "aav": 46.4,
            "contractNote": "$41.8M (2026-27) rising to $51.0M (2029-30)"
          },
          {
            "player": "Desmond Bane",
            "position": "SG",
            "aav": 42.2,
            "contractNote": "Acquired from Memphis in June 2025; $39.4M (2026-27) rising to $44.9M (2028-29)"
          },
          {
            "player": "Jalen Suggs",
            "position": "PG",
            "aav": 28.9,
            "contractNote": "$32.4M (2026-27) declining to $26.7M (2029-30)"
          }
        ],
        "fact": "Per Basketball-Reference; Orlando's 2026-27 payroll is $223.3M",
        "source": "https://www.basketball-reference.com/contracts/ORL.html"
      }
    ],
    "analystNotes": "Forbes valued the Magic at $3.9B in October 2025 on $318M of revenue, and Orlando is now paying contender money for first-round exits: Banchero, Wagner, Bane and Suggs put the 2026-27 payroll at $223M, and the 2026 season ended with a seven-game first-round loss to Detroit and Jamahl Mosley's firing. Kia Center's city financing keeps capex near zero, which is why the DeVos family can carry that payroll on Orlando's revenue base. The FanDuel Sports Network Florida shutdown cut local media to a roughly $8M Cox over-the-air deal plus a $1-2M DAZN stream, about half the old RSN fee. A second-round series win with this core, or the league's 2027-28 local streaming package restoring media income, is what moves Orlando past $4.5B.",
    "unverifiedAsOf": {}
  },
  "washington-wizards": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "arena.newArenaPlans",
        "old": "$800M renovation underway (2025-2028): $515M DC public + $285M Monumental; completing in phases; anchors franchise's Washington presence through 2030s+",
        "new": "Capital One Arena renovation now budgeted at more than $1B ($515M from the District, remainder from Monumental); phase 2 underway in fall 2026 with concourse work done before the 2026-27 season, interior premium work through 2026-27, and the exterior and Grand Pavilion finished before the 2027-28 season; Monumental and Capital One extended the naming-rights deal by 20 years (announced 2026)",
        "fact": "Updated renderings and budget released August 2026; naming rights extended 20 years",
        "source": "https://russianmachineneverbreaks.com/2026/08/12/capital-one-arena-renovations-renderings-monumental-1-billion-visibowl/ ; https://wjla.com/newsletter-daily/phase-2-of-construction-underway-at-capital-one-arena-fall-and-winter-events-to-continue-garth-brooks-capitals-wizards-events-september-2026"
      },
      {
        "field": "arena.namingRightsDeal",
        "old": {
          "sponsor": "Capital One Financial",
          "annualValue_M": 8,
          "totalValue_M": null,
          "expiryYear": null,
          "notes": "Capital One naming began 2017 (from Verizon Center 2006-2017, MCI Center 1997-2006); paid to Monumental Sports & Entertainment"
        },
        "new": {
          "sponsor": "Capital One Financial",
          "annualValue_M": 8,
          "totalValue_M": null,
          "expiryYear": 2046,
          "notes": "Capital One naming began 2017 (from Verizon Center 2006-2017, MCI Center 1997-2006); paid to Monumental Sports & Entertainment; extended by 20 years in 2026 alongside the $1B renovation, value undisclosed; expiry year is an estimate based on a 2026 extension"
        },
        "fact": "20-year naming-rights extension announced with the August 2026 renovation update; annual value not disclosed so the prior $8M figure is kept",
        "source": "https://russianmachineneverbreaks.com/2026/08/12/capital-one-arena-renovations-renderings-monumental-1-billion-visibowl/"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 1,
        "new": 0,
        "fact": "No playoffs 2022-2026",
        "source": "https://www.basketball-reference.com/playoffs/NBA_2026.html"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Alexandre Sarr (#2 pick 2024) — on rookie contract; full franchise rebuild underway",
        "new": "Trae Young, acquired from Atlanta January 9, 2026 and re-signed in July 2026 on a four-year deal worth about $212.8M ($49.5M in 2026-27 to $58.4M in 2029-30); Anthony Davis acquired from Dallas in February 2026 ($58.5M in 2026-27, through 2027-28); AJ Dybantsa drafted 2026 ($14.7M rookie scale)",
        "fact": "Young trade per Wikipedia 2025-26 transactions; four-year re-signing per NBA.com; salary schedule per Basketball-Reference; Davis trade per Wikipedia (Feb 2026 multi-team deal)",
        "source": "https://www.nba.com/news/nba-offseason-deals-2026 ; https://www.basketball-reference.com/contracts/WAS.html ; https://en.wikipedia.org/wiki/List_of_2025%E2%80%9326_NBA_season_transactions"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Kyle Kuzma",
            "position": "SF",
            "aav": 25.5,
            "contractNote": "4yr/$102M (2022), through 2025-26"
          }
        ],
        "new": [
          {
            "player": "Anthony Davis",
            "position": "C/PF",
            "aav": 60.6,
            "contractNote": "Acquired from Dallas Feb 2026; $58.5M (2026-27), $62.8M (2027-28)"
          },
          {
            "player": "Trae Young",
            "position": "PG",
            "aav": 53.2,
            "contractNote": "Acquired from Atlanta Jan 9, 2026; re-signed July 2026, 4 years about $212.8M: $49.5M, $50.5M, $54.4M, $58.4M through 2029-30"
          },
          {
            "player": "AJ Dybantsa",
            "position": "SF",
            "aav": 16.7,
            "contractNote": "2026 draft pick on rookie scale; $14.7M in 2026-27"
          }
        ],
        "fact": "Kuzma was traded to Milwaukee in 2025; figures per Basketball-Reference",
        "source": "https://www.basketball-reference.com/contracts/WAS.html"
      }
    ],
    "analystNotes": "Forbes valued the Wizards at $4.7B in October 2025 on $389M of revenue, a market-and-building number for a team with zero playoff trips in five years, and Monumental spent 2026 doubling down on the building: Capital One Arena's renovation is now a $1B-plus project with $515M from the District, phase 2 underway this fall, completion before 2027-28, and a 20-year Capital One naming extension. Washington also stopped tanking, trading for Trae Young in January and Anthony Davis in February 2026 and then re-signing Young for four years and roughly $213M, so $108M of the 2026-27 payroll sits in two veterans next to 2026 draftee AJ Dybantsa. Monumental Sports Network means the FanDuel collapse never touched this team's local media. A playoff berth in the sixth-largest DMA inside a rebuilt arena is what unlocks the $5B-plus number the market already supports.",
    "unverifiedAsOf": {}
  },
  "milwaukee-bucks": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports Wisconsin / FanDuel Sports Network, ~$15M/yr",
        "new": "WVTV-DT2 (Sinclair, Milwaukee) over the air for 2026-27 after FanDuel Sports Network Wisconsin shut down at the end of the 2025-26 regular season; Milwaukee is one of the OTA-only teams among the 13 former FanDuel clubs",
        "fact": "Wikipedia 2026-27 season page lists WVTV-DT2; Sports Media Watch groups the Bucks as OTA-only",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_Milwaukee_Bucks_season ; https://www.sportsmediawatch.com/2026/08/hornets-magic-new-local-rights-deals-streaming-ota/"
      },
      {
        "field": "media.streamingNotes",
        "old": "Standard NBA League Pass; Deer District digital content expands fan engagement",
        "new": "No pay-TV RSN for 2026-27; NBA asked the 13 former FanDuel teams for one-year or opt-out deals ahead of a league-run local streaming package targeted for 2027-28; NBA League Pass unchanged",
        "fact": "League guidance per Hoops Rumors (April 2026)",
        "source": "https://www.hoopsrumors.com/2026/04/nba-tells-13-teams-to-look-for-new-regional-tv-deals.html"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 5,
        "new": 4,
        "fact": "Playoffs 2022-2025; missed the 2026 playoffs",
        "source": "https://www.basketball-reference.com/playoffs/NBA_2026.html"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Giannis Antetokounmpo — 3yr/$186M extension (2023), $62M AAV, through 2027-28; Damian Lillard — 4yr/$220M (2023), $55M AAV",
        "new": "Giannis Antetokounmpo was traded to Miami on July 6, 2026 for Tyler Herro, Jaime Jaquez Jr., Kel'el Ware, Kasparas Jakucionis, the No. 13 pick (Nate Ament), Miami's 2031 and 2033 first-round picks and a 2030 swap; Damian Lillard was waived in July 2025 and signed with Portland; 2026-27 is the first season since 2012-13 without Giannis",
        "fact": "Trade per Wikipedia 2026-27 transactions; Lillard waiver per Wikipedia 2025-26 transactions",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_Milwaukee_Bucks_season ; https://en.wikipedia.org/wiki/List_of_2025%E2%80%9326_NBA_season_transactions"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Giannis Antetokounmpo",
            "position": "PF",
            "aav": 62,
            "contractNote": "3yr/$186M extension (2023), through 2027-28; free agency decision post-2028 is the franchise's most consequential event"
          },
          {
            "player": "Damian Lillard",
            "position": "PG",
            "aav": 55,
            "contractNote": "4yr/$220M (2023), through 2026-27; acquired from Portland in 2023 trade"
          }
        ],
        "new": [
          {
            "player": "Tyler Herro",
            "position": "SG",
            "aav": 33,
            "contractNote": "Acquired from Miami July 6, 2026 in the Giannis trade; $33M in 2026-27, expiring"
          },
          {
            "player": "Myles Turner",
            "position": "C",
            "aav": 27.9,
            "contractNote": "Signed from Indiana July 2025; $26.6M (2026-27) rising to $29.1M (2028-29)"
          },
          {
            "player": "Kyle Kuzma",
            "position": "SF",
            "aav": 20.3,
            "contractNote": "$20.3M in 2026-27, expiring"
          }
        ],
        "fact": "Per Basketball-Reference; Bucks 2026-27 payroll $193.8M with only $116.8M committed for 2027-28",
        "source": "https://www.basketball-reference.com/contracts/MIL.html"
      }
    ],
    "analystNotes": "Forbes valued the Bucks at $4.3B in October 2025 on $355M of revenue with just $26M of operating income, and the two events that defined the enrichment have both resolved against Milwaukee: Damian Lillard was waived and stretched in July 2025, and on July 6, 2026 Giannis Antetokounmpo was traded to Miami for Tyler Herro, three young players, the No. 13 pick and two future firsts. What remains is Fiserv Forum and the Deer District, a $194M payroll that drops to $117M in 2027-28, and a local TV line that fell from FanDuel Sports Network Wisconsin to an over-the-air deal on WVTV. The franchise missed the 2026 playoffs and enters 2026-27 without Giannis for the first time since 2012-13. How fast the Miami picks and the cap space become a new core is the whole valuation question for the league's 40th-ranked market.",
    "unverifiedAsOf": {}
  },
  "denver-nuggets": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Nikola Jokic — 5yr/$270M supermax (2022), $54M AAV, through 2026-27; 3× MVP, 2023 champion and Finals MVP",
        "new": "Nikola Jokic, $59.0M in 2026-27 and $62.8M in 2027-28 (contract runs through 2027-28); 3x MVP, 2023 champion and Finals MVP",
        "fact": "Salary schedule per Basketball-Reference shows Jokic under contract through 2027-28",
        "source": "https://www.basketball-reference.com/contracts/DEN.html"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Nikola Jokic",
            "position": "C",
            "aav": 54,
            "contractNote": "5yr/$270M supermax (2022), through 2026-27; highest win-shares per game in NBA history"
          },
          {
            "player": "Jamal Murray",
            "position": "PG",
            "aav": 29.3,
            "contractNote": "5yr/$207M max extension effective 2021-22, through 2025-26"
          }
        ],
        "new": [
          {
            "player": "Nikola Jokic",
            "position": "C",
            "aav": 60.9,
            "contractNote": "$59.0M (2026-27), $62.8M (2027-28); through 2027-28"
          },
          {
            "player": "Jamal Murray",
            "position": "PG",
            "aav": 53.8,
            "contractNote": "$50.1M (2026-27), $53.8M (2027-28), $57.5M (2028-29)"
          },
          {
            "player": "Aaron Gordon",
            "position": "PF",
            "aav": 36.4,
            "contractNote": "$33.7M (2026-27) rising to $39.0M (2028-29)"
          }
        ],
        "fact": "Per Basketball-Reference; Denver's 2026-27 payroll is $221.1M, with DeMar DeRozan added Sept 8, 2026",
        "source": "https://www.basketball-reference.com/contracts/DEN.html ; https://en.wikipedia.org/wiki/List_of_2026%E2%80%9327_NBA_season_transactions"
      }
    ],
    "analystNotes": "Forbes valued the Nuggets at $4.6B in October 2025 on $364M of revenue, and the asset base is unchanged: Kroenke owns Ball Arena outright, shares it with the Avalanche, and owns Altitude, so Denver never had a FanDuel Sports Network problem. Jokic is signed through 2027-28 at $59.0M and $62.8M with no extension yet on file, and the 2026 season ended in a six-game first-round loss to Minnesota despite a fifth straight playoff trip and a $221M payroll that added DeMar DeRozan in September. The 17th-ranked DMA caps sponsorship and gate upside, which is why Denver sits below Cleveland and Houston on Forbes despite the 2023 title. A Jokic extension in summer 2027 is the single event that protects the number; a decline to sign would reprice the franchise immediately.",
    "unverifiedAsOf": {}
  },
  "minnesota-timberwolves": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.primaryOwner",
        "old": "Marc Lore & Alex Rodriguez (co-owners)",
        "new": "Marc Lore & Alex Rodriguez (co-owners); Lore agreed August 21, 2026 to sell most of his control stake to Marc Stad (Dragoneer Investment Group) at a $4.5B valuation, with Elisa Stad to serve as governor; pending league approval",
        "fact": "Control sale agreed Aug 21, 2026 at $4.5B per transactions.js (verified there); Wikipedia's 2026-27 season page still lists Rodriguez and Lore as owners pending close",
        "source": "data/transactions.js ; https://en.wikipedia.org/wiki/2026%E2%80%9327_Minnesota_Timberwolves_season"
      },
      {
        "field": "ownership.ownershipGroup",
        "old": [
          {
            "name": "Marc Lore",
            "role": "co-owner",
            "pct": null
          },
          {
            "name": "Alex Rodriguez",
            "role": "co-owner",
            "pct": null
          }
        ],
        "new": [
          {
            "name": "Marc Stad (Dragoneer Investment Group)",
            "role": "incoming control owner; agreed Aug 2026 at $4.5B valuation, pending approval",
            "pct": null
          },
          {
            "name": "Elisa Stad",
            "role": "incoming governor",
            "pct": null
          },
          {
            "name": "Marc Lore",
            "role": "co-owner (selling most of his stake)",
            "pct": null
          },
          {
            "name": "Alex Rodriguez",
            "role": "co-owner",
            "pct": null
          }
        ],
        "fact": "Per transactions.js agreed control transaction dated 2026-08-21",
        "source": "data/transactions.js"
      },
      {
        "field": "media.localTVDeal",
        "old": "Amazon Prime Video (regional streaming deal, 2024), ~$15M/yr — one of NBA's first streaming-primary local broadcast agreements",
        "new": "DAZN exclusive in-market streaming home for 2026-27, announced July 30, 2026, with 15 games free; reported as a five-year deal with a mutual opt-out after year one; replaces FanDuel Sports Network North, which shut down after the 2025-26 regular season",
        "fact": "Minnesota was the first of the 13 former FanDuel teams to go streaming-only; Star Tribune reported five years with a mutual opt-out after one",
        "source": "https://minnesotasnewcountry.com/timberwolves-dazn-local-broadcast-deal/ ; https://www.sportsmediawatch.com/tv-schedules/nba-tv-schedule/minnesota-timberwolves/ ; https://www.startribune.com/minnesota-timberwolves-how-to-watch-games-dazn-tv-channel-streaming-pricing-nba-schedule-2026-27/601873174"
      },
      {
        "field": "media.streamingNotes",
        "old": "Wolves broke new ground as one of first NBA teams to pivot to streaming-first local distribution as RSN landscape collapsed; NBA League Pass also available",
        "new": "Streaming-exclusive local distribution on DAZN from 2026-27 (team-branded subscription, 15 free games); structured with a year-one opt-out to fit the NBA's planned 2027-28 league-wide local streaming package; NBA League Pass unchanged",
        "fact": "Per DAZN announcement coverage and Hoops Rumors league guidance",
        "source": "https://www.hoopsrumors.com/2026/04/nba-tells-13-teams-to-look-for-new-regional-tv-deals.html"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 2,
        "new": 5,
        "fact": "Playoffs every year 2022-2026; beat Denver 4-2 in the 2026 first round, lost 4-2 to San Antonio in round two",
        "source": "https://www.basketball-reference.com/playoffs/NBA_2026.html"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Anthony Edwards — 5yr/$245M max extension (2023), $49M AAV, through 2027-28",
        "new": "Anthony Edwards, $48.9M in 2026-27 rising to $55.7M in 2028-29, paired with LaMelo Ball, acquired from Charlotte July 10, 2026 in a four-team trade ($40.8M in 2026-27, through 2028-29)",
        "fact": "Ball trade cost Julius Randle, Naz Reid, three first-round swaps and a 2033 first; salaries per Basketball-Reference",
        "source": "https://en.wikipedia.org/wiki/List_of_2026%E2%80%9327_NBA_season_transactions ; https://www.basketball-reference.com/contracts/MIN.html"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Anthony Edwards",
            "position": "SG",
            "aav": 49,
            "contractNote": "5yr/$245M max (2023), through 2027-28; supermax eligible with All-NBA trigger"
          }
        ],
        "new": [
          {
            "player": "Anthony Edwards",
            "position": "SG",
            "aav": 52.3,
            "contractNote": "$48.9M (2026-27), $52.3M (2027-28), $55.7M (2028-29)"
          },
          {
            "player": "LaMelo Ball",
            "position": "PG",
            "aav": 43.6,
            "contractNote": "Acquired from Charlotte July 10, 2026; $40.8M (2026-27) rising to $46.4M (2028-29)"
          },
          {
            "player": "Rudy Gobert",
            "position": "C",
            "aav": 37.3,
            "contractNote": "$36.5M (2026-27), $38.0M (2027-28)"
          }
        ],
        "fact": "Per Basketball-Reference; 2026-27 payroll $215.3M",
        "source": "https://www.basketball-reference.com/contracts/MIN.html"
      }
    ],
    "analystNotes": "Forbes valued the Timberwolves at $3.6B in October 2025 with a $41M operating loss, and fourteen months later Marc Lore agreed to sell most of his control stake to Dragoneer's Marc Stad at a $4.5B valuation, a 25% step-up over Forbes and three times the $1.5B Taylor purchase price. The basketball case is real: five straight playoff trips, a 2026 second-round run, Anthony Edwards at $48.9M, and LaMelo Ball added in July for Randle, Reid and future swaps. Minnesota also became the league's first streaming-only local team, moving to DAZN with 15 free games after FanDuel Sports Network North closed, on a deal built to roll into the NBA's 2027-28 package. Closing the Stad transaction and a Target Center replacement plan from the new owners are the two items that carry the number past $4.5B.",
    "unverifiedAsOf": {}
  },
  "oklahoma-city-thunder": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "arena.newArenaPlans",
        "old": "New $900M Continental Coliseum breaking ground March 2026; fully public-funded via OKC MAPS 4 sales tax; opening 2028; Paycom Center to be replaced; modern facility will dramatically increase premium seating capacity",
        "new": "Continental Coliseum broke ground March 26, 2026 on the former Myriad Convention Center site: $900M funded by a 72-month one-cent sales tax that starts when MAPS 4 ends, $78M from MAPS 4 and $50M from Thunder ownership; Continental Resources signed a 15-year naming-rights deal (announced March 24, 2026); opening targeted for late summer 2028 with a contractual deadline of June 2029; Thunder signed a 25-year lease that runs through at least 2053",
        "fact": "Groundbreaking, funding split, naming partner and lease term per the City of Oklahoma City",
        "source": "https://www.okc.gov/News-articles/Oklahoma-City-and-Thunder-break-ground-on-Continental-Coliseum ; https://en.wikipedia.org/wiki/Continental_Coliseum"
      },
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports Oklahoma / FanDuel Sports Network, ~$12M/yr",
        "new": "Griffin Media (Oklahoma broadcast group) over the air for 2026-27 after FanDuel Sports Network Oklahoma shut down at the end of the 2025-26 regular season; Sports Media Watch listed the Thunder among teams expected to focus on over-the-air distribution",
        "fact": "Wikipedia 2026-27 season page lists Griffin Media as television partner",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_Oklahoma_City_Thunder_season ; https://www.sportsmediawatch.com/2026/08/hornets-magic-new-local-rights-deals-streaming-ota/"
      },
      {
        "field": "media.streamingNotes",
        "old": "Standard NBA League Pass",
        "new": "No pay-TV RSN for 2026-27; NBA asked the 13 former FanDuel teams for one-year or opt-out deals ahead of a league-run local streaming package targeted for 2027-28; NBA League Pass unchanged",
        "fact": "League guidance per Hoops Rumors (April 2026)",
        "source": "https://www.hoopsrumors.com/2026/04/nba-tells-13-teams-to-look-for-new-regional-tv-deals.html"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 2,
        "new": 3,
        "fact": "Playoffs 2024, 2025 and 2026; swept Phoenix and the Lakers in 2026, then lost the West finals 4-3 to San Antonio",
        "source": "https://www.basketball-reference.com/playoffs/NBA_2026.html"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Shai Gilgeous-Alexander — 4yr/$285M supermax extension (2025), $71.25M AAV — richest single-season contract in NBA history",
        "new": "Shai Gilgeous-Alexander, 2025-26 MVP (second straight); $40.8M in 2026-27, then the 4yr/$285M supermax runs $61.0M (2027-28) to $75.6M (2030-31)",
        "fact": "MVP per Wikipedia 2025-26 season page; salary schedule per Basketball-Reference",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_NBA_season ; https://www.basketball-reference.com/contracts/OKC.html"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Shai Gilgeous-Alexander",
            "position": "PG",
            "aav": 71.25,
            "contractNote": "4yr/$285M supermax (2025), $71.25M AAV — highest single-season contract in NBA history at signing; 2024-25 MVP"
          },
          {
            "player": "Chet Holmgren",
            "position": "C/PF",
            "aav": 11,
            "contractNote": "On rookie scale through 2025-26; max extension expected"
          }
        ],
        "new": [
          {
            "player": "Shai Gilgeous-Alexander",
            "position": "PG",
            "aav": 71.25,
            "contractNote": "4yr/$285M supermax (2025) starting 2027-28: $61.0M to $75.6M; 2024-25 and 2025-26 MVP"
          },
          {
            "player": "Chet Holmgren",
            "position": "C/PF",
            "aav": 48.1,
            "contractNote": "Rookie-scale max extension (2025); $41.5M (2026-27) rising to $54.8M (2030-31)"
          },
          {
            "player": "Jalen Williams",
            "position": "SF",
            "aav": 48.1,
            "contractNote": "Rookie-scale max extension (2025); $41.5M (2026-27) rising to $54.8M (2030-31)"
          }
        ],
        "fact": "Holmgren and Williams extensions are now on the books at identical $41.5M-to-$54.8M schedules; 2026-27 payroll $216.2M, 2027-28 $237.7M",
        "source": "https://www.basketball-reference.com/contracts/OKC.html"
      }
    ],
    "analystNotes": "Forbes valued the Thunder at $4.35B in October 2025 on $357M of revenue, and the two things that were promises then are now signed: Continental Coliseum broke ground March 26, 2026 with $900M of mostly public money plus $50M from ownership, a 15-year Continental Resources naming deal and a 25-year lease that keeps the team in Oklahoma City through at least 2053, opening in summer 2028. Shai Gilgeous-Alexander won a second straight MVP, and the payroll now reflects the dynasty price, with Holmgren and Jalen Williams at $41.5M each and SGA's $285M supermax starting in 2027-28 for a $238M bill that year. The 2026 defense ended in a seven-game West finals loss to San Antonio, and local TV dropped from FanDuel Sports Network Oklahoma to over-the-air on Griffin Media. Whether a smallest-market team can keep three max players together under the second apron through the arena opening is the question that sets the ceiling.",
    "unverifiedAsOf": {}
  },
  "portland-trail-blazers": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.localTVDeal",
        "old": "Root Sports Northwest (AT&T Sports Networks), ~$12M/yr",
        "new": "Rip City Television Network, the team's own over-the-air affiliate network, per the 2026-27 season page; Root Sports Northwest is no longer the Blazers' carrier",
        "fact": "Wikipedia 2026-27 Trail Blazers page lists Rip City Television Network as the television partner",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_Portland_Trail_Blazers_season"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 2,
        "new": 1,
        "fact": "One appearance in the 2022-2026 window: lost 4-1 to San Antonio in the 2026 first round",
        "source": "https://www.basketball-reference.com/playoffs/NBA_2026.html"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Scoot Henderson (#3 pick 2023) — on rookie scale; full franchise rebuild underway",
        "new": "Ja Morant, acquired from Memphis June 29, 2026 for Jerami Grant and Kris Murray; $42.2M in 2026-27 and $44.9M in 2027-28; Damian Lillard returned to Portland in July 2025 after Milwaukee waived him ($13.4M in 2026-27)",
        "fact": "Morant trade per Wikipedia 2026-27 transactions; Lillard signing per 2025-26 transactions; salaries per Basketball-Reference",
        "source": "https://en.wikipedia.org/wiki/List_of_2026%E2%80%9327_NBA_season_transactions ; https://www.basketball-reference.com/contracts/POR.html"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Scoot Henderson",
            "position": "PG",
            "aav": 10.5,
            "contractNote": "Rookie scale contract through 2026-27; franchise cornerstone of rebuild"
          }
        ],
        "new": [
          {
            "player": "Ja Morant",
            "position": "PG",
            "aav": 43.5,
            "contractNote": "Acquired from Memphis June 29, 2026; $42.2M (2026-27), $44.9M (2027-28)"
          },
          {
            "player": "Jrue Holiday",
            "position": "PG",
            "aav": 36,
            "contractNote": "$34.8M (2026-27), $37.2M (2027-28)"
          },
          {
            "player": "Shaedon Sharpe",
            "position": "SG",
            "aav": 22.5,
            "contractNote": "$20.1M (2026-27) rising to $24.9M (2029-30)"
          },
          {
            "player": "Scoot Henderson",
            "position": "PG",
            "aav": 13.6,
            "contractNote": "$13.6M in 2026-27, final rookie-scale year"
          }
        ],
        "fact": "Per Basketball-Reference; 2026-27 payroll $194.5M",
        "source": "https://www.basketball-reference.com/contracts/POR.html"
      }
    ],
    "analystNotes": "Forbes valued the Trail Blazers at $4.25B in October 2025, matching the Dundon group's price for the Allen estate stake ($4.0B for 80.1% closed, $4.5B on the remaining 19.9% due by 2028), on $361M of revenue. The new owner moved fast: Portland returned to the playoffs in 2026, then traded Jerami Grant and Kris Murray for Ja Morant at $42.2M, pairing him with Jrue Holiday and a returned Damian Lillard, and the local broadcast is now the team-run Rip City Television Network rather than Root Sports. The unresolved item is the building, a 1995 arena whose renovation depends on the state and local financing Dundon's side lined up before closing. A funded Moda Center overhaul is what turns the only major-league team in the Pacific Northwest outside Seattle into a $5B franchise.",
    "unverifiedAsOf": {
      "arena.newArenaPlans": "May 2026"
    }
  },
  "utah-jazz": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "arena.newArenaPlans",
        "old": "$525M Utah state/city infrastructure earmarked for Delta Center upgrades shared between Jazz and Utah Hockey Club; retractable seating and dual-sport configuration enhancements",
        "new": "Multi-phase Delta Center rebuild into a dual-sport arena for the Jazz and Utah Mammoth: Phase 2 finished after 143 days of summer 2026 construction with re-sloped seating (SEG calls them the steepest sightlines of any dual-sport arena), a 439-space parking garage and 18 local food vendors; the south-end dynamic slope and full seat replacement are scheduled for the 2027-28 season; $525M state/city infrastructure package still the public component",
        "fact": "Phase 2 completion and 2027-28 finish per Deseret News and SEG release",
        "source": "https://www.deseret.com/sports/2026/09/25/delta-center-renovations-revealed-for-2026-2027-utah-jazz-season/ ; https://www.nhl.com/utah/news/smith-entertainment-group-unveils-next-steps-on-the-transformation-of-the-delta-center-into-a-world-class-dual-sport-venue-release-5-8-26"
      },
      {
        "field": "arena.capacity",
        "old": 18305,
        "new": 17867,
        "fact": "Official Jazz seating capacity for 2026-27 is 17,867 after the Phase 2 reconfiguration",
        "source": "https://www.deseret.com/sports/2026/09/25/delta-center-renovations-revealed-for-2026-2027-utah-jazz-season/"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 2,
        "new": 1,
        "fact": "Only 2022 falls in the 2022-2026 window; Utah missed the 2026 playoffs and holds the No. 2 pick of the 2026 draft (Darryn Peterson)",
        "source": "https://www.basketball-reference.com/playoffs/NBA_2026.html ; https://en.wikipedia.org/wiki/2026%E2%80%9327_Utah_Jazz_season"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Lauri Markkanen — 5yr/$238M (2023), $47.6M AAV, through 2027-28; franchise in rebuild with strong draft assets",
        "new": "Jaren Jackson Jr., acquired from Memphis February 3, 2026 for three first-round picks and role players ($49.0M in 2026-27, through 2029-30), alongside Lauri Markkanen ($46.1M in 2026-27, through 2028-29); Keyonte George signed a 5yr/$155M extension in July 2026",
        "fact": "Jackson trade per Wikipedia 2025-26 transactions; George extension per Hoops Rumors; salaries per Basketball-Reference",
        "source": "https://en.wikipedia.org/wiki/List_of_2025%E2%80%9326_NBA_season_transactions ; https://www.hoopsrumors.com/2026/07/2026-27-nba-contract-extension-tracker.html"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Lauri Markkanen",
            "position": "PF",
            "aav": 47.6,
            "contractNote": "5yr/$238M (2023), through 2027-28"
          }
        ],
        "new": [
          {
            "player": "Jaren Jackson Jr.",
            "position": "PF/C",
            "aav": 51.3,
            "contractNote": "Acquired from Memphis Feb 3, 2026; $49.0M (2026-27) rising to $53.5M (2029-30)"
          },
          {
            "player": "Lauri Markkanen",
            "position": "PF",
            "aav": 49.8,
            "contractNote": "$46.1M (2026-27), $49.8M (2027-28), $53.5M (2028-29)"
          },
          {
            "player": "Keyonte George",
            "position": "PG",
            "aav": 31,
            "contractNote": "5yr/$155M rookie-scale extension (July 2026) starting 2027-28: $28.7M to $33.6M through 2031-32"
          }
        ],
        "fact": "Per Basketball-Reference and Hoops Rumors; Walker Kessler was sign-and-traded to the Lakers July 8, 2026 for two first-round picks and two swaps",
        "source": "https://www.basketball-reference.com/contracts/UTA.html"
      },
      {
        "field": "media.localTVDeal",
        "old": "Smith Entertainment Group in-house media operations, ~$15M/yr — integrates Jazz and Utah Hockey Club content distribution",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (Wikipedia lists KJZZ-TV, KUTV, Jazz+ (Kiswe) and Root Sports Northwest; the enrichment's ~$15M in-house figure not re-verified)",
        "source": null
      }
    ],
    "analystNotes": "Forbes valued the Jazz at $4.1B in October 2025 on $340M of revenue, and Ryan Smith's case rests on owning the building: Delta Center's Phase 2 rebuild finished in 143 days this summer, re-sloping the bowl for both the Jazz and the NHL's Utah Mammoth at a reduced 17,867 basketball capacity, with the full seat replacement due for 2027-28 on top of $525M in state and city infrastructure money. The roster stopped tanking in February 2026 when Utah sent three first-round picks to Memphis for Jaren Jackson Jr. at $49M, kept Lauri Markkanen at $46.1M, extended Keyonte George for $155M and drafted Darryn Peterson second overall, while flipping Walker Kessler to the Lakers for two more firsts. Salt Lake City is still a bottom-five DMA, so the number depends on the dual-sport building throwing off NHL-plus-NBA event revenue. A finished arena and a playoff return in 2027 are what lift Utah toward the $4.5B small-market ceiling set by Oklahoma City.",
    "unverifiedAsOf": {}
  },
  "golden-state-warriors": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.championshipsLast10Years",
        "old": 4,
        "new": 3,
        "fact": "Titles in 2017, 2018 and 2022 fall inside the 2017-2026 window; the 2015 title no longer does",
        "source": "https://www.basketball-reference.com/playoffs/"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Stephen Curry — 3yr extension signed Aug 2023, $55.8M AAV, through 2028-29",
        "new": "Stephen Curry, $62.6M in 2026-27, then a 2yr/$116M extension signed July 2026 covering 2027-28 and 2028-29 (second-year player option); Jimmy Butler on an expiring $56.8M",
        "fact": "Extension per Hoops Rumors and ESPN; 2026-27 salary per Basketball-Reference",
        "source": "https://www.hoopsrumors.com/2026/07/2026-27-nba-contract-extension-tracker.html ; https://www.basketball-reference.com/contracts/GSW.html"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Stephen Curry",
            "position": "PG",
            "aav": 55.8,
            "contractNote": "3yr extension (Aug 2023), ~$167M total through 2028-29; all-time 3-point record holder"
          },
          {
            "player": "Draymond Green",
            "position": "PF",
            "aav": 22.3,
            "contractNote": "4yr/$100M extension (Oct 2022), through 2026-27"
          }
        ],
        "new": [
          {
            "player": "Stephen Curry",
            "position": "PG",
            "aav": 58,
            "contractNote": "$62.6M (2026-27), then 2yr/$116M extension (July 2026) for 2027-28 and 2028-29 with a player option"
          },
          {
            "player": "Jimmy Butler",
            "position": "SF",
            "aav": 56.8,
            "contractNote": "Acquired from Miami Jan 2025; $56.8M in 2026-27, expiring"
          },
          {
            "player": "Draymond Green",
            "position": "PF",
            "aav": 27.7,
            "contractNote": "Re-signed July 30, 2026; $27.7M in 2026-27"
          },
          {
            "player": "Kristaps Porzingis",
            "position": "C",
            "aav": 20,
            "contractNote": "Acquired from Atlanta Feb 5, 2026 for Jonathan Kuminga and Buddy Hield; $19.5M (2026-27), $20.5M (2027-28)"
          }
        ],
        "fact": "Per Basketball-Reference and Wikipedia transactions; only $60.8M is committed for 2027-28 before the Curry extension",
        "source": "https://www.basketball-reference.com/contracts/GSW.html ; https://en.wikipedia.org/wiki/List_of_2025%E2%80%9326_NBA_season_transactions"
      }
    ],
    "analystNotes": "Forbes ranked the Warriors first in the NBA at $11.0B in October 2025 on $880M of revenue and $409M of operating income, both league highs, and every dollar of that gap over the Knicks and Lakers comes from owning Chase Center and its Mission Bay district outright with no public debt. The basketball side is in its final Curry chapter: Golden State missed the 2026 playoffs out of the play-in, then extended Curry for two years and $116M through 2028-29 with Jimmy Butler on an expiring $56.8M and only $61M otherwise committed for 2027-28. The 2017-2026 window now holds three titles rather than four, and the brand premium is still priced as if the dynasty were current. What moves the number is whether the 2027 cap space rebuilds a contender around Curry's last contract or the franchise enters a post-Curry reset at a $900M revenue base.",
    "unverifiedAsOf": {}
  },
  "los-angeles-clippers": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.primaryOwner",
        "old": "Steve Ballmer (former Microsoft CEO, sole owner)",
        "new": "Steve Ballmer (sole owner), suspended without pay for one year by the NBA on September 2, 2026 following the Kawhi Leonard/Aspiration salary-cap circumvention investigation; the team was fined $30M and forfeited its 2029-2033 first-round picks plus a 2029 Pacers first",
        "fact": "Sanctions announced Sept 2, 2026: one-year suspensions for Ballmer and president of business operations Gillian Zucker, six months for Lawrence Frank, $30M team fine, $700K fine for Leonard",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_Los_Angeles_Clippers_season"
      },
      {
        "field": "media.localTVDeal",
        "old": "NBC Sports California / streaming hybrid, ~$30M/yr",
        "new": "FanDuel Sports Network SoCal carried the Clippers through 2025-26 and shut down with Main Street Sports Group in April 2026; the 2026-27 local partner is listed as TBA, with Sports Media Watch reporting an expected over-the-air focus",
        "fact": "Clippers were one of the 13 former FanDuel Sports Network teams; no 2026-27 deal announced in sources found",
        "source": "https://www.hoopsrumors.com/2026/04/nba-tells-13-teams-to-look-for-new-regional-tv-deals.html ; https://en.wikipedia.org/wiki/2026%E2%80%9327_Los_Angeles_Clippers_season ; https://www.sportsmediawatch.com/2026/08/hornets-magic-new-local-rights-deals-streaming-ota/"
      },
      {
        "field": "media.streamingNotes",
        "old": "Clippers exploring DTC distribution options leveraging Ballmer's tech background; NBA League Pass available",
        "new": "No pay-TV RSN for 2026-27 after the FanDuel Sports Network SoCal shutdown; NBA asked the 13 affected teams for one-year or opt-out deals ahead of a league-run local streaming package targeted for 2027-28; NBA League Pass unchanged",
        "fact": "League guidance per Hoops Rumors (April 2026)",
        "source": "https://www.hoopsrumors.com/2026/04/nba-tells-13-teams-to-look-for-new-regional-tv-deals.html"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Kawhi Leonard — 3yr/$153M (2023), $51M AAV, through 2025-26; James Harden on 2yr/$70M (2023)",
        "new": "Darius Garland, acquired from Cleveland in February 2026 for James Harden ($42.2M in 2026-27, through 2027-28), and Brandon Ingram, acquired from Toronto September 14, 2026 in the Kawhi Leonard trade ($40.0M, through 2027-28)",
        "fact": "Leonard was traded to Toronto for Ingram, Gradey Dick and five draft picks once the NBA investigation concluded",
        "source": "https://en.wikipedia.org/wiki/List_of_2026%E2%80%9327_NBA_season_transactions ; https://www.basketball-reference.com/contracts/LAC.html"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Kawhi Leonard",
            "position": "SF",
            "aav": 51,
            "contractNote": "3yr/$153M (2023), through 2025-26; chronic load management/injury risk"
          },
          {
            "player": "James Harden",
            "position": "PG",
            "aav": 35,
            "contractNote": "2yr/$70M (2023), through 2024-25"
          }
        ],
        "new": [
          {
            "player": "Darius Garland",
            "position": "PG",
            "aav": 43.5,
            "contractNote": "Acquired from Cleveland Feb 2026 for James Harden; $42.2M (2026-27), $44.9M (2027-28)"
          },
          {
            "player": "Brandon Ingram",
            "position": "SF",
            "aav": 41,
            "contractNote": "Acquired from Toronto Sept 14, 2026 in the Kawhi Leonard trade; $40.0M (2026-27), $41.9M (2027-28)"
          },
          {
            "player": "Bradley Beal",
            "position": "SG",
            "aav": 6.6,
            "contractNote": "Re-signed Aug 13, 2026; $6.4M (2026-27), $6.7M (2027-28)"
          }
        ],
        "fact": "Per Basketball-Reference; 2026-27 payroll $193.7M with only $26.7M committed for 2028-29",
        "source": "https://www.basketball-reference.com/contracts/LAC.html"
      },
      {
        "field": "arena.newArenaPlans",
        "old": null,
        "new": "Intuit Dome hosted the 2026 NBA All-Star Game on February 15, 2026; two hotels (a Fairfield by Marriott and a 15-story Arya Hotel) were slated to open adjacent to the arena in June 2026",
        "fact": "Per Wikipedia Intuit Dome page",
        "source": "https://en.wikipedia.org/wiki/Intuit_Dome"
      }
    ],
    "analystNotes": "Forbes valued the Clippers at $7.5B in October 2025 on $569M of revenue, a number that is almost entirely Intuit Dome: Ballmer's $2B privately built arena hosted the 2026 All-Star Game and throws off event income no other NBA tenant in Los Angeles controls. The basketball and governance picture then broke: a 42-40 team lost its play-in game, and on September 2, 2026 the NBA suspended Ballmer for a year without pay, fined the team $30M and stripped its 2029-2033 first-round picks over the Kawhi Leonard cap-circumvention case, with Leonard shipped to Toronto twelve days later for Brandon Ingram and Gradey Dick. The roster is Darius Garland and Ingram at $42.2M and $40.0M on a $194M payroll with almost nothing committed past 2027-28, and the local TV deal died with FanDuel Sports Network SoCal. The building keeps the floor near $7B; a decade without tradable firsts is what caps the ceiling.",
    "unverifiedAsOf": {}
  },
  "los-angeles-lakers": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.primaryOwner",
        "old": "Mark Walter (majority, Guggenheim Partners CEO) / Jeanie Buss (governor)",
        "new": "Mark Walter (majority, TWG Global) / Jeanie Buss (governor); Walter agreed August 12, 2026 to sell his majority stake, together with the Buss family's remaining 17.8%, to Joshua Kushner and Bob Iger at a $12.5B valuation, the largest North American team sale on record; Jeanie Buss has petitioned to block the family-stake sale (hearing set for December 2026) and NBA approval is pending",
        "fact": "Sale terms and Buss challenge per transactions.js (contested, hearing Dec 9, 2026), SI (Dec 8 court date, approval not on the September board agenda) and The Ringer",
        "source": "data/transactions.js ; https://www.si.com/nba/lakers/onsi/lakers-record-ownership-sale-faces-longer-wait-for-nba-approval ; https://www.theringer.com/2026/08/12/nba/lakers-sale-josh-kushner-bob-iger-12-billion-nba-owners"
      },
      {
        "field": "ownership.ownershipGroup",
        "old": [
          {
            "name": "Mark Walter",
            "role": "majority owner",
            "pct": "majority"
          },
          {
            "name": "Jeanie Buss",
            "role": "governor / minority owner",
            "pct": null
          },
          {
            "name": "Magic Johnson",
            "role": "small passive minority",
            "pct": null
          }
        ],
        "new": [
          {
            "name": "Mark Walter (TWG Global)",
            "role": "majority owner; agreed Aug 2026 to sell to Kushner and Iger at $12.5B, pending approval",
            "pct": "majority"
          },
          {
            "name": "Joshua Kushner and Bob Iger",
            "role": "incoming majority owners (contested; NBA approval pending)",
            "pct": null
          },
          {
            "name": "Jeanie Buss",
            "role": "governor; Buss family trusts hold about 17.8%, sale contested by Jeanie Buss",
            "pct": "~17.8% (family)"
          },
          {
            "name": "Todd Boehly, Edward P. Roski, Patrick Soon-Shiong",
            "role": "minority owners",
            "pct": null
          }
        ],
        "fact": "Minority holders per Wikipedia's NBA owners list; Buss family percentage per SI",
        "source": "https://en.wikipedia.org/wiki/List_of_NBA_team_owners ; https://www.si.com/nba/lakers/onsi/lakers-record-ownership-sale-faces-longer-wait-for-nba-approval"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 3,
        "new": 4,
        "fact": "Playoffs 2023-2026; beat Houston 4-2 in the 2026 first round, swept by Oklahoma City in round two",
        "source": "https://www.basketball-reference.com/playoffs/NBA_2026.html"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Luka Doncic — acquired from Dallas Mavericks Feb 2025; 5yr/$346M (2024), $69.2M AAV; LeBron James on $52.6M option through 2025-26",
        "new": "Luka Doncic, $49.8M in 2026-27 rising to $57.8M in 2028-29; LeBron James left for Philadelphia on July 27, 2026 after the Lakers renounced his rights; Walker Kessler acquired from Utah in a July 8, 2026 sign-and-trade for two first-round picks and two swaps",
        "fact": "Per Wikipedia 2026-27 transactions and Basketball-Reference",
        "source": "https://en.wikipedia.org/wiki/List_of_2026%E2%80%9327_NBA_season_transactions ; https://www.basketball-reference.com/contracts/LAL.html"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Luka Doncic",
            "position": "PG",
            "aav": 69.2,
            "contractNote": "5yr/$346M (2024), $69.2M AAV; acquired from Dallas Feb 2025 for Anthony Davis; 5× All-Star under age 26"
          },
          {
            "player": "LeBron James",
            "position": "SF",
            "aav": 52.6,
            "contractNote": "$52.6M player option exercised for 2025-26; playing into age 41 as NBA all-time scoring leader"
          }
        ],
        "new": [
          {
            "player": "Luka Doncic",
            "position": "PG",
            "aav": 53.8,
            "contractNote": "$49.8M (2026-27), $53.8M (2027-28), $57.8M (2028-29)"
          },
          {
            "player": "Austin Reaves",
            "position": "SG",
            "aav": 46.2,
            "contractNote": "$41.2M (2026-27) rising to $51.1M (2029-30)"
          },
          {
            "player": "Walker Kessler",
            "position": "C",
            "aav": 32.5,
            "contractNote": "Sign-and-trade from Utah July 8, 2026; $30.2M (2026-27) rising to $34.8M (2029-30)"
          }
        ],
        "fact": "LeBron James signed a 2yr/$8M deal with Philadelphia; figures per Basketball-Reference; 2026-27 payroll $204.0M",
        "source": "https://www.basketball-reference.com/contracts/LAL.html"
      }
    ],
    "analystNotes": "Forbes valued the Lakers at $10.0B in October 2025 on $551M of revenue, and in August 2026 Mark Walter agreed to sell his majority stake plus the Buss family's 17.8% to Joshua Kushner and Bob Iger at $12.5B, a $2.5B gain in fourteen months and the largest price ever paid for a North American team. The deal is not done: Jeanie Buss has petitioned to block the family-stake sale with a December hearing, and the NBA did not take it up at its September board meeting. On the court the Lakers won a 2026 first-round series before being swept by Oklahoma City, then let LeBron James walk to Philadelphia and paid two firsts and two swaps for Walker Kessler around Luka Doncic at $49.8M and Austin Reaves at $41.2M. The Spectrum SportsNet contract through 2032 and AEG's control of Crypto.com Arena are unchanged, so the $12.5B print, if approved, becomes the new ceiling for every trophy franchise.",
    "unverifiedAsOf": {
      "ownership.acquisitionPrice": "May 2026"
    }
  },
  "phoenix-suns": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports Arizona / FanDuel Sports Network, ~$20M/yr",
        "new": "Arizona's Family Sports (Gray Media over-the-air stations KTVK/KPHO and statewide affiliates) under the five-year deal signed April 28, 2023 that replaced Bally Sports Arizona, plus Fubo in Albuquerque and the Kiswe-powered Suns Live stream; Phoenix was not among the 13 teams hit by the 2026 FanDuel Sports Network shutdown",
        "fact": "Gray deal per Wikipedia FanDuel Sports Network history; 2026-27 carriers per Wikipedia season page",
        "source": "https://en.wikipedia.org/wiki/FanDuel_Sports_Network ; https://en.wikipedia.org/wiki/2026%E2%80%9327_Phoenix_Suns_season"
      },
      {
        "field": "media.streamingNotes",
        "old": "Standard NBA League Pass",
        "new": "Suns Live direct-to-consumer stream (Kiswe) alongside the Gray over-the-air package; NBA League Pass unchanged",
        "fact": "Per Wikipedia 2026-27 season page",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_Phoenix_Suns_season"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Devin Booker — 4yr/$224M (2023), $56M AAV, through 2026-27; Kevin Durant age 36",
        "new": "Devin Booker, $57.1M in 2026-27 rising to $69.2M in 2029-30 (extended in 2025); Kevin Durant traded to Houston in June 2025 for Jalen Green, Dillon Brooks and picks; Bradley Beal waived in 2025",
        "fact": "Durant trade per Wikipedia 2025-26 transactions; Booker schedule per Basketball-Reference",
        "source": "https://en.wikipedia.org/wiki/List_of_2025%E2%80%9326_NBA_season_transactions ; https://www.basketball-reference.com/contracts/PHO.html"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Devin Booker",
            "position": "SG",
            "aav": 56,
            "contractNote": "4yr/$224M (2023), through 2026-27; 4× All-Star"
          },
          {
            "player": "Kevin Durant",
            "position": "SF",
            "aav": 56.5,
            "contractNote": "2yr/$113M (2023); age 36+ entering 2025-26; injury risk increasing"
          },
          {
            "player": "Bradley Beal",
            "position": "SG",
            "aav": 50.2,
            "contractNote": "5yr/$251M (2022), through 2026-27; no-trade clause; $56.3M in 2025-26 — most constrained cap item in Western Conference"
          }
        ],
        "new": [
          {
            "player": "Devin Booker",
            "position": "SG",
            "aav": 62.8,
            "contractNote": "$57.1M (2026-27), $61.0M (2027-28), $64.1M (2028-29), $69.2M (2029-30)"
          },
          {
            "player": "Jalen Green",
            "position": "SG",
            "aav": 36.1,
            "contractNote": "Acquired from Houston June 2025 in the Durant trade; $36.3M (2026-27), $36.0M (2027-28)"
          },
          {
            "player": "Dillon Brooks",
            "position": "SF",
            "aav": 24.3,
            "contractNote": "$20.0M in 2026-27, then 3yr/$73M extension (July 2026) through 2029-30"
          },
          {
            "player": "Miles Bridges",
            "position": "SF",
            "aav": 22.8,
            "contractNote": "Acquired from Charlotte July 13, 2026 for Grayson Allen, Royce O'Neale and a 2033 first; $22.8M in 2026-27, expiring"
          }
        ],
        "fact": "Per Basketball-Reference and Hoops Rumors; 2026-27 payroll $216.2M",
        "source": "https://www.basketball-reference.com/contracts/PHO.html ; https://www.hoopsrumors.com/2026/07/2026-27-nba-contract-extension-tracker.html"
      }
    ],
    "analystNotes": "Forbes valued the Suns at $5.425B in October 2025 on $455M of revenue with a $33M operating loss, the price of the Durant-Booker-Beal experiment that Mat Ishbia unwound in 2025 by trading Durant to Houston and waiving Beal. The 2026 team made the playoffs and was swept by Oklahoma City, and the rebuild-on-the-fly now carries Booker's extension from $57.1M to $69.2M through 2029-30, Jalen Green at $36.3M, a Dillon Brooks extension and Miles Bridges, a $216M payroll for a first-round exit. Phoenix dodged the FanDuel collapse because Ishbia moved to Gray's over-the-air stations in 2023, and the 1992 Mortgage Matchup Center remains the second-oldest building in the league with no replacement deal on record. A playoff series win and a signed arena agreement with the city are what would turn the fourth-fastest-growing DMA's valuation from a market bet into an operating one.",
    "unverifiedAsOf": {}
  },
  "sacramento-kings": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Domantas Sabonis — 4yr/$218M (2022), $54.5M AAV; Zach LaVine acquired from Chicago 2025",
        "new": "Domantas Sabonis, $45.5M in 2026-27 and $48.6M in 2027-28; Zach LaVine on an expiring $49.0M for 2026-27; De'Andre Hunter acquired from Cleveland in February 2026",
        "fact": "Salary schedule per Basketball-Reference; Hunter trade per Wikipedia 2025-26 transactions",
        "source": "https://www.basketball-reference.com/contracts/SAC.html ; https://en.wikipedia.org/wiki/List_of_2025%E2%80%9326_NBA_season_transactions"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Domantas Sabonis",
            "position": "C",
            "aav": 54.5,
            "contractNote": "4yr/$218M (2022), through 2025-26; 3× All-Star; franchise anchor"
          },
          {
            "player": "Zach LaVine",
            "position": "SG",
            "aav": 46,
            "contractNote": "Acquired from Chicago Bulls 2025 along with picks; 3yr/$138M through 2024-25"
          }
        ],
        "new": [
          {
            "player": "Zach LaVine",
            "position": "SG",
            "aav": 49,
            "contractNote": "$49.0M in 2026-27, expiring"
          },
          {
            "player": "Domantas Sabonis",
            "position": "C",
            "aav": 47,
            "contractNote": "$45.5M (2026-27), $48.6M (2027-28)"
          },
          {
            "player": "Keegan Murray",
            "position": "SF",
            "aav": 28,
            "contractNote": "Rookie-scale extension; $24.1M (2026-27) rising to $31.9M (2030-31)"
          },
          {
            "player": "De'Andre Hunter",
            "position": "SF",
            "aav": 24.9,
            "contractNote": "Acquired from Cleveland Feb 2026; $24.9M in 2026-27, expiring"
          }
        ],
        "fact": "Per Basketball-Reference; DeMar DeRozan was waived July 6, 2026; 2026-27 payroll $191.8M falling to $124.4M in 2027-28",
        "source": "https://www.basketball-reference.com/contracts/SAC.html ; https://en.wikipedia.org/wiki/List_of_2026%E2%80%9327_NBA_season_transactions"
      },
      {
        "field": "media.localTVDeal",
        "old": "NBC Sports California, ~$15M/yr",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (Wikipedia lists NBC Sports California plus CBS 13 for 2026-27; over-the-air component and fee not sourced)",
        "source": null
      }
    ],
    "analystNotes": "Forbes valued the Kings at $4.45B in October 2025 on $354M of revenue, an 8.3x mark on Ranadive's $534M 2013 purchase that rests on Golden 1 Center, the DOCO district and a captive single-team market rather than on results. Sacramento has one playoff trip in five years and missed again in 2026 while paying Zach LaVine $49.0M and Domantas Sabonis $45.5M for a lottery finish, then waived DeMar DeRozan in July. The real asset is the 2027 ledger: LaVine and De'Andre Hunter expire, and committed payroll drops from $192M to $124M with Keegan Murray extended through 2030-31. NBC Sports California kept the local TV line intact through the RSN collapse, so the swing factor is purely whether the 2027 cap room produces a playoff team in the largest one-team market in the country.",
    "unverifiedAsOf": {}
  },
  "dallas-mavericks": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports Southwest / FanDuel Sports Network, ~$12M/yr",
        "new": "Tegna over-the-air stations (KFAA-led affiliate network) carry the Mavericks; Dallas left Bally Sports Southwest before the 2024-25 season and was not among the 13 teams hit by the 2026 FanDuel Sports Network shutdown",
        "fact": "Wikipedia 2026-27 season page lists TEGNA Inc. as television partner; FanDuel Sports Network Southwest history per Wikipedia",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_Dallas_Mavericks_season ; https://en.wikipedia.org/wiki/FanDuel_Sports_Network"
      },
      {
        "field": "arena.newArenaPlans",
        "old": "Active discussions between Stars, Mavs, and city/county on renovation or new arena; AAC naming rights expire 2031, triggering natural decision point",
        "new": "Mavericks' American Airlines Center lease runs through 2031; Wikipedia notes the team could move afterward to a new arena in Irving proposed as part of a Las Vegas Sands integrated resort; the WNBA Dallas Wings move into AAC for at least the 2027 season",
        "fact": "Per Wikipedia American Airlines Center page (updated June 2026)",
        "source": "https://en.wikipedia.org/wiki/American_Airlines_Center"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 4,
        "new": 2,
        "fact": "Playoffs in 2022 and 2024 within the 2022-2026 window; missed 2025 and 2026",
        "source": "https://www.basketball-reference.com/playoffs/NBA_2026.html"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Anthony Davis — acquired from Lakers in Luka Doncic trade Feb 2025; 3yr/$186M (2023), $62M AAV; Cooper Flagg selected #1 overall pick 2025",
        "new": "Cooper Flagg, 2025-26 Rookie of the Year, on a rookie scale deal ($14.5M in 2026-27); Anthony Davis was traded to Washington in February 2026; Kyrie Irving re-signed in 2025 ($39.5M in 2026-27, through 2027-28)",
        "fact": "Flagg ROY per Wikipedia 2025-26 season page; Davis trade per Wikipedia 2025-26 transactions; salaries per Basketball-Reference",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_NBA_season ; https://en.wikipedia.org/wiki/List_of_2025%E2%80%9326_NBA_season_transactions ; https://www.basketball-reference.com/contracts/DAL.html"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Anthony Davis",
            "position": "C",
            "aav": 62,
            "contractNote": "3yr/$186M (2023), through 2025-26; acquired from Lakers in blockbuster Doncic trade Feb 2025"
          },
          {
            "player": "Kyrie Irving",
            "position": "PG",
            "aav": 42,
            "contractNote": "3yr/$126M (2023), through 2025-26"
          },
          {
            "player": "Cooper Flagg",
            "position": "SF",
            "aav": 14,
            "contractNote": "#1 overall pick 2025; on rookie scale through 2028-29"
          }
        ],
        "new": [
          {
            "player": "Kyrie Irving",
            "position": "PG",
            "aav": 41,
            "contractNote": "$39.5M (2026-27), $42.4M (2027-28)"
          },
          {
            "player": "Cooper Flagg",
            "position": "SF",
            "aav": 16.3,
            "contractNote": "2025-26 Rookie of the Year; $14.5M (2026-27), $15.2M (2027-28), $19.2M (2028-29 team option year)"
          },
          {
            "player": "Zaccharie Risacher",
            "position": "SF",
            "aav": 15.6,
            "contractNote": "Acquired from Atlanta July 19, 2026 (2024 No. 1 pick); $13.8M (2026-27), $17.4M (2027-28)"
          },
          {
            "player": "P.J. Washington",
            "position": "PF",
            "aav": 22.2,
            "contractNote": "$19.8M (2026-27) rising to $24.6M (2029-30)"
          }
        ],
        "fact": "Per Basketball-Reference and Wikipedia 2026-27 transactions; 2026-27 payroll $197.9M",
        "source": "https://www.basketball-reference.com/contracts/DAL.html ; https://en.wikipedia.org/wiki/List_of_2026%E2%80%9327_NBA_season_transactions"
      }
    ],
    "analystNotes": "Forbes valued the Mavericks at $5.1B in October 2025 on $407M of revenue, and the Adelson-Dumont thesis is still a Texas gaming and real estate play: the AAC lease runs to 2031, and the exit ramp on record is a Las Vegas Sands integrated resort in Irving with a new arena attached. The post-Doncic roster reset finished in February 2026 when Anthony Davis went to Washington, leaving Cooper Flagg, the 2025-26 Rookie of the Year on $14.5M, and 2024 No. 1 pick Zaccharie Risacher, acquired in July, as the core next to Kyrie Irving at $39.5M. Dallas missed the playoffs in 2025 and 2026 and its local TV moved to Tegna over-the-air stations before the RSN collapse, so media income is already reset. Flagg's development and a Texas casino bill are the two variables, and only one of them is about basketball.",
    "unverifiedAsOf": {}
  },
  "houston-rockets": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 1,
        "new": 2,
        "fact": "Playoffs in 2025 and 2026; lost 4-2 to the Lakers in the 2026 first round",
        "source": "https://www.basketball-reference.com/playoffs/NBA_2026.html"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Jalen Green — 5yr/$165M (2023), $33M AAV; Kevin Durant acquired from Phoenix Suns 2025",
        "new": "Kevin Durant ($43.9M in 2026-27, $46.1M in 2027-28) and Alperen Sengun ($35.6M in 2026-27, through 2029-30); Amen Thompson signed a 5yr/$208M rookie-scale extension in July 2026; Jalen Green went to Phoenix in the June 2025 Durant trade",
        "fact": "Thompson extension per Hoops Rumors; salaries per Basketball-Reference",
        "source": "https://www.hoopsrumors.com/2026/07/2026-27-nba-contract-extension-tracker.html ; https://www.basketball-reference.com/contracts/HOU.html"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Jalen Green",
            "position": "SG",
            "aav": 33,
            "contractNote": "5yr/$165M (2023), through 2027-28; franchise cornerstone"
          },
          {
            "player": "Kevin Durant",
            "position": "SF",
            "aav": 56.5,
            "contractNote": "Acquired from Phoenix Suns 2025; age 36+; global brand extends Houston's reach"
          },
          {
            "player": "Fred VanVleet",
            "position": "PG",
            "aav": 43.3,
            "contractNote": "3yr/$130M (2023), through 2025-26"
          }
        ],
        "new": [
          {
            "player": "Kevin Durant",
            "position": "SF",
            "aav": 45,
            "contractNote": "Acquired from Phoenix June 2025; $43.9M (2026-27), $46.1M (2027-28)"
          },
          {
            "player": "Alperen Sengun",
            "position": "C",
            "aav": 37.8,
            "contractNote": "$35.6M (2026-27) rising to $39.0M (2028-29 and 2029-30)"
          },
          {
            "player": "Amen Thompson",
            "position": "SF",
            "aav": 41.6,
            "contractNote": "$12.3M in 2026-27, then 5yr/$208M extension (July 2026): $35.9M (2027-28) to $47.3M (2031-32)"
          },
          {
            "player": "Fred VanVleet",
            "position": "PG",
            "aav": 25,
            "contractNote": "$25M in 2026-27, expiring"
          }
        ],
        "fact": "Per Basketball-Reference and Hoops Rumors; 2026-27 payroll $205.5M",
        "source": "https://www.basketball-reference.com/contracts/HOU.html"
      }
    ],
    "analystNotes": "Forbes valued the Rockets at $5.9B in October 2025 on $467M of revenue and $191M of operating income, the third-best margin in the league, and the Space City Home Network bet means Houston's local media line never touched FanDuel Sports Network. The Durant trade produced two straight playoff trips but a six-game first-round loss to the Lakers in 2026, and the franchise then paid for its future rather than its present: Amen Thompson's 5yr/$208M extension starts in 2027-28 next to Sengun's deal through 2029-30, while Durant's $43.9M and VanVleet's expiring $25M carry the 2026-27 season. The $180M Toyota Center renovation was due this year and locks in the building for a decade. Whether the Thompson-Sengun core wins a series before Durant's contract ends in 2028 is what decides if Houston holds the No. 6 valuation in the league.",
    "unverifiedAsOf": {
      "arena.newArenaPlans": "May 2026"
    }
  },
  "memphis-grizzlies": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports Southeast / FanDuel Sports Network, ~$12M/yr",
        "new": "Gray Media over-the-air affiliates for 2026-27 after FanDuel Sports Network Southeast shut down at the end of the 2025-26 regular season, with DAZN reported near an exclusive in-market streaming agreement",
        "fact": "Wikipedia 2026-27 season page lists Gray Media; Yahoo/Hoops Rumors report DAZN near a deal with Memphis",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_Memphis_Grizzlies_season ; https://sports.yahoo.com/articles/pacers-expected-move-local-broadcasts-201055030.html"
      },
      {
        "field": "media.streamingNotes",
        "old": "Standard NBA League Pass",
        "new": "DAZN streaming deal reported but not confirmed in sources found; NBA asked the 13 former FanDuel teams for one-year or opt-out deals ahead of a league-run local streaming package targeted for 2027-28; NBA League Pass unchanged",
        "fact": "League guidance per Hoops Rumors (April 2026)",
        "source": "https://www.hoopsrumors.com/2026/04/nba-tells-13-teams-to-look-for-new-regional-tv-deals.html"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 2,
        "new": 3,
        "fact": "Playoffs 2022, 2023 and 2025 within the 2022-2026 window; missed 2026",
        "source": "https://www.basketball-reference.com/playoffs/NBA_2026.html"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Ja Morant — 5yr/$231M (2022), $46.2M AAV, through 2026-27; multiple gun-related suspensions create ongoing reputational risk",
        "new": "Full teardown: Ja Morant traded to Portland June 29, 2026 for Jerami Grant and Kris Murray; Jaren Jackson Jr. traded to Utah February 3, 2026 for three first-round picks; Desmond Bane traded to Orlando June 2025; 2026 draftee Cameron Boozer ($11.8M) is the new centerpiece",
        "fact": "Per Wikipedia 2025-26 and 2026-27 transactions and Basketball-Reference",
        "source": "https://en.wikipedia.org/wiki/List_of_2026%E2%80%9327_NBA_season_transactions ; https://en.wikipedia.org/wiki/List_of_2025%E2%80%9326_NBA_season_transactions ; https://www.basketball-reference.com/contracts/MEM.html"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Ja Morant",
            "position": "PG",
            "aav": 46.2,
            "contractNote": "5yr/$231M (2022), through 2026-27; two gun-related suspensions (2022-23 and 2023-24); trade speculation active"
          },
          {
            "player": "Jaren Jackson Jr.",
            "position": "C/PF",
            "aav": 60,
            "contractNote": "4yr/$240M (2024), through 2027-28; 2023 Defensive Player of the Year"
          }
        ],
        "new": [
          {
            "player": "Jerami Grant",
            "position": "PF",
            "aav": 35.3,
            "contractNote": "Acquired from Portland June 29, 2026 in the Morant trade; $34.2M (2026-27), $36.4M (2027-28)"
          },
          {
            "player": "Isaiah Stewart",
            "position": "C",
            "aav": 15,
            "contractNote": "Acquired from Detroit July 8, 2026; $15M per year through 2027-28"
          },
          {
            "player": "Cameron Boozer",
            "position": "PF",
            "aav": 13.4,
            "contractNote": "2026 first-round pick; $11.8M (2026-27) rising to $16.5M (2029-30 option year)"
          }
        ],
        "fact": "Per Basketball-Reference; 2026-27 payroll $161.1M, the lowest in the league among teams sampled, with $119M committed for 2027-28",
        "source": "https://www.basketball-reference.com/contracts/MEM.html"
      }
    ],
    "analystNotes": "Forbes valued the Grizzlies at $3.5B in October 2025 on $306M of revenue with $28M of operating income, the thinnest margin in the West, and in the twelve months since Memphis has sold every star: Desmond Bane to Orlando, Jaren Jackson Jr. to Utah for three firsts in February 2026, and Ja Morant to Portland in June for Jerami Grant and Kris Murray. The result is a $161M payroll built around 2026 draftee Cameron Boozer and a pile of picks, in the 45th DMA, with the local TV line reduced to Gray over-the-air stations and a pending DAZN stream after FanDuel Sports Network Southeast closed. Pera's $377M 2012 entry is still a 9x mark, but this is now the purest national-revenue-pool franchise in the league. Converting the Jackson and Morant picks into the next star is the only path back above $4B.",
    "unverifiedAsOf": {
      "arena.namingRightsDeal": "May 2026"
    }
  },
  "new-orleans-pelicans": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports New Orleans / FanDuel Sports Network, ~$12M/yr",
        "new": "Gulf Coast Sports & Entertainment Network, a Gray Media over-the-air network across Louisiana, Mississippi and Alabama launched October 2, 2024 after Diamond dropped the Pelicans; New Orleans was not among the 13 teams hit by the 2026 FanDuel Sports Network shutdown",
        "fact": "Per Wikipedia Gulf Coast Sports & Entertainment Network and 2026-27 season pages",
        "source": "https://en.wikipedia.org/wiki/Gulf_Coast_Sports_%26_Entertainment_Network ; https://en.wikipedia.org/wiki/2026%E2%80%9327_New_Orleans_Pelicans_season"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Zion Williamson — 5yr/$197M (2022), $39.4M AAV, through 2026-27; Brandon Ingram requested trade 2025",
        "new": "Zion Williamson, $42.2M in 2026-27 and $44.9M in 2027-28; Brandon Ingram was traded to Toronto in February 2025 and CJ McCollum to Washington in 2025; Jamahl Mosley hired as head coach May 18, 2026",
        "fact": "Salary schedule per Basketball-Reference; Mosley hire per Wikipedia 2026-27 season page",
        "source": "https://www.basketball-reference.com/contracts/NOP.html ; https://en.wikipedia.org/wiki/2026%E2%80%9327_New_Orleans_Pelicans_season"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Zion Williamson",
            "position": "PF",
            "aav": 39.4,
            "contractNote": "5yr/$197M (2022), through 2026-27; chronic injury history limits availability; $39.4M guaranteed regardless"
          },
          {
            "player": "Brandon Ingram",
            "position": "SF",
            "aav": 31.6,
            "contractNote": "5yr/$158M (2021), through 2025-26; submitted trade request 2025"
          },
          {
            "player": "CJ McCollum",
            "position": "PG",
            "aav": 29.3,
            "contractNote": "3yr/$88M (2022), through 2024-25"
          }
        ],
        "new": [
          {
            "player": "Zion Williamson",
            "position": "PF",
            "aav": 43.5,
            "contractNote": "$42.2M (2026-27), $44.9M (2027-28)"
          },
          {
            "player": "Jordan Poole",
            "position": "SG",
            "aav": 34,
            "contractNote": "$34.0M in 2026-27, expiring"
          },
          {
            "player": "Dejounte Murray",
            "position": "PG",
            "aav": 31.8,
            "contractNote": "$32.8M (2026-27), $30.8M (2027-28)"
          },
          {
            "player": "Trey Murphy III",
            "position": "SF",
            "aav": 29,
            "contractNote": "$27.0M (2026-27) rising to $31.0M (2028-29)"
          }
        ],
        "fact": "Per Basketball-Reference; 2026-27 payroll $204.3M",
        "source": "https://www.basketball-reference.com/contracts/NOP.html"
      }
    ],
    "analystNotes": "Forbes valued the Pelicans at $3.55B in October 2025 on $302M of revenue, the lowest revenue base in the league, and the operating story has not changed: New Orleans missed the playoffs in 2025 and 2026, changed coaches to Jamahl Mosley in May, and still pays Zion Williamson $42.2M on a $204M payroll with Jordan Poole's $34M expiring. The one structural fix already happened in 2024, when the team left Diamond for Gray's over-the-air Gulf Coast network, so the 2026 FanDuel collapse passed New Orleans by. The Smoothie King Center decision, a $250M renovation or a $1B-plus new arena, is still open with the building past its 25th year. Zion's availability and a signed arena plan are the two inputs; without both the franchise stays anchored to the national revenue pool at the bottom of the West.",
    "unverifiedAsOf": {
      "arena.newArenaPlans": "May 2026"
    }
  },
  "san-antonio-spurs": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports Southwest / FanDuel Sports Network, ~$15M/yr",
        "new": "Tegna over-the-air affiliates for 2026-27 after FanDuel Sports Network Southwest shut down at the end of the 2025-26 regular season, with DAZN reported near an exclusive in-market streaming agreement",
        "fact": "Wikipedia 2026-27 season page lists Tegna Inc.; Yahoo/Hoops Rumors report DAZN near a deal with San Antonio",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_San_Antonio_Spurs_season ; https://sports.yahoo.com/articles/pacers-expected-move-local-broadcasts-201055030.html"
      },
      {
        "field": "media.streamingNotes",
        "old": "Standard NBA League Pass",
        "new": "DAZN streaming deal reported but not confirmed in sources found; NBA asked the 13 former FanDuel teams for one-year or opt-out deals ahead of a league-run local streaming package targeted for 2027-28; NBA League Pass unchanged",
        "fact": "League guidance per Hoops Rumors (April 2026)",
        "source": "https://www.hoopsrumors.com/2026/04/nba-tells-13-teams-to-look-for-new-regional-tv-deals.html"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 0,
        "new": 1,
        "fact": "2026 playoffs: beat Portland 4-1, Minnesota 4-2 and Oklahoma City 4-3 to win the Western Conference, then lost the Finals 4-1 to New York",
        "source": "https://www.basketball-reference.com/playoffs/NBA_2026.html"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Victor Wembanyama — rookie scale contract ($13.75M AAV through 2026-27); 2024 Rookie of the Year; #1 pick 2023; supermax extension eligible 2026",
        "new": "Victor Wembanyama, 2025-26 Defensive Player of the Year and All-NBA; signed a 5yr/$252M rookie-scale max extension in July 2026 (25% of cap, fifth-year player option, 15% trade kicker) running 2027-28 through 2031-32 after declining the 30% Rose Rule structure that could have reached $303M; $16.9M in 2026-27",
        "fact": "Largest rookie extension in NBA history; terms per Hoops Rumors, ESPN and Yahoo; DPOY per Wikipedia 2025-26 season page",
        "source": "https://www.hoopsrumors.com/2026/07/2026-27-nba-contract-extension-tracker.html ; https://sports.yahoo.com/articles/san-antonio-spurs-sign-victor-225912820.html ; https://en.wikipedia.org/wiki/2025%E2%80%9326_NBA_season"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Victor Wembanyama",
            "position": "C/PF",
            "aav": 13.75,
            "contractNote": "Rookie scale through 2026-27; 7'4\" wingspan; considered once-in-generation talent; max extension ~$280M eligible summer 2026"
          },
          {
            "player": "De'Aaron Fox",
            "position": "PG",
            "aav": 30,
            "contractNote": "Acquired from Sacramento Kings in 3-team trade Feb 2025; established All-Star guard to complement Wembanyama's development"
          }
        ],
        "new": [
          {
            "player": "Victor Wembanyama",
            "position": "C/PF",
            "aav": 50.5,
            "contractNote": "$16.9M in 2026-27, then 5yr/$252M extension (July 2026): $43.5M (2027-28) to $57.4M (2031-32), fifth-year player option; 2025-26 DPOY"
          },
          {
            "player": "De'Aaron Fox",
            "position": "PG",
            "aav": 55.8,
            "contractNote": "$49.8M (2026-27) rising to $61.8M (2029-30)"
          },
          {
            "player": "Devin Vassell",
            "position": "SG",
            "aav": 26.2,
            "contractNote": "$27.0M (2026-27), $24.7M (2027-28), $27.0M (2028-29)"
          }
        ],
        "fact": "Per Basketball-Reference and Hoops Rumors; 2026-27 payroll $198.3M",
        "source": "https://www.basketball-reference.com/contracts/SAS.html"
      }
    ],
    "analystNotes": "Forbes valued the Spurs at $4.4B in October 2025 on $401M of revenue, and the number is already stale: San Antonio won the 2026 Western Conference, beating Oklahoma City in seven before losing the Finals to New York in five, with Victor Wembanyama taking Defensive Player of the Year and then signing a 5yr/$252M extension at 25% of the cap, leaving roughly $50M on the table versus the Rose Rule maximum to keep the roster together. De'Aaron Fox's deal runs to $61.8M by 2029-30, so the Spurs carry two max contracts into the 2030 opening of the $1.3B Hemisfair arena that gives them venue economics for the first time. Local TV reset to Tegna over-the-air stations plus a pending DAZN stream after FanDuel Sports Network Southwest closed. The first Wembanyama title, and the arena on schedule, would push a small-market franchise past $6B on brand alone.",
    "unverifiedAsOf": {}
  },
  "new-york-yankees": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$57M/team/year from MLB national deals (ESPN through 2028 ~$550M/yr, Fox through 2028 ~$729M/yr, Apple TV+ ~$85M/yr)",
        "new": "2026-2028 national deals: ESPN ~$550M/yr (30-game national package plus MLB.TV distribution), NBC/Peacock ~$200M/yr (Sunday Night Baseball, Wild Card games), Netflix ~$50M/yr (Home Run Derby), alongside the existing Fox (~$729M/yr) and TNT packages that run through 2028 (CNBC, Nov 2025); the CBA expires Dec 1, 2026 and a lockout over the owners' salary cap proposal is widely expected",
        "fact": "MLB signed three-year national deals with ESPN, NBC and Netflix in Nov 2025 for 2026-2028 (~$800M/yr combined); CBA expires Dec 1, 2026",
        "source": "https://www.cnbc.com/2025/11/19/mlb-media-rights-deals-nbc-espn-netflix.html"
      },
      {
        "field": "ownership.institutionalInvestors",
        "old": "None — wholly family-owned; Yankees have consistently rejected partial sales. YES Network (26% stake) is the only external structural complexity.",
        "new": "Apollo Sports Capital agreed (Aug 11, 2026) to a ~$2.6B debt-plus-equity investment in Yankee Global Enterprises (team, YES Network, Legends, NYCFC and AC Milan stakes) at a reported $10B+ holding-company mark; Apollo takes ~8% common plus convertible preferred (up to 16%), which needs an MLB waiver of the 15% PE cap; Steinbrenners keep 60%+ and control",
        "fact": "Apollo Sports Capital investment in YGE announced Aug 11, 2026 (verified in transactions.js)",
        "source": "https://ir.apollo.com/news-events/press-releases/detail/641/yankee-global-enterprises-welcomes-apollo-sports-capital-as"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Aaron Judge — 9yr/$360M extension signed Dec 2022, $40M AAV, through 2031",
        "new": "Aaron Judge, 9yr/$360M extension signed Dec 2022, $40M AAV, through 2031; won his third AL MVP in 2025",
        "fact": "Judge won 2025 AL MVP",
        "source": "https://www.mlbtraderumors.com/2026/03/offseason-in-review-new-york-yankees-17.html"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Aaron Judge",
            "position": "CF/RF",
            "aav": 40,
            "contractNote": "9yr/$360M (Dec 2022), through 2031; 2022 AL MVP, 62 HR record"
          },
          {
            "player": "Gerrit Cole",
            "position": "SP",
            "aav": 36,
            "contractNote": "9yr/$324M (Dec 2019), through 2028; 2023 AL Cy Young"
          },
          {
            "player": "Carlos Rodón",
            "position": "SP",
            "aav": 27,
            "contractNote": "6yr/$162M (Dec 2022), through 2028"
          }
        ],
        "new": [
          {
            "player": "Aaron Judge",
            "position": "CF/RF",
            "aav": 40,
            "contractNote": "9yr/$360M (Dec 2022), through 2031; 2022, 2024 and 2025 AL MVP"
          },
          {
            "player": "Cody Bellinger",
            "position": "OF/1B",
            "aav": 32.5,
            "contractNote": "5yr/$162.5M (Jan 2026) after opting out of his 2026 option; re-signed with New York"
          },
          {
            "player": "Gerrit Cole",
            "position": "SP",
            "aav": 36,
            "contractNote": "9yr/$324M (Dec 2019), through 2028; 2023 AL Cy Young; began 2026 recovering from surgery"
          },
          {
            "player": "Carlos Rodón",
            "position": "SP",
            "aav": 27,
            "contractNote": "6yr/$162M (Dec 2022), through 2028"
          }
        ],
        "fact": "Bellinger re-signed 5yr/$162.5M in Jan 2026; Cole, Rodón and Schmidt opened 2026 recovering from surgeries",
        "source": "https://www.mlbtraderumors.com/2026/01/yankees-to-re-sign-cody-bellinger.html"
      },
      {
        "field": "media.localTVDeal",
        "old": "YES Network — Yankees own ~26% equity stake (reacquired 2019 from Fox/Sinclair group); YES generates ~$300M+ annual revenue with ~$150M+ flowing to team between rights fee and equity distributions; richest local media arrangement in MLB",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (YES Network arrangement not re-checked with a 2026 source)",
        "source": null
      },
      {
        "field": "media.streamingNotes",
        "old": "Apple TV+ Friday Game of the Week; ESPN/Fox national packages; YES available on streaming via YouTube TV, Hulu Live, fuboTV",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (Apple TV+ Friday package status for 2026 not re-checked)",
        "source": null
      }
    ],
    "analystNotes": "The Yankees are the first MLB franchise Forbes marks above $8B, at $8.5B on the March 2026 list with $710M of revenue and a $53M operating loss after a $61.8M luxury tax bill. Apollo's August 2026 investment in Yankee Global Enterprises reportedly values the holding company, which bundles YES Network and Legends with the team, above $10B, a 17% premium to the Forbes mark that prices the media and hospitality stack rather than the club alone. A 93-68 wild card berth in 2026 follows a 2025 season that ended with Judge's third MVP but no pennant; the 2009 title remains the last one. The number moves on whether MLB waives its 15% private equity cap for Apollo and on how the December 2026 CBA fight resets payroll economics for the sport's biggest spender.",
    "unverifiedAsOf": {}
  },
  "boston-red-sox": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$57M/team/year from MLB national deals (ESPN through 2028 ~$550M/yr, Fox through 2028 ~$729M/yr, Apple TV+ ~$85M/yr)",
        "new": "2026-2028 national deals: ESPN ~$550M/yr (30-game national package plus MLB.TV distribution), NBC/Peacock ~$200M/yr (Sunday Night Baseball, Wild Card games), Netflix ~$50M/yr (Home Run Derby), alongside the existing Fox (~$729M/yr) and TNT packages that run through 2028 (CNBC, Nov 2025); the CBA expires Dec 1, 2026 and a lockout over the owners' salary cap proposal is widely expected",
        "fact": "MLB signed three-year national deals with ESPN, NBC and Netflix in Nov 2025 for 2026-2028 (~$800M/yr combined); CBA expires Dec 1, 2026",
        "source": "https://www.cnbc.com/2025/11/19/mlb-media-rights-deals-nbc-espn-netflix.html"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Triston Casas — pre-arb; team in rebuilding mode following Devers trade (Jan 2025)",
        "new": "Garrett Crochet, 6yr/$170M extension signed Mar 31, 2025, through 2030; 2025 AL strikeout leader (255 K, 2.59 ERA); Devers traded to San Francisco June 15, 2025",
        "fact": "Crochet extension Mar 2025; Devers traded June 2025; Bregman left for the Cubs Jan 2026",
        "source": "https://en.wikipedia.org/wiki/Garrett_Crochet"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Rafael Devers",
            "position": "3B",
            "aav": 30.1,
            "contractNote": "11yr/$331M extension (signed Jan 2023); traded to San Francisco Giants Jan 2025 — contract transferred in deal"
          },
          {
            "player": "Masataka Yoshida",
            "position": "DH/OF",
            "aav": 21,
            "contractNote": "5yr/$90M (Dec 2022); through 2027"
          }
        ],
        "new": [
          {
            "player": "Garrett Crochet",
            "position": "SP",
            "aav": 28.3,
            "contractNote": "6yr/$170M extension (Mar 31, 2025), through 2030; 18-5, 2.59 ERA, 255 K in 2025; lat strain limited 2026"
          },
          {
            "player": "Ranger Suárez",
            "position": "SP",
            "aav": 30,
            "contractNote": "5yr/$150M free-agent deal (Jan 2026) from Philadelphia"
          },
          {
            "player": "Masataka Yoshida",
            "position": "DH/OF",
            "aav": 21,
            "contractNote": "5yr/$90M (Dec 2022); through 2027"
          },
          {
            "player": "Rafael Devers",
            "position": "3B/DH",
            "aav": 30.1,
            "contractNote": "11yr/$331M extension (Jan 2023); traded to San Francisco Giants June 15, 2025 for Kyle Harrison, Jordan Hicks and prospects; Alex Bregman (3yr/$120M, Feb 2025) opted out and signed with the Cubs Jan 2026"
          }
        ],
        "fact": "Devers traded to Giants June 2025; Crochet 6yr/$170M; Suárez 5yr/$150M Jan 2026; Sonny Gray (Nov 25, 2025) and Willson Contreras (Dec 21, 2025) acquired from St. Louis",
        "source": "https://en.wikipedia.org/wiki/2026_Boston_Red_Sox_season"
      }
    ],
    "analystNotes": "Forbes values the Red Sox at $5.25B on the 2026 list with $567M of revenue and $78M of operating income, and Boston backed that up on the field with an 87-74 wild card season, its second straight playoff trip, after sitting 14 games under .500 in the spring. The structural pieces are unchanged: FSG owns 80% of NESN and owns Fenway Park outright, so the club keeps rights fees, distribution economics and every non-game dollar at a 37,755-seat park that stays full. The Devers trade to San Francisco in June 2025 and the pivot to pitching, Crochet at 6yr/$170M and Ranger Suárez at 5yr/$150M, define the current window. What moves the number is a Bregman-style star bat or a deeper October run; the NESN and Fenway floor already prices in the downside.",
    "unverifiedAsOf": {
      "ownership.ownerNetWorth": "May 2026"
    }
  },
  "toronto-blue-jays": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$57M/team/year from MLB national deals (ESPN through 2028 ~$550M/yr, Fox through 2028 ~$729M/yr, Apple TV+ ~$85M/yr)",
        "new": "2026-2028 national deals: ESPN ~$550M/yr (30-game national package plus MLB.TV distribution), NBC/Peacock ~$200M/yr (Sunday Night Baseball, Wild Card games), Netflix ~$50M/yr (Home Run Derby), alongside the existing Fox (~$729M/yr) and TNT packages that run through 2028 (CNBC, Nov 2025); the CBA expires Dec 1, 2026 and a lockout over the owners' salary cap proposal is widely expected",
        "fact": "MLB signed three-year national deals with ESPN, NBC and Netflix in Nov 2025 for 2026-2028 (~$800M/yr combined); CBA expires Dec 1, 2026",
        "source": "https://www.cnbc.com/2025/11/19/mlb-media-rights-deals-nbc-espn-netflix.html"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 2,
        "new": 3,
        "fact": "Completed-season count for 2021-2025; 2025 postseason field: AL Blue Jays, Mariners, Guardians, Yankees, Red Sox, Tigers; NL Brewers, Phillies, Dodgers, Cubs, Padres, Reds; Toronto won the 2025 AL pennant and lost World Series Game 7 to the Dodgers",
        "source": "https://en.wikipedia.org/wiki/2025_Major_League_Baseball_postseason"
      },
      {
        "field": "ownership.institutionalInvestors",
        "old": "Rogers Communications is publicly traded; Rogers Control Trust (family) controls majority of voting shares. Sportico's 2026 reporting indicates Rogers exploring partial sale of sports assets at implied ~$18B total valuation for sports portfolio.",
        "new": "Rogers Communications is publicly traded; Rogers Control Trust (family) controls the voting shares. Rogers is buying the final 25% of MLSE for $3.1B (close expected Q4 2026), then plans to fold the Blue Jays into a consolidated sports group and sell a minority stake, targeted for the first half of 2027 (Front Office Sports, July 2026); Sportico has reported an ~$18B implied sports-portfolio valuation",
        "fact": "Rogers to complete MLSE buyout in Q4 2026 and sell a minority stake in the combined sports group including the Blue Jays in H1 2027",
        "source": "https://frontofficesports.com/blue-jays-maple-leafs-owner-to-put-stake-in-sports-empire-up-for-sale/"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Vladimir Guerrero Jr.",
            "position": "1B",
            "aav": 35.7,
            "contractNote": "14yr/$500M extension (2025), through 2038; third-largest contract in MLB history; $325M signing bonus"
          },
          {
            "player": "George Springer",
            "position": "CF",
            "aav": 25,
            "contractNote": "6yr/$150M (Nov 2020), through 2026; postseason presence"
          }
        ],
        "new": [
          {
            "player": "Vladimir Guerrero Jr.",
            "position": "1B",
            "aav": 35.7,
            "contractNote": "14yr/$500M extension (2025), through 2038; $325M signing bonus"
          },
          {
            "player": "Dylan Cease",
            "position": "SP",
            "aav": 30,
            "contractNote": "7yr/$210M free-agent deal (Dec 2, 2025); largest free-agent contract in Blue Jays history"
          },
          {
            "player": "Kazuma Okamoto",
            "position": "3B/1B",
            "aav": 15,
            "contractNote": "4yr/$60M (Jan 4, 2026) from NPB"
          },
          {
            "player": "George Springer",
            "position": "CF",
            "aav": 25,
            "contractNote": "6yr/$150M (Nov 2020), through 2026; Bo Bichette left for the Mets (3yr/$126M, Jan 2026)"
          }
        ],
        "fact": "Cease 7yr/$210M (Dec 2025), Okamoto 4yr/$60M (Jan 2026), Tyler Rogers 3yr/$37M; Bichette signed with the Mets",
        "source": "https://en.wikipedia.org/wiki/Dylan_Cease"
      },
      {
        "field": "media.localTVDeal",
        "old": "Sportsnet (Rogers Media subsidiary) — fully owned by parent Rogers Communications; no arm's-length media deal; team, stadium, and RSN are all Rogers properties, creating complex intracompany revenue recognition",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (Sportsnet arrangement assumed unchanged under Rogers ownership; not separately checked)",
        "source": null
      }
    ],
    "analystNotes": "The Blue Jays sit at $2.5B on the 2026 Forbes list with $445M of revenue and a $71M operating loss, the price of a 2025 pennant run that ended in a World Series Game 7 loss to the Dodgers and a payroll that paid $13.6M in luxury tax. Toronto then spent again, Dylan Cease at 7yr/$210M and Kazuma Okamoto at 4yr/$60M, lost Bo Bichette to the Mets, and finished 78-83 and out of the 2026 race. The ownership story now matters more than the roster: Rogers closes its $3.1B buyout of the last quarter of MLSE in Q4 2026, then plans to fold the Blue Jays and Rogers Centre into one sports group and sell a minority stake in the first half of 2027. That process will put a third-party mark on a franchise Forbes has never valued above $2.5B, and it is the single event that resets the number.",
    "unverifiedAsOf": {}
  },
  "tampa-bay-rays": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$57M/team/year from MLB national deals (ESPN through 2028 ~$550M/yr, Fox through 2028 ~$729M/yr, Apple TV+ ~$85M/yr)",
        "new": "2026-2028 national deals: ESPN ~$550M/yr (30-game national package plus MLB.TV distribution), NBC/Peacock ~$200M/yr (Sunday Night Baseball, Wild Card games), Netflix ~$50M/yr (Home Run Derby), alongside the existing Fox (~$729M/yr) and TNT packages that run through 2028 (CNBC, Nov 2025); the CBA expires Dec 1, 2026 and a lockout over the owners' salary cap proposal is widely expected",
        "fact": "MLB signed three-year national deals with ESPN, NBC and Netflix in Nov 2025 for 2026-2028 (~$800M/yr combined); CBA expires Dec 1, 2026",
        "source": "https://www.cnbc.com/2025/11/19/mlb-media-rights-deals-nbc-espn-netflix.html"
      },
      {
        "field": "ownership.primaryOwner",
        "old": "Patrick Zalupski (pending, ~2025); Stuart Sternberg (outgoing)",
        "new": "Patrick Zalupski (control person; group closed on ~90% of the club Sept 30, 2025 at a reported $1.7B); Bill Cosgrove co-chair; Ken Babby CEO; Stuart Sternberg retains ~10%",
        "fact": "Zalupski group approved Sept 22 and closed Sept 30, 2025 (transactions.js); Cosgrove co-chair and Babby CEO per ESPN owners list",
        "source": "https://www.wusf.org/sports/2025-09-30/zalupski-officially-takes-over-tampa-bay-rays"
      },
      {
        "field": "ownership.ownershipGroup",
        "old": [
          {
            "name": "Patrick Zalupski",
            "role": "incoming majority owner / principal",
            "pct": null
          },
          {
            "name": "Stuart Sternberg",
            "role": "outgoing majority / seller",
            "pct": null
          },
          {
            "name": "Matthew Silverman",
            "role": "president (operational continuity)",
            "pct": null
          }
        ],
        "new": [
          {
            "name": "Patrick Zalupski",
            "role": "control person / co-chair (Dream Finders Homes CEO)",
            "pct": null
          },
          {
            "name": "Bill Cosgrove",
            "role": "co-chair (Union Home Mortgage CEO)",
            "pct": null
          },
          {
            "name": "Ken Babby",
            "role": "CEO / partner",
            "pct": null
          },
          {
            "name": "Stuart Sternberg",
            "role": "minority (retained ~10%)",
            "pct": 10
          }
        ],
        "fact": "Ownership group after the Sept 2025 close",
        "source": "https://www.espn.com/mlb/story/_/id/47979684/who-current-mlb-team-owners"
      },
      {
        "field": "stadium.name",
        "old": "Tropicana Field (damaged; team playing at Steinbrenner Field 2025)",
        "new": "Tropicana Field",
        "fact": "Rays returned to a rebuilt Tropicana Field for the 2026 home opener after ~$60M of hurricane repairs and a new roof; 2025 was played at Steinbrenner Field",
        "source": "https://frontofficesports.com/rays-return-to-rebuilt-tropicana-field-but-bigger-questions-remain/"
      },
      {
        "field": "stadium.ownershipModel",
        "old": "owned by St. Petersburg / city of Tampa Bay; Rays are tenants under long-term lease; Tropicana Field roof destroyed by Hurricane Milton Oct 2024 — team displaced to Steinbrenner Field (Yankees spring training facility) for 2025 season",
        "new": "owned by the City of St. Petersburg; Rays lease runs through 2028; Tropicana Field roof was destroyed by Hurricane Milton (Oct 2024), the team played 2025 at Steinbrenner Field, and returned to the repaired dome in April 2026",
        "fact": "Trop lease through 2028; 2026 return",
        "source": "https://www.cbssports.com/mlb/news/tampa-bay-rays-new-stadium-mlb/"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "Pre-hurricane: Rays and St. Petersburg had agreed on $1.3B stadium development project adjacent to Tropicana Field site. Post-Hurricane Milton (Oct 2024): Sternberg withdrew from the agreement in early 2025; new ownership group (Zalupski) will need to negotiate fresh stadium solution. Future unclear as of mid-2025.",
        "new": "$2.3B ballpark and mixed-use entertainment district on the Hillsborough College site across from Raymond James Stadium in Tampa; ~$880M public (Hillsborough County ~$800M, City of Tampa ~$80M) and ~$1.4B private plus overruns; county owns the stadium, Rays pay $4M/yr rent on a projected 35-year lease; ~31,000 seats; target opening 2029; Tampa City Council approved 4-3 on Aug 27, 2026 and Hillsborough County approved 5-2 on Aug 28, 2026",
        "fact": "Tampa stadium financing approved Aug 27-28, 2026",
        "source": "https://www.cbssports.com/mlb/news/tampa-bay-rays-new-stadium-mlb/"
      },
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports Sun — carrier affected by Diamond Sports Group bankruptcy (2023); Rays negotiating post-Diamond local broadcast arrangement; among the MLB franchises most affected by RSN collapse due to small market and limited local alternatives",
        "new": "Rays.tv produced and distributed by MLB Local Media from 2026 after the Rays terminated their FanDuel Sports Network Sun deal in Jan 2026 when Main Street Sports missed rights payments; FDSN shut down April 14, 2026",
        "fact": "Rays moved to MLB Local Media for 2026",
        "source": "https://en.wikipedia.org/wiki/MLB_Local_Media"
      },
      {
        "field": "media.streamingNotes",
        "old": "Apple TV+ Friday games; some Rays games moved to direct streaming during RSN transition; MLB.TV blackout restrictions complicate in-market access",
        "new": "In-market streaming through MLB.TV / the MLB app and the ESPN app under the 2026 ESPN-MLB.TV arrangement; no blackout-based RSN model remains",
        "fact": "MLB Local Media teams stream in-market via MLB.TV and ESPN",
        "source": "https://www.sportspro.com/news/broadcast-ott/espn-mlb-tv-angels-tigers-local-rights-rsn-february-2026/"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Wander Franco — suspended; team in transition under new ownership",
        "new": "Junior Caminero, 3B, club control through 2030; extension talks open as of Feb 2026 but no deal; his Sept 11, 2026 walk-off clinched the playoff berth",
        "fact": "Caminero is the franchise player; no extension yet",
        "source": "https://www.mlbtraderumors.com/2026/02/junior-caminero-open-to-extension-talks-with-rays.html"
      }
    ],
    "analystNotes": "The Rays finally have both halves of the story: a 98-63 team that won the 2026 AL East and the AL's top seed, and a $2.3B Tampa ballpark deal that Hillsborough County and the City of Tampa approved on Aug 27-28, 2026 with roughly $880M of public money and a 2029 opening. Forbes marked the club at $1.7B in March 2026 on $290M of revenue, exactly the price Patrick Zalupski's group paid when it closed on Sept 30, 2025, so the new owner is already playing with house money on the stadium optionality he bought. Local TV moved to MLB-produced Rays.tv after FanDuel Sports Network collapsed, which stabilizes distribution but not the rights fee. Shovels in the ground in Tampa, and a first World Series run from this roster, are what push the number toward the $2B-plus small-market comps.",
    "unverifiedAsOf": {}
  },
  "baltimore-orioles": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$57M/team/year from MLB national deals (ESPN through 2028 ~$550M/yr, Fox through 2028 ~$729M/yr, Apple TV+ ~$85M/yr)",
        "new": "2026-2028 national deals: ESPN ~$550M/yr (30-game national package plus MLB.TV distribution), NBC/Peacock ~$200M/yr (Sunday Night Baseball, Wild Card games), Netflix ~$50M/yr (Home Run Derby), alongside the existing Fox (~$729M/yr) and TNT packages that run through 2028 (CNBC, Nov 2025); the CBA expires Dec 1, 2026 and a lockout over the owners' salary cap proposal is widely expected",
        "fact": "MLB signed three-year national deals with ESPN, NBC and Netflix in Nov 2025 for 2026-2028 (~$800M/yr combined); CBA expires Dec 1, 2026",
        "source": "https://www.cnbc.com/2025/11/19/mlb-media-rights-deals-nbc-espn-netflix.html"
      },
      {
        "field": "ownership.primaryOwner",
        "old": "David Rubenstein (Carlyle Group co-founder, majority purchaser)",
        "new": "David Rubenstein (control person; his group bought ~40% in March 2024 and completed the second-stage purchase of the Angelos family stake in 2024, taking the group to ~97%)",
        "fact": "Rubenstein group completed the Angelos buyout in 2024 and owns ~97%",
        "source": "https://www.thebanner.com/sports/orioles-mlb/orioles-sale-david-rubenstein-angelos-XSZ43VGRU5GPDJ5FI5U3JHP6TE/"
      },
      {
        "field": "media.localTVDeal",
        "old": "MASN (Mid-Atlantic Sports Network) — Orioles own 67% of MASN, Nationals own 33%; long-running revenue dispute with Nationals over rights fees paid by MASN to both teams in arbitration since 2012; district court ruled in 2023 that Nationals owed ~$100M+ in underpaid fees from Orioles-advantaged MASN arrangement",
        "new": "MASN (Mid-Atlantic Sports Network), now wholly controlled by the Orioles after the Nationals left for MLB-produced Nationals.tv in 2026; the 13-year rights-fee dispute was settled March 3, 2025 and the Nationals' MASN agreement ended after the 2025 season; MASN2 shut down March 3, 2026",
        "fact": "MASN dispute settled March 2025; Nationals exited after 2025",
        "source": "https://en.wikipedia.org/wiki/Mid-Atlantic_Sports_Network"
      },
      {
        "field": "media.streamingNotes",
        "old": "MASN available on streaming platforms; Apple TV+ Friday games; legal uncertainty around MASN rights fee dispute creates ongoing revenue risk",
        "new": "MASN carried on cable and vMVPDs; the settled Nationals dispute removes the litigation overhang but also removes the Nationals' programming from the network",
        "fact": "MASN is an Orioles-only network from 2026",
        "source": "https://en.wikipedia.org/wiki/Mid-Atlantic_Sports_Network"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Adley Rutschman",
            "position": "C",
            "aav": 15,
            "contractNote": "6yr/$90M extension (Mar 2023), through 2028; franchise catcher"
          },
          {
            "player": "Gunnar Henderson",
            "position": "SS",
            "aav": null,
            "contractNote": "Pre-arbitration through 2026; extension discussions expected; comps suggest $200M+ deal"
          }
        ],
        "new": [
          {
            "player": "Adley Rutschman",
            "position": "C",
            "aav": 15,
            "contractNote": "6yr/$90M extension (Mar 2023), through 2028"
          },
          {
            "player": "Gunnar Henderson",
            "position": "SS",
            "aav": null,
            "contractNote": "Turned down an Orioles extension offer in spring 2025 (Boras client); arbitration years through 2028; Rubenstein says the club is 'open for business' on a deal"
          }
        ],
        "fact": "Henderson declined a spring 2025 extension offer; no deal as of 2026",
        "source": "https://www.mlbtraderumors.com/2026/03/orioles-made-gunnar-henderson-an-extension-offer-last-spring.html"
      }
    ],
    "analystNotes": "Forbes puts the Orioles at $2.1B on the 2026 list with $355M of revenue and $23M of operating income, up 22% from the $1.725B David Rubenstein's group paid when it took control in 2024 and then bought out the rest of the Angelos family stake. The March 2025 MASN settlement ended a 13-year rights-fee war and, from 2026, leaves Baltimore as the sole owner of an Orioles-only network after Washington moved to MLB-produced Nationals.tv, which trades litigation risk for a thinner programming base. On the field the young core stalled at 79-82 in 2026, a second straight miss, and Gunnar Henderson turned down an extension offer. The Camden Yards development rights in the 30-year lease are the value lever; a Henderson deal and a return to October are what keep the multiple from slipping.",
    "unverifiedAsOf": {}
  },
  "chicago-white-sox": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$57M/team/year from MLB national deals (ESPN through 2028 ~$550M/yr, Fox through 2028 ~$729M/yr, Apple TV+ ~$85M/yr)",
        "new": "2026-2028 national deals: ESPN ~$550M/yr (30-game national package plus MLB.TV distribution), NBC/Peacock ~$200M/yr (Sunday Night Baseball, Wild Card games), Netflix ~$50M/yr (Home Run Derby), alongside the existing Fox (~$729M/yr) and TNT packages that run through 2028 (CNBC, Nov 2025); the CBA expires Dec 1, 2026 and a lockout over the owners' salary cap proposal is widely expected",
        "fact": "MLB signed three-year national deals with ESPN, NBC and Netflix in Nov 2025 for 2026-2028 (~$800M/yr combined); CBA expires Dec 1, 2026",
        "source": "https://www.cnbc.com/2025/11/19/mlb-media-rights-deals-nbc-espn-netflix.html"
      },
      {
        "field": "stadium.name",
        "old": "Guaranteed Rate Field",
        "new": "Rate Field",
        "fact": "Guaranteed Rate Field was shortened to Rate Field in Dec 2024 after the sponsor's rebrand",
        "source": "https://en.wikipedia.org/wiki/Rate_Field"
      },
      {
        "field": "stadium.namingRightsDeal",
        "old": {
          "sponsor": "Guaranteed Rate (mortgage company)",
          "annualValue_M": 5.2,
          "totalValue_M": null,
          "expiryYear": 2026,
          "notes": "Naming rights deal with Guaranteed Rate mortgage company; previously U.S. Cellular Field ('The Cell'); deal expiring around 2026 — renewal or replacement under negotiation as team addresses stadium future"
        },
        "new": {
          "sponsor": "Rate (formerly Guaranteed Rate)",
          "annualValue_M": 5.2,
          "totalValue_M": null,
          "expiryYear": 2029,
          "notes": "13-year deal announced Oct 31, 2016 (reported $20.4M over its first ten years); name shortened to Rate Field in Dec 2024; the team's lease at the ISFA-owned park runs through 2029, which is also when a new ballpark would need to be ready"
        },
        "fact": "Naming deal is the 2016 13-year Guaranteed Rate agreement; Rate Field since Dec 2024; lease through 2029",
        "source": "https://en.wikipedia.org/wiki/Rate_Field"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "White Sox seeking public support for new stadium in Chicago's South Loop/Near South Side; early proposals sought ~$1B+ in public financing; City Council debate ongoing as of 2025 with political complications given the 2024 historic 121-loss season diminishing leverage",
        "new": "Justin Ishbia unveiled 'The Railyards' in Sept 2026: an ~80-acre mixed-use district on the Amtrak 14th Street rail yard on the west bank of the river (across from Related Midwest's The 78, where Reinsdorf failed to win public funds), with a 35,000-38,000-seat ballpark, residential, commercial and a Northwestern Medicine facility; the ballpark would be privately financed with a public ask for roads, bridges and a possible Metra station; Rate Field lease expires 2029",
        "fact": "Ishbia Railyards plan presented Sept 2026",
        "source": "https://therealdeal.com/chicago/2026/09/08/ishbias-vision-for-white-sox-stadium-development-revealed/"
      }
    ],
    "analystNotes": "The White Sox went from 121 losses in 2024 and a third straight 100-loss year in 2025 to an 83-78 wild card berth in 2026, the first club ever to make the playoffs after three consecutive 100-loss seasons, and Forbes still had them at $1.94B on the 2026 list with $239M of revenue and a $40M operating loss. Justin Ishbia bought the limited partners' shares at a $1.8B mark in 2025, holds a control option from 2029 to 2034, and in September 2026 put his own plan on the table: a privately financed 35,000-38,000-seat ballpark inside an 80-acre Railyards district on the Amtrak yard, with public money asked only for infrastructure. The Rate Field lease and naming deal both expire in 2029, which is the real deadline. City approval of the Railyards infrastructure package, plus the timing of Ishbia's control purchase, are what move a club that trades at 40% of the Cubs' value in the same market.",
    "unverifiedAsOf": {}
  },
  "cleveland-guardians": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$57M/team/year from MLB national deals (ESPN through 2028 ~$550M/yr, Fox through 2028 ~$729M/yr, Apple TV+ ~$85M/yr)",
        "new": "2026-2028 national deals: ESPN ~$550M/yr (30-game national package plus MLB.TV distribution), NBC/Peacock ~$200M/yr (Sunday Night Baseball, Wild Card games), Netflix ~$50M/yr (Home Run Derby), alongside the existing Fox (~$729M/yr) and TNT packages that run through 2028 (CNBC, Nov 2025); the CBA expires Dec 1, 2026 and a lockout over the owners' salary cap proposal is widely expected",
        "fact": "MLB signed three-year national deals with ESPN, NBC and Netflix in Nov 2025 for 2026-2028 (~$800M/yr combined); CBA expires Dec 1, 2026",
        "source": "https://www.cnbc.com/2025/11/19/mlb-media-rights-deals-nbc-espn-netflix.html"
      },
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports Great Lakes (Diamond Sports Group) — affected by Diamond's 2023 bankruptcy; Guardians among MLB teams forced to negotiate post-RSN local TV transition; team exploring direct streaming deals and potential CHSN-style local network",
        "new": "CLEGuardians.tv produced and distributed by MLB Local Media since 2025 (post-Diamond Sports exit); Cleveland qualified for MLB's 2025 media disruption distribution (up to $15M) for lost local TV fees",
        "fact": "Guardians joined MLB Local Media in 2025",
        "source": "https://en.wikipedia.org/wiki/MLB_Local_Media"
      },
      {
        "field": "media.streamingNotes",
        "old": "Apple TV+ Friday games; MLB.TV; local streaming future uncertain post-Diamond bankruptcy; FanDuel Sports Network (formerly Bally Sports) in transition",
        "new": "In-market streaming through MLB.TV / MLB app and, from 2026, the ESPN app under the ESPN-MLB.TV distribution deal",
        "fact": "MLB Local Media in-market streaming via MLB.TV and ESPN",
        "source": "https://www.sportspro.com/news/broadcast-ott/espn-mlb-tv-angels-tigers-local-rights-rsn-february-2026/"
      },
      {
        "field": "stadium.ownershipModel",
        "old": "owned by Gateway Economic Development Corporation (public); Guardians hold long-term lease with major renovation commitment; $202M renovation completed 2015 (public-private partnership)",
        "new": "owned by Gateway Economic Development Corporation (public); Guardians hold a long-term lease; $202M renovation completed 2015 and a further $200M+ 'Progressive Field Reimagined' program ran 2023-2026, with the final phase (new upper-deck seating and concrete) completed for the 2026 season",
        "fact": "Third and final renovation phase completed before 2026",
        "source": "https://www.crainscleveland.com/sports-recreation/ccl-guardians-progressive-20260331/"
      },
      {
        "field": "ownership.ownerBackground",
        "old": "Larry Dolan (media attorney, brother of Cablevision's Charles Dolan) bought franchise in 2000 for $323M. Larry died 2025; son Paul Dolan assumed principal role. David Blitzer, a Blackstone executive and multi-sport franchise investor, acquired 25-30% stake in 2022 with a 2028 option for majority — the likely future ownership transition point.",
        "new": "Larry Dolan (media attorney, brother of Cablevision's Charles Dolan) bought the franchise in 2000 for $323M; his son Paul Dolan is the principal owner. David Blitzer, a Blackstone executive and multi-sport franchise investor, bought a 25% stake in June 2022 with an option to become controlling owner in 2028. Secondary reports in 2026 put his stake nearer 35%, which would be an increase on the 2022 purchase rather than a different deal; the 2028 path to control is the ownership transition point.",
        "fact": "The June 2022 announcement was a 25% stake with an option for control in six years (2028). Later reports of ~35% are treated as an increase, not a conflicting figure.",
        "source": "https://www.mlb.com/news/david-blitzer-guardians-minority-owner"
      },
      {
        "field": "ownership.ownershipGroup",
        "old": [
          {
            "name": "Paul Dolan",
            "role": "majority owner / chairman / CEO",
            "pct": null
          },
          {
            "name": "David Blitzer",
            "role": "minority investor (~25-30%); option for majority in 2028",
            "pct": 27
          }
        ],
        "new": [
          {
            "name": "Paul Dolan",
            "role": "majority owner / chairman / CEO",
            "pct": null
          },
          {
            "name": "David Blitzer",
            "role": "minority owner; 25% at the June 2022 purchase, reported nearer 35% by 2026; option for control in 2028",
            "pct": 25
          }
        ],
        "fact": "Stake set to the 25% from the 2022 announcement; the 2026 ~35% reports noted as an increase.",
        "source": "https://www.espn.com/mlb/story/_/id/34102163/minority-stake-cleveland-guardians-goes-david-blitzer-future-option-controlling-interest-per-reports"
      }
    ],
    "analystNotes": "Cleveland is the small-market template at $1.66B on the 2026 Forbes list with $337M of revenue and $53M of operating income, one of the best margins in the league, and a third straight AL Central title in 2026 after climbing from 61-66 in August to 85-76. The Progressive Field Reimagined program, more than $200M across three phases, finished for 2026 on a publicly owned park under a long lease, and local TV runs through MLB-produced CLEGuardians.tv with a media disruption payment cushioning the lost Diamond rights fee. David Blitzer's minority stake carries a control option later this decade, and that transfer, priced against a club that wins on a bottom-third payroll, is the event that re-rates the franchise. Until then the number tracks José Ramírez's production and whatever the December 2026 CBA does to revenue sharing.",
    "unverifiedAsOf": {
      "stadium.namingRightsDeal": "May 2026"
    }
  },
  "detroit-tigers": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$57M/team/year from MLB national deals (ESPN through 2028 ~$550M/yr, Fox through 2028 ~$729M/yr, Apple TV+ ~$85M/yr)",
        "new": "2026-2028 national deals: ESPN ~$550M/yr (30-game national package plus MLB.TV distribution), NBC/Peacock ~$200M/yr (Sunday Night Baseball, Wild Card games), Netflix ~$50M/yr (Home Run Derby), alongside the existing Fox (~$729M/yr) and TNT packages that run through 2028 (CNBC, Nov 2025); the CBA expires Dec 1, 2026 and a lockout over the owners' salary cap proposal is widely expected",
        "fact": "MLB signed three-year national deals with ESPN, NBC and Netflix in Nov 2025 for 2026-2028 (~$800M/yr combined); CBA expires Dec 1, 2026",
        "source": "https://www.cnbc.com/2025/11/19/mlb-media-rights-deals-nbc-espn-netflix.html"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 1,
        "new": 2,
        "fact": "Completed-season count for 2021-2025; 2025 postseason field: AL Blue Jays, Mariners, Guardians, Yankees, Red Sox, Tigers; NL Brewers, Phillies, Dodgers, Cubs, Padres, Reds; Tigers went 76-85 in 2026 and traded Skubal at the deadline",
        "source": "https://www.cbssports.com/mlb/news/2026-mlb-playoff-picture-standings-bracket/"
      },
      {
        "field": "stadium.namingRightsDeal",
        "old": {
          "sponsor": "Comerica Bank (will become Fifth Third after 2026)",
          "annualValue_M": 2.2,
          "totalValue_M": 66,
          "expiryYear": 2034,
          "notes": "Comerica Bank paid $66M over 30 years ($2.2M/yr) when agreed in 1998; extended through 2034 in 2018. Fifth Third Bancorp acquired Comerica in 2025 deal — stadium will be renamed after 2026 season pending Fifth Third's rebranding decisions. New naming rights deal likely ~$8-10M/yr given current market rates."
        },
        "new": {
          "sponsor": "Fifth Third Bank (Fifth Third Park from the 2027 season; Comerica Park through 2026)",
          "annualValue_M": 2.2,
          "totalValue_M": 66,
          "expiryYear": 2034,
          "notes": "Comerica's original 30-year/$66M deal (extended through 2034 in 2018) transfers to Fifth Third after its $10.9B acquisition of Comerica closed in 2026; the Tigers and Fifth Third announced on Sept 21, 2026 that the park becomes Fifth Third Park for 2027, the first name change in its history; whether the rights fee was reset was not disclosed"
        },
        "fact": "Comerica Park to be renamed Fifth Third Park for 2027 (announced Sept 21, 2026)",
        "source": "https://www.mlb.com/news/tigers-ballpark-name-changed-to-fifth-third-park"
      },
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports Detroit (Diamond Sports Group) — affected by Diamond bankruptcy; Tigers negotiating post-RSN local broadcast solution; Detroit market has fewer cord-cutting alternatives than larger markets, creating transition complexity",
        "new": "Detroit SportsNet, launched for the 2026 season by Ilitch Sports + Entertainment in partnership with MLB Local Media after the Tigers terminated FanDuel Sports Network Detroit in Jan 2026 over missed rights payments; carries Tigers and (from 2026-27) Red Wings games; distributed on DirecTV, Xfinity, Spectrum, U-verse and streamed via MLB.TV / tigers.com",
        "fact": "Detroit SportsNet replaced FDSN Detroit for 2026",
        "source": "https://en.wikipedia.org/wiki/Detroit_SportsNet"
      },
      {
        "field": "media.streamingNotes",
        "old": "Apple TV+ Friday games; MLB.TV; local media future contingent on post-Diamond RSN resolution",
        "new": "Direct-to-consumer via MLB.TV (Tigers.TV) and tigers.com/watch, plus DirecTV Stream and Fubo; Apple TV+ Friday games nationally",
        "fact": "Detroit SportsNet DTC distribution",
        "source": "https://en.wikipedia.org/wiki/Detroit_SportsNet"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Tarik Skubal — 2024 AL Cy Young winner; extension expected as franchise cornerstone",
        "new": "Kevin McGonigle, SS/2B, 8yr/$150M extension (Apr 15, 2026) through 2034, a record guarantee for a player still prospect-eligible; Tarik Skubal (2024 and 2025 AL Cy Young) was traded to the Dodgers Aug 3, 2026 ahead of free agency after Detroit's 4yr/$75M extension offer went nowhere",
        "fact": "McGonigle extension Apr 2026; Skubal traded Aug 2026",
        "source": "https://en.wikipedia.org/wiki/Kevin_McGonigle"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Tarik Skubal",
            "position": "SP",
            "aav": null,
            "contractNote": "Pre-extension as of 2025; 2024 AL Cy Young; control through arbitration, extension discussions likely to yield $150M+ deal"
          },
          {
            "player": "Spencer Torkelson",
            "position": "1B",
            "aav": null,
            "contractNote": "Pre-arb franchise corner; 2021 #1 overall pick in development"
          },
          {
            "player": "Riley Greene",
            "position": "CF",
            "aav": null,
            "contractNote": "Pre-arb; emerging offensive talent"
          }
        ],
        "new": [
          {
            "player": "Framber Valdez",
            "position": "SP",
            "aav": 38.3,
            "contractNote": "3yr/$115M free-agent deal (Feb 2026): $17.5M 2026, $37.5M 2027, $35M 2028, opt-out after 2027, $40M mutual option 2029; $20M signing bonus deferred to 2030+"
          },
          {
            "player": "Kevin McGonigle",
            "position": "SS/2B",
            "aav": 18.75,
            "contractNote": "8yr/$150M extension (Apr 15, 2026) through 2034, signed three weeks after his MLB debut"
          },
          {
            "player": "Tarik Skubal",
            "position": "SP",
            "aav": null,
            "contractNote": "Traded to the Los Angeles Dodgers Aug 3, 2026 for River Ryan, Zyhir Hope and Brady Smith; free agent after 2026"
          },
          {
            "player": "Spencer Torkelson",
            "position": "1B",
            "aav": null,
            "contractNote": "Arbitration years; 2021 No. 1 overall pick"
          },
          {
            "player": "Riley Greene",
            "position": "CF",
            "aav": null,
            "contractNote": "Arbitration years"
          }
        ],
        "fact": "Valdez 3yr/$115M (Feb 2026), McGonigle 8yr/$150M (Apr 2026), Skubal traded (Aug 2026)",
        "source": "https://www.mlbtraderumors.com/2026/02/tigers-framber-valdez-agree-to-three-year-deal.html"
      }
    ],
    "analystNotes": "Detroit's $1.8B Forbes mark (2026 list, $363M revenue, $27M operating income) was built on the 2024-2025 playoff runs and the cheapest ace in baseball; 2026 broke both, a 76-85 season and the Aug 3 trade of Tarik Skubal to the Dodgers after Chris Ilitch declined to fund a $400M-plus extension. The Ilitches did spend where it locks value: Framber Valdez at 3yr/$115M, Kevin McGonigle at a record 8yr/$150M three weeks into his career, and Detroit SportsNet, an in-house channel run with MLB Local Media that replaced FanDuel Sports Network Detroit and now bundles the Red Wings. Comerica Park becomes Fifth Third Park in 2027 after the bank merger, an opening to reprice a $2.2M-a-year naming deal that has not moved since 1998. The rights fee attached to that rename, and whether the young core returns to October without Skubal, set the next Forbes print.",
    "unverifiedAsOf": {}
  },
  "kansas-city-royals": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$57M/team/year from MLB national deals (ESPN through 2028 ~$550M/yr, Fox through 2028 ~$729M/yr, Apple TV+ ~$85M/yr)",
        "new": "2026-2028 national deals: ESPN ~$550M/yr (30-game national package plus MLB.TV distribution), NBC/Peacock ~$200M/yr (Sunday Night Baseball, Wild Card games), Netflix ~$50M/yr (Home Run Derby), alongside the existing Fox (~$729M/yr) and TNT packages that run through 2028 (CNBC, Nov 2025); the CBA expires Dec 1, 2026 and a lockout over the owners' salary cap proposal is widely expected",
        "fact": "MLB signed three-year national deals with ESPN, NBC and Netflix in Nov 2025 for 2026-2028 (~$800M/yr combined); CBA expires Dec 1, 2026",
        "source": "https://www.cnbc.com/2025/11/19/mlb-media-rights-deals-nbc-espn-netflix.html"
      },
      {
        "field": "onField.championshipsLast10Years",
        "old": 1,
        "new": 0,
        "fact": "The 2015 title now falls outside the 2016-2025 ten-year window",
        "source": "https://en.wikipedia.org/wiki/2025_Major_League_Baseball_postseason"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "New $1.9B ballpark at Crown Center (85-acre mixed-use development totaling $3B) announced 2026; ~2/3 private / ~1/3 public funding; state + city earmarks; groundbreaking targeted for 2027; targeted opening ~2030",
        "new": "New ~$1.9B ballpark at Crown Center on the site of Hallmark's headquarters, part of a $3B, 85-acre district announced with Hallmark Cards on April 22, 2026; Kansas City Council approved the framework 11-2 in Aug 2026 with $600M of city-backed bonds repaid from a stadium taxing district, and Missouri's June 2025 special-session plan covers annual bond payments equal to the teams' current state tax generation (~$1.5B over 30 years); no public vote required after the 2024 Jackson County measure failed 58-42; groundbreaking targeted 2027, opening ~2030; Kauffman lease runs through 2031",
        "fact": "Crown Center site announced Apr 2026; council framework approved Aug 2026",
        "source": "https://www.kcur.org/sports/2026-04-22/kansas-city-royals-stadium-location-crown-center"
      },
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports Kansas City (Diamond Sports Group); Diamond filed Chapter 11 bankruptcy 2023; Royals and other Bally teams face uncertain local media future as Diamond restructures",
        "new": "Royals.tv produced and distributed by MLB Local Media from 2026 after the Royals terminated FanDuel Sports Network Kansas City in Jan 2026 over missed rights payments; FDSN shut down April 14, 2026",
        "fact": "Royals moved to MLB Local Media for 2026",
        "source": "https://en.wikipedia.org/wiki/MLB_Local_Media"
      },
      {
        "field": "media.streamingNotes",
        "old": "MLB.TV nationally; Royals exploring direct-to-consumer streaming options as RSN landscape collapses",
        "new": "In-market streaming through MLB.TV / MLB app and the ESPN app; MLB.TV nationally",
        "fact": "MLB Local Media in-market streaming",
        "source": "https://www.sportspro.com/news/broadcast-ott/espn-mlb-tv-angels-tigers-local-rights-rsn-february-2026/"
      }
    ],
    "analystNotes": "The Royals' stadium saga is settled: on April 22, 2026 the club and Hallmark announced a ~$1.9B ballpark at Crown Center inside a $3B district, the City Council approved the framework 11-2 in August with $600M of city bonds, and Missouri's matching plan needs no public vote after the 2024 county measure failed. Forbes marked Kansas City at $1.64B on the 2026 list with $330M of revenue and $25M of operating income, near the bottom of the league, and a 68-93 season plus the move to MLB-produced Royals.tv after FanDuel Sports Network collapsed explain why. Bobby Witt Jr. is locked through 2034 at a $26.3M AAV that looks better every year. Groundbreaking in 2027 and a firm 2030 opening are what carry this franchise into the $2B tier that new-ballpark peers reached.",
    "unverifiedAsOf": {}
  },
  "minnesota-twins": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$57M/team/year from MLB national deals (ESPN through 2028 ~$550M/yr, Fox through 2028 ~$729M/yr, Apple TV+ ~$85M/yr)",
        "new": "2026-2028 national deals: ESPN ~$550M/yr (30-game national package plus MLB.TV distribution), NBC/Peacock ~$200M/yr (Sunday Night Baseball, Wild Card games), Netflix ~$50M/yr (Home Run Derby), alongside the existing Fox (~$729M/yr) and TNT packages that run through 2028 (CNBC, Nov 2025); the CBA expires Dec 1, 2026 and a lockout over the owners' salary cap proposal is widely expected",
        "fact": "MLB signed three-year national deals with ESPN, NBC and Netflix in Nov 2025 for 2026-2028 (~$800M/yr combined); CBA expires Dec 1, 2026",
        "source": "https://www.cnbc.com/2025/11/19/mlb-media-rights-deals-nbc-espn-netflix.html"
      },
      {
        "field": "ownership.primaryOwner",
        "old": "Tom Pohlad (controlling owner / chairman)",
        "new": "Tom Pohlad (controlling owner / chairman, formally named Dec 2025)",
        "fact": "ESPN's Sept 2026 owners list: Tom Pohlad named controlling owner Dec 2025",
        "source": "https://www.espn.com/mlb/story/_/id/47979684/who-current-mlb-team-owners"
      },
      {
        "field": "ownership.ownershipGroup",
        "old": [
          {
            "name": "Tom Pohlad",
            "role": "controlling owner / chairman",
            "pct": null
          },
          {
            "name": "Jim Pohlad",
            "role": "minority / former chairman",
            "pct": null
          },
          {
            "name": "New minority investors (3)",
            "role": "minority passive (2024 addition)",
            "pct": null
          }
        ],
        "new": [
          {
            "name": "Tom Pohlad",
            "role": "controlling owner / chairman",
            "pct": null
          },
          {
            "name": "Jim Pohlad",
            "role": "minority / former chairman",
            "pct": null
          },
          {
            "name": "Glick Family Investments",
            "role": "limited partner (part of the ~20% sold Dec 2025)",
            "pct": null
          },
          {
            "name": "George G. Hicks",
            "role": "limited partner (Dec 2025)",
            "pct": null
          },
          {
            "name": "Craig Leipold",
            "role": "limited partner (Dec 2025; Minnesota Wild owner)",
            "pct": null
          }
        ],
        "fact": "Pohlads ended the control-sale process in Aug 2025 and sold just over 20% to three LPs on Dec 17, 2025 at a reported $1.75B, ~$350M used to pay down debt (transactions.js)",
        "source": "https://sports.yahoo.com/articles/twins-finally-reveal-limited-partners-163622135.html"
      },
      {
        "field": "ownership.institutionalInvestors",
        "old": "Three new minority investors added in 2024; names undisclosed",
        "new": "Glick Family Investments, George G. Hicks and Craig Leipold bought just over 20% in Dec 2025 at a reported $1.75B valuation (~$350M), proceeds applied against roughly $400-500M of club debt; the family kept control after failing to find a buyer for the whole club in 2025",
        "fact": "Dec 2025 LP sale",
        "source": "https://sports.yahoo.com/articles/twins-finally-reveal-limited-partners-163622135.html"
      },
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports North (Diamond Sports Group); Diamond filed Chapter 11 bankruptcy 2023; Twins among teams exploring streaming alternatives as RSN revenues uncertain; Twins TV situation among the most uncertain in AL Central",
        "new": "Twins.tv produced and distributed by MLB Local Media since 2025 after the Diamond Sports / Bally Sports North exit; Minnesota qualified for MLB's 2025 media disruption distribution",
        "fact": "Twins joined MLB Local Media in 2025",
        "source": "https://en.wikipedia.org/wiki/MLB_Local_Media"
      },
      {
        "field": "media.streamingNotes",
        "old": "MLB.TV nationally; Twins pursuing direct streaming partnerships to replace/supplement RSN",
        "new": "In-market streaming through MLB.TV / MLB app and the ESPN app; MLB.TV nationally",
        "fact": "MLB Local Media in-market streaming",
        "source": "https://www.sportspro.com/news/broadcast-ott/espn-mlb-tv-angels-tigers-local-rights-rsn-february-2026/"
      }
    ],
    "analystNotes": "The Twins' valuation story is a balance sheet story: the Pohlads pulled the club off the market in August 2025, then sold just over 20% to three limited partners in December at a reported $1.75B and used the ~$350M to cut roughly $400-500M of debt. Forbes landed at $1.71B on the 2026 list with $315M of revenue and only $11M of operating income, so the private mark and the public one agree. Target Field's $15M-a-year Target deal runs to 2035 and local TV is now MLB-produced Twins.tv, which caps the downside but not the upside. A second straight losing season (76-85) with Buxton and López on the 60-day IL leaves a future control sale, at a price the 2025 process failed to find, as the only real catalyst.",
    "unverifiedAsOf": {}
  },
  "houston-astros": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$57M/team/year from MLB national deals (ESPN through 2028 ~$550M/yr, Fox through 2028 ~$729M/yr, Apple TV+ ~$85M/yr)",
        "new": "2026-2028 national deals: ESPN ~$550M/yr (30-game national package plus MLB.TV distribution), NBC/Peacock ~$200M/yr (Sunday Night Baseball, Wild Card games), Netflix ~$50M/yr (Home Run Derby), alongside the existing Fox (~$729M/yr) and TNT packages that run through 2028 (CNBC, Nov 2025); the CBA expires Dec 1, 2026 and a lockout over the owners' salary cap proposal is widely expected",
        "fact": "MLB signed three-year national deals with ESPN, NBC and Netflix in Nov 2025 for 2026-2028 (~$800M/yr combined); CBA expires Dec 1, 2026",
        "source": "https://www.cnbc.com/2025/11/19/mlb-media-rights-deals-nbc-espn-netflix.html"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Jose Altuve — 5yr/$125M extension signed 2019, through 2024; re-signed on new deal; franchise cornerstone SS/2B since 2011",
        "new": "Jose Altuve, 5yr/$125M extension (2024) through 2029; Jeremy Peña (Boras client) rejected extension talks and is the pending decision",
        "fact": "Altuve 5yr/$125M 2024 extension; Peña extension talks failed",
        "source": "https://sports.yahoo.com/articles/astros-news-ex-gm-makes-225322861.html"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Jose Altuve",
            "position": "2B",
            "aav": 29,
            "contractNote": "Multi-year extension; franchise icon; 3x All-Star, 2017 WS MVP, 7x AL batting title contender"
          },
          {
            "player": "Framber Valdez",
            "position": "SP",
            "aav": 16,
            "contractNote": "Extension keeping ace starter through mid-2020s; elite sinker/curveball arsenal"
          }
        ],
        "new": [
          {
            "player": "Jose Altuve",
            "position": "2B/LF",
            "aav": 25,
            "contractNote": "5yr/$125M extension (2024), through 2029; 2017 WS MVP"
          },
          {
            "player": "Tatsuya Imai",
            "position": "SP",
            "aav": 18,
            "contractNote": "3yr/$54M (2025-26 offseason) from NPB"
          },
          {
            "player": "Framber Valdez",
            "position": "SP",
            "aav": null,
            "contractNote": "Left in free agency; signed 3yr/$115M with Detroit (Feb 2026)"
          },
          {
            "player": "Jeremy Peña",
            "position": "SS",
            "aav": null,
            "contractNote": "Arbitration years; hired Scott Boras after extension talks with the club failed; free agent after 2027"
          }
        ],
        "fact": "Valdez left for Detroit; Imai signed 3yr/$54M; Peña unextended",
        "source": "https://en.wikipedia.org/wiki/2026_Houston_Astros_season"
      }
    ],
    "analystNotes": "The Astros are worth $3.2B on the 2026 Forbes list with $464M of revenue and a $45M operating loss, a franchise still priced on eight straight postseasons even though the streak ended in 2025 and 2026 came down to the final day at 80-81 in a dead heat with Texas. Space City Home Network, co-owned with the Rockets, kept Houston out of the FanDuel collapse that hit nine clubs, and the Daikin naming deal runs to 2039. Jim Crane let Framber Valdez walk to Detroit at 3yr/$115M, bought Tatsuya Imai at 3yr/$54M, and has not extended Jeremy Peña, who hired Boras after talks broke down. The number now depends on whether Crane re-funds the roster around Altuve's back half or accepts a step down from the $3B-plus contender tier.",
    "unverifiedAsOf": {
      "stadium.namingRightsDeal": "May 2026"
    }
  },
  "los-angeles-angels": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$57M/team/year from MLB national deals (ESPN through 2028 ~$550M/yr, Fox through 2028 ~$729M/yr, Apple TV+ ~$85M/yr)",
        "new": "2026-2028 national deals: ESPN ~$550M/yr (30-game national package plus MLB.TV distribution), NBC/Peacock ~$200M/yr (Sunday Night Baseball, Wild Card games), Netflix ~$50M/yr (Home Run Derby), alongside the existing Fox (~$729M/yr) and TNT packages that run through 2028 (CNBC, Nov 2025); the CBA expires Dec 1, 2026 and a lockout over the owners' salary cap proposal is widely expected",
        "fact": "MLB signed three-year national deals with ESPN, NBC and Netflix in Nov 2025 for 2026-2028 (~$800M/yr combined); CBA expires Dec 1, 2026",
        "source": "https://www.cnbc.com/2025/11/19/mlb-media-rights-deals-nbc-espn-netflix.html"
      },
      {
        "field": "ownership.primaryOwner",
        "old": "Arte Moreno (majority owner / chairman)",
        "new": "Arte Moreno (control person until close); Stan Kroenke / Kroenke Sports & Entertainment agreed Sept 1, 2026 to buy Moreno's controlling interest at a reported ~$4B (MLB record), Moreno keeping an undisclosed minority stake; close expected Q1 2027 pending MLB approval",
        "fact": "KSE purchase of the Angels' controlling interest announced Sept 2026 (transactions.js)",
        "source": "https://www.mlb.com/news/stan-kroenke-purchases-angels-from-arte-moreno"
      },
      {
        "field": "ownership.ownershipGroup",
        "old": [
          {
            "name": "Arte Moreno",
            "role": "majority owner / chairman",
            "pct": null
          },
          {
            "name": "Carole Moreno",
            "role": "co-owner",
            "pct": null
          }
        ],
        "new": [
          {
            "name": "Arte Moreno",
            "role": "majority owner / chairman (selling control; retains undisclosed minority stake)",
            "pct": null
          },
          {
            "name": "Carole Moreno",
            "role": "co-owner",
            "pct": null
          },
          {
            "name": "Stan Kroenke / Kroenke Sports & Entertainment",
            "role": "incoming controlling owner (agreed Sept 2026; close expected Q1 2027 pending MLB approval)",
            "pct": null
          }
        ],
        "fact": "Kroenke agreed to buy control Sept 2026",
        "source": "https://www.mlb.com/news/stan-kroenke-purchases-angels-from-arte-moreno"
      },
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports West (Diamond Sports Group); Diamond filed Chapter 11 bankruptcy 2023; Angels among the most exposed teams to RSN collapse given the large LA market — Bally West covered both Angels and Kings (NHL); loss of RSN revenues is the key financial risk",
        "new": "Angels Broadcast Television (ABTV), after terminating with Main Street Sports in Jan 2026, the Angels agreed on March 9, 2026 to buy Main Street's stake in FanDuel Sports Network West, becoming sole owner of the channel, which was renamed ABTV on May 1, 2026; distributed on cable across Southern California, Las Vegas and Hawaii and nationally on DirecTV, with 12 games simulcast on KCOP-TV",
        "fact": "Angels bought out and renamed their RSN in 2026",
        "source": "https://en.wikipedia.org/wiki/Angels_Broadcast_Television"
      },
      {
        "field": "media.streamingNotes",
        "old": "MLB.TV nationally; Angels exploring streaming deals as Diamond restructures; LA market cable penetration declining; Peacock/Apple TV+ national games provide exposure",
        "new": "Direct-to-consumer streaming through MLB's platform (MLB.TV / ESPN app) for in-market fans without cable; MLB.TV nationally",
        "fact": "In-market DTC via MLB for ABTV",
        "source": "https://www.sportsmediawatch.com/2026/03/angels-own-operate-fanduel-sports-network-buyout-main-street/"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Mike Trout",
            "position": "CF",
            "aav": 35.5,
            "contractNote": "12yr/$426.5M (2019), through 2030; injuries have severely limited availability; Trout played in 29/82/119 games 2021-2023"
          },
          {
            "player": "Anthony Rendon",
            "position": "3B",
            "aav": 38.6,
            "contractNote": "7yr/$245M (2019), through 2026; persistent injuries; played in 58 games total 2022-2023; widely viewed as worst contract in Angels history"
          }
        ],
        "new": [
          {
            "player": "Mike Trout",
            "position": "CF/DH",
            "aav": 35.5,
            "contractNote": "12yr/$426.5M (2019), through 2030; four years and $141.8M remain after 2026"
          },
          {
            "player": "Anthony Rendon",
            "position": "3B",
            "aav": 38.6,
            "contractNote": "7yr/$245M (2019) ends 2026; restructured Jan 2026 so he does not play in 2026 and his $38M final-year salary is paid $7.6M/yr over 2026-2030"
          }
        ],
        "fact": "Rendon's 2026 salary deferred over five years; he is not playing in 2026",
        "source": "https://www.mlbtraderumors.com/2026/01/anthony-rendons-2026-salary-to-be-paid-over-five-years.html"
      }
    ],
    "analystNotes": "The Angels are the largest number in baseball's 2026 sale market: Stan Kroenke agreed on Sept 1, 2026 to buy Arte Moreno's controlling interest at a reported ~$4B, a 43% premium to the $2.8B Forbes mark from March and a record for an MLB club, with closing expected in the first quarter of 2027. Forbes counts $377M of revenue and a $14M operating loss for a 62-98 team with no playoff trip since 2014, so Kroenke is paying for the Los Angeles market and roughly 130 acres of publicly owned parking around Angel Stadium, not the roster. The club bought out Main Street's half of its RSN and relaunched it as Angels Broadcast Television in May 2026, keeping local rights in house through the FanDuel collapse. Rendon is paid off through 2030, Trout has $141.8M left through 2030, and the stadium land deal Kroenke negotiates with Anaheim is what turns $4B into a rational price.",
    "unverifiedAsOf": {}
  },
  "oakland-athletics": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$57M/team/year from MLB national deals (ESPN through 2028 ~$550M/yr, Fox through 2028 ~$729M/yr, Apple TV+ ~$85M/yr)",
        "new": "2026-2028 national deals: ESPN ~$550M/yr (30-game national package plus MLB.TV distribution), NBC/Peacock ~$200M/yr (Sunday Night Baseball, Wild Card games), Netflix ~$50M/yr (Home Run Derby), alongside the existing Fox (~$729M/yr) and TNT packages that run through 2028 (CNBC, Nov 2025); the CBA expires Dec 1, 2026 and a lockout over the owners' salary cap proposal is widely expected",
        "fact": "MLB signed three-year national deals with ESPN, NBC and Netflix in Nov 2025 for 2026-2028 (~$800M/yr combined); CBA expires Dec 1, 2026",
        "source": "https://www.cnbc.com/2025/11/19/mlb-media-rights-deals-nbc-espn-netflix.html"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 1,
        "new": 0,
        "fact": "Completed-season count for 2021-2025; 2025 postseason field: AL Blue Jays, Mariners, Guardians, Yankees, Red Sox, Tigers; NL Brewers, Phillies, Dodgers, Cubs, Padres, Reds; A's finished 64-97 in 2026 (the 2020 appearance is outside the 2021-2025 window)",
        "source": "https://en.wikipedia.org/wiki/2026_Athletics_season"
      },
      {
        "field": "ownership.institutionalInvestors",
        "old": "Minority stake sale explored 2025 at implied $2B valuation (25% chunk = ~$500M); Aramark Sports + Entertainment holds equity stake via concessions partnership",
        "new": "Harbinger Sports Partners (Mark Cuban GP/president) bought a minority stake in July 2026, reported at ~$50M for new shares at a ~$3.8B post-money mark that covers the club plus the Las Vegas ballpark, part of Fisher's ~$550M equity raise for the stadium; Aramark Sports + Entertainment also holds equity via its concessions partnership",
        "fact": "Harbinger/Cuban minority stake July 2026 (transactions.js)",
        "source": "https://www.espn.com/mlb/story/_/id/49435620/cuban-investment-group-purchases-minority-stake-athletics"
      },
      {
        "field": "stadium.ownershipModel",
        "old": "minor-league ballpark in Sacramento; A's using as temporary home for 2025-2027 seasons while Las Vegas stadium is constructed; Sacramento city-owned facility",
        "new": "West Sacramento city-owned minor-league park (River Cats); A's temporary home for 2025-2027 while the Las Vegas ballpark is built; the club replaced the field and upgraded dugouts and cages for 2026 and played six 2026 home games at Las Vegas Ballpark in Summerlin",
        "fact": "2026 second season in West Sacramento; six games in Las Vegas",
        "source": "https://en.wikipedia.org/wiki/2026_Athletics_season"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "New Las Vegas ballpark on the Tropicana Las Vegas site (strip-adjacent); ~$1.75-2B total cost; Fisher committed $1B private investment; Goldman Sachs $300M construction loan; Aramark $175M equity/concessions stake; Nevada Tourism Infrastructure Tax provides ~$380M public contribution; 33,000 capacity; targeted opening 2028",
        "new": "$2B, 33,000-seat fully enclosed ballpark at Las Vegas Blvd and Tropicana Ave on the Strip; groundbreaking June 23, 2025; foundation complete Feb 2026, first roof truss raised June 2026; ~$400M spent by May 2026 with the project reported on time and on budget; Fisher funding $1B+ privately (Goldman Sachs construction loan, Aramark and Harbinger equity), Nevada's tourism-tax package ~$380M; target opening Feb 29, 2028 with an adjacent $1.19B Bally's resort",
        "fact": "Vegas ballpark construction status mid-2026",
        "source": "https://ballparkdigest.com/2026/05/23/after-400m-new-athletics-ballpark-is-on-time-on-budget/"
      },
      {
        "field": "media.localTVDeal",
        "old": "NBC Sports California (AT&T SportsNet) went dark in 2023; A's playing games without a local cable TV deal in transition years; exploring direct streaming and OTA broadcast options in both Sacramento and Las Vegas markets",
        "new": "NBC Sports California carries A's telecasts during the Sacramento years (2026 season broadcaster per the 2026 season record); no Las Vegas-market deal announced",
        "fact": "2026 TV on NBC Sports California (the enrichment's 'went dark in 2023' claim conflicted with the AT&T SportsNet history and current carriage)",
        "source": "https://en.wikipedia.org/wiki/2026_Athletics_season"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Brent Rooker — breakout 2023-24 seasons; signed multi-year extension; represents the scrappy value-player model the A's rely on given low payroll",
        "new": "Brent Rooker, 5yr/$60M extension (Jan 7, 2025); out for the rest of 2026 after knee surgery",
        "fact": "Rooker extension Jan 2025; season-ending surgery 2026",
        "source": "https://en.wikipedia.org/wiki/Brent_Rooker"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Brent Rooker",
            "position": "LF/DH",
            "aav": 10,
            "contractNote": "Multi-year extension; emerged as key offensive piece during Oakland final seasons and Sacramento transition"
          }
        ],
        "new": [
          {
            "player": "Brent Rooker",
            "position": "DH/LF",
            "aav": 12,
            "contractNote": "5yr/$60M extension (Jan 7, 2025); 2026 ended by knee cartilage surgery after 48 games"
          }
        ],
        "fact": "Rooker 5yr/$60M",
        "source": "https://en.wikipedia.org/wiki/Brent_Rooker"
      },
      {
        "field": "media.streamingNotes",
        "old": "MLB.TV nationally; A's broadcasting some games on local OTA affiliates during Sacramento transition; Las Vegas media deal TBD",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (in-market streaming arrangement for Sacramento not sourced)",
        "source": null
      }
    ],
    "analystNotes": "The A's are a stadium bond with a baseball team attached: Forbes marks the club at $2B on the 2026 list with $320M of revenue and $45M of operating income, while Mark Cuban's Harbinger Sports Partners bought in during July 2026 at a reported ~$3.8B post-money mark that includes the $2B Las Vegas ballpark. That ballpark is real, with the foundation done in February 2026, the first roof truss up in June, about $400M spent and a Feb 29, 2028 target, and Fisher's $1B-plus private commitment is backed by Goldman, Aramark and now Cuban. The interim product is thin, a 64-97 team playing in a 14,014-seat minor-league park in West Sacramento with six games shifted to Summerlin. Opening on time on the Strip, and a Las Vegas media deal that does not yet exist, are what close the gap between the Forbes number and the price investors are already paying.",
    "unverifiedAsOf": {}
  },
  "seattle-mariners": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$57M/team/year from MLB national deals (ESPN through 2028 ~$550M/yr, Fox through 2028 ~$729M/yr, Apple TV+ ~$85M/yr)",
        "new": "2026-2028 national deals: ESPN ~$550M/yr (30-game national package plus MLB.TV distribution), NBC/Peacock ~$200M/yr (Sunday Night Baseball, Wild Card games), Netflix ~$50M/yr (Home Run Derby), alongside the existing Fox (~$729M/yr) and TNT packages that run through 2028 (CNBC, Nov 2025); the CBA expires Dec 1, 2026 and a lockout over the owners' salary cap proposal is widely expected",
        "fact": "MLB signed three-year national deals with ESPN, NBC and Netflix in Nov 2025 for 2026-2028 (~$800M/yr combined); CBA expires Dec 1, 2026",
        "source": "https://www.cnbc.com/2025/11/19/mlb-media-rights-deals-nbc-espn-netflix.html"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 1,
        "new": 2,
        "fact": "Completed-season count for 2021-2025; 2025 postseason field: AL Blue Jays, Mariners, Guardians, Yankees, Red Sox, Tigers; NL Brewers, Phillies, Dodgers, Cubs, Padres, Reds; Seattle won the 2025 AL West and reached ALCS Game 7, then collapsed to 74-86 in 2026",
        "source": "https://en.wikipedia.org/wiki/2025_Major_League_Baseball_postseason"
      },
      {
        "field": "media.localTVDeal",
        "old": "ROOT Sports Northwest (AT&T/DirecTV regional network); unlike most RSNs, ROOT Sports Northwest remained operational — not part of Diamond Sports Group/Bally bankruptcy; Mariners have more stable local TV than most AL West competitors",
        "new": "Mariners.tv produced and distributed by MLB Local Media from 2026; the team-controlled ROOT Sports Northwest signed off after the 2025 finale and shut down Dec 31, 2025; Seattle qualified for MLB's 2025 media disruption distribution",
        "fact": "ROOT Sports Northwest shut down; MLB Local Media from 2026",
        "source": "https://awfulannouncing.com/mlb/mariners-shutting-down-root-sports-network-local-media-2026.html"
      },
      {
        "field": "media.streamingNotes",
        "old": "ROOT Sports streaming app; MLB.TV nationally; Apple TV+ Friday games; Mariners among the most profitable teams in 2022 (best EBITDA in MLB that year)",
        "new": "In-market streaming through MLB.TV / MLB app and the ESPN app; MLB.TV nationally; Apple TV+ Friday games",
        "fact": "MLB Local Media in-market streaming",
        "source": "https://www.sportspro.com/news/broadcast-ott/espn-mlb-tv-angels-tigers-local-rights-rsn-february-2026/"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Julio Rodríguez — 12yr guaranteed/$210M (up to $470M with options), signed Aug 2022 as a rookie; through 2034 with club options potentially through 2039",
        "new": "Cal Raleigh, C, 6yr/$105M extension (Mar 2025) through 2030 with a full no-trade clause; 60 HR, 125 RBI, .948 OPS in 2025, the first catcher to hit 60",
        "fact": "Raleigh extension and 60-HR 2025",
        "source": "https://www.mlb.com/news/cal-raleigh-mariners-extension"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Julio Rodríguez",
            "position": "CF",
            "aav": 17.5,
            "contractNote": "12yr/$210M guaranteed + club options potentially worth $470M total (Aug 2022, as a rookie); through 2034; opt-outs and escalators based on MVP voting performance; unprecedented deal structure"
          },
          {
            "player": "Logan Gilbert",
            "position": "SP",
            "aav": 18,
            "contractNote": "5yr/$140M extension (2024), anchoring rotation through late 2020s"
          }
        ],
        "new": [
          {
            "player": "Julio Rodríguez",
            "position": "CF",
            "aav": 17.5,
            "contractNote": "12yr/$210M guaranteed with options up to $470M (Aug 2022); through 2034 base term"
          },
          {
            "player": "Cal Raleigh",
            "position": "C",
            "aav": 17.5,
            "contractNote": "6yr/$105M extension (Mar 2025), through 2030; full no-trade clause; 60 HR in 2025"
          },
          {
            "player": "Logan Gilbert",
            "position": "SP",
            "aav": 18,
            "contractNote": "5yr/$140M extension (2024)"
          }
        ],
        "fact": "Raleigh 6yr/$105M added",
        "source": "https://www.mlb.com/news/cal-raleigh-mariners-extension"
      }
    ],
    "analystNotes": "Seattle's $2.35B Forbes mark on the 2026 list ($390M revenue, $24M operating income) was set right after the best season in a generation, a 2025 AL West title, a Game 7 ALCS loss to Toronto and Cal Raleigh's 60-homer year, and before the 2026 collapse to 74-86. The bigger structural change is media: the team-controlled ROOT Sports Northwest, the RSN that had insulated the Mariners from the Diamond bankruptcy, shut down on Dec 31, 2025, and games now run through MLB-produced Mariners.tv. Raleigh is locked through 2030 at a $17.5M AAV and Rodríguez through 2034, so the payroll base is cheap for the production. What moves the number is a replacement for the ROOT rights fee and whether ownership spends the 2025 windfall on a roster that can get back to October.",
    "unverifiedAsOf": {}
  },
  "texas-rangers": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$57M/team/year from MLB national deals (ESPN through 2028 ~$550M/yr, Fox through 2028 ~$729M/yr, Apple TV+ ~$85M/yr)",
        "new": "2026-2028 national deals: ESPN ~$550M/yr (30-game national package plus MLB.TV distribution), NBC/Peacock ~$200M/yr (Sunday Night Baseball, Wild Card games), Netflix ~$50M/yr (Home Run Derby), alongside the existing Fox (~$729M/yr) and TNT packages that run through 2028 (CNBC, Nov 2025); the CBA expires Dec 1, 2026 and a lockout over the owners' salary cap proposal is widely expected",
        "fact": "MLB signed three-year national deals with ESPN, NBC and Netflix in Nov 2025 for 2026-2028 (~$800M/yr combined); CBA expires Dec 1, 2026",
        "source": "https://www.cnbc.com/2025/11/19/mlb-media-rights-deals-nbc-espn-netflix.html"
      },
      {
        "field": "ownership.ownershipGroup",
        "old": [
          {
            "name": "Ray Davis",
            "role": "co-owner / managing partner",
            "pct": null
          },
          {
            "name": "Bob Simpson",
            "role": "co-owner / limited partner",
            "pct": null
          }
        ],
        "new": [
          {
            "name": "Ray Davis",
            "role": "co-owner / managing partner",
            "pct": null
          },
          {
            "name": "Bob Simpson",
            "role": "co-owner / limited partner",
            "pct": null
          },
          {
            "name": "Cade Cunningham",
            "role": "minority investor (Feb 2026; Detroit Pistons guard)",
            "pct": null
          }
        ],
        "fact": "Cade Cunningham acquired a minority stake in Feb 2026 per ESPN's owners list",
        "source": "https://www.espn.com/mlb/story/_/id/47979684/who-current-mlb-team-owners"
      },
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports Southwest (Diamond Sports Group); Diamond filed Chapter 11 bankruptcy 2023; Rangers exploring alternatives as Diamond restructures; Texas is among the most lucrative local sports markets in the US",
        "new": "Rangers Sports Network, team-owned network launched Jan 2025 by Rangers Sports Media & Entertainment after Diamond; games distributed through ad-hoc carriage deals (AT&T, Spectrum, DirecTV and others), a 15-plus game over-the-air package with Gray Media and Nexstar stations (KDAF Dallas flagship), and direct-to-consumer streaming that moved from Victory+ to Bzzr on July 15, 2026",
        "fact": "Rangers Sports Network operating in 2026; streaming partner switched to Bzzr July 2026",
        "source": "https://en.wikipedia.org/wiki/Rangers_Sports_Network"
      },
      {
        "field": "media.streamingNotes",
        "old": "MLB.TV nationally; Apple TV+ Friday games; Rangers 2023 World Series drives national viewership; exploring direct-to-consumer streaming partnerships",
        "new": "Bzzr direct-to-consumer subscription (replaced Victory+ July 15, 2026) plus MLB.TV nationally; Apple TV+ Friday games",
        "fact": "DTC platform change July 2026",
        "source": "https://en.wikipedia.org/wiki/Rangers_Sports_Network"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Corey Seager",
            "position": "SS",
            "aav": 32.5,
            "contractNote": "10yr/$325M (Dec 2021), through 2031; franchise-record deal at signing; 2023 WS MVP; 2x WS MVP in career"
          },
          {
            "player": "Marcus Semien",
            "position": "2B",
            "aav": 29,
            "contractNote": "7yr/$175M (Dec 2021), through 2027; signed same day as Seager; dual-SS/2B keystone of 2023 championship team"
          },
          {
            "player": "Nathan Eovaldi",
            "position": "SP",
            "aav": 18,
            "contractNote": "4yr/$68M (2023), through 2026; ace of 2023 postseason run"
          }
        ],
        "new": [
          {
            "player": "Corey Seager",
            "position": "SS",
            "aav": 32.5,
            "contractNote": "10yr/$325M (Dec 2021), through 2031; 2023 WS MVP"
          },
          {
            "player": "Marcus Semien",
            "position": "2B",
            "aav": 29,
            "contractNote": "7yr/$175M (Dec 2021), through 2027"
          },
          {
            "player": "MacKenzie Gore",
            "position": "SP",
            "aav": null,
            "contractNote": "Acquired from Washington Jan 22, 2026 for five prospects (Fien, Rosario, Fitz-Gerald, Cabrera, Ortiz); arbitration years"
          },
          {
            "player": "Nathan Eovaldi",
            "position": "SP",
            "aav": 18,
            "contractNote": "4yr/$68M (2023), through 2026"
          }
        ],
        "fact": "Gore trade Jan 2026",
        "source": "https://en.wikipedia.org/wiki/MacKenzie_Gore"
      }
    ],
    "analystNotes": "Texas is worth $2.7B on the 2026 Forbes list with $398M of revenue and a $44M operating loss, the cost of carrying Seager and Semien plus a January 2026 trade of five prospects for MacKenzie Gore, and the payoff came down to the last day of the season at 80-81, tied with Houston for the AL West. Globe Life Field's $25M-a-year naming deal runs to 2043 and the team-owned Rangers Sports Network survived the RSN collapse, though its streaming arm had to jump from Victory+ to Bzzr in July 2026, a reminder that self-distribution is fragile. Davis and Simpson added Cade Cunningham as a minority investor in February 2026. A division title from a .500 club would not move Forbes much; a durable carriage deal that replaces the old $40-60M RSN fee would.",
    "unverifiedAsOf": {}
  },
  "atlanta-braves": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$57M/team/year from MLB national deals (ESPN through 2028 ~$550M/yr, Fox through 2028 ~$729M/yr, Apple TV+ ~$85M/yr)",
        "new": "2026-2028 national deals: ESPN ~$550M/yr (30-game national package plus MLB.TV distribution), NBC/Peacock ~$200M/yr (Sunday Night Baseball, Wild Card games), Netflix ~$50M/yr (Home Run Derby), alongside the existing Fox (~$729M/yr) and TNT packages that run through 2028 (CNBC, Nov 2025); the CBA expires Dec 1, 2026 and a lockout over the owners' salary cap proposal is widely expected",
        "fact": "MLB signed three-year national deals with ESPN, NBC and Netflix in Nov 2025 for 2026-2028 (~$800M/yr combined); CBA expires Dec 1, 2026",
        "source": "https://www.cnbc.com/2025/11/19/mlb-media-rights-deals-nbc-espn-netflix.html"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 5,
        "new": 4,
        "fact": "Completed-season count for 2021-2025; 2025 postseason field: AL Blue Jays, Mariners, Guardians, Yankees, Red Sox, Tigers; NL Brewers, Phillies, Dodgers, Cubs, Padres, Reds; Atlanta missed in 2025 (7-year streak ended) and won the 2026 NL East at 94-67",
        "source": "https://www.cbssports.com/mlb/news/2026-mlb-playoff-picture-standings-bracket/"
      },
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports South / Diamond Sports Group (in Chapter 11 bankruptcy restructuring 2023-2024); Braves launched Bally Live direct-to-consumer streaming option as RSN model under stress; new direct streaming deals likely post-restructuring",
        "new": "BravesVision, in-house regional network launched March 27, 2026 with Raycom Sports (Gray Media handles ad sales and studio) after the Braves terminated FanDuel Sports Network South in Jan 2026 over Main Street's missed payments; carried on DirecTV, Xfinity, U-verse, Spectrum and others, with 25 games over the air on 'Braves on Gray' stations",
        "fact": "BravesVision replaced FDSN South for 2026",
        "source": "https://en.wikipedia.org/wiki/BravesVision"
      },
      {
        "field": "media.streamingNotes",
        "old": "Apple TV+ (Friday night games), Peacock (select games), MLB.TV blackout rules apply; team and league negotiating new regional distribution model post-Diamond bankruptcy",
        "new": "Braves.tv direct-to-consumer package through MLB.TV; BravesVision on Fubo and DirecTV Stream; Apple TV+ Friday games and NBC/Peacock Sunday nights nationally",
        "fact": "BravesVision DTC via MLB.TV",
        "source": "https://en.wikipedia.org/wiki/BravesVision"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Ronald Acuña Jr.",
            "position": "OF",
            "aav": 17,
            "contractNote": "8yr/$100M (2019 extension), final years at $17M; through 2026; signed when Acuña was still pre-MVP"
          },
          {
            "player": "Matt Olson",
            "position": "1B",
            "aav": 21,
            "contractNote": "8yr/$168M (2022), through 2029; acquired from Oakland, immediately signed to franchise-cornerstone extension"
          },
          {
            "player": "Michael Harris II",
            "position": "CF",
            "aav": 9,
            "contractNote": "8yr/$72M extension (2023), through 2030; signed to club-friendly deal as 2022 NL Rookie of the Year"
          }
        ],
        "new": [
          {
            "player": "Ronald Acuña Jr.",
            "position": "OF",
            "aav": 17,
            "contractNote": "8yr/$100M (2019 extension); $17M in 2026 with club options for 2027-2028"
          },
          {
            "player": "Matt Olson",
            "position": "1B",
            "aav": 21,
            "contractNote": "8yr/$168M (2022), through 2029"
          },
          {
            "player": "Michael Harris II",
            "position": "CF",
            "aav": 9,
            "contractNote": "8yr/$72M extension (2023), through 2030"
          },
          {
            "player": "Robert Suarez",
            "position": "RP",
            "aav": 15,
            "contractNote": "3yr/$45M (2025-26 offseason) from San Diego"
          }
        ],
        "fact": "Suarez 3yr/$45M added; Braves also signed Ha-Seong Kim and Mike Yastrzemski and re-signed Raisel Iglesias",
        "source": "https://www.mlbtraderumors.com/2026/03/offseason-in-review-atlanta-braves-17.html"
      }
    ],
    "analystNotes": "The Braves are the only MLB club you can buy on an exchange, and Forbes marks them at $3.35B on the 2026 list with $524M of revenue and $27M of operating income, the Battery Atlanta real estate layered on a 94-67 division winner that bounced back from its 2025 miss. The 2026 media move matters most for the public shareholders: Atlanta tore up FanDuel Sports Network South in January when Main Street missed payments and launched BravesVision on March 27 with Raycom and Gray, taking distribution and ad sales in house instead of collecting a shrinking rights fee. Truist's $10M-a-year naming deal runs to 2042 and Acuña's club options for 2027-2028 keep the star cheap. The number moves on BravesVision's carriage and subscriber economics, which Atlanta Braves Holdings will have to disclose quarter by quarter.",
    "unverifiedAsOf": {
      "ownership.ownerNetWorth": "May 2026"
    }
  },
  "miami-marlins": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$57M/team/year from MLB national deals (ESPN through 2028 ~$550M/yr, Fox through 2028 ~$729M/yr, Apple TV+ ~$85M/yr)",
        "new": "2026-2028 national deals: ESPN ~$550M/yr (30-game national package plus MLB.TV distribution), NBC/Peacock ~$200M/yr (Sunday Night Baseball, Wild Card games), Netflix ~$50M/yr (Home Run Derby), alongside the existing Fox (~$729M/yr) and TNT packages that run through 2028 (CNBC, Nov 2025); the CBA expires Dec 1, 2026 and a lockout over the owners' salary cap proposal is widely expected",
        "fact": "MLB signed three-year national deals with ESPN, NBC and Netflix in Nov 2025 for 2026-2028 (~$800M/yr combined); CBA expires Dec 1, 2026",
        "source": "https://www.cnbc.com/2025/11/19/mlb-media-rights-deals-nbc-espn-netflix.html"
      },
      {
        "field": "ownership.institutionalInvestors",
        "old": "MLB approved PE ownership rule (Dec 2023) may create opportunity for minority PE stake sale",
        "new": "About 15% sold in spring 2026 to two unnamed South Florida families at a reported $1.55B valuation (~$233M), with proceeds used to pay down debt ahead of a possible salary floor under the next CBA; MLB's PE rules still allow a minority institutional stake",
        "fact": "15% stake sale spring 2026 (transactions.js)",
        "source": "https://www.sportcal.com/news/mlbs-marlins-sell-15-stake-in-debt-payoff-as-salary-floor-prospect-looms/"
      },
      {
        "field": "ownership.ownershipGroup",
        "old": [
          {
            "name": "Bruce Sherman",
            "role": "principal owner / managing general partner",
            "pct": null
          },
          {
            "name": "Jorge Mas",
            "role": "minority investor / board member",
            "pct": null
          },
          {
            "name": "Various limited partners",
            "role": "minority investors",
            "pct": null
          }
        ],
        "new": [
          {
            "name": "Bruce Sherman",
            "role": "principal owner / managing general partner",
            "pct": null
          },
          {
            "name": "Jorge Mas",
            "role": "minority investor / board member",
            "pct": null
          },
          {
            "name": "Two South Florida families (unnamed)",
            "role": "minority investors (~15%, spring 2026)",
            "pct": 15
          },
          {
            "name": "Various limited partners",
            "role": "minority investors",
            "pct": null
          }
        ],
        "fact": "New minority investors 2026",
        "source": "https://www.sportcal.com/news/mlbs-marlins-sell-15-stake-in-debt-payoff-as-salary-floor-prospect-looms/"
      },
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports Florida / Diamond Sports Group (in bankruptcy restructuring); Marlins among most affected by RSN collapse given small local TV audience; team exploring direct-to-consumer alternatives",
        "new": "Marlins.tv produced and distributed by MLB Local Media from 2026 after the Marlins terminated FanDuel Sports Network Florida in Jan 2026 over Main Street's missed rights payments",
        "fact": "Marlins moved to MLB Local Media for 2026",
        "source": "https://en.wikipedia.org/wiki/MLB_Local_Media"
      },
      {
        "field": "media.streamingNotes",
        "old": "Apple TV+ (Friday night games), MLB.TV; local TV situation in flux post-Diamond bankruptcy",
        "new": "In-market streaming through MLB.TV / MLB app and the ESPN app; Apple TV+ Friday games nationally",
        "fact": "MLB Local Media in-market streaming",
        "source": "https://www.sportspro.com/news/broadcast-ott/espn-mlb-tv-angels-tigers-local-rights-rsn-february-2026/"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Sandy Alcantara",
            "position": "SP",
            "aav": 11.2,
            "contractNote": "5yr/$56M extension (2022), through 2027; Cy Young winner 2022; missed 2023-24 recovering from TJ surgery"
          },
          {
            "player": "Jazz Chisholm Jr.",
            "position": "OF/2B",
            "aav": 5,
            "contractNote": "Pre-arb through 2025; traded to Yankees July 2024; listed for historical contract context"
          }
        ],
        "new": [
          {
            "player": "Sandy Alcantara",
            "position": "SP",
            "aav": 11.2,
            "contractNote": "5yr/$56M extension (2022), through 2027 incl. option; Miami kept him at the 2026 deadline while in the wild card race"
          }
        ],
        "fact": "Alcantara retained at 2026 deadline",
        "source": "https://www.mlbtraderumors.com/2026/07/report-marlins-likely-to-buy-at-deadline-keep-sandy-alcantara.html"
      }
    ],
    "analystNotes": "The Marlins remain the floor of the league at $1.5B on the 2026 Forbes list, but the $320M of revenue and $53M of operating income show a club that runs profitably on a payroll near $79M, and a 52-42 first half in 2026 briefly made it look like a contender before a franchise-record 12-game skid ended things at 79-82. Bruce Sherman sold about 15% in spring 2026 at a reported $1.55B, a 3% premium to Forbes, and used the ~$233M to cut debt before a CBA that may impose a salary floor. Local TV moved to MLB-produced Marlins.tv after FanDuel Sports Network folded. Nine years after the $1.2B purchase, the value case still needs a buyer with conviction about South Florida or a CBA outcome that forces revenue sharing recipients to spend.",
    "unverifiedAsOf": {}
  },
  "new-york-mets": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$57M/team/year from MLB national deals (ESPN through 2028 ~$550M/yr, Fox through 2028 ~$729M/yr, Apple TV+ ~$85M/yr)",
        "new": "2026-2028 national deals: ESPN ~$550M/yr (30-game national package plus MLB.TV distribution), NBC/Peacock ~$200M/yr (Sunday Night Baseball, Wild Card games), Netflix ~$50M/yr (Home Run Derby), alongside the existing Fox (~$729M/yr) and TNT packages that run through 2028 (CNBC, Nov 2025); the CBA expires Dec 1, 2026 and a lockout over the owners' salary cap proposal is widely expected",
        "fact": "MLB signed three-year national deals with ESPN, NBC and Netflix in Nov 2025 for 2026-2028 (~$800M/yr combined); CBA expires Dec 1, 2026",
        "source": "https://www.cnbc.com/2025/11/19/mlb-media-rights-deals-nbc-espn-netflix.html"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Francisco Lindor — 10yr/$341M (2021), $34.1M AAV through 2031; plus Juan Soto 15yr/$765M (Jan 2025), $51M AAV through 2039",
        "new": "Juan Soto, 15yr/$765M (Dec 2024), $51M AAV through 2039; Francisco Lindor 10yr/$341M through 2031; the two played only 44 games together in 2026",
        "fact": "Soto and Lindor injuries in 2026",
        "source": "https://www.espn.com/mlb/story/_/id/49895199/mlb-2026-new-york-mets-lessons-2027-soto-benge-ewing-lindor-senga-cohen-stearns"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Juan Soto",
            "position": "OF",
            "aav": 51,
            "contractNote": "15yr/$765M (Jan 2025) — largest contract in professional sports history; signed before 2025 season; through 2039"
          },
          {
            "player": "Francisco Lindor",
            "position": "SS",
            "aav": 34.1,
            "contractNote": "10yr/$341M (2021 extension), through 2031; signed shortly after Cohen acquisition to anchor franchise rebuild"
          },
          {
            "player": "Kodai Senga",
            "position": "SP",
            "aav": 15,
            "contractNote": "5yr/$75M (2023), through 2027; missed most of 2024 with injury"
          }
        ],
        "new": [
          {
            "player": "Juan Soto",
            "position": "OF",
            "aav": 51,
            "contractNote": "15yr/$765M (Dec 2024), through 2039; largest contract in professional sports by total value"
          },
          {
            "player": "Francisco Lindor",
            "position": "SS",
            "aav": 34.1,
            "contractNote": "10yr/$341M (2021 extension), through 2031"
          },
          {
            "player": "Bo Bichette",
            "position": "3B/SS",
            "aav": 42,
            "contractNote": "3yr/$126M (Jan 20, 2026) with player options for 2027 and 2028; .615 OPS in his first Mets season"
          },
          {
            "player": "Devin Williams",
            "position": "RP",
            "aav": 17,
            "contractNote": "3yr/$51M (2025-26 offseason)"
          },
          {
            "player": "Kodai Senga",
            "position": "SP",
            "aav": 15,
            "contractNote": "5yr/$75M (2023), through 2027"
          },
          {
            "player": "Freddy Peralta",
            "position": "SP",
            "aav": null,
            "contractNote": "Acquired from Milwaukee Jan 21, 2026 for Jett Williams and Brandon Sproat; traded to Tampa Bay Aug 2, 2026"
          }
        ],
        "fact": "Bichette 3yr/$126M, Williams 3yr/$51M, Peralta in and out in 2026",
        "source": "https://en.wikipedia.org/wiki/2026_New_York_Mets_season"
      }
    ],
    "analystNotes": "Steve Cohen's Mets are worth $3.5B on the 2026 Forbes list and lost $213M at the operating line on $553M of revenue, the deepest loss in the sport, after a $91.6M luxury tax bill; the 2026 return on that spend was a 74-87 last-place finish, the first since 2003, with Soto and Lindor sharing the lineup for only 44 games and Bo Bichette's 3yr/$126M deal producing a .615 OPS. Cohen has said the club took on too much risk in the offseason overhaul. The asset base is intact, an ~8% SNY stake, Citi Field and a $20M-a-year naming deal, and the Mets trade at 41% of the Yankees' mark in the same market. The gap closes only if the Soto and Lindor contracts, $85M a year through 2031, anchor a contender again; the December 2026 CBA, and any cap that lands, is the other variable.",
    "unverifiedAsOf": {
      "stadium.namingRightsDeal": "May 2026"
    }
  },
  "philadelphia-phillies": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$57M/team/year from MLB national deals (ESPN through 2028 ~$550M/yr, Fox through 2028 ~$729M/yr, Apple TV+ ~$85M/yr)",
        "new": "2026-2028 national deals: ESPN ~$550M/yr (30-game national package plus MLB.TV distribution), NBC/Peacock ~$200M/yr (Sunday Night Baseball, Wild Card games), Netflix ~$50M/yr (Home Run Derby), alongside the existing Fox (~$729M/yr) and TNT packages that run through 2028 (CNBC, Nov 2025); the CBA expires Dec 1, 2026 and a lockout over the owners' salary cap proposal is widely expected",
        "fact": "MLB signed three-year national deals with ESPN, NBC and Netflix in Nov 2025 for 2026-2028 (~$800M/yr combined); CBA expires Dec 1, 2026",
        "source": "https://www.cnbc.com/2025/11/19/mlb-media-rights-deals-nbc-espn-netflix.html"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Bryce Harper",
            "position": "1B/OF",
            "aav": 25.4,
            "contractNote": "13yr/$330M (2019), through 2031; moved from RF to 1B post-UCL surgery; 2021 NL MVP"
          },
          {
            "player": "Trea Turner",
            "position": "SS",
            "aav": 27.3,
            "contractNote": "11yr/$300M (2023 extension), through 2033; added to pair with Harper as franchise cornerstone duo"
          },
          {
            "player": "Zack Wheeler",
            "position": "SP",
            "aav": 23.6,
            "contractNote": "5yr/$118M (2019-2024); re-signed on new deal; perennial Cy Young contender"
          }
        ],
        "new": [
          {
            "player": "Bryce Harper",
            "position": "1B",
            "aav": 25.4,
            "contractNote": "13yr/$330M (2019), through 2031"
          },
          {
            "player": "Trea Turner",
            "position": "SS",
            "aav": 27.3,
            "contractNote": "11yr/$300M (2023), through 2033"
          },
          {
            "player": "Kyle Schwarber",
            "position": "DH",
            "aav": 30,
            "contractNote": "5yr/$150M (Dec 2025), a record AAV for a DH, after 56 HR and 132 RBI in 2025"
          },
          {
            "player": "J.T. Realmuto",
            "position": "C",
            "aav": 15,
            "contractNote": "3yr/$45M (Jan 20, 2026) re-sign"
          },
          {
            "player": "Zack Wheeler",
            "position": "SP",
            "aav": 42,
            "contractNote": "3yr/$126M extension (2024), through 2027; Ranger Suárez left for Boston (5yr/$150M, Jan 2026)"
          }
        ],
        "fact": "Schwarber 5yr/$150M and Realmuto 3yr/$45M re-signed; Suárez left",
        "source": "https://www.mlb.com/news/kyle-schwarber-phillies-free-agent-contract"
      }
    ],
    "analystNotes": "Philadelphia is a $3.4B franchise on the 2026 Forbes list with $539M of revenue and a $52M operating loss, the cost of paying $56.1M in luxury tax for a roster John Middleton keeps extending: Schwarber back at 5yr/$150M with a record DH AAV, Realmuto at 3yr/$45M, Harper through 2031 and Turner through 2033. The 2026 season nearly wasted it, a 9-19 start cost Rob Thomson his job in April, and the club reached the final day at 87-74 needing one result to claim the last NL wild card after hosting the All-Star Game in July. NBC Sports Philadelphia, with the Phillies' partial stake and Comcast behind it, is the most stable local deal in the division. Sustained October runs from a core that is now 30-plus across the board are what defend a multiple that already prices in the 2022 pennant.",
    "unverifiedAsOf": {
      "ownership.institutionalInvestors": "May 2026"
    }
  },
  "washington-nationals": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$57M/team/year from MLB national deals (ESPN through 2028 ~$550M/yr, Fox through 2028 ~$729M/yr, Apple TV+ ~$85M/yr)",
        "new": "2026-2028 national deals: ESPN ~$550M/yr (30-game national package plus MLB.TV distribution), NBC/Peacock ~$200M/yr (Sunday Night Baseball, Wild Card games), Netflix ~$50M/yr (Home Run Derby), alongside the existing Fox (~$729M/yr) and TNT packages that run through 2028 (CNBC, Nov 2025); the CBA expires Dec 1, 2026 and a lockout over the owners' salary cap proposal is widely expected",
        "fact": "MLB signed three-year national deals with ESPN, NBC and Netflix in Nov 2025 for 2026-2028 (~$800M/yr combined); CBA expires Dec 1, 2026",
        "source": "https://www.cnbc.com/2025/11/19/mlb-media-rights-deals-nbc-espn-netflix.html"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 1,
        "new": 0,
        "fact": "Completed-season count for 2021-2025; 2025 postseason field: AL Blue Jays, Mariners, Guardians, Yankees, Red Sox, Tigers; NL Brewers, Phillies, Dodgers, Cubs, Padres, Reds; the 2019 title run is outside the 2021-2025 window; Nationals went 76-85 in 2026 under new baseball president Paul Toboni and 33-year-old manager Blake Butera",
        "source": "https://en.wikipedia.org/wiki/2026_Washington_Nationals_season"
      },
      {
        "field": "media.localTVDeal",
        "old": "MASN (Mid-Atlantic Sports Network) — contentious arrangement: MASN is majority owned by Baltimore Orioles (Peter Angelos family); Nationals have a minority stake (~33%) and have been in litigation with MASN over rights fee payments since 2012; legal dispute has lasted over a decade and remains partially unresolved",
        "new": "Nationals.tv produced and distributed by MLB Local Media from 2026; the Orioles-Nationals MASN rights-fee dispute was settled March 3, 2025 and the Nationals' MASN agreement ended after the 2025 season, ending the ~33% MASN stake arrangement",
        "fact": "Nationals left MASN for MLB Local Media in 2026 after the 2025 settlement",
        "source": "https://en.wikipedia.org/wiki/Mid-Atlantic_Sports_Network"
      },
      {
        "field": "media.streamingNotes",
        "old": "Apple TV+ (Friday night games), MLB.TV; MASN streaming via cable packages; legal dispute with MASN means Nationals have received below-market rights fees for years",
        "new": "Nationals.tv in-market streaming through MLB.TV / MLB app and the ESPN app, plus an over-the-air/cable channel; Apple TV+ Friday games nationally",
        "fact": "Nationals.tv distribution",
        "source": "https://en.wikipedia.org/wiki/2026_Washington_Nationals_season"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "MacKenzie Gore — emerging ace; James Wood — 2024 debut, considered top-5 MLB prospect; rebuilding around young core post-Soto/Scherzer era",
        "new": "James Wood, OF, arbitration-eligible after 2027, free agent after 2030; Boras client with no extension; MacKenzie Gore was traded to Texas Jan 22, 2026 for five prospects",
        "fact": "Gore traded Jan 2026; Wood unextended",
        "source": "https://en.wikipedia.org/wiki/MacKenzie_Gore"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "MacKenzie Gore",
            "position": "SP",
            "aav": 4.5,
            "contractNote": "Pre-arb; considered key rotation anchor for rebuilding Nationals"
          },
          {
            "player": "James Wood",
            "position": "OF",
            "aav": 0.7,
            "contractNote": "Pre-arb (2024 MLB debut); top prospect; center of Nationals' next competitive window"
          }
        ],
        "new": [
          {
            "player": "James Wood",
            "position": "OF",
            "aav": 0.7,
            "contractNote": "Pre-arbitration; Boras client; centerpiece of the rebuild"
          },
          {
            "player": "MacKenzie Gore",
            "position": "SP",
            "aav": null,
            "contractNote": "Traded to the Texas Rangers Jan 22, 2026 for Gavin Fien, Alejandro Rosario, Devin Fitz-Gerald, Yeremy Cabrera and Abimelec Ortiz"
          }
        ],
        "fact": "Gore trade Jan 2026",
        "source": "https://en.wikipedia.org/wiki/MacKenzie_Gore"
      },
      {
        "field": "ownership.institutionalInvestors",
        "old": "Fully family-owned; no PE or institutional investors as of 2024",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source on a Lerner sale process; ESPN lists the Lerner family as owner)",
        "source": null
      }
    ],
    "analystNotes": "The Nationals' two structural handicaps moved in opposite directions: the MASN war ended with a March 2025 settlement and Washington now controls its own feed through MLB-produced Nationals.tv, but the club is still a tenant in a DC-owned park with no naming deal and no development upside. Forbes marks the franchise at $2.15B on the 2026 list with $300M of revenue and a $15M operating loss, and the Lerners hired a 35-year-old baseball president and a 33-year-old manager, traded MacKenzie Gore to Texas for five prospects in January 2026 and finished 76-85. James Wood is the only asset on the field, and as a Boras client he will not sign early. Selling Nationals Park naming rights, worth $5-10M a year the club has left on the table since 2008, is the cheapest lever; a Lerner sale is the one that resets the number.",
    "unverifiedAsOf": {}
  },
  "chicago-cubs": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$57M/team/year from MLB national deals (ESPN through 2028 ~$550M/yr, Fox through 2028 ~$729M/yr, Apple TV+ ~$85M/yr)",
        "new": "2026-2028 national deals: ESPN ~$550M/yr (30-game national package plus MLB.TV distribution), NBC/Peacock ~$200M/yr (Sunday Night Baseball, Wild Card games), Netflix ~$50M/yr (Home Run Derby), alongside the existing Fox (~$729M/yr) and TNT packages that run through 2028 (CNBC, Nov 2025); the CBA expires Dec 1, 2026 and a lockout over the owners' salary cap proposal is widely expected",
        "fact": "MLB signed three-year national deals with ESPN, NBC and Netflix in Nov 2025 for 2026-2028 (~$800M/yr combined); CBA expires Dec 1, 2026",
        "source": "https://www.cnbc.com/2025/11/19/mlb-media-rights-deals-nbc-espn-netflix.html"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 3,
        "new": 1,
        "fact": "Completed-season count for 2021-2025; 2025 postseason field: AL Blue Jays, Mariners, Guardians, Yankees, Red Sox, Tigers; NL Brewers, Phillies, Dodgers, Cubs, Padres, Reds; Cubs went 92-70 in 2025 and lost the NLDS to Milwaukee, then clinched a 2026 wild card at 88-73",
        "source": "https://en.wikipedia.org/wiki/2025_Major_League_Baseball_postseason"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Dansby Swanson — 7yr/$177M (2023), $25.3M AAV through 2029",
        "new": "Pete Crow-Armstrong, CF, 6yr/$115M extension (Mar 2026) covering 2027-2032; first Cubs 30-30 season since Sosa in 2025 with a Gold Glove",
        "fact": "PCA extension Mar 2026",
        "source": "https://www.mlbtraderumors.com/2026/03/cubs-extend-pete-crow-armstrong.html"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Dansby Swanson",
            "position": "SS",
            "aav": 25.3,
            "contractNote": "7yr/$177M (Dec 2022), through 2029; Cubs signed as key piece of post-dynasty rebuild"
          },
          {
            "player": "Cody Bellinger",
            "position": "OF/1B",
            "aav": 26.7,
            "contractNote": "3yr/$80M (2024), through 2026; re-signed after strong 2023 bounce-back; key offensive piece"
          },
          {
            "player": "Seiya Suzuki",
            "position": "OF",
            "aav": 14,
            "contractNote": "5yr/$85M (2022), through 2026; first Japanese star import to franchise"
          }
        ],
        "new": [
          {
            "player": "Alex Bregman",
            "position": "3B",
            "aav": 35,
            "contractNote": "5yr/$175M (Jan 14, 2026), $70M deferred; after opting out of Boston"
          },
          {
            "player": "Nico Hoerner",
            "position": "2B",
            "aav": 23.5,
            "contractNote": "6yr/$141M extension (Mar 27, 2026)"
          },
          {
            "player": "Dansby Swanson",
            "position": "SS",
            "aav": 25.3,
            "contractNote": "7yr/$177M (Dec 2022), through 2029"
          },
          {
            "player": "Pete Crow-Armstrong",
            "position": "CF",
            "aav": 19.2,
            "contractNote": "6yr/$115M extension (Mar 2026), 2027-2032, no club option"
          },
          {
            "player": "Seiya Suzuki",
            "position": "OF",
            "aav": 14,
            "contractNote": "5yr/$85M (2022), through 2026; Kyle Tucker (one season, 2025) left for the Dodgers and Cody Bellinger for the Yankees"
          }
        ],
        "fact": "Bregman 5yr/$175M, Hoerner 6yr/$141M, PCA 6yr/$115M; Tucker and Bellinger departed",
        "source": "https://en.wikipedia.org/wiki/Alex_Bregman"
      },
      {
        "field": "media.localTVDeal",
        "old": "Marquee Sports Network — Cubs-owned regional sports network launched Feb 2020; Cubs own majority stake in partnership with Sinclair Broadcast Group; Marquee provides Cubs with media ownership economics (rights fees + distribution revenue) rather than just a rights fee from an outside RSN",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (Marquee/Comcast carriage status in 2026 not re-checked)",
        "source": null
      },
      {
        "field": "media.streamingNotes",
        "old": "Apple TV+ (Friday night games), MLB.TV; Marquee available via cable/streaming; Cubs exploring expanded streaming distribution; Comcast carriage dispute (2025) created distribution friction",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (not re-checked)",
        "source": null
      }
    ],
    "analystNotes": "The Cubs are a $5B franchise on the 2026 Forbes list, third in baseball, on $599M of revenue and $58M of operating income, and the base is the same as always: the Ricketts own Wrigley Field and the land, own Marquee Sports Network, and can spend without a public landlord. Jed Hoyer used that in the 2025-26 offseason, Alex Bregman at 5yr/$175M with $70M deferred, Nico Hoerner at 6yr/$141M and Pete Crow-Armstrong at 6yr/$115M through 2032, while letting Kyle Tucker walk to the Dodgers after one season. The result was an 88-73 wild card berth behind a 102-win Milwaukee team, a second straight October after the 2025 NLDS loss to the Brewers. A deep run, and a Marquee carriage settlement with Comcast that stops the subscriber bleed, are what justify a $5B mark that already assumes Wrigley's non-game revenue keeps compounding.",
    "unverifiedAsOf": {}
  },
  "cincinnati-reds": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$57M/team/year from MLB national deals (ESPN through 2028 ~$550M/yr, Fox through 2028 ~$729M/yr, Apple TV+ ~$85M/yr)",
        "new": "2026-2028 national deals: ESPN ~$550M/yr (30-game national package plus MLB.TV distribution), NBC/Peacock ~$200M/yr (Sunday Night Baseball, Wild Card games), Netflix ~$50M/yr (Home Run Derby), alongside the existing Fox (~$729M/yr) and TNT packages that run through 2028 (CNBC, Nov 2025); the CBA expires Dec 1, 2026 and a lockout over the owners' salary cap proposal is widely expected",
        "fact": "MLB signed three-year national deals with ESPN, NBC and Netflix in Nov 2025 for 2026-2028 (~$800M/yr combined); CBA expires Dec 1, 2026",
        "source": "https://www.cnbc.com/2025/11/19/mlb-media-rights-deals-nbc-espn-netflix.html"
      },
      {
        "field": "ownership.primaryOwner",
        "old": "Phil Castellini (president / managing partner) / Castellini family",
        "new": "Phil Castellini (principal owner since Feb 12, 2026, succeeding his father Bob Castellini) / Castellini family",
        "fact": "ESPN's Sept 2026 owners list: Phil Castellini became principal owner Feb 12, 2026",
        "source": "https://www.espn.com/mlb/story/_/id/47979684/who-current-mlb-team-owners"
      },
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports Ohio / Diamond Sports Group (in Chapter 11 bankruptcy restructuring 2023-2024); Reds among teams most exposed to RSN collapse; exploring direct-to-consumer streaming alternatives; Cincinnati market smaller than most MLB markets",
        "new": "Reds.tv produced and distributed by MLB Local Media from 2026 after the Reds terminated FanDuel Sports Network Ohio in Jan 2026 over Main Street's missed rights payments; FDSN shut down April 14, 2026",
        "fact": "Reds moved to MLB Local Media for 2026",
        "source": "https://en.wikipedia.org/wiki/MLB_Local_Media"
      },
      {
        "field": "media.streamingNotes",
        "old": "Apple TV+ (Friday night games), MLB.TV; local TV situation under restructuring",
        "new": "In-market streaming through MLB.TV / MLB app and the ESPN app; Apple TV+ Friday games nationally",
        "fact": "MLB Local Media in-market streaming",
        "source": "https://www.sportspro.com/news/broadcast-ott/espn-mlb-tv-angels-tigers-local-rights-rsn-february-2026/"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Elly De La Cruz — 10yr/$175M extension (2025), $17.5M AAV through 2034; 2023-24 breakout as one of baseball's most exciting young players (MLB's first 30-30-30-30 player)",
        "new": "Elly De La Cruz, 10yr/$175M extension (2025), $17.5M AAV through 2034; 30-30 season in 2026, the fourth in Reds history",
        "fact": "EDLC 30-30 in 2026",
        "source": "https://en.wikipedia.org/wiki/2026_Cincinnati_Reds_season"
      },
      {
        "field": "ownership.primaryOwner",
        "old": "Phil Castellini (president / managing partner) / Castellini family",
        "new": "Phil Castellini (controlling owner since February 2026) / Castellini family",
        "fact": "MLB clubs approved the transfer of control from Bob Castellini to his son Phil on February 12, 2026.",
        "source": "https://www.fox19.com/2026/02/13/phil-castellini-takes-over-control-reds-bob-castellini/"
      },
      {
        "field": "ownership.ownerBackground",
        "old": "Bob Castellini was a major produce distribution businessman (Castellini Company) who led the 2006 acquisition for $270M. Bob Castellini served as managing general partner and chairman until his passing in January 2024. Son Phil Castellini (president/COO since 2016) assumed managing partner role. Carl Lindner Jr. (Great American Insurance) was a co-investor. The Reds are historically one of baseball's oldest franchises (1882 NL charter member) but have struggled to compete as a small-market team without significant payroll investment",
        "new": "Bob Castellini, a produce-distribution businessman (Castellini Company), led the January 2006 purchase of 70% of the club from Carl Lindner Jr. for $270M and ran it as principal owner for twenty years. MLB clubs approved the transfer of control to his son Phil Castellini, the club's president and CEO since July 2024, on February 12, 2026; Bob Castellini remains part of the ownership group. The Reds, an 1882 NL charter member, compete as a small-market club without significant payroll investment.",
        "fact": "Corrects an earlier claim that Bob Castellini died in January 2024; he is alive, and control passed to Phil Castellini by MLB approval on February 12, 2026.",
        "source": "https://www.redlegnation.com/2026/02/12/the-cincinnati-reds-have-a-new-controlling-owner-phil-castellini/"
      },
      {
        "field": "ownership.ownershipGroup",
        "old": [
          {
            "name": "Phil Castellini",
            "role": "president / managing partner",
            "pct": null
          },
          {
            "name": "Castellini family",
            "role": "majority ownership group",
            "pct": null
          },
          {
            "name": "Carl Lindner III (Great American Insurance)",
            "role": "minority investor",
            "pct": null
          }
        ],
        "new": [
          {
            "name": "Phil Castellini",
            "role": "controlling owner and CEO (since February 2026)",
            "pct": null
          },
          {
            "name": "Bob Castellini",
            "role": "principal owner 2006 to 2026; remains in the ownership group",
            "pct": null
          },
          {
            "name": "Castellini family",
            "role": "majority ownership group",
            "pct": null
          },
          {
            "name": "Carl Lindner III (Great American Insurance)",
            "role": "minority investor",
            "pct": null
          }
        ],
        "fact": "Succession approved by MLB on February 12, 2026.",
        "source": "https://www.si.com/mlb/reds/onsi/news/mlb-officially-approves-reds-owner-bob-castellini-successor-01kha7v3454m"
      }
    ],
    "analystNotes": "Cincinnati is a $1.6B franchise on the 2026 Forbes list with $336M of revenue and $26M of operating income, a small-market club whose main assets are Elly De La Cruz on a 10yr/$175M deal through 2034 and Hunter Greene on a below-market extension. The 2025 wild card trip, the first playoff appearance since 2020, did not carry over: 2026 ended 75-86 and last in the NL Central, 27 games behind Milwaukee, even with De La Cruz posting the fourth 30-30 season in club history. Phil Castellini formally became principal owner in February 2026, and local TV moved to MLB-produced Reds.tv after the FanDuel Sports Network shutdown, which trims a rights fee that was already modest. In a county-owned park with a $2.5M-a-year naming deal, the only lever that moves the number is winning with the De La Cruz window.",
    "unverifiedAsOf": {}
  },
  "milwaukee-brewers": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$57M/team/year from MLB national deals (ESPN through 2028 ~$550M/yr, Fox through 2028 ~$729M/yr, Apple TV+ ~$85M/yr)",
        "new": "2026-2028 national deals: ESPN ~$550M/yr (30-game national package plus MLB.TV distribution), NBC/Peacock ~$200M/yr (Sunday Night Baseball, Wild Card games), Netflix ~$50M/yr (Home Run Derby), alongside the existing Fox (~$729M/yr) and TNT packages that run through 2028 (CNBC, Nov 2025); the CBA expires Dec 1, 2026 and a lockout over the owners' salary cap proposal is widely expected",
        "fact": "MLB signed three-year national deals with ESPN, NBC and Netflix in Nov 2025 for 2026-2028 (~$800M/yr combined); CBA expires Dec 1, 2026",
        "source": "https://www.cnbc.com/2025/11/19/mlb-media-rights-deals-nbc-espn-netflix.html"
      },
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports Wisconsin / Diamond Sports Group (in Chapter 11 bankruptcy restructuring 2023-2024); Milwaukee is one of the smallest TV markets in MLB, making RSN economics particularly challenging; team exploring direct streaming alternatives",
        "new": "Brewers.tv produced and distributed by MLB Local Media from 2026 after the Brewers terminated FanDuel Sports Network Wisconsin in Jan 2026 over Main Street's missed rights payments; FDSN shut down April 14, 2026",
        "fact": "Brewers moved to MLB Local Media for 2026",
        "source": "https://en.wikipedia.org/wiki/MLB_Local_Media"
      },
      {
        "field": "media.streamingNotes",
        "old": "Apple TV+ (Friday night games), MLB.TV; Wisconsin market has limited regional broadcast depth",
        "new": "In-market streaming through MLB.TV / MLB app and the ESPN app; Apple TV+ Friday games nationally",
        "fact": "MLB Local Media in-market streaming",
        "source": "https://www.sportspro.com/news/broadcast-ott/espn-mlb-tv-angels-tigers-local-rights-rsn-february-2026/"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Christian Yelich",
            "position": "LF",
            "aav": 23.9,
            "contractNote": "9yr/$215M extension (2019), through 2028; signed after back-to-back NL MVP/runner-up; club-friendly deal for first few years that became expensive as Yelich declined post-2019"
          },
          {
            "player": "Jackson Chourio",
            "position": "OF",
            "aav": 7.3,
            "contractNote": "8yr/$82M extension (2023), through 2030; signed before MLB debut as top prospect; AAV rises significantly in later years"
          },
          {
            "player": "Freddy Peralta",
            "position": "SP",
            "aav": 10.5,
            "contractNote": "5yr/$52.5M extension (2022), through 2026; consistent starter with strikeout ability"
          }
        ],
        "new": [
          {
            "player": "Christian Yelich",
            "position": "LF/DH",
            "aav": 23.9,
            "contractNote": "9yr/$215M extension (2019), through 2028"
          },
          {
            "player": "Jackson Chourio",
            "position": "OF",
            "aav": 10.25,
            "contractNote": "8yr/$82M (Dec 2023) with club options for 2032-2033; third 20-20 season before age 23 in 2026 despite a WBC hand fracture"
          },
          {
            "player": "Freddy Peralta",
            "position": "SP",
            "aav": null,
            "contractNote": "Traded to the New York Mets Jan 21, 2026 for Jett Williams and Brandon Sproat"
          }
        ],
        "fact": "Peralta traded to the Mets Jan 2026; Chourio 20-20 again in 2026",
        "source": "https://en.wikipedia.org/wiki/2026_New_York_Mets_season"
      }
    ],
    "analystNotes": "Milwaukee is the best-run franchise in the sport relative to its market: a 97-win NL Central champion in 2025 that went to the NLCS, then a franchise-record 102-59 in 2026, a fourth straight division title and the National League's top seed, all on a bottom-half payroll after trading Freddy Peralta to the Mets in January. Forbes marks the club at $1.9B on the 2026 list with $354M of revenue and $47M of operating income, and the $290M state-backed American Family Field deal from 2023 locks the lease through 2043. Local TV moved to MLB-produced Brewers.tv after FanDuel Sports Network shut down, which costs rights-fee dollars in the league's smallest TV market. Jackson Chourio is signed through 2031 at $82M. A first World Series title from this roster is the one thing that would lift a 1.5-million-person market into the $2B-plus tier.",
    "unverifiedAsOf": {}
  },
  "pittsburgh-pirates": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$57M/team/year from MLB national deals (ESPN through 2028 ~$550M/yr, Fox through 2028 ~$729M/yr, Apple TV+ ~$85M/yr)",
        "new": "2026-2028 national deals: ESPN ~$550M/yr (30-game national package plus MLB.TV distribution), NBC/Peacock ~$200M/yr (Sunday Night Baseball, Wild Card games), Netflix ~$50M/yr (Home Run Derby), alongside the existing Fox (~$729M/yr) and TNT packages that run through 2028 (CNBC, Nov 2025); the CBA expires Dec 1, 2026 and a lockout over the owners' salary cap proposal is widely expected",
        "fact": "MLB signed three-year national deals with ESPN, NBC and Netflix in Nov 2025 for 2026-2028 (~$800M/yr combined); CBA expires Dec 1, 2026",
        "source": "https://www.cnbc.com/2025/11/19/mlb-media-rights-deals-nbc-espn-netflix.html"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Paul Skenes — service-time controlled through ~2029; no extension signed as of 2025; 2024 NL Rookie of the Year, sub-2.00 ERA in debut season",
        "new": "Paul Skenes, 2025 NL Cy Young; final pre-arbitration year in 2026 at a record $1.085M; no extension, with the club reportedly unwilling to go to a $50M AAV and Skenes expected to test free agency after 2029; Konnor Griffin signed 9yr/$140M a week after his April 2026 debut",
        "fact": "Skenes unextended; Griffin record rookie extension",
        "source": "https://www.si.com/mlb/pirates/onsi/news/pittsburgh-pirates-paul-skenes-2026-salary-revealed"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Bryan Reynolds",
            "position": "CF/LF",
            "aav": 17.75,
            "contractNote": "6yr/$106.5M (Feb 2022), through 2027; hometown-discount deal for small-market star"
          },
          {
            "player": "Ke'Bryan Hayes",
            "position": "3B",
            "aav": 8.75,
            "contractNote": "8yr/$70M (Mar 2021), through 2028; Gold Glove caliber, bat has underperformed"
          },
          {
            "player": "Paul Skenes",
            "position": "SP",
            "aav": null,
            "contractNote": "Pre-arb; no extension as of 2025; franchise cornerstone"
          }
        ],
        "new": [
          {
            "player": "Konnor Griffin",
            "position": "SS",
            "aav": 15.6,
            "contractNote": "9yr/$140M extension (Apr 2026), one week after his April 3, 2026 debut; largest guarantee in Pirates history"
          },
          {
            "player": "Bryan Reynolds",
            "position": "OF",
            "aav": 17.75,
            "contractNote": "6yr/$106.5M (Feb 2022), through 2027"
          },
          {
            "player": "Paul Skenes",
            "position": "SP",
            "aav": null,
            "contractNote": "Pre-arbitration through 2026 ($1.085M); 2025 NL Cy Young; no extension; club control through 2029"
          }
        ],
        "fact": "Griffin 9yr/$140M added; Skenes still unextended",
        "source": "https://en.wikipedia.org/wiki/Konnor_Griffin"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Bryan Reynolds",
            "position": "CF/LF",
            "aav": 17.75,
            "contractNote": "6yr/$106.5M (Feb 2022), through 2027; hometown-discount deal for small-market star"
          },
          {
            "player": "Ke'Bryan Hayes",
            "position": "3B",
            "aav": 8.75,
            "contractNote": "8yr/$70M (Mar 2021), through 2028; Gold Glove caliber, bat has underperformed"
          },
          {
            "player": "Paul Skenes",
            "position": "SP",
            "aav": null,
            "contractNote": "Pre-arb; no extension as of 2025; franchise cornerstone"
          }
        ],
        "new": [
          {
            "player": "Bryan Reynolds",
            "position": "CF/LF",
            "aav": 17.75,
            "contractNote": "6yr/$106.5M (Feb 2022), through 2027; hometown-discount deal for small-market star"
          },
          {
            "player": "Paul Skenes",
            "position": "SP",
            "aav": null,
            "contractNote": "Pre-arb; no extension as of 2025; franchise cornerstone"
          }
        ],
        "fact": "Removed unverified contract line(s): Ke'Bryan Hayes",
        "source": null
      }
    ],
    "analystNotes": "Pittsburgh is a $1.62B franchise on the 2026 Forbes list with $330M of revenue and $48M of operating income, a 15% margin that reflects how the Nuttings run the club, and the roster finally broke .500 at 81-80 in 2026, the best record since 2018 and still an eleventh straight miss. The asset picture changed in April 2026 when Konnor Griffin, a teenager, signed a 9yr/$140M extension a week after his debut, the largest guarantee in franchise history; Paul Skenes, the 2025 NL Cy Young, played 2026 for $1.085M with no extension and a front office that will not go near a $50M AAV. SportsNet Pittsburgh with the Penguins and Fenway Sports Group keeps local TV stable. Whether Bob Nutting pays Skenes before the 2029 free-agent clock runs out is the whole valuation debate.",
    "unverifiedAsOf": {}
  },
  "st-louis-cardinals": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$57M/team/year from MLB national deals (ESPN through 2028 ~$550M/yr, Fox through 2028 ~$729M/yr, Apple TV+ ~$85M/yr)",
        "new": "2026-2028 national deals: ESPN ~$550M/yr (30-game national package plus MLB.TV distribution), NBC/Peacock ~$200M/yr (Sunday Night Baseball, Wild Card games), Netflix ~$50M/yr (Home Run Derby), alongside the existing Fox (~$729M/yr) and TNT packages that run through 2028 (CNBC, Nov 2025); the CBA expires Dec 1, 2026 and a lockout over the owners' salary cap proposal is widely expected",
        "fact": "MLB signed three-year national deals with ESPN, NBC and Netflix in Nov 2025 for 2026-2028 (~$800M/yr combined); CBA expires Dec 1, 2026",
        "source": "https://www.cnbc.com/2025/11/19/mlb-media-rights-deals-nbc-espn-netflix.html"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 1,
        "new": 2,
        "fact": "Completed-season count for 2021-2025; 2025 postseason field: AL Blue Jays, Mariners, Guardians, Yankees, Red Sox, Tigers; NL Brewers, Phillies, Dodgers, Cubs, Padres, Reds; Cardinals went 77-84 in 2026 in the first year of the Chaim Bloom rebuild",
        "source": "https://www.cbssports.com/mlb/news/2026-mlb-playoff-picture-standings-bracket/"
      },
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports Midwest (Diamond Sports Group/Sinclair); ~$73M local TV revenue in 2024; Cardinals re-upped with Diamond despite bankruptcy proceedings; outcome of Diamond restructuring may alter future local deal terms",
        "new": "Cardinals.tv produced and distributed by MLB Local Media from 2026 after the Cardinals terminated FanDuel Sports Network Midwest in Jan 2026 over Main Street's missed rights payments; the DeWitts have acknowledged a hit to local broadcast revenue versus the ~$73M Diamond deal",
        "fact": "Cardinals moved to MLB Local Media for 2026",
        "source": "https://en.wikipedia.org/wiki/MLB_Local_Media"
      },
      {
        "field": "media.streamingNotes",
        "old": "Bally Sports+ streaming app in territory; MLB.TV out-of-market; Apple TV+ Friday Night Baseball nationally",
        "new": "In-market streaming through MLB.TV / MLB app and the ESPN app; Apple TV+ Friday games nationally",
        "fact": "MLB Local Media in-market streaming",
        "source": "https://www.sportspro.com/news/broadcast-ott/espn-mlb-tv-angels-tigers-local-rights-rsn-february-2026/"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Nolan Arenado — 3yr/$66M remaining on original 10yr/$260M deal (signed 2019), ~$32M AAV through 2027; trade rumors circulated in 2025 as team rebuilds",
        "new": "Rebuild under president of baseball operations Chaim Bloom: Nolan Arenado traded to Arizona Jan 13, 2026 (St. Louis covers $31M of the remaining $42M), Sonny Gray to Boston Nov 25, 2025 and Willson Contreras to Boston Dec 21, 2025; ownership put more than $50M into those deals; the core is Brendan Donovan and JJ Wetherholt",
        "fact": "Arenado, Gray and Contreras traded in the 2025-26 offseason",
        "source": "https://www.mlbtraderumors.com/2026/01/cardinals-trade-nolan-arenado-diamondbacks.html"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Nolan Arenado",
            "position": "3B",
            "aav": 32,
            "contractNote": "Remaining years on 10yr/$260M (2019 extension with Colorado); through 2027; perennial Gold Glove; trade demand grew as Cardinals pivoted to rebuild"
          },
          {
            "player": "Sonny Gray",
            "position": "SP",
            "aav": 25,
            "contractNote": "4yr/$100M (Dec 2022), through 2026; consistent NL Cy Young contender-level starter"
          }
        ],
        "new": [
          {
            "player": "Nolan Arenado",
            "position": "3B",
            "aav": null,
            "contractNote": "Traded to the Diamondbacks Jan 13, 2026 for Jack Martinez; Cardinals pay $31M of the $42M owed for 2026-2027"
          },
          {
            "player": "Sonny Gray",
            "position": "SP",
            "aav": null,
            "contractNote": "Traded to the Red Sox with cash Nov 25, 2025 for Brandon Clarke and Richard Fitts"
          },
          {
            "player": "Willson Contreras",
            "position": "1B",
            "aav": null,
            "contractNote": "Traded to the Red Sox Dec 21, 2025 for Hunter Dobbins and pitching prospects"
          }
        ],
        "fact": "Veteran contracts moved out; salary retained",
        "source": "https://www.cbssports.com/mlb/news/cardinals-rebuild-payroll-chaim-bloom-nolan-arenado-brendan-donovan-jj-wetherholt/"
      }
    ],
    "analystNotes": "The Cardinals are a $2.75B franchise on the 2026 Forbes list with $350M of revenue and $33M of operating income, a mark held up by a team-owned Busch Stadium and Ballpark Village rather than by the product, which was a 77-84 rebuild in 2026. Chaim Bloom cleared the veteran payroll in one offseason, Gray and Contreras to Boston and Arenado to Arizona with the DeWitts eating more than $50M in retained salary. The bigger revenue hit is media: the $73M Diamond Sports deal is gone, the Cardinals terminated FanDuel Sports Network Midwest in January 2026 when Main Street missed payments, and games now run through MLB-produced Cardinals.tv at a lower fee. The DeWitt family's 30-year, 17x return is intact; the next re-rating waits on a new local media structure and on Donovan and Wetherholt becoming a contender again.",
    "unverifiedAsOf": {}
  },
  "los-angeles-dodgers": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$57M/team/year from MLB national deals (ESPN through 2028 ~$550M/yr, Fox through 2028 ~$729M/yr, Apple TV+ ~$85M/yr)",
        "new": "2026-2028 national deals: ESPN ~$550M/yr (30-game national package plus MLB.TV distribution), NBC/Peacock ~$200M/yr (Sunday Night Baseball, Wild Card games), Netflix ~$50M/yr (Home Run Derby), alongside the existing Fox (~$729M/yr) and TNT packages that run through 2028 (CNBC, Nov 2025); the CBA expires Dec 1, 2026 and a lockout over the owners' salary cap proposal is widely expected",
        "fact": "MLB signed three-year national deals with ESPN, NBC and Netflix in Nov 2025 for 2026-2028 (~$800M/yr combined); CBA expires Dec 1, 2026",
        "source": "https://www.cnbc.com/2025/11/19/mlb-media-rights-deals-nbc-espn-netflix.html"
      },
      {
        "field": "onField.championshipsLast10Years",
        "old": 1,
        "new": 3,
        "fact": "World Series titles in 2020, 2024 and 2025 (beat Toronto 5-4 in 11 innings in Game 7 on Nov 1, 2025, the first repeat since the 1998-2000 Yankees)",
        "source": "https://www.espn.com/mlb/story/_/id/46796786/world-series-2025-los-angeles-dodgers-champions-repeat-dynasty"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Shohei Ohtani — 10yr/$700M (Dec 2023), $70M AAV, through 2033; largest contract in professional sports history; $680M of $700M total deferred to post-contract",
        "new": "Shohei Ohtani, 10yr/$700M (Dec 2023), $70M AAV through 2033 with $680M deferred; two straight World Series titles (2024, 2025)",
        "fact": "Repeat champions 2025",
        "source": "https://www.espn.com/mlb/story/_/id/46796786/world-series-2025-los-angeles-dodgers-champions-repeat-dynasty"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Shohei Ohtani",
            "position": "DH/SP",
            "aav": 70,
            "contractNote": "10yr/$700M (Dec 2023) through 2033; $680M deferred; actual cash AAV ~$2M/yr until 2034; luxury tax figure ~$46M AAV"
          },
          {
            "player": "Mookie Betts",
            "position": "SS/RF",
            "aav": 36.5,
            "contractNote": "12yr/$365M (Apr 2020) through 2032; $115M deferred; Gold Glove, multiple MVP-caliber seasons"
          },
          {
            "player": "Freddie Freeman",
            "position": "1B",
            "aav": 27,
            "contractNote": "6yr/$162M (Apr 2022) through 2027; $57M deferred; 2020 NL MVP, 2024 WS MVP"
          },
          {
            "player": "Kyle Tucker",
            "position": "RF",
            "aav": 48,
            "contractNote": "5yr/$240M (2025), through 2029; acquired via trade from Houston, re-signed immediately"
          }
        ],
        "new": [
          {
            "player": "Shohei Ohtani",
            "position": "DH/SP",
            "aav": 70,
            "contractNote": "10yr/$700M (Dec 2023) through 2033; $680M deferred; luxury-tax AAV ~$46M"
          },
          {
            "player": "Kyle Tucker",
            "position": "RF",
            "aav": 60,
            "contractNote": "4yr/$240M free-agent deal (Jan 21, 2026); $64M signing bonus, $30M deferred, opt-outs after 2027 and 2028; ~$57.1M luxury-tax AAV, the highest in MLB history"
          },
          {
            "player": "Mookie Betts",
            "position": "SS/RF",
            "aav": 36.5,
            "contractNote": "12yr/$365M (Apr 2020) through 2032; $115M deferred"
          },
          {
            "player": "Freddie Freeman",
            "position": "1B",
            "aav": 27,
            "contractNote": "6yr/$162M (Apr 2022) through 2027; $57M deferred; 2024 WS MVP"
          },
          {
            "player": "Tarik Skubal",
            "position": "SP",
            "aav": null,
            "contractNote": "Acquired from Detroit Aug 3, 2026 for River Ryan, Zyhir Hope and Brady Smith; free agent after 2026"
          }
        ],
        "fact": "Tucker signed as a free agent Jan 2026 (the enrichment's 'acquired via trade from Houston, 5yr/$240M, 2025' was wrong); Skubal acquired Aug 2026",
        "source": "https://www.mlbtraderumors.com/2026/01/dodgers-to-sign-kyle-tucker.html"
      },
      {
        "field": "media.localTVDeal",
        "old": "SportsNet LA (Spectrum Sports/Charter Communications); 25-year deal signed 2013 totaling $8.35B through 2039 (~$334M/yr at face value; reported annual receipts ~$196M in 2022 due to deal structure); Dodgers co-own SportsNet LA with Charter",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (SportsNet LA / Charter arrangement not re-checked with a 2026 source)",
        "source": null
      }
    ],
    "analystNotes": "The Dodgers are a $7.8B franchise on the 2026 Forbes list, the first MLB club with $850M of revenue, and the operating line is a $20M loss only because Guggenheim paid a record $169.4M in luxury tax to win a second straight World Series, an 11-inning Game 7 over Toronto on Nov 1, 2025. The machine kept feeding itself: Kyle Tucker at 4yr/$240M in January 2026 with a $57.1M tax AAV, the highest ever, then Tarik Skubal at the August deadline, and a 99-62 division title. Team-owned Dodger Stadium and the $8.35B SportsNet LA deal through 2039 underwrite it, with $1.4B-plus of deferred salary keeping the cash cost of the roster manageable. The December 2026 CBA is the only thing that can touch this model; a hard cap would hit the Dodgers harder than any other club.",
    "unverifiedAsOf": {}
  },
  "san-francisco-giants": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$57M/team/year from MLB national deals (ESPN through 2028 ~$550M/yr, Fox through 2028 ~$729M/yr, Apple TV+ ~$85M/yr)",
        "new": "2026-2028 national deals: ESPN ~$550M/yr (30-game national package plus MLB.TV distribution), NBC/Peacock ~$200M/yr (Sunday Night Baseball, Wild Card games), Netflix ~$50M/yr (Home Run Derby), alongside the existing Fox (~$729M/yr) and TNT packages that run through 2028 (CNBC, Nov 2025); the CBA expires Dec 1, 2026 and a lockout over the owners' salary cap proposal is widely expected",
        "fact": "MLB signed three-year national deals with ESPN, NBC and Netflix in Nov 2025 for 2026-2028 (~$800M/yr combined); CBA expires Dec 1, 2026",
        "source": "https://www.cnbc.com/2025/11/19/mlb-media-rights-deals-nbc-espn-netflix.html"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Logan Webb — 5yr/$90M extension (Mar 2022), $18M AAV, through 2026; Giants ace and homegrown franchise cornerstone",
        "new": "Logan Webb, 5yr/$90M extension (2023), $18M AAV through 2028; Buster Posey (president of baseball operations) says he will not be traded; 4.31 ERA and a knee injury in 2026",
        "fact": "Webb runs through 2028, not 2026",
        "source": "https://www.mlbtraderumors.com/2026/06/posey-discusses-giants-deadline-no-plans-to-trade-logan-webb.html"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Logan Webb",
            "position": "SP",
            "aav": 18,
            "contractNote": "5yr/$90M extension (Mar 2022) through 2026; NL Cy Young contender, 200+ innings per year"
          },
          {
            "player": "Matt Chapman",
            "position": "3B",
            "aav": 18,
            "contractNote": "3yr/$54M (Dec 2023) through 2026; Gold Glove third baseman, cornerstone of rebuild"
          },
          {
            "player": "Jung Hoo Lee",
            "position": "CF",
            "aav": 18.8,
            "contractNote": "6yr/$113M (Jan 2024) through 2029; KBO Korean star; injury-plagued debut 2024"
          }
        ],
        "new": [
          {
            "player": "Rafael Devers",
            "position": "DH/1B",
            "aav": 30.1,
            "contractNote": "11yr/$331M (Boston extension, Jan 2023); acquired June 15, 2025; $211M owed over seven years after 2026; season-ending core surgery in 2026"
          },
          {
            "player": "Matt Chapman",
            "position": "3B",
            "aav": 25.2,
            "contractNote": "6yr/$151M extension (Sept 2024), $25M in 2026 and $100M for 2027-2030; core-muscle surgery ended his 2026 on June 30"
          },
          {
            "player": "Logan Webb",
            "position": "SP",
            "aav": 18,
            "contractNote": "5yr/$90M extension (2023), through 2028"
          },
          {
            "player": "Jung Hoo Lee",
            "position": "CF",
            "aav": 18.8,
            "contractNote": "6yr/$113M (Jan 2024), through 2029"
          }
        ],
        "fact": "Devers acquired June 2025; Chapman extended Sept 2024; Webb runs to 2028",
        "source": "https://www.cbssports.com/mlb/news/regrading-rafael-devers-trade-red-sox-giants-one-year-later/"
      },
      {
        "field": "media.localTVDeal",
        "old": "NBC Sports Bay Area (Giants co-own the RSN with NBCUniversal via a joint venture); generated ~$92M in local TV revenue for the Giants in 2022; unlike Bally Sports/Diamond teams, Giants' co-ownership structure protects against RSN bankruptcy risk",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (NBC Sports Bay Area JV not re-checked for 2026)",
        "source": null
      }
    ],
    "analystNotes": "The Giants are a $4.05B franchise on the 2026 Forbes list, fourth in baseball, with $477M of revenue and $54M of operating income, a mark carried by a privately financed, team-owned Oracle Park, the Mission Rock development and a co-owned NBC Sports Bay Area, none of which showed up in the standings: 65-96 in 2026 was the worst season since 2017. Buster Posey's bets went bad at once, Rafael Devers, acquired from Boston in June 2025 with $211M still owed after 2026, and Matt Chapman on a 6yr/$151M extension both had season-ending surgery, and Logan Webb posted a 4.31 ERA before a knee injury. Sixth Street's 10% stake from 2025 sets a private mark near Forbes. The gap between a top-four valuation and a bottom-three team closes only if the 2027 roster contends; the real estate does not need to win, but the multiple does.",
    "unverifiedAsOf": {}
  },
  "san-diego-padres": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$57M/team/year from MLB national deals (ESPN through 2028 ~$550M/yr, Fox through 2028 ~$729M/yr, Apple TV+ ~$85M/yr)",
        "new": "2026-2028 national deals: ESPN ~$550M/yr (30-game national package plus MLB.TV distribution), NBC/Peacock ~$200M/yr (Sunday Night Baseball, Wild Card games), Netflix ~$50M/yr (Home Run Derby), alongside the existing Fox (~$729M/yr) and TNT packages that run through 2028 (CNBC, Nov 2025); the CBA expires Dec 1, 2026 and a lockout over the owners' salary cap proposal is widely expected",
        "fact": "MLB signed three-year national deals with ESPN, NBC and Netflix in Nov 2025 for 2026-2028 (~$800M/yr combined); CBA expires Dec 1, 2026",
        "source": "https://www.cnbc.com/2025/11/19/mlb-media-rights-deals-nbc-espn-netflix.html"
      },
      {
        "field": "ownership.primaryOwner",
        "old": "Seidler family (Peter Seidler died Nov 2023; John Seidler managing); sale to José Feliciano / Kwanza Jones pending",
        "new": "José E. Feliciano (control person) and Kwanza Jones, $3.9B sale from the Seidler family trust announced May 2, 2026, approved unanimously by MLB owners Aug 17, 2026 and completed; the buyers hold ~40% of the equity with control, the Seidlers keep a stake, minority partners include Joey and Jesse Buss",
        "fact": "Padres sale closed Aug 2026 (transactions.js)",
        "source": "https://www.espn.com/mlb/story/_/id/49640765/mlb-unanimously-approves-sale-san-diego-padres"
      },
      {
        "field": "ownership.ownershipGroup",
        "old": [
          {
            "name": "Seidler family",
            "role": "controlling owners (pending sale)",
            "pct": null
          },
          {
            "name": "Ron Fowler",
            "role": "executive chairman / limited partner",
            "pct": null
          },
          {
            "name": "José E. Feliciano",
            "role": "incoming controlling owner (deal pending)",
            "pct": null
          },
          {
            "name": "Kwanza Jones",
            "role": "incoming co-owner (deal pending)",
            "pct": null
          }
        ],
        "new": [
          {
            "name": "José E. Feliciano",
            "role": "control person / chairman (Clearlake Capital co-founder)",
            "pct": null
          },
          {
            "name": "Kwanza Jones",
            "role": "co-owner; first Black woman to hold a controlling stake in an MLB club",
            "pct": null
          },
          {
            "name": "Seidler family",
            "role": "minority (retained equity after the 2026 sale)",
            "pct": null
          },
          {
            "name": "Joey and Jesse Buss",
            "role": "minority partners",
            "pct": null
          },
          {
            "name": "Ron Fowler",
            "role": "limited partner / former executive chairman",
            "pct": null
          }
        ],
        "fact": "Post-sale ownership group",
        "source": "https://www.espn.com/mlb/story/_/id/48659063/padres-reach-agreement-sell-group-led-kwanza-jones-jose-e-feliciano"
      },
      {
        "field": "ownership.acquisitionYear",
        "old": 2012,
        "new": 2026,
        "fact": "Sale closed Aug 2026",
        "source": "https://www.espn.com/mlb/story/_/id/49640765/mlb-unanimously-approves-sale-san-diego-padres"
      },
      {
        "field": "ownership.acquisitionPrice",
        "old": 0.6,
        "new": 3.9,
        "fact": "$3.9B reported valuation, an MLB record at the time (later topped by the Angels' ~$4B)",
        "source": "https://www.espn.com/mlb/story/_/id/49640765/mlb-unanimously-approves-sale-san-diego-padres"
      },
      {
        "field": "stadium.namingRightsDeal",
        "old": {
          "sponsor": "Petco (pet supply retail)",
          "annualValue_M": 7.7,
          "totalValue_M": null,
          "expiryYear": 2026,
          "notes": "Original 22-year/$60M deal signed 2003 ($2.7M/yr); renegotiated and extended at higher rate; current deal estimated ~$7-8M/yr; Petco is headquartered in San Diego, aligning brand with local community"
        },
        "new": {
          "sponsor": "Petco (pet supply retail)",
          "annualValue_M": 7.7,
          "totalValue_M": null,
          "expiryYear": 2027,
          "notes": "Original 22-year/$60M deal (2003) renegotiated; the 2021 renewal runs through at least 2027; Petco is headquartered in San Diego; no post-2027 extension announced as of Sept 2026"
        },
        "fact": "Petco deal runs through at least 2027 per the 2021 renewal",
        "source": "https://en.wikipedia.org/wiki/Petco_Park"
      },
      {
        "field": "media.streamingNotes",
        "old": "Padres own direct streaming rights in territory; simulcast on KFMB free-to-air; MLB.TV out-of-market; Apple TV+ Friday Night Baseball",
        "new": "Padres.tv in-market streaming through MLB.TV / MLB app and the ESPN app; KFMB over-the-air simulcasts; Apple TV+ Friday games nationally",
        "fact": "Padres.tv via MLB Local Media since 2023",
        "source": "https://en.wikipedia.org/wiki/MLB_Local_Media"
      }
    ],
    "analystNotes": "San Diego produced the cleanest control-sale comp in baseball: José Feliciano and Kwanza Jones bought about 40% of the equity with control at a $3.9B valuation, announced May 2, 2026, approved unanimously on Aug 17 and closed, a 26% premium to the $3.1B Forbes mark from March and a 6.5x return on the Seidler group's $600M entry in 2012. Forbes counts $452M of revenue and roughly breakeven operations for a club that paid $7M in luxury tax, owns its local rights through MLB-produced Padres.tv, and went 90-71 to take the top NL wild card in 2026 for a third playoff trip in four years. Tatis, Machado and Bogaerts are locked through 2032-2034. The new owners' first decisions, the Petco naming deal that expires after 2027 and whether they keep spending like Peter Seidler did, set the next mark.",
    "unverifiedAsOf": {}
  },
  "colorado-rockies": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$57M/team/year from MLB national deals (ESPN through 2028 ~$550M/yr, Fox through 2028 ~$729M/yr, Apple TV+ ~$85M/yr)",
        "new": "2026-2028 national deals: ESPN ~$550M/yr (30-game national package plus MLB.TV distribution), NBC/Peacock ~$200M/yr (Sunday Night Baseball, Wild Card games), Netflix ~$50M/yr (Home Run Derby), alongside the existing Fox (~$729M/yr) and TNT packages that run through 2028 (CNBC, Nov 2025); the CBA expires Dec 1, 2026 and a lockout over the owners' salary cap proposal is widely expected",
        "fact": "MLB signed three-year national deals with ESPN, NBC and Netflix in Nov 2025 for 2026-2028 (~$800M/yr combined); CBA expires Dec 1, 2026",
        "source": "https://www.cnbc.com/2025/11/19/mlb-media-rights-deals-nbc-espn-netflix.html"
      },
      {
        "field": "ownership.institutionalInvestors",
        "old": "Walton-Penner group (Walmart family / PE background) has ~40% stake",
        "new": "Greg Penner and Carrie Walton Penner's group (Denver Broncos owners) completed the purchase of a ~40% minority stake in April 2026, the largest minority position in MLB; the Monforts retain control; Paul DePodesta was hired as president of baseball operations and Josh Byrnes as GM for 2026",
        "fact": "Walton-Penner 40% stake closed April 2026",
        "source": "https://en.wikipedia.org/wiki/2026_Colorado_Rockies_season"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Kris Bryant",
            "position": "OF/3B",
            "aav": 26,
            "contractNote": "7yr/$182M (Mar 2022), through 2028; back injuries have derailed tenure; played fewer than 100 games total 2022-2024; widely viewed as worst free-agent contract of the era"
          },
          {
            "player": "Ryan McMahon",
            "position": "2B",
            "aav": 11.7,
            "contractNote": "6yr/$70M (Feb 2022) through 2027; consistent Gold Glove-caliber 2B; team's best value contract"
          }
        ],
        "new": [
          {
            "player": "Kris Bryant",
            "position": "OF/3B",
            "aav": 26,
            "contractNote": "7yr/$182M (Mar 2022), through 2028; 48 games in three seasons and none since April 12, 2025"
          },
          {
            "player": "Ryan McMahon",
            "position": "3B",
            "aav": 11.7,
            "contractNote": "6yr/$70M (Feb 2022) through 2027"
          }
        ],
        "fact": "Bryant has not played since April 2025",
        "source": "https://www.si.com/mlb/rockies/colorado-rockies-four-100-loss-seasons-historic-levels-losing"
      }
    ],
    "analystNotes": "Colorado is the sport's clearest case of a valuation that ignores the standings: Forbes has the Rockies at $1.68B on the 2026 list with $319M of revenue and $20M of operating income, and the team has lost 100 games four years running, 43-119 in 2025 and 58-103 in 2026, the first such streak since the 1962-65 Mets. The change is upstairs: the Walton-Penner group that rebuilt the Broncos closed on a ~40% minority stake in April 2026, the largest in MLB, and the Monforts brought in Paul DePodesta and Josh Byrnes to run baseball operations. Coors Field, the Denver market and a $1.5M-a-year Coors naming deal that has never been repriced are the assets. The number moves when the Penners take control, and not before.",
    "unverifiedAsOf": {}
  },
  "arizona-diamondbacks": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$57M/team/year from MLB national deals (ESPN through 2028 ~$550M/yr, Fox through 2028 ~$729M/yr, Apple TV+ ~$85M/yr)",
        "new": "2026-2028 national deals: ESPN ~$550M/yr (30-game national package plus MLB.TV distribution), NBC/Peacock ~$200M/yr (Sunday Night Baseball, Wild Card games), Netflix ~$50M/yr (Home Run Derby), alongside the existing Fox (~$729M/yr) and TNT packages that run through 2028 (CNBC, Nov 2025); the CBA expires Dec 1, 2026 and a lockout over the owners' salary cap proposal is widely expected",
        "fact": "MLB signed three-year national deals with ESPN, NBC and Netflix in Nov 2025 for 2026-2028 (~$800M/yr combined); CBA expires Dec 1, 2026",
        "source": "https://www.cnbc.com/2025/11/19/mlb-media-rights-deals-nbc-espn-netflix.html"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 2,
        "new": 1,
        "fact": "Completed-season count for 2021-2025; 2025 postseason field: AL Blue Jays, Mariners, Guardians, Yankees, Red Sox, Tigers; NL Brewers, Phillies, Dodgers, Cubs, Padres, Reds; the 2023 pennant remains the only trip in the window; Arizona entered the final day of 2026 at 86-75 needing a win over San Diego and a Phillies loss for the last NL wild card",
        "source": "https://www.cbssports.com/mlb/news/2026-mlb-playoff-picture-standings-bracket/"
      },
      {
        "field": "stadium.ownershipModel",
        "old": "owned by Maricopa County; Diamondbacks lease under agreement expiring 2027; retractable roof (only MLB ballpark with a roof in this era besides Marlins and Rangers); Maricopa County and team in negotiations over new stadium or Chase Field renovation",
        "new": "owned by Maricopa County through the Arizona Sports and Tourism Authority-era stadium district; lease expires after 2027; Gov. Katie Hobbs signed a June 2025 bill directing up to $500M of stadium-area sales tax to renovations over 30 years with the team adding $250M, but lease-extension talks with the county were still described by the club as 'non-productive' in Sept 2026, holding up a roof replacement and other repairs",
        "fact": "Renovation funding signed 2025; lease extension unresolved Sept 2026",
        "source": "https://www.axios.com/local/phoenix/2026/09/01/diamondbacks-chase-field-lease"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "$500M Arizona state public funding bill for new stadium cleared the Arizona House in 2025, headed to Governor Hobbs; new stadium in Phoenix metro likely if signed; would reset team's venue economics entirely",
        "new": "No new stadium: the June 2025 state law funds up to $500M of Chase Field renovations (roof, HVAC) from stadium-district sales tax over 30 years, plus $250M from the team, in exchange for the Diamondbacks staying at Chase Field long term; the required lease extension with Maricopa County was not signed as of Sept 2026 and the current lease ends in 2027",
        "fact": "Chase Field renovation path replaced the new-stadium bill; lease extension pending",
        "source": "https://www.espn.com/mlb/story/_/id/45599472/gov-katie-hobbs-signs-upgrades-d-backs-chase-field"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Ketel Marte",
            "position": "2B/CF",
            "aav": 19.4,
            "contractNote": "6yr/$116.5M (Mar 2021) through 2026; consistent All-Star, franchise stalwart"
          },
          {
            "player": "Corbin Carroll",
            "position": "CF/LF",
            "aav": 13.875,
            "contractNote": "8yr/$111M (Jan 2024) through 2031; pre-arb extension locking in ROY and breakout star through prime years"
          },
          {
            "player": "Zac Gallen",
            "position": "SP",
            "aav": 12,
            "contractNote": "5yr/$60M (Nov 2022) through 2027; D-backs homegrown ace; sub-3.00 ERA franchise starter"
          }
        ],
        "new": [
          {
            "player": "Corbin Carroll",
            "position": "CF/LF",
            "aav": 13.875,
            "contractNote": "8yr/$111M (Mar 2023) through 2030 with a 2031 club option"
          },
          {
            "player": "Ketel Marte",
            "position": "2B",
            "aav": 19.4,
            "contractNote": "Extension through 2030 (signed 2025)"
          },
          {
            "player": "Nolan Arenado",
            "position": "3B",
            "aav": 5.5,
            "contractNote": "Acquired from St. Louis Jan 13, 2026 for Jack Martinez; Arizona pays $11M of the $42M owed for 2026-2027 ($5M in 2026, $6M in 2027)"
          }
        ],
        "fact": "Arenado acquired Jan 2026; Carroll's deal dates from March 2023",
        "source": "https://www.mlbtraderumors.com/2026/01/cardinals-trade-nolan-arenado-diamondbacks.html"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Ketel Marte",
            "position": "2B/CF",
            "aav": 19.4,
            "contractNote": "6yr/$116.5M (Mar 2021) through 2026; consistent All-Star, franchise stalwart"
          },
          {
            "player": "Corbin Carroll",
            "position": "CF/LF",
            "aav": 13.875,
            "contractNote": "8yr/$111M (Jan 2024) through 2031; pre-arb extension locking in ROY and breakout star through prime years"
          },
          {
            "player": "Zac Gallen",
            "position": "SP",
            "aav": 12,
            "contractNote": "5yr/$60M (Nov 2022) through 2027; D-backs homegrown ace; sub-3.00 ERA franchise starter"
          }
        ],
        "new": [
          {
            "player": "Ketel Marte",
            "position": "2B/CF",
            "aav": 19.4,
            "contractNote": "6yr/$116.5M (Mar 2021) through 2026; consistent All-Star, franchise stalwart"
          },
          {
            "player": "Corbin Carroll",
            "position": "CF/LF",
            "aav": 13.875,
            "contractNote": "8yr/$111M (Jan 2024) through 2031; pre-arb extension locking in ROY and breakout star through prime years"
          }
        ],
        "fact": "Removed unverified contract line(s): Zac Gallen",
        "source": null
      }
    ],
    "analystNotes": "Arizona is a $1.96B franchise on the 2026 Forbes list with $324M of revenue and a $31M operating loss, and the valuation question is entirely about the building: Gov. Hobbs signed a June 2025 law steering up to $500M of stadium-district sales tax into Chase Field over 30 years with $250M from the team, which killed the new-stadium track, but the lease extension with Maricopa County that unlocks it was still stalled in September 2026 with the current lease ending after 2027. The team stayed relevant, adding Nolan Arenado for $11M of exposure in January and reaching the final day of 2026 at 86-75 with a shot at the last NL wild card. Corbin Carroll's 8yr/$111M deal runs through 2030. A signed lease and a roof replacement in the 2026-27 offseason are worth more to Ken Kendrick's mark than any single contract.",
    "unverifiedAsOf": {
      "stadium.namingRightsDeal": "May 2026"
    }
  },
  "boston-bruins": {
    "asOf": "2026-09",
    "changes": [],
    "analystNotes": "Forbes put the Bruins at $2.7B in December 2024 on $268M of revenue and $69M of operating income, and the structure behind that number has not moved: Delaware North owns TD Garden and the Hub on Causeway district, and the Jacobs family holds 20% of NESN. The hockey side wobbled, with a last-place 2024-25, the Marchand trade to Florida, and a 2026 first-round exit to Buffalo, but Pastrnak ($11.25M through 2030-31) and McAvoy ($9.5M through 2029-30) keep the roster core intact. Succession at Delaware North is the one event that would reprice this franchise, because any sale would set a new Original Six record.",
    "unverifiedAsOf": {}
  },
  "buffalo-sabres": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 0,
        "new": 1,
        "fact": "Sabres clinched a playoff spot April 4, 2026, ending a 14-year drought, won the Atlantic Division April 13, 2026 (first since 2010), beat Boston in 6 and lost Game 7 in overtime to Montreal in the second round",
        "source": "https://en.wikipedia.org/wiki/Buffalo_Sabres ; https://en.wikipedia.org/wiki/2026_Stanley_Cup_playoffs"
      },
      {
        "field": "arena.namingRightsDeal",
        "old": {
          "sponsor": "KeyBank",
          "annualValue_M": 5,
          "totalValue_M": null,
          "expiryYear": null,
          "notes": "KeyBank naming rights (formerly HSBC Arena, First Niagara Center); multi-year deal; revenue retained by facility ownership/operating agreement; Sabres exploring significant public funding for future arena upgrades"
        },
        "new": {
          "sponsor": "KeyBank",
          "annualValue_M": 5,
          "totalValue_M": null,
          "expiryYear": 2036,
          "notes": "New KeyBank naming-rights contract announced July 30, 2025 keeps the KeyBank Center name through the 2035-36 season; lease runs through September 2031; annual value not disclosed (prior ~$5M/yr estimate retained)"
        },
        "fact": "Sabres and KeyBank announced a new naming-rights contract on July 30, 2025 running through 2035-36",
        "source": "https://en.wikipedia.org/wiki/Buffalo_Sabres ; https://en.wikipedia.org/wiki/2025%E2%80%9326_NHL_season"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Tage Thompson",
            "position": "C",
            "aav": 7.14,
            "contractNote": "7yr/$50M signed Aug 2022, through 2029-30; led team with 47 goals in 2023-24"
          },
          {
            "player": "Jason Zucker",
            "position": "LW",
            "aav": 5,
            "contractNote": "1yr/$5M (2023-24); veteran leadership role"
          }
        ],
        "new": [
          {
            "player": "Josh Norris",
            "position": "C",
            "aav": 7.95,
            "contractNote": "$7.95M AAV, four seasons left after 2026-27 per CapWages; acquired from Ottawa"
          },
          {
            "player": "Zach Benson",
            "position": "LW",
            "aav": 7.5,
            "contractNote": "$7.5M AAV, seven seasons remaining per CapWages (new long-term deal)"
          },
          {
            "player": "Tage Thompson",
            "position": "C",
            "aav": 7.14,
            "contractNote": "7yr/$50M signed Aug 2022, through 2029-30"
          },
          {
            "player": "Josh Doan",
            "position": "RW",
            "aav": 6.95,
            "contractNote": "$6.95M AAV, seven seasons remaining per CapWages"
          }
        ],
        "fact": "2026-27 cap sheet: Norris $7.95M, Benson $7.5M, Thompson $7.14M, Doan $6.95M; Zucker's 2023-24 one-year deal is long expired",
        "source": "https://capwages.com/teams/buffalo_sabres"
      },
      {
        "field": "media.localTVDeal",
        "old": "MSG Network (MSG Sports & Entertainment); Sabres games broadcast regionally on MSG Network and MSG+",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source found)",
        "source": null
      }
    ],
    "analystNotes": "Forbes valued the Sabres at $1.1B in December 2024 on $169M of revenue, the profile of a small-market team with a 14-year playoff drought, and that drought is over: Buffalo won the Atlantic Division in April 2026 and took Montreal to a Game 7 overtime in the second round. Playoff gates and a KeyBank naming deal that now runs through 2035-36 give the revenue line its first real lift since Pegula bought the club for $189M in 2011. The number moves on whether 2026 becomes a run of contention rather than a one-year spike in a 1.2M-person metro.",
    "unverifiedAsOf": {}
  },
  "detroit-red-wings": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 2,
        "new": 0,
        "fact": "Detroit missed the playoffs in 2022 through 2026; eliminated April 11, 2026 for a tenth straight season, the longest active drought in the NHL",
        "source": "https://en.wikipedia.org/wiki/Detroit_Red_Wings"
      },
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports Detroit (Diamond Sports Group / Sinclair Broadcast Group); Red Wings regional rights held by Bally Sports through 2033 but Diamond's bankruptcy restructuring created uncertainty; team exploring direct-to-consumer streaming alternatives",
        "new": "Detroit SportsNet, a channel built with MLB Local Media (the Tigers' partner), carries Red Wings regional games from 2026-27 after FanDuel Sports Network Detroit went dark on April 30, 2026; in-market streaming through the MLB app",
        "fact": "Main Street Sports Group (FanDuel Sports Network) ceased operations April 30, 2026; Red Wings moved to Detroit SportsNet via an MLB Local Media partnership for 2026-27",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_NHL_season ; https://en.wikipedia.org/wiki/FanDuel_Sports_Network ; data/forbes-proxies.js (verified)"
      },
      {
        "field": "media.streamingNotes",
        "old": "Bally Sports+ streaming; ESPN+ for national games; Diamond Sports restructuring may accelerate shift to team-controlled streaming",
        "new": "Detroit SportsNet in-market streaming via the MLB app; ESPN+/Hulu and TNT/Max for US national games",
        "fact": "Local streaming now runs through the MLB app under the Detroit SportsNet arrangement",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_NHL_season"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Dylan Larkin",
            "position": "C",
            "aav": 8.7,
            "contractNote": "8yr/$69.6M signed March 2023, through 2030-31; team captain and franchise cornerstone"
          },
          {
            "player": "Lucas Raymond",
            "position": "RW",
            "aav": 8,
            "contractNote": "8yr/$64M extension (2023), through 2031-32; Swedish-born 2021 4th-overall pick"
          }
        ],
        "new": [
          {
            "player": "Dylan Larkin",
            "position": "C",
            "aav": 8.7,
            "contractNote": "8yr/$69.6M signed March 2023, through 2030-31"
          },
          {
            "player": "Moritz Seider",
            "position": "D",
            "aav": 8.55,
            "contractNote": "$8.55M AAV, five seasons left after 2026-27 per CapWages; modified NTC from 2028-29"
          },
          {
            "player": "Lucas Raymond",
            "position": "RW",
            "aav": 8.075,
            "contractNote": "$8.075M AAV, six seasons remaining per CapWages; 10-team no-trade list"
          }
        ],
        "fact": "CapWages 2026-27: Larkin $8.7M, Seider $8.55M, Raymond $8.075M (not $8.0M)",
        "source": "https://capwages.com/teams/detroit_red_wings"
      }
    ],
    "analystNotes": "Forbes had Detroit at $2.125B in December 2024 on $229M of revenue, a valuation built on the Original Six brand, Little Caesars Arena and the District Detroit real estate rather than results: the Red Wings have now missed the playoffs ten straight years, the longest active drought in the league, and the front office was handed to an interim GM in September 2026. Local media is settled for now, with FanDuel Sports Network Detroit dark since April 30, 2026 and games moved to Detroit SportsNet through the Tigers' MLB Local Media deal. The number moves on the first playoff series in a decade, because Larkin, Seider and Raymond are all locked through at least 2030-31 and the market has nothing left to price but wins.",
    "unverifiedAsOf": {}
  },
  "florida-panthers": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.championshipsLast10Years",
        "old": 1,
        "new": 2,
        "fact": "Panthers beat Edmonton in six games in the 2025 Stanley Cup Final for back-to-back titles (2024, 2025); Sam Bennett won the Conn Smythe",
        "source": "https://en.wikipedia.org/wiki/2025_Stanley_Cup_playoffs ; https://en.wikipedia.org/wiki/Florida_Panthers"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 5,
        "new": 4,
        "fact": "Playoffs in 2022, 2023, 2024 and 2025; missed the 2026 playoffs at 40-38-4 (7th in the Atlantic), the first defending champion to miss since 2014-15",
        "source": "https://en.wikipedia.org/wiki/Florida_Panthers ; https://en.wikipedia.org/wiki/2026_Stanley_Cup_playoffs"
      },
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports Florida (Diamond Sports Group / Sinclair); regional rights through ~2030; Diamond bankruptcy created uncertainty; Panthers also exploring streaming options in South Florida market",
        "new": "Scripps Sports over-the-air deal (WSFL-TV) in place since 2024-25, so the April 30, 2026 shutdown of FanDuel Sports Network did not touch the Panthers' local rights",
        "fact": "Panthers moved local broadcasts to Scripps Sports / WSFL-TV for 2024-25; FanDuel Sports Network ceased operations April 30, 2026",
        "source": "https://en.wikipedia.org/wiki/Florida_Panthers ; https://en.wikipedia.org/wiki/FanDuel_Sports_Network"
      },
      {
        "field": "media.streamingNotes",
        "old": "Bally Sports+ streaming; NHL.tv for out-of-market; ESPN+ for national games",
        "new": "Over-the-air Scripps model with team-arranged in-market streaming; ESPN+/Hulu and TNT/Max for national games",
        "fact": "Local rights are broadcast-first under Scripps since 2024-25",
        "source": "https://en.wikipedia.org/wiki/Florida_Panthers"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Matthew Tkachuk",
            "position": "LW",
            "aav": 9.5,
            "contractNote": "8yr/$76M signed 2022, through 2029-30; acquired from Calgary in blockbuster 2022 trade for Jonathan Huberdeau; led Panthers to back-to-back Finals"
          },
          {
            "player": "Brad Marchand",
            "position": "LW/C",
            "aav": 5.25,
            "contractNote": "6yr/$31.5M signed 2025; acquired from Boston at 2025 trade deadline; Bruins retained 50% of salary"
          }
        ],
        "new": [
          {
            "player": "Aleksander Barkov",
            "position": "C",
            "aav": 10,
            "contractNote": "$10M AAV captain; 8yr deal signed 2021 through 2029-30"
          },
          {
            "player": "Matthew Tkachuk",
            "position": "RW",
            "aav": 9.5,
            "contractNote": "8yr/$76M signed 2022, through 2029-30; 16-team no-trade list from Aug 2028"
          },
          {
            "player": "Sam Reinhart",
            "position": "RW",
            "aav": 8.625,
            "contractNote": "8yr/$69M signed 2024, through 2031-32"
          },
          {
            "player": "Brady Tkachuk",
            "position": "LW",
            "aav": 8.21,
            "contractNote": "$8.205714M AAV through 2027-28; acquired from Ottawa June 21, 2026 for a package of draft picks after requesting a trade"
          },
          {
            "player": "Sam Bennett",
            "position": "C",
            "aav": 8,
            "contractNote": "$8M AAV, eight-year deal signed June 2025; 2025 Conn Smythe winner; full NMC through June 30, 2030"
          },
          {
            "player": "Brad Marchand",
            "position": "LW",
            "aav": 5.25,
            "contractNote": "6yr/$31.5M signed 2025, through 2030-31"
          }
        ],
        "fact": "Brady Tkachuk joined Florida June 21, 2026; Bennett re-signed at $8M after the 2025 Cup; Bobrovsky left for Toronto as a free agent in 2026",
        "source": "https://capwages.com/teams/florida_panthers ; https://en.wikipedia.org/wiki/Ottawa_Senators ; https://en.wikipedia.org/wiki/Florida_Panthers"
      }
    ],
    "analystNotes": "Forbes valued the Panthers at $1.4B in December 2024 on $189M of revenue, before the second straight Stanley Cup in June 2025 and a decade of arena-lease stability through 2033; that number is now the floor for a franchise Viola bought for $250M in 2013. Local media never became a problem because Florida had already moved to Scripps over-the-air television in 2024-25 when FanDuel Sports Network shut down on April 30, 2026. The 2026 miss at 40-38-4 is the first crack, so the next Forbes print turns on whether the Barkov, Tkachuk brothers and Bennett core gets back to a Final rather than on the building.",
    "unverifiedAsOf": {
      "arena.namingRightsDeal": "May 2026"
    }
  },
  "montreal-canadiens": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.nationalShareNote",
        "old": "~$19M/team/year from US national deals (ESPN/TNT); Canadian national deal with Rogers Sportsnet C$5.2B through 2026 adds ~C$40-50M/year for Canadian franchises; Canadiens additionally benefit from TVA Sports (Quebecor) rights for French-language Quebec market — among the richest per-team broadcast markets in hockey",
        "new": "~$19M/team/year from US national deals (ESPN/TNT through 2027-28). Canadian national rights: new 12-year Rogers deal worth C$11B (announced April 2, 2025) runs 2026-27 through 2037-38, nearly double the C$5.2B 2013 deal; the seven Canadian clubs share the national pool on top of their own regional rights; Amazon Prime Video sublicenses Wednesday Night Hockey and CBC's Hockey Night in Canada partnership ended after 2025-26. Canadiens also hold the Quebec francophone market through RDS regionally and TVA Sports nationally.",
        "fact": "Rogers extended Canadian national NHL rights for 12 years (2026-27 to 2037-38) at C$11B, announced April 2, 2025; Prime Video keeps Wednesday nights and CBC dropped off after 2025-26",
        "source": "https://en.wikipedia.org/wiki/NHL_on_Sportsnet"
      },
      {
        "field": "media.localTVDeal",
        "old": "TVA Sports (French-language; Groupe TVA / Quebecor, major rights-holder for francophone Quebec); RDS (French, Bell Media subsidiary); Sportsnet (English); CJAD 800 AM (English radio)",
        "new": "RDS (Bell Media) holds French regional rights and TSN2 English regional rights under a 12-year deal from 2014-15; TVA Sports carries national French games as Rogers' sublicensee; CJAD 800 English radio",
        "fact": "Wikipedia lists Bell Media (TSN2) for regional English and RDS for French under a 12-year deal that began 2014-15",
        "source": "https://en.wikipedia.org/wiki/Montreal_Canadiens ; https://en.wikipedia.org/wiki/NHL_on_Sportsnet"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Cole Caufield — 8yr/$62.8M ($7.85M AAV), signed June 2023, through 2030-31",
        "new": "Nick Suzuki (captain) $7.875M AAV through 2029-30 and Cole Caufield $7.85M AAV through 2030-31; Noah Dobson, acquired June 27, 2025 and signed 8yr/$76M ($9.5M AAV), is the top cap hit",
        "fact": "Dobson was acquired from the Islanders on June 27, 2025 for Emil Heineman and two 2025 first-round picks and signed an eight-year, $76M deal the same day",
        "source": "https://en.wikipedia.org/wiki/Noah_Dobson ; https://capwages.com/teams/montreal_canadiens"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Cole Caufield",
            "position": "RW",
            "aav": 7.85,
            "contractNote": "8yr/$62.8M signed June 2023, through 2030-31; elite goal-scorer; American-born franchise centerpiece of the rebuild"
          },
          {
            "player": "Nick Suzuki",
            "position": "C",
            "aav": 7.875,
            "contractNote": "8yr/$63M (2022 extension), through 2029-30; team captain; key piece of the rebuild"
          }
        ],
        "new": [
          {
            "player": "Noah Dobson",
            "position": "D",
            "aav": 9.5,
            "contractNote": "8yr/$76M signed June 27, 2025 on acquisition from the Islanders; through 2032-33"
          },
          {
            "player": "Lane Hutson",
            "position": "D",
            "aav": 8.85,
            "contractNote": "$8.85M AAV eight-year extension (2025), begins 2026-27; 2025 Calder Trophy winner"
          },
          {
            "player": "Nick Suzuki",
            "position": "C",
            "aav": 7.875,
            "contractNote": "8yr/$63M (2022), through 2029-30; captain"
          },
          {
            "player": "Cole Caufield",
            "position": "RW",
            "aav": 7.85,
            "contractNote": "8yr/$62.8M signed June 2023, through 2030-31"
          },
          {
            "player": "Juraj Slafkovsky",
            "position": "LW",
            "aav": 7.6,
            "contractNote": "8yr/$60.8M (2024), through 2032-33"
          }
        ],
        "fact": "CapWages 2026-27: Dobson $9.5M, Hutson $8.85M, Suzuki $7.875M, Caufield $7.85M, Slafkovsky $7.6M",
        "source": "https://capwages.com/teams/montreal_canadiens ; https://en.wikipedia.org/wiki/Noah_Dobson"
      }
    ],
    "analystNotes": "Forbes put the Canadiens at $3.0B in December 2024 on $321M of revenue and $142M of operating income, the highest margin in the league, because the Molsons own Bell Centre outright and sit on the richest bilingual media market in hockey. The rebuild arrived ahead of schedule: Montreal beat Tampa Bay and Buffalo in seven games each and reached the 2026 conference final, with Dobson ($9.5M), Hutson ($8.85M), Suzuki and Caufield all signed through at least 2029-30. The next leg up is the new C$11B Rogers national deal that starts in 2026-27 and a first Cup since 1993, either of which pushes this franchise toward Toronto's tier.",
    "unverifiedAsOf": {}
  },
  "ottawa-senators": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 1,
        "new": 2,
        "fact": "Playoffs in 2025 (lost to Toronto in six, first postseason since 2017) and 2026 (swept by Carolina in the first round)",
        "source": "https://en.wikipedia.org/wiki/Ottawa_Senators ; https://en.wikipedia.org/wiki/2026_Stanley_Cup_playoffs"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Brady Tkachuk — 7yr/$57.5M ($8.22M AAV), signed Oct 2021, through 2027-28",
        "new": "Tim Stützle, 8yr/$66.8M ($8.35M AAV) through 2030-31; captaincy vacant after Brady Tkachuk requested and received a trade to Florida on June 21, 2026 for a package of draft picks",
        "fact": "Brady Tkachuk traded to Florida June 21, 2026 after requesting a trade; one pick was flipped to San Jose for William Eklund, Kasper Halttunen and Brandon Svoboda",
        "source": "https://en.wikipedia.org/wiki/Ottawa_Senators"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Brady Tkachuk",
            "position": "LW",
            "aav": 8.22,
            "contractNote": "7yr/$57.5M signed Oct 2021, through 2027-28; team captain; son of NHL veteran Keith Tkachuk, brother of Matthew Tkachuk (Panthers)"
          },
          {
            "player": "Tim Stützle",
            "position": "C/LW",
            "aav": 7.625,
            "contractNote": "8yr/$61M extension (2022), through 2030; German-born 2020 3rd-overall pick; developing as co-star alongside Tkachuk"
          }
        ],
        "new": [
          {
            "player": "Tim Stützle",
            "position": "C",
            "aav": 8.35,
            "contractNote": "8yr/$66.8M (2022), through 2030-31; 10-team no-trade list from 2027-28"
          },
          {
            "player": "Linus Ullmark",
            "position": "G",
            "aav": 8.25,
            "contractNote": "$8.25M AAV with full no-move clause (4yr extension signed 2024)"
          },
          {
            "player": "Jake Sanderson",
            "position": "D",
            "aav": 8.05,
            "contractNote": "8yr/$64.4M (2023), through 2031-32"
          },
          {
            "player": "Thomas Chabot",
            "position": "D",
            "aav": 8,
            "contractNote": "8yr/$64M (2019), through 2027-28"
          },
          {
            "player": "Dylan Cozens",
            "position": "C",
            "aav": 7.1,
            "contractNote": "$7.1M AAV through 2029-30; acquired from Buffalo March 2025"
          }
        ],
        "fact": "Stützle's cap hit is $8.35M (not $7.625M); Tkachuk is off the books after the June 2026 trade",
        "source": "https://capwages.com/teams/ottawa_senators ; https://en.wikipedia.org/wiki/Ottawa_Senators"
      },
      {
        "field": "arena.newArenaPlans",
        "old": "The Senators have long sought a new downtown Ottawa arena at LeBreton Flats; discussions with National Capital Commission ongoing; no firm timeline or public funding commitment as of 2025",
        "new": "LeBreton Flats downtown arena: NCC selected the Senators' proposal June 23, 2022, expanded the site from 6 to 10 acres in September 2024, and the land purchase agreement was finalized in August 2025; the club has said construction is still several years away and no budget, financing plan or opening date has been published",
        "fact": "Land sale agreement with the National Capital Commission finalized August 2025; site now 10 acres",
        "source": "https://en.wikipedia.org/wiki/Ottawa_Senators"
      },
      {
        "field": "media.localTVDeal",
        "old": "Sportsnet (Rogers; English); TSN (English); TVA Sports (French-language Quebec market); CFRA 580 AM (radio)",
        "new": "TSN5 (Bell Media) carries English regional games; TVA Sports French; national Canadian windows on Sportsnet and Prime Video under the Rogers deal; CFRA 580 radio",
        "fact": "Wikipedia infobox lists TSN5 as the English regional broadcaster",
        "source": "https://en.wikipedia.org/wiki/Ottawa_Senators"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$19M/team/year from US national deals (ESPN/TNT); Canadian national deal with Rogers Sportsnet + TSN adds ~C$40-50M/year for Canadian franchises",
        "new": "~$19M/team/year from US national deals (ESPN/TNT through 2027-28). Canadian national rights: new 12-year Rogers deal worth C$11B (announced April 2, 2025) runs 2026-27 through 2037-38, nearly double the C$5.2B 2013 deal; the seven Canadian clubs share the national pool on top of their own regional rights; Amazon Prime Video sublicenses Wednesday Night Hockey and CBC's Hockey Night in Canada partnership ended after 2025-26.",
        "fact": "Rogers extended Canadian national NHL rights for 12 years (2026-27 to 2037-38) at C$11B, announced April 2, 2025; Prime Video keeps Wednesday nights and CBC dropped off after 2025-26",
        "source": "https://en.wikipedia.org/wiki/NHL_on_Sportsnet"
      }
    ],
    "analystNotes": "Forbes valued Ottawa at $1.15B in December 2024 on $154M of revenue, barely above the $950M Andlauer paid in 2023, and the two things that drive a Canadian small-market number both improved: the C$11B Rogers national deal starts in 2026-27 and the LeBreton Flats land deal with the NCC closed in August 2025, moving a downtown arena from talk to a signed site. On the ice the Senators made the playoffs in 2025 and 2026 for the first time since 2017, then traded captain Brady Tkachuk to Florida on June 21, 2026 at his request, leaving Stützle ($8.35M through 2030-31) as the franchise anchor. A funded LeBreton arena with a construction date is the single event that reprices this club.",
    "unverifiedAsOf": {}
  },
  "tampa-bay-lightning": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "arena.name",
        "old": "Amalie Arena",
        "new": "Benchmark International Arena",
        "fact": "Amalie Arena was renamed Benchmark International Arena on August 13, 2025",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_NHL_season ; https://en.wikipedia.org/wiki/Tampa_Bay_Lightning"
      },
      {
        "field": "arena.namingRightsDeal",
        "old": {
          "sponsor": "Amalie Oil Company",
          "annualValue_M": null,
          "totalValue_M": null,
          "expiryYear": null,
          "notes": "Renamed from St. Pete Times Forum to Tampa Bay Times Forum, then Amalie Arena in 2014; multi-year naming rights deal with Tampa-based motor oil company; exact annual value undisclosed; estimated ~$3-4M/yr"
        },
        "new": {
          "sponsor": "Benchmark International",
          "annualValue_M": null,
          "totalValue_M": null,
          "expiryYear": null,
          "notes": "Renamed Benchmark International Arena August 13, 2025 (Tampa-based M&A advisory firm); terms undisclosed; prior names: Ice Palace (1996), St. Pete Times Forum, Tampa Bay Times Forum, Amalie Arena (2014-2025)"
        },
        "fact": "New naming partner Benchmark International from August 13, 2025; terms not disclosed",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_NHL_season"
      },
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports Sun (Diamond Sports Group / Sinclair; regional rights for Florida market); Diamond bankruptcy has created uncertainty similar to other Bally Sports RSN markets",
        "new": "Scripps Sports over-the-air (WXPX-TV) carries Lightning regional games after FanDuel Sports Network Sun went dark with the April 30, 2026 shutdown of Main Street Sports Group",
        "fact": "Wikipedia infobox lists Scripps Sports (WXPX-TV); FanDuel Sports Network ceased operations April 30, 2026",
        "source": "https://en.wikipedia.org/wiki/Tampa_Bay_Lightning ; https://en.wikipedia.org/wiki/FanDuel_Sports_Network"
      },
      {
        "field": "media.streamingNotes",
        "old": "Bally Sports+ streaming; ESPN+ for national games; NHL.tv for out-of-market",
        "new": "Over-the-air Scripps model with in-market streaming arranged by the team; ESPN+/Hulu and TNT/Max for national games",
        "fact": "Local rights moved from the RSN to Scripps broadcast television",
        "source": "https://en.wikipedia.org/wiki/Tampa_Bay_Lightning"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Nikita Kucherov — 8yr/$76M ($9.5M AAV), through 2027-28; 2024 Hart Trophy winner",
        "new": "Nikita Kucherov, 8yr/$76M ($9.5M AAV), final season 2026-27 (UFA July 2027); Hart Trophy winner in 2024 and again in 2026",
        "fact": "CapWages shows one season left on Kucherov's deal; the 2025-26 Hart Trophy went to Kucherov",
        "source": "https://capwages.com/teams/tampa_bay_lightning ; https://en.wikipedia.org/wiki/2025%E2%80%9326_NHL_season"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Nikita Kucherov",
            "position": "RW",
            "aav": 9.5,
            "contractNote": "8yr/$76M, through 2027-28; 2024 NHL MVP (Hart Trophy); highest-scoring player in Lightning history; becoming UFA 2027 is a franchise-defining decision point"
          },
          {
            "player": "Brayden Point",
            "position": "C",
            "aav": 9.5,
            "contractNote": "8yr/$76M extension signed 2022, through 2029-30; elite two-way center; 3x 40-goal scorer"
          }
        ],
        "new": [
          {
            "player": "Nikita Kucherov",
            "position": "RW",
            "aav": 9.5,
            "contractNote": "8yr/$76M, expires after 2026-27; Hart Trophy 2024 and 2026; extension or UFA decision due summer 2027"
          },
          {
            "player": "Brayden Point",
            "position": "C",
            "aav": 9.5,
            "contractNote": "8yr/$76M (2022), through 2029-30; full NMC"
          },
          {
            "player": "Andrei Vasilevskiy",
            "position": "G",
            "aav": 9.5,
            "contractNote": "8yr/$76M (2019), through 2027-28; 2026 Vezina Trophy"
          },
          {
            "player": "Jake Guentzel",
            "position": "LW",
            "aav": 9,
            "contractNote": "7yr/$63M signed July 2024, through 2030-31"
          }
        ],
        "fact": "Four $9M+ contracts; Vasilevskiy won the 2025-26 Vezina",
        "source": "https://capwages.com/teams/tampa_bay_lightning ; https://en.wikipedia.org/wiki/2025%E2%80%9326_NHL_season"
      }
    ],
    "analystNotes": "Forbes valued the Lightning at $1.8B in December 2024, exactly the mark of the October 2024 Blue Owl-led majority purchase, on $220M of revenue and $44M of operating income. The building got a new name in August 2025 (Benchmark International Arena) and the RSN problem resolved itself when FanDuel Sports Network Sun died on April 30, 2026 and games moved to Scripps over-the-air television, while Kucherov added a second Hart Trophy in 2026. The number now hinges on July 2027: Kucherov's $9.5M deal expires after 2026-27 and re-signing the league MVP under a $104M cap alongside Point, Vasilevskiy and Guentzel at $9M-plus each is the decision that sets the next decade.",
    "unverifiedAsOf": {}
  },
  "toronto-maple-leafs": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.primaryOwner",
        "old": "Rogers Communications (75% of MLSE, controlling); Larry Tanenbaum / Kilmer Sports (25%)",
        "new": "Rogers Communications (75% of MLSE, with an agreement announced July 6, 2026 to buy Kilmer Sports' remaining 25% and take MLSE to 100%)",
        "fact": "Rogers agreed July 6, 2026 to acquire Kilmer Sports Inc.'s 25% of MLSE at an implied MLSE mark of about US$12.2B (status: agreed)",
        "source": "data/transactions.js (verified)"
      },
      {
        "field": "ownership.ownershipGroup",
        "old": [
          {
            "name": "Rogers Communications",
            "role": "majority owner (75% of MLSE)",
            "pct": 75
          },
          {
            "name": "Larry Tanenbaum / Kilmer Sports",
            "role": "minority owner (25% of MLSE)",
            "pct": 25
          }
        ],
        "new": [
          {
            "name": "Rogers Communications",
            "role": "controlling owner (75% of MLSE; agreed July 2026 to acquire the final 25%)",
            "pct": 75
          },
          {
            "name": "Larry Tanenbaum / Kilmer Sports (with OMERS)",
            "role": "minority owner (25% of MLSE), sale to Rogers agreed July 6, 2026",
            "pct": 25
          }
        ],
        "fact": "Kilmer/OMERS 25% stake sale to Rogers agreed July 6, 2026",
        "source": "data/transactions.js (verified)"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 5,
        "new": 4,
        "fact": "Playoffs in 2022, 2023, 2024 and 2025 (lost to Florida in seven in the second round); Toronto was not among the 16 qualifiers in 2026",
        "source": "https://en.wikipedia.org/wiki/2025_Stanley_Cup_playoffs ; https://en.wikipedia.org/wiki/2026_Stanley_Cup_playoffs"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Auston Matthews",
            "position": "C",
            "aav": 13.25,
            "contractNote": "4yr/$53M signed Sept 2023, through 2027-28; NHL's highest-paid player; 2x 60-goal scorer; 2022 Hart Trophy winner; Arizona-born franchise icon"
          },
          {
            "player": "William Nylander",
            "position": "RW",
            "aav": 11.5,
            "contractNote": "8yr/$92M extension signed Jan 2024, through 2031-32; Swedish-born; elite offensive winger; full no-trade clause"
          }
        ],
        "new": [
          {
            "player": "Auston Matthews",
            "position": "C",
            "aav": 13.25,
            "contractNote": "4yr/$53M signed Sept 2023, through 2027-28; captain; NMC"
          },
          {
            "player": "William Nylander",
            "position": "RW",
            "aav": 11.5,
            "contractNote": "8yr/$92M signed Jan 2024, through 2031-32; NMC"
          },
          {
            "player": "Matthew Knies",
            "position": "LW",
            "aav": 7.75,
            "contractNote": "6yr/$46.5M signed 2025, through 2030-31"
          },
          {
            "player": "Sergei Bobrovsky",
            "position": "G",
            "aav": 7,
            "contractNote": "$7M AAV, three seasons, signed as a free agent from Florida in 2026 (age 38); NMC"
          }
        ],
        "fact": "Mitch Marner left via sign-and-trade to Vegas June 30, 2025 (8yr/$96M, for Nicolas Roy); Knies and Bobrovsky are now top-four cap hits",
        "source": "https://capwages.com/teams/toronto_maple_leafs ; https://en.wikipedia.org/wiki/Mitch_Marner ; https://en.wikipedia.org/wiki/Florida_Panthers"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$19M/team/year from US national deals (ESPN/TNT); Canadian national deal with Rogers Sportsnet adds ~C$40-50M/year for Canadian franchises; Rogers owns both MLSE (75%) AND Sportsnet — a unique vertical integration where the broadcaster and the content owner are the same entity, creating complex but potentially valuable intra-company arrangements",
        "new": "~$19M/team/year from US national deals (ESPN/TNT through 2027-28). Canadian national rights: new 12-year Rogers deal worth C$11B (announced April 2, 2025) runs 2026-27 through 2037-38, nearly double the C$5.2B 2013 deal; the seven Canadian clubs share the national pool on top of their own regional rights; Amazon Prime Video sublicenses Wednesday Night Hockey and CBC's Hockey Night in Canada partnership ended after 2025-26. Rogers now owns both MLSE and the national rights holder, so the Leafs' television value is captured at the Rogers portfolio level.",
        "fact": "Rogers extended Canadian national NHL rights for 12 years (2026-27 to 2037-38) at C$11B, announced April 2, 2025; Prime Video keeps Wednesday nights and CBC dropped off after 2025-26",
        "source": "https://en.wikipedia.org/wiki/NHL_on_Sportsnet"
      }
    ],
    "analystNotes": "Forbes valued the Maple Leafs at $3.8B in December 2024, first in the NHL, on $308M of revenue and $125M of operating income, and the ownership story has since closed the loop: Rogers agreed in July 2026 to buy Kilmer Sports' final 25% of MLSE at an implied MLSE mark near US$12.2B, giving the broadcaster that just signed the C$11B national deal 100% of the team, the arena and the Raptors. The hockey side reset: Marner was sign-and-traded to Vegas for $12M a year in June 2025, Toronto missed the 2026 playoffs after a second-round exit in 2025, and Matthews' $13.25M deal now has two seasons left. A first Cup since 1967, or Matthews' 2028 decision, is the only thing that moves a number this insulated.",
    "unverifiedAsOf": {
      "arena.newArenaPlans": "May 2026"
    }
  },
  "carolina-hurricanes": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.championshipsLast10Years",
        "old": 0,
        "new": 1,
        "fact": "Hurricanes beat the Vegas Golden Knights 4-2 in the 2026 Stanley Cup Final (June 3-14, 2026), their second title and first since 2006; captain Jordan Staal won the Conn Smythe",
        "source": "https://en.wikipedia.org/wiki/2026_Stanley_Cup_playoffs ; https://en.wikipedia.org/wiki/2025%E2%80%9326_NHL_season ; https://en.wikipedia.org/wiki/Carolina_Hurricanes"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 4,
        "new": 5,
        "fact": "Playoffs every year 2022-2026; 2025 conference final loss to Florida, 2026 Stanley Cup",
        "source": "https://en.wikipedia.org/wiki/2025_Stanley_Cup_playoffs ; https://en.wikipedia.org/wiki/2026_Stanley_Cup_playoffs"
      },
      {
        "field": "media.localTVDeal",
        "old": "Carolina Hurricanes TV (team-owned regional broadcast); after Bally Sports/Diamond Sports bankruptcy, Hurricanes launched their own direct-to-consumer broadcast operation — a leading example of team-owned media in NHL",
        "new": "Hurricanes Hockey Network, a team-owned regional network run by Hurricanes Holdings from 2026-27 using the NHL production hub, with Amazon Prime Video in-market streaming, after FanDuel Sports Network South went dark April 30, 2026",
        "fact": "FanDuel Sports Network shut down April 30, 2026; Carolina moved to a team-owned network produced through the NHL hub with Prime Video streaming",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_NHL_season ; https://en.wikipedia.org/wiki/FanDuel_Sports_Network ; data/forbes-proxies.js (verified) ; https://en.wikipedia.org/wiki/Carolina_Hurricanes"
      },
      {
        "field": "media.streamingNotes",
        "old": "HockeyTV / team-owned streaming direct to fans; NHL.TV League Pass; national games on ESPN+/Hulu and TNT/Max",
        "new": "Amazon Prime Video carries in-market streaming for the team-owned network from 2026-27; ESPN+/Hulu and TNT/Max national",
        "fact": "Prime Video is the in-market streaming home for the NHL-hub direct-to-distributor teams in 2026-27",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_NHL_season"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Sebastian Aho",
            "position": "C",
            "aav": 9.75,
            "contractNote": "8yr/$78M extension signed 2023, through 2030-31; captain and franchise cornerstone since 2016"
          },
          {
            "player": "Andrei Svechnikov",
            "position": "RW",
            "aav": 7.75,
            "contractNote": "8yr/$62M signed 2021, through 2028-29"
          },
          {
            "player": "Jaccob Slavin",
            "position": "D",
            "aav": 5.3,
            "contractNote": "7yr/$37.1M, through 2026-27; elite defensive defenseman"
          }
        ],
        "new": [
          {
            "player": "Sebastian Aho",
            "position": "C",
            "aav": 9.75,
            "contractNote": "8yr/$78M (2023), through 2031-32; full NMC"
          },
          {
            "player": "Nikolaj Ehlers",
            "position": "LW",
            "aav": 8.5,
            "contractNote": "6yr/$51M signed July 2025 as a free agent; NMC through 2026-27"
          },
          {
            "player": "Andrei Svechnikov",
            "position": "RW",
            "aav": 7.75,
            "contractNote": "8yr/$62M (2021), through 2028-29"
          },
          {
            "player": "K'Andre Miller",
            "position": "D",
            "aav": 7.5,
            "contractNote": "8yr/$60M signed on acquisition from the Rangers, July 2025"
          },
          {
            "player": "Seth Jarvis",
            "position": "RW",
            "aav": 7.42,
            "contractNote": "8yr/$63.2M (2024), through 2031-32; deferred-salary structure"
          },
          {
            "player": "Jaccob Slavin",
            "position": "D",
            "aav": 6.396,
            "contractNote": "8yr/$51.2M extension (2025) begins 2026-27, through 2033-34"
          }
        ],
        "fact": "CapWages 2026-27: Aho $9.75M, Ehlers $8.5M, Svechnikov $7.75M, Miller $7.5M, Jarvis $7.42M, Slavin $6.396M; team cap hit $95.5M against a $104M cap",
        "source": "https://capwages.com/teams/carolina_hurricanes ; https://en.wikipedia.org/wiki/Carolina_Hurricanes"
      }
    ],
    "analystNotes": "Forbes had Carolina at $1.25B in December 2024, and the market has already moved past it: Dundon sold 12.5% in March 2026 at a $2.66B implied mark, then the Hurricanes won the 2026 Stanley Cup over Vegas in six games with Jordan Staal taking the Conn Smythe. Revenue of $183M in that Forbes print undercounts a team that now owns its own regional network (Hurricanes Hockey Network with Prime Video streaming from 2026-27), plays to a sellout streak and has Aho, Ehlers, Svechnikov, Miller, Jarvis and Slavin locked through at least 2028-29. The next print catches up to the sale price; what pushes it past $2.66B is turning the 80 acres around Lenovo Center into a district.",
    "unverifiedAsOf": {}
  },
  "columbus-blue-jackets": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports Ohio (Diamond Sports / Sinclair successor arrangement); Columbus among teams affected by Diamond Sports Group bankruptcy 2023; media rights situation in flux",
        "new": "Direct-to-distributor model from 2026-27: regional telecasts produced by NHL Productions through the league hub and sold to distributors by the team, with Amazon Prime Video in-market streaming, after FanDuel Sports Network Ohio went dark April 30, 2026",
        "fact": "FanDuel Sports Network closed April 30, 2026; Columbus joined the NHL production-hub, direct-to-distributor group with Prime Video streaming for 2026-27",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_NHL_season ; https://en.wikipedia.org/wiki/FanDuel_Sports_Network ; data/forbes-proxies.js (verified)"
      },
      {
        "field": "media.streamingNotes",
        "old": "NHL.TV League Pass; national ESPN+/Hulu and TNT/Max; local streaming via Bally Sports app or successor service",
        "new": "Amazon Prime Video in-market streaming from 2026-27; ESPN+/Hulu and TNT/Max national",
        "fact": "Prime Video carries in-market games for the hub-produced teams",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_NHL_season"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Zach Werenski",
            "position": "D",
            "aav": 9,
            "contractNote": "7yr/$63M extension signed 2023, through 2029-30; franchise cornerstone defenseman"
          },
          {
            "player": "Kirill Marchenko",
            "position": "RW",
            "aav": 6.5,
            "contractNote": "3yr/$19.5M bridge deal; emerging franchise scorer"
          }
        ],
        "new": [
          {
            "player": "Zach Werenski",
            "position": "D",
            "aav": 9.583,
            "contractNote": "6yr/$57.5M (2022), through 2027-28; 2026 Norris Trophy winner; NMC with 10-team list"
          },
          {
            "player": "Ivan Provorov",
            "position": "D",
            "aav": 8.5,
            "contractNote": "7yr/$59.5M signed July 2025, through 2031-32"
          },
          {
            "player": "Sean Monahan",
            "position": "C",
            "aav": 5.5,
            "contractNote": "5yr/$27.5M (2024), through 2028-29; full NMC"
          },
          {
            "player": "Kirill Marchenko",
            "position": "RW",
            "aav": 3.85,
            "contractNote": "3yr/$11.55M (2024), final year 2026-27, RFA after"
          }
        ],
        "fact": "Werenski's cap hit is $9,583,333 through 2027-28 and he won the 2025-26 Norris; Marchenko's bridge deal is $3.85M, not $6.5M",
        "source": "https://capwages.com/teams/columbus_blue_jackets ; https://en.wikipedia.org/wiki/2025%E2%80%9326_NHL_season"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Zach Werenski — franchise D-man; Kirill Marchenko emerging as offensive cornerstone",
        "new": "Zach Werenski, 2026 Norris Trophy winner, $9.58M AAV through 2027-28; Adam Fantilli and Kirill Marchenko lead the forward group",
        "fact": "Werenski won the 2025-26 Norris Trophy",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_NHL_season"
      }
    ],
    "analystNotes": "Forbes valued Columbus at $1.0B in December 2024, last in the league, on $150M of revenue and essentially zero operating income, and nothing structural has changed: John McConnell still owns the club, Nationwide Arena is still publicly owned, and the team missed the playoffs again in 2025 (89 points) and 2026 (92 points). The one revenue variable did resolve: FanDuel Sports Network Ohio died on April 30, 2026 and the Blue Jackets now sell hub-produced telecasts direct to distributors with Prime Video streaming, which keeps local media alive at lower guaranteed dollars. Werenski's 2026 Norris Trophy and a 92-point team say the floor is close to lifting; a first playoff series since 2020 is what moves the number.",
    "unverifiedAsOf": {}
  },
  "new-jersey-devils": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Jack Hughes — 8yr/$9.75M AAV extension signed 2023, through 2030-31; Nico Hischier captain",
        "new": "Jack Hughes, 8yr/$64M ($8.0M AAV) signed Nov 2021, through 2029-30; Nico Hischier captain at $7.25M; Luke Hughes $9M AAV is the top cap hit",
        "fact": "CapWages 2026-27: Jack Hughes $8.0M (four seasons left), Luke Hughes $9.0M, Hamilton $9.0M, Meier $8.8M, Bratt $7.875M, Hischier $7.25M",
        "source": "https://capwages.com/teams/new_jersey_devils"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Jack Hughes",
            "position": "C",
            "aav": 9.75,
            "contractNote": "8yr/$78M extension signed 2023, through 2030-31; No. 1 overall pick 2019"
          },
          {
            "player": "Nico Hischier",
            "position": "C",
            "aav": 8.25,
            "contractNote": "7yr/$57.75M signed 2022, through 2026-27; captain; extension discussions pending"
          },
          {
            "player": "Jesper Bratt",
            "position": "LW",
            "aav": 8.25,
            "contractNote": "8yr/$66M signed 2022, through 2029-30; elite scorer"
          }
        ],
        "new": [
          {
            "player": "Luke Hughes",
            "position": "D",
            "aav": 9,
            "contractNote": "7yr/$63M signed Oct 2025, through 2031-32"
          },
          {
            "player": "Dougie Hamilton",
            "position": "D",
            "aav": 9,
            "contractNote": "7yr/$63M (2021), through 2027-28"
          },
          {
            "player": "Timo Meier",
            "position": "LW",
            "aav": 8.8,
            "contractNote": "8yr/$70.4M (2023), through 2030-31"
          },
          {
            "player": "Jack Hughes",
            "position": "C",
            "aav": 8,
            "contractNote": "8yr/$64M (2021), through 2029-30"
          },
          {
            "player": "Jesper Bratt",
            "position": "RW",
            "aav": 7.875,
            "contractNote": "8yr/$63M (2023), through 2030-31"
          },
          {
            "player": "Nico Hischier",
            "position": "C",
            "aav": 7.25,
            "contractNote": "$7.25M AAV; captain; CapWages shows six seasons remaining, implying a new extension at the same cap hit (not second-sourced)"
          }
        ],
        "fact": "Prior AAVs for Jack Hughes ($9.75M), Hischier ($8.25M) and Bratt ($8.25M) were wrong; corrected to $8.0M, $7.25M and $7.875M",
        "source": "https://capwages.com/teams/new_jersey_devils"
      }
    ],
    "analystNotes": "Forbes valued the Devils at $2.1B in December 2024 on $265M of revenue and $67M of operating income, a number that rests on HBSE owning Prudential Center outright and the Jack Hughes ($8.0M through 2029-30) and Hischier core rather than on results: New Jersey lost in the first round in 2025 and missed the 2026 playoffs at 87 points. The cap sheet is heavy and long, with Luke Hughes, Hamilton and Meier all at $8.8M-plus, so the roster is built for a window that has not opened. The number moves when this group wins a round, and it moves the other way if a fifth-place Metropolitan finish becomes the norm in a market the Rangers still own.",
    "unverifiedAsOf": {}
  },
  "new-york-islanders": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Matt Barzal — 5yr/$7.75M AAV through 2026-27; franchise face",
        "new": "Mathew Barzal, 8yr/$73.2M ($9.15M AAV) through 2030-31; Bo Horvat captain ($8.5M through 2030-31); 2025 No. 1 pick Matthew Schaefer won the 2026 Calder Trophy",
        "fact": "Barzal's cap hit is $9.15M through 2030-31; Horvat is captain; Schaefer won the 2025-26 Calder",
        "source": "https://capwages.com/teams/new_york_islanders ; https://en.wikipedia.org/wiki/New_York_Islanders ; https://en.wikipedia.org/wiki/2025%E2%80%9326_NHL_season"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Matt Barzal",
            "position": "C",
            "aav": 7.75,
            "contractNote": "5yr/$38.75M signed 2022, through 2026-27; franchise cornerstone; extension discussions upcoming"
          },
          {
            "player": "Noah Dobson",
            "position": "D",
            "aav": 8.5,
            "contractNote": "7yr/$59.5M signed 2023, through 2029-30; elite offensive defenseman"
          }
        ],
        "new": [
          {
            "player": "Mathew Barzal",
            "position": "C/RW",
            "aav": 9.15,
            "contractNote": "8yr/$73.2M (2022 extension), through 2030-31; 22-team no-trade list"
          },
          {
            "player": "Bo Horvat",
            "position": "C",
            "aav": 8.5,
            "contractNote": "8yr/$68M (2023), through 2030-31; captain"
          },
          {
            "player": "Ilya Sorokin",
            "position": "G",
            "aav": 8.25,
            "contractNote": "8yr/$66M (2023), through 2031-32; NMC through 2027-28"
          },
          {
            "player": "Matthew Schaefer",
            "position": "D",
            "aav": 0.986,
            "contractNote": "ELC ($986,250 cap hit, up to $3.5M bonuses); 2025 first overall pick; 2026 Calder Trophy"
          }
        ],
        "fact": "Noah Dobson was traded to Montreal June 27, 2025 for Emil Heineman and two 2025 first-round picks; Barzal's 2022 extension is $9.15M, not $7.75M",
        "source": "https://capwages.com/teams/new_york_islanders ; https://en.wikipedia.org/wiki/Noah_Dobson"
      }
    ],
    "analystNotes": "Forbes valued the Islanders at $1.9B in December 2024 on $200M of revenue, a number that is almost entirely UBS Arena: the $1.1B privately financed building, its $175M UBS naming deal through 2041, and the New York market. The hockey product has been flat, with no playoffs in 2025 or 2026 and Noah Dobson traded to Montreal in June 2025, but the 2025 first overall pick Matthew Schaefer won the 2026 Calder and Barzal ($9.15M), Horvat and Sorokin are signed through 2030-31 or later. Schaefer turning into a franchise defenseman is the only lever that moves this valuation ahead of the building.",
    "unverifiedAsOf": {}
  },
  "new-york-rangers": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 4,
        "new": 3,
        "fact": "Playoffs in 2022, 2023 and 2024; missed in 2025 and 2026",
        "source": "https://en.wikipedia.org/wiki/New_York_Rangers ; https://en.wikipedia.org/wiki/2026_Stanley_Cup_playoffs"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Adam Fox — 7yr/$9.5M AAV signed 2021, through 2027-28; Norris Trophy winner 2021",
        "new": "Igor Shesterkin, 8yr/$92M ($11.57M AAV) signed Dec 2024, through 2033-34; J.T. Miller captain ($8M through 2029-30); Adam Fox $9.5M through 2027-28",
        "fact": "Shesterkin's cap hit is $11,567,857 with an NMC; Miller (acquired from Vancouver Jan 2025) is captain",
        "source": "https://capwages.com/teams/new_york_rangers ; https://en.wikipedia.org/wiki/New_York_Rangers"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Adam Fox",
            "position": "D",
            "aav": 9.5,
            "contractNote": "7yr/$66.5M signed 2021, through 2027-28; Norris Trophy 2021; best defenseman in franchise history since Brian Leetch"
          },
          {
            "player": "Igor Shesterkin",
            "position": "G",
            "aav": 11.5,
            "contractNote": "4yr/$46M signed 2022, through 2025-26; Hart Trophy finalist; elite franchise goaltender; extension pending"
          },
          {
            "player": "Chris Kreider",
            "position": "LW",
            "aav": 6.5,
            "contractNote": "7yr/$45.5M signed 2021, through 2026-27; team leader"
          }
        ],
        "new": [
          {
            "player": "Igor Shesterkin",
            "position": "G",
            "aav": 11.568,
            "contractNote": "8yr/$92M signed Dec 2024, 2025-26 through 2032-33; NMC; richest goalie contract in NHL history"
          },
          {
            "player": "Pavel Dorofeyev",
            "position": "RW",
            "aav": 11,
            "contractNote": "$11M AAV; acquired in the 2026 offseason (terms and mechanism not second-sourced)"
          },
          {
            "player": "Adam Fox",
            "position": "D",
            "aav": 9.5,
            "contractNote": "7yr/$66.5M (2021), through 2027-28; NMC to May 2027"
          },
          {
            "player": "Mika Zibanejad",
            "position": "C",
            "aav": 8.5,
            "contractNote": "8yr/$68M (2021), through 2029-30; NMC"
          },
          {
            "player": "J.T. Miller",
            "position": "C",
            "aav": 8,
            "contractNote": "7yr/$56M (2022), through 2029-30; captain; acquired from Vancouver January 2025"
          }
        ],
        "fact": "Kreider is no longer on the roster; Panarin was traded to the Kings at the 2026 deadline for Liam Greentree and two picks; Dorofeyev added in the 2026 offseason",
        "source": "https://capwages.com/teams/new_york_rangers ; https://en.wikipedia.org/wiki/New_York_Rangers"
      }
    ],
    "analystNotes": "Forbes valued the Rangers at $3.5B in December 2024, second in the NHL, on $315M of revenue and $104M of operating income, and every input to that number is structural: the largest US market, Madison Square Garden with no naming rights sold, and an owned RSN in MSG Network that never went through the Diamond bankruptcy. The team has not matched the balance sheet, missing the playoffs in 2025 and 2026, trading Panarin to Los Angeles at the 2026 deadline and retooling around Shesterkin's $92M deal, Fox, Zibanejad and captain J.T. Miller. A real contender under Mike Sullivan is the only lever left; the market and the building are already fully priced.",
    "unverifiedAsOf": {}
  },
  "philadelphia-flyers": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 0,
        "new": 1,
        "fact": "Flyers qualified in 2026, beat Pittsburgh in six in the first round and were swept by Carolina in the second round",
        "source": "https://en.wikipedia.org/wiki/2026_Stanley_Cup_playoffs ; https://en.wikipedia.org/wiki/Pittsburgh_Penguins"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Matvei Michkov — No. 7 overall pick 2023; Cam Atkinson veteran presence",
        "new": "Matvei Michkov (ELC through 2026-27, RFA in 2027) with Trevor Zegras ($9.125M AAV, acquired from Anaheim in 2025 and extended) and Travis Konecny (8yr/$70M, $8.75M AAV through 2032-33); Sean Couturier captain",
        "fact": "CapWages 2026-27: Zegras $9.125M, Konecny $8.75M, Couturier $7.75M, Michkov $950K ELC with one season left",
        "source": "https://capwages.com/teams/philadelphia_flyers ; https://en.wikipedia.org/wiki/Philadelphia_Flyers"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Sean Couturier",
            "position": "C",
            "aav": 7.75,
            "contractNote": "8yr/$62M signed 2021, through 2028-29; captain; injury history a concern"
          },
          {
            "player": "Travis Konecny",
            "position": "RW",
            "aav": 7,
            "contractNote": "8yr/$56M signed 2022, through 2029-30; team's best scorer"
          },
          {
            "player": "Matvei Michkov",
            "position": "RW",
            "aav": 0.925,
            "contractNote": "3yr/$2.775M entry-level, through 2025-26; franchise prospect; considered among NHL's elite future players"
          }
        ],
        "new": [
          {
            "player": "Trevor Zegras",
            "position": "C/LW",
            "aav": 9.125,
            "contractNote": "$9.125M AAV extension after the 2025 trade from Anaheim"
          },
          {
            "player": "Travis Konecny",
            "position": "RW",
            "aav": 8.75,
            "contractNote": "8yr/$70M signed July 2024, 2025-26 through 2032-33; 14-team no-trade list from 2031-32"
          },
          {
            "player": "Sean Couturier",
            "position": "C",
            "aav": 7.75,
            "contractNote": "8yr/$62M (2021), through 2029-30; captain"
          },
          {
            "player": "Owen Tippett",
            "position": "RW",
            "aav": 6.2,
            "contractNote": "8yr/$49.6M (2024), through 2031-32"
          },
          {
            "player": "Matvei Michkov",
            "position": "RW",
            "aav": 0.95,
            "contractNote": "3yr ELC ($950K cap hit) runs through 2026-27; RFA summer 2027"
          }
        ],
        "fact": "Konecny's extension is $8.75M (not $7M); Michkov's ELC ends after 2026-27; Zegras is now the top cap hit",
        "source": "https://capwages.com/teams/philadelphia_flyers"
      }
    ],
    "analystNotes": "Forbes valued the Flyers at $2.3B in December 2024 on $260M of revenue and $71M of operating income, and the Comcast structure behind it is the most insulated in the league: the team, Xfinity Mobile Arena and NBC Sports Philadelphia sit under one parent, so the April 2026 collapse of FanDuel Sports Network never touched Philadelphia. The rebuild produced its first playoff series since 2020 in 2026, a six-game win over Pittsburgh, with Zegras ($9.125M), Konecny ($8.75M through 2032-33) and Michkov (RFA in 2027) as the core and a $90M offer sheet for Leo Carlsson in July 2026 signalling Comcast's appetite to spend. The privately financed $1.3B arena shared with the 76ers, targeted around 2030, is the next step change in the number.",
    "unverifiedAsOf": {}
  },
  "pittsburgh-penguins": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.championshipsLast10Years",
        "old": 2,
        "new": 1,
        "fact": "Only the 2017 Cup falls inside the 2017-2026 window; the 2016 title has aged out",
        "source": "https://en.wikipedia.org/wiki/Pittsburgh_Penguins"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 1,
        "new": 2,
        "fact": "Playoffs in 2022 and 2026; Pittsburgh fell behind 3-0 to Philadelphia in the 2026 first round, won two, then lost Game 6 in overtime",
        "source": "https://en.wikipedia.org/wiki/Pittsburgh_Penguins ; https://en.wikipedia.org/wiki/2026_Stanley_Cup_playoffs"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Sidney Crosby",
            "position": "C",
            "aav": 8.7,
            "contractNote": "2yr/$17.4M signed Sept 2024, through 2026-27; playing at $8.7M — dramatically below market for a player of his production; age 38 going into contract; franchise cornerstone since 2005"
          },
          {
            "player": "Evgeni Malkin",
            "position": "C",
            "aav": 6.1,
            "contractNote": "2yr/$12.2M signed 2023, through 2024-25; end-of-career contract for franchise legend"
          },
          {
            "player": "Kris Letang",
            "position": "D",
            "aav": 6.1,
            "contractNote": "2yr/$12.2M through 2024-25; franchise defenseman completing career in Pittsburgh"
          }
        ],
        "new": [
          {
            "player": "Erik Karlsson",
            "position": "D",
            "aav": 10,
            "contractNote": "$10M cap hit (San Jose retains part of the $11.5M AAV); final season 2026-27"
          },
          {
            "player": "Sidney Crosby",
            "position": "C",
            "aav": 8.7,
            "contractNote": "2yr/$17.4M signed Sept 16, 2024, final season 2026-27 (age 39); captain"
          },
          {
            "player": "Kris Letang",
            "position": "D",
            "aav": 6.1,
            "contractNote": "6yr/$36.6M (2022), through 2027-28"
          },
          {
            "player": "Evgeni Malkin",
            "position": "C",
            "aav": 5.5,
            "contractNote": "One-year $5.5M deal for 2026-27 (age 40) after his 4yr/$24.4M contract expired"
          }
        ],
        "fact": "CapWages 2026-27: Karlsson $10M (one season left), Crosby $8.7M (one season left), Letang $6.1M (two seasons left), Malkin $5.5M (one season left)",
        "source": "https://capwages.com/teams/pittsburgh_penguins ; https://en.wikipedia.org/wiki/Pittsburgh_Penguins"
      }
    ],
    "analystNotes": "Forbes valued the Penguins at $1.75B in December 2024 on $223M of revenue, and the Hoffmann family paid $1.7B for control in December 2025 (full control June 23, 2026), so the print and the sale sit within 3% of each other. The buyers got a better first year than the bear case: Pittsburgh returned to the playoffs in 2026 and pushed Philadelphia to overtime in Game 6, with Crosby ($8.7M) and Malkin (one year at $5.5M at age 40) both playing out final seasons. Everything about the next Forbes number is the post-Crosby plan, because his contract, Malkin's and Karlsson's all expire after 2026-27 and PPG Paints Arena is publicly owned, so there is no real estate to lean on.",
    "unverifiedAsOf": {}
  },
  "washington-capitals": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Alex Ovechkin — 5yr/$47.5M ($9.5M AAV) signed July 2021, through 2025-26; broke Gordie Howe all-time goals record 2023; contract ends after 2025-26 season",
        "new": "Alex Ovechkin re-signed July 2, 2026 on a one-year deal ($4.25M cap hit plus $4.75M in bonuses) for 2026-27 at age 41; passed Gretzky with goal 895 on April 6, 2025 and scored his 900th on November 5, 2025; Alex Tuch ($10.5M) is now the top cap hit",
        "fact": "Ovechkin signed a one-year, $4.25M contract (plus $4.75M bonus) on July 2, 2026",
        "source": "https://en.wikipedia.org/wiki/Alexander_Ovechkin ; https://capwages.com/teams/washington_capitals"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Alex Ovechkin",
            "position": "LW",
            "aav": 9.5,
            "contractNote": "5yr/$47.5M signed July 2021, through 2025-26 (age 40 season); broke Gordie Howe's all-time NHL goals record (894 career goals); one final season remaining; retirement to be determined after 2025-26"
          },
          {
            "player": "Dylan Strome",
            "position": "C",
            "aav": 7.35,
            "contractNote": "7yr/$51.45M signed 2022, through 2028-29; franchise C post-Ovechkin"
          },
          {
            "player": "Tom Wilson",
            "position": "RW/LW",
            "aav": 7.25,
            "contractNote": "7yr/$50.75M signed 2021, through 2027-28; power-forward cornerstone"
          }
        ],
        "new": [
          {
            "player": "Alex Tuch",
            "position": "RW",
            "aav": 10.5,
            "contractNote": "$10.5M AAV; joined Washington for 2026-27 (acquisition terms not second-sourced)"
          },
          {
            "player": "Jakob Chychrun",
            "position": "D",
            "aav": 9,
            "contractNote": "8yr/$72M (2025), through 2032-33; NMC to May 2028"
          },
          {
            "player": "Pierre-Luc Dubois",
            "position": "C",
            "aav": 8.5,
            "contractNote": "8yr/$68M (2023), through 2030-31"
          },
          {
            "player": "Jordan Kyrou",
            "position": "RW",
            "aav": 8.125,
            "contractNote": "8yr/$65M (2023), through 2030-31; acquired from St. Louis (2026)"
          },
          {
            "player": "Tom Wilson",
            "position": "RW",
            "aav": 6.54,
            "contractNote": "7yr/$45.78M extension (2024), 2025-26 through 2031-32"
          },
          {
            "player": "Dylan Strome",
            "position": "C",
            "aav": 5,
            "contractNote": "5yr/$25M (2023), through 2027-28"
          },
          {
            "player": "Alex Ovechkin",
            "position": "LW",
            "aav": 4.25,
            "contractNote": "One-year $4.25M plus $4.75M bonuses for 2026-27, signed July 2, 2026; all-time goals leader"
          }
        ],
        "fact": "CapWages 2026-27: Tuch $10.5M, Chychrun $9.0M, Dubois $8.5M, Kyrou $8.125M, Wilson $6.54M, Strome $5.0M, Ovechkin $4.25M; prior Strome ($7.35M) and Wilson ($7.25M) figures were wrong",
        "source": "https://capwages.com/teams/washington_capitals ; https://en.wikipedia.org/wiki/Alexander_Ovechkin"
      }
    ],
    "analystNotes": "Forbes valued the Capitals at $2.15B in December 2024 on $244M of revenue and $81M of operating income, and the Ovechkin premium the market feared losing did not end: he passed Gretzky on April 6, 2025, hit 900 goals in November 2025, and on July 2, 2026 signed a one-year deal at a $4.25M cap hit for an age-41 season. Around him Monumental has rebuilt the payroll with Tuch ($10.5M), Chychrun ($9M), Dubois and Kyrou, owns Capital One Arena and its own network, and has the DC lease locked to 2050. The 2026 playoff miss says the on-ice floor is the risk; the true post-Ovechkin year, now 2027-28 at the earliest, is what the next valuation will be written against.",
    "unverifiedAsOf": {}
  },
  "utah-hockey-club": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "team",
        "old": "Utah Hockey Club",
        "new": "Utah Mammoth",
        "fact": "Permanent name Utah Mammoth revealed May 7, 2025 after fan voting; Yeti was blocked at the USPTO",
        "source": "https://en.wikipedia.org/wiki/Utah_Mammoth ; https://en.wikipedia.org/wiki/2025%E2%80%9326_NHL_season"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 0,
        "new": 1,
        "fact": "Utah went 43-33-6 (92 points) in 2025-26 and lost in the first round to Vegas in six games, the franchise's first playoff series since relocation",
        "source": "https://en.wikipedia.org/wiki/Utah_Mammoth ; https://en.wikipedia.org/wiki/2026_Stanley_Cup_playoffs"
      },
      {
        "field": "arena.newArenaPlans",
        "old": "Salt Lake City council approved $900M package (2025); dedicated hockey-only arena in the district is under discussion but not confirmed; short-term Delta Center capacity constraints noted (16,200 among the smallest in NHL)",
        "new": "Delta Center is being rebuilt for hockey in phases inside the $900M package ($525M renovation): Phase 1 (April-October 2025) rebuilt the lower bowl and removed obstructed seats; Phase 2 (May 4 to September 26, 2026) added terrace ledges with full-view seating and sideline gondolas plus a premium parking structure; Phase 3 follows the 2026-27 season; unobstructed hockey seating goes from about 12,000 to a 17,000 target; no separate hockey arena is planned",
        "fact": "Delta Center renovation phases and the 12,000-to-17,000 unobstructed-seat target",
        "source": "https://en.wikipedia.org/wiki/Delta_Center"
      },
      {
        "field": "media.localTVDeal",
        "old": "KJZZ (local broadcast) + streaming-forward distribution model; partial deal with Utah-area RSN; team exploring direct-to-consumer given RSN industry collapse",
        "new": "KUPX-TV (Utah 16) over-the-air plus the team's Mammoth+ direct-to-consumer stream (rebranded from Utah HC+); KZNS/KSL Sports Zone radio",
        "fact": "Wikipedia infobox lists KUPX-TV and Mammoth+",
        "source": "https://en.wikipedia.org/wiki/Utah_Mammoth"
      },
      {
        "field": "media.streamingNotes",
        "old": "ESPN+/Hulu for national games; Utah HC leaning into streaming distribution as first-year franchise",
        "new": "Mammoth+ direct-to-consumer stream for in-market fans; ESPN+/Hulu and TNT/Max national",
        "fact": "Utah HC+ rebranded as Mammoth+ after the name change",
        "source": "https://en.wikipedia.org/wiki/Utah_Mammoth"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Clayton Keller — 8yr/$67.2M ($8.4M AAV) signed 2023, inherited as top scorer from Arizona roster",
        "new": "Clayton Keller (first captain, named Oct 4, 2024), $7.15M AAV through 2027-28; Logan Cooley, 8yr/$80M ($10M AAV) from 2026-27, is the top cap hit",
        "fact": "Keller's cap hit is $7.15M with two seasons left; Cooley's eight-year, $10M AAV deal begins 2026-27",
        "source": "https://capwages.com/teams/utah_mammoth ; https://en.wikipedia.org/wiki/Utah_Mammoth"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Clayton Keller",
            "position": "C/LW",
            "aav": 8.4,
            "contractNote": "8yr/$67.2M, signed Jul 2023, runs through 2030-31; team captain and top scorer"
          },
          {
            "player": "Mikhail Sergachev",
            "position": "D",
            "aav": 8.5,
            "contractNote": "7yr/$59.5M, signed 2023 (acquired from Tampa); defensive anchor"
          }
        ],
        "new": [
          {
            "player": "Logan Cooley",
            "position": "C",
            "aav": 10,
            "contractNote": "8yr/$80M signed August 2025, 2026-27 through 2033-34"
          },
          {
            "player": "Mikhail Sergachev",
            "position": "D",
            "aav": 8.5,
            "contractNote": "8yr/$68M (2023), through 2030-31; 16-team trade list from June 2027"
          },
          {
            "player": "Nick Schmaltz",
            "position": "C/RW",
            "aav": 8,
            "contractNote": "$8M AAV eight-year deal with NMC through 2033-34"
          },
          {
            "player": "Clayton Keller",
            "position": "LW",
            "aav": 7.15,
            "contractNote": "8yr/$57.2M (2019), through 2027-28; captain; NMC to June 2028"
          },
          {
            "player": "Dylan Guenther",
            "position": "RW",
            "aav": 7.143,
            "contractNote": "8yr/$57.14M (2024), through 2032-33"
          }
        ],
        "fact": "CapWages 2026-27: Cooley $10M, Sergachev $8.5M, Schmaltz $8M, Keller $7.15M, Guenther $7.14M; JJ Peterka no longer on the roster",
        "source": "https://capwages.com/teams/utah_mammoth"
      }
    ],
    "analystNotes": "Forbes valued Utah at $1.2B in December 2024, the price Ryan Smith paid the NHL in 2024, on $123M of first-season revenue, and the two constraints in that number are being removed: the club became the Utah Mammoth on May 7, 2025, and the Delta Center rebuild moved unobstructed hockey seating from roughly 12,000 toward a 17,000 target through phases completed in October 2025 and September 2026. The team made its first playoffs in 2026 (92 points, lost to Vegas in six) with Cooley signed at $10M a year through 2033-34 and Keller, Sergachev and Guenther locked in. Full-capacity gates from 2026-27 are what the next revenue line shows, and the Vegas comparable says the valuation follows.",
    "unverifiedAsOf": {}
  },
  "chicago-blackhawks": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.championshipsLast10Years",
        "old": 1,
        "new": 0,
        "fact": "The 2015 Cup has aged out of the 2017-2026 window; Chicago has no title since",
        "source": "https://en.wikipedia.org/wiki/2026_Stanley_Cup_playoffs"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Connor Bedard — 3yr ELC at $950K cap hit (signed July 2023), ELC expires after 2025-26; extension negotiations began 2025; widely projected 8yr deal ~$10-12M AAV",
        "new": "Connor Bedard, captain, signed a 5yr/$75M ($15M AAV) extension July 17, 2026 running 2026-27 through 2030-31 after 75 points in 69 games in 2025-26",
        "fact": "Bedard extension: July 17, 2026, five years, $75M, $15M AAV, full NMC",
        "source": "https://en.wikipedia.org/wiki/Connor_Bedard ; https://capwages.com/teams/chicago_blackhawks"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Connor Bedard",
            "position": "C",
            "aav": 0.95,
            "contractNote": "3yr ELC, $950K cap hit through 2025-26; extension talks expected to reset AAV to $10M+ range; 2023 #1 overall pick"
          },
          {
            "player": "Seth Jones",
            "position": "D",
            "aav": 9.5,
            "contractNote": "8yr/$76M signed 2021, through 2028-29; highest-paid defenseman at signing; on-ice performance has underwhelmed vs. contract"
          }
        ],
        "new": [
          {
            "player": "Connor Bedard",
            "position": "C",
            "aav": 15,
            "contractNote": "5yr/$75M signed July 17, 2026, through 2030-31; full NMC; captain"
          },
          {
            "player": "Frank Nazar",
            "position": "C",
            "aav": 6.6,
            "contractNote": "7yr/$46.2M (2025), through 2032-33"
          },
          {
            "player": "Bowen Byram",
            "position": "D",
            "aav": 6.25,
            "contractNote": "$6.25M AAV; acquired from Buffalo"
          }
        ],
        "fact": "Seth Jones was traded to Florida in March 2025 with Chicago retaining $2.5M; Bedard now carries $15M",
        "source": "https://capwages.com/teams/chicago_blackhawks ; https://en.wikipedia.org/wiki/Connor_Bedard"
      }
    ],
    "analystNotes": "Forbes valued the Blackhawks at $2.45B in December 2024 on $260M of revenue and $100M of operating income, a number carried by the Original Six brand, a 50% share of the United Center and equity in Chicago Sports Network while the team missed the playoffs every year from 2022 through 2026. The rebuild now has its price: Bedard, named captain, signed a five-year, $75M extension ($15M a year) on July 17, 2026 after a 75-point season, and Seth Jones' $9.5M is gone to Florida. The United Center district development is the long-dated real estate call; the near-term valuation swing is Bedard's group ending the playoff drought under a $104M cap.",
    "unverifiedAsOf": {
      "arena.newArenaPlans": "May 2026"
    }
  },
  "colorado-avalanche": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 4,
        "new": 5,
        "fact": "Playoffs every year 2022-2026; lost in seven to Dallas in 2025; won the 2025-26 Presidents' Trophy, swept Los Angeles and beat Minnesota before losing the 2026 Western final to Vegas in six",
        "source": "https://en.wikipedia.org/wiki/2025_Stanley_Cup_playoffs ; https://en.wikipedia.org/wiki/2026_Stanley_Cup_playoffs ; https://en.wikipedia.org/wiki/An%C5%BEe_Kopitar"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Nathan MacKinnon — 8yr/$100.8M ($12.6M AAV) signed 2022, through 2030-31; 2024 Hart Trophy winner; widely considered best player in NHL",
        "new": "Nathan MacKinnon, 8yr/$100.8M ($12.6M AAV) through 2030-31, 2024 Hart Trophy; Cale Makar signed an 8yr/$163.2M ($20.4M AAV) extension on August 28, 2026, the richest contract in NHL history and the first above $20M a year, following his $9M final season in 2026-27",
        "fact": "Makar extension August 28, 2026: eight years, $163.2M, $20.4M AAV",
        "source": "https://en.wikipedia.org/wiki/Cale_Makar ; https://capwages.com/teams/colorado_avalanche"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Nathan MacKinnon",
            "position": "C",
            "aav": 12.6,
            "contractNote": "8yr/$100.8M signed Jun 2022, through 2030-31; Hart Trophy 2024; increasingly looks like a bargain vs. Kaprizov's $17M reset"
          },
          {
            "player": "Cale Makar",
            "position": "D",
            "aav": 9,
            "contractNote": "6yr/$54M signed 2022, through 2027-28; 2022 Conn Smythe; consensus best defenseman in NHL"
          },
          {
            "player": "Mikko Rantanen",
            "position": "RW",
            "aav": 9.25,
            "contractNote": "5yr/$46.25M through 2025-26; extension negotiations or trade decision anticipated 2025-26"
          }
        ],
        "new": [
          {
            "player": "Nathan MacKinnon",
            "position": "C",
            "aav": 12.6,
            "contractNote": "8yr/$100.8M (2022), through 2030-31; Hart Trophy 2024"
          },
          {
            "player": "Martin Necas",
            "position": "RW",
            "aav": 11.5,
            "contractNote": "$11.5M AAV eight-year extension (2025); acquired in the January 2025 Rantanen trade"
          },
          {
            "player": "Cale Makar",
            "position": "D",
            "aav": 9,
            "contractNote": "6yr/$54M signed July 24, 2021, final season 2026-27; 8yr/$163.2M ($20.4M AAV) extension signed Aug 28, 2026 begins 2027-28; 2025 Norris Trophy"
          },
          {
            "player": "Devon Toews",
            "position": "D",
            "aav": 7.25,
            "contractNote": "7yr/$50.75M (2024), through 2030-31"
          }
        ],
        "fact": "Rantanen was traded to Carolina in January 2025 and is now in Dallas; Necas extended at $11.5M; Makar's record extension signed Aug 28, 2026",
        "source": "https://capwages.com/teams/colorado_avalanche ; https://en.wikipedia.org/wiki/Cale_Makar"
      }
    ],
    "analystNotes": "Forbes valued the Avalanche at $1.7B in December 2024 on $198M of revenue, low for a franchise that owns its arena, its RSN and a 2022 Cup, and the team has kept the on-ice case intact with five straight playoff years, a 2025-26 Presidents' Trophy and a run to the 2026 Western final. The cost of that core just reset: Makar signed an eight-year, $163.2M extension on August 28, 2026, a $20.4M cap hit from 2027-28 that is the largest in NHL history, on top of MacKinnon at $12.6M through 2030-31 and Necas at $11.5M. KSE is never a seller, so the valuation lever is Denver's 3M-person market converting the Ball Arena parking lots into a district while this roster is still winning.",
    "unverifiedAsOf": {}
  },
  "dallas-stars": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 4,
        "new": 5,
        "fact": "Playoffs every year 2022-2026; reached the 2025 Western final (beat Colorado and Winnipeg, lost to Edmonton in six); lost the 2026 first round to Minnesota in six",
        "source": "https://en.wikipedia.org/wiki/2025_Stanley_Cup_playoffs ; https://en.wikipedia.org/wiki/2026_Stanley_Cup_playoffs"
      },
      {
        "field": "media.localTVDeal",
        "old": "Victory+ (team-owned direct streaming platform launched 2023); Stars became one of first NHL teams to launch own direct-to-consumer streaming after Bally Sports North collapsed; local games on KFAA broadcast partner; pioneering post-RSN media model",
        "new": "Amazon Prime Video holds Stars regional streaming rights for 2026-27, with the over-the-air broadcast package (KFAA) retained; this succeeds the team-run Victory+ model launched in 2024",
        "fact": "For 2026-27 the Stars and Ducks moved regional rights to Amazon Prime Video while keeping broadcast television packages",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_NHL_season ; https://en.wikipedia.org/wiki/Dallas_Stars"
      },
      {
        "field": "media.streamingNotes",
        "old": "ESPN+/Hulu for national games; Victory+ direct streaming replaces traditional RSN; cost $4.99/month vs. old cable bundle; Stars capturing full local media revenue without RSN middleman",
        "new": "Amazon Prime Video is the in-market streaming home from 2026-27; ESPN+/Hulu and TNT/Max national",
        "fact": "Prime Video regional rights from 2026-27",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_NHL_season"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Jason Robertson — 4yr bridge deal at $7.75M AAV (through 2025-26); extension at $11-13M AAV anticipated; top-10 NHL scorer",
        "new": "Jason Robertson signed a one-year, $12M deal for 2026-27 (UFA in July 2027) after 45 goals and 96 points in 2025-26; Mikko Rantanen, 8yr/$96M ($12M AAV) through 2032-33, was acquired in March 2025",
        "fact": "CapWages shows Robertson at $12M with one season left; Wikipedia records his 45-goal, 96-point 2025-26",
        "source": "https://capwages.com/teams/dallas_stars ; https://en.wikipedia.org/wiki/Jason_Robertson"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Jason Robertson",
            "position": "LW",
            "aav": 7.75,
            "contractNote": "4yr/$31M bridge deal through 2025-26; extension at ~$11-13M projected given Kaprizov market reset; extension or trade decision defines Stars' 2026-27 cap structure"
          },
          {
            "player": "Roope Hintz",
            "position": "C",
            "aav": 8.45,
            "contractNote": "8yr/$67.6M signed 2022, through 2029-30; franchise center"
          },
          {
            "player": "Miro Heiskanen",
            "position": "D",
            "aav": 8.45,
            "contractNote": "8yr/$67.6M signed 2021, through 2028-29; elite two-way defenseman"
          }
        ],
        "new": [
          {
            "player": "Jason Robertson",
            "position": "LW",
            "aav": 12,
            "contractNote": "One-year $12M for 2026-27, UFA after; 45 goals, 96 points in 2025-26"
          },
          {
            "player": "Mikko Rantanen",
            "position": "RW",
            "aav": 12,
            "contractNote": "8yr/$96M signed March 2025 on acquisition from Carolina, through 2032-33; full NMC"
          },
          {
            "player": "Thomas Harley",
            "position": "D",
            "aav": 10.587,
            "contractNote": "$10.587M AAV eight-year extension (2025), full NMC"
          },
          {
            "player": "Roope Hintz",
            "position": "C",
            "aav": 8.45,
            "contractNote": "8yr/$67.6M (2022), through 2030-31"
          },
          {
            "player": "Miro Heiskanen",
            "position": "D",
            "aav": 8.45,
            "contractNote": "8yr/$67.6M (2021), through 2028-29"
          },
          {
            "player": "Wyatt Johnston",
            "position": "C",
            "aav": 8.4,
            "contractNote": "$8.4M AAV through 2030-31"
          },
          {
            "player": "Jake Oettinger",
            "position": "G",
            "aav": 8.25,
            "contractNote": "8yr/$66M (2024), through 2032-33"
          }
        ],
        "fact": "CapWages 2026-27: Robertson $12M, Rantanen $12M, Harley $10.587M, Seguin $9.85M, Hintz and Heiskanen $8.45M, Johnston $8.4M, Oettinger $8.25M",
        "source": "https://capwages.com/teams/dallas_stars"
      }
    ],
    "analystNotes": "Forbes valued the Stars at $2.0B in December 2024 on $230M of revenue and $59M of operating income, up more than eight times on Gaglardi's $240M bankruptcy purchase in 2011, and the operating case keeps compounding in the fastest-growing metro in the league. Dallas has made the playoffs five straight years, including a 2025 Western final, and now carries the most expensive skater group outside Colorado: Rantanen and Robertson at $12M each, Harley at $10.6M, plus Hintz, Heiskanen, Johnston and Oettinger between $8.25M and $8.45M. Local media moved from the self-run Victory+ platform to Amazon Prime Video for 2026-27; the valuation lever now is what happens to the American Airlines Center lease that expires around 2031 and whether the Mavericks build separately.",
    "unverifiedAsOf": {}
  },
  "minnesota-wild": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "arena.name",
        "old": "Xcel Energy Center",
        "new": "Grand Casino Arena",
        "fact": "Renamed Grand Casino Arena effective September 3, 2025 (announced June 30, 2025) under a deal with the Mille Lacs Band of Ojibwe, ending Xcel Energy's 25-year naming run",
        "source": "https://en.wikipedia.org/wiki/Grand_Casino_Arena ; https://en.wikipedia.org/wiki/2025%E2%80%9326_NHL_season"
      },
      {
        "field": "arena.namingRightsDeal",
        "old": {
          "sponsor": "Xcel Energy",
          "annualValue_M": 3.6,
          "totalValue_M": null,
          "expiryYear": 2026,
          "notes": "Xcel Energy (utility company) naming rights; deal set to expire ~2026; Wild asking $362M in public renovation funding (2026) in connection with arena upgrade discussions"
        },
        "new": {
          "sponsor": "Grand Casino (Mille Lacs Band of Ojibwe)",
          "annualValue_M": null,
          "totalValue_M": null,
          "expiryYear": null,
          "notes": "Grand Casino Arena naming deal announced June 30, 2025, effective September 3, 2025; Mille Lacs Band of Ojibwe owns Grand Casino Hinckley and Grand Casino Mille Lacs; value and length undisclosed; Xcel Energy (2000-2025 sponsor) remains a team partner"
        },
        "fact": "New naming partner from September 3, 2025; terms undisclosed",
        "source": "https://en.wikipedia.org/wiki/Grand_Casino_Arena"
      },
      {
        "field": "arena.ownershipModel",
        "old": "Owned by Minnesota Sports & Entertainment (Craig Leipold); one of the few NHL arenas directly owned by the franchise ownership group (not city/county); team retains all arena P&L including concerts, events, and non-hockey programming",
        "new": "Owned by the City of Saint Paul and operated by Minnesota Sports & Entertainment (Craig Leipold), which runs the building and its event calendar; built in 2000 with a $65M state loan and $65M in Saint Paul bonds",
        "fact": "Wikipedia lists the City of Saint Paul as owner and MSE as operator",
        "source": "https://en.wikipedia.org/wiki/Grand_Casino_Arena ; https://en.wikipedia.org/wiki/Minnesota_Wild"
      },
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports North (Diamond Sports / Sinclair) through 2024-25; Diamond Sports Group filed Chapter 11 in 2023 — Wild among teams working on post-Bally distribution alternative; direct streaming model being explored for 2025+",
        "new": "Team-owned regional network produced with NHL Productions through the league hub and sold direct to distributors from 2026-27, with Amazon Prime Video in-market streaming, after FanDuel Sports Network North went dark April 30, 2026",
        "fact": "FanDuel Sports Network closed April 30, 2026; Minnesota joined the NHL hub direct-to-distributor group with Prime Video streaming",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_NHL_season ; https://en.wikipedia.org/wiki/FanDuel_Sports_Network ; data/forbes-proxies.js (verified)"
      },
      {
        "field": "media.streamingNotes",
        "old": "ESPN+/Hulu for national games; local streaming transition from Bally Sports North ongoing; Wild among NHL teams facing most acute RSN disruption given Diamond's bankruptcy",
        "new": "Amazon Prime Video in-market streaming from 2026-27; ESPN+/Hulu and TNT/Max national",
        "fact": "Prime Video in-market streaming for hub-produced teams",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_NHL_season"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 3,
        "new": 4,
        "fact": "Playoffs in 2022, 2023, 2025 (lost to Vegas in six) and 2026 (beat Dallas in six, lost to Colorado in five)",
        "source": "https://en.wikipedia.org/wiki/2025_Stanley_Cup_playoffs ; https://en.wikipedia.org/wiki/2026_Stanley_Cup_playoffs ; https://en.wikipedia.org/wiki/Minnesota_Wild"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Kirill Kaprizov — 8yr/$136M ($17M AAV) signed Sept 2025, begins 2026-27 through 2033-34; richest contract in NHL history at signing",
        "new": "Kirill Kaprizov, 8yr/$136M ($17M AAV) from 2026-27 through 2033-34, richest contract at signing until Makar's August 2026 deal; Quinn Hughes, acquired from Vancouver December 12, 2025, is in the final year of his $7.85M deal (UFA July 2027); Jared Spurgeon captain",
        "fact": "Quinn Hughes traded to Minnesota December 12, 2025 for Marco Rossi, Zeev Buium, Liam Öhgren and a 2026 first-round pick",
        "source": "https://en.wikipedia.org/wiki/Quinn_Hughes ; https://capwages.com/teams/minnesota_wild"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Kirill Kaprizov",
            "position": "LW",
            "aav": 17,
            "contractNote": "8yr/$136M signed Sept 2025, 2026-27 through 2033-34; NHL record AAV at signing; resets forward market above MacKinnon's $12.6M"
          },
          {
            "player": "Matt Boldy",
            "position": "LW",
            "aav": 7,
            "contractNote": "7yr/$49M signed 2023, through 2029-30; emerging second star alongside Kaprizov"
          },
          {
            "player": "Filip Gustavsson",
            "position": "G",
            "aav": 6.25,
            "contractNote": "5yr/$31.25M signed 2023, through 2027-28; franchise goalie"
          }
        ],
        "new": [
          {
            "player": "Kirill Kaprizov",
            "position": "LW",
            "aav": 17,
            "contractNote": "8yr/$136M signed Sept 2025, 2026-27 through 2033-34; full NMC"
          },
          {
            "player": "Brock Faber",
            "position": "D",
            "aav": 8.5,
            "contractNote": "8yr/$68M (2024), 2025-26 through 2032-33"
          },
          {
            "player": "Quinn Hughes",
            "position": "D",
            "aav": 7.85,
            "contractNote": "6yr/$47.1M (2021), final season 2026-27; acquired Dec 12, 2025; 2024 Norris Trophy"
          },
          {
            "player": "Matt Boldy",
            "position": "LW",
            "aav": 7,
            "contractNote": "7yr/$49M (2023), through 2029-30"
          },
          {
            "player": "Filip Gustavsson",
            "position": "G",
            "aav": 6.8,
            "contractNote": "$6.8M AAV extension (2025); NMC through June 2028"
          }
        ],
        "fact": "CapWages 2026-27: Kaprizov $17M, Faber $8.5M, Quinn Hughes $7.85M, Spurgeon $7.575M, Boldy $7M, Gustavsson $6.8M",
        "source": "https://capwages.com/teams/minnesota_wild ; https://en.wikipedia.org/wiki/Quinn_Hughes"
      }
    ],
    "analystNotes": "Forbes valued the Wild at $1.55B in December 2024 on $200M of revenue, and the two open questions in that print both closed in 2025-26: the building became Grand Casino Arena on September 3, 2025 under a Mille Lacs Band naming deal, and when FanDuel Sports Network North died on April 30, 2026 Minnesota moved to a team-owned, NHL-hub-produced network with Prime Video streaming. On the ice Leipold went all in, paying Kaprizov $17M a year from 2026-27 and trading three first-round-pedigree players plus a first for Quinn Hughes in December 2025, and the team won a round in 2026. Hughes' contract expires after 2026-27, so his extension, and the hundreds of millions Saint Paul needs for the city-owned arena, are the next two numbers that matter.",
    "unverifiedAsOf": {}
  },
  "nashville-predators": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports South (Diamond Sports / Sinclair) — facing disruption from Diamond Chapter 11 filing 2023; Predators working on post-Bally distribution; local broadcast on WZTV",
        "new": "Multi-year Scripps Sports deal from 2026-27 with the new independent station WNPX-TV as flagship and CBS affiliate WTVF as sister outlet, after FanDuel Sports Network South went dark April 30, 2026; a direct-to-consumer platform is pending",
        "fact": "Scripps Sports holds Predators local rights beginning 2026-27 via WNPX-TV and WTVF",
        "source": "https://en.wikipedia.org/wiki/Nashville_Predators ; https://en.wikipedia.org/wiki/2026%E2%80%9327_NHL_season ; https://en.wikipedia.org/wiki/FanDuel_Sports_Network ; data/forbes-proxies.js (verified)"
      },
      {
        "field": "media.streamingNotes",
        "old": "ESPN+/Hulu for national games; post-Bally streaming transition in progress for local games; Nashville market exploring direct-to-consumer options",
        "new": "Over-the-air Scripps model with a direct-to-consumer platform pending; ESPN+/Hulu and TNT/Max national",
        "fact": "Scripps over-the-air deal with DTC platform pending for 2026-27",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_NHL_season"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Roman Josi",
            "position": "D",
            "aav": 9.06,
            "contractNote": "8yr/$72.5M signed 2019, through 2026-27; 2020 Norris Trophy; aging but still franchise captain; extension or succession planning imminent"
          },
          {
            "player": "Filip Forsberg",
            "position": "LW",
            "aav": 8.5,
            "contractNote": "8yr/$68M signed 2022, through 2029-30; franchise leading scorer; 2022 extension kept him in Nashville long-term"
          }
        ],
        "new": [
          {
            "player": "Roman Josi",
            "position": "D",
            "aav": 9.059,
            "contractNote": "8yr/$72.5M (2019), through 2027-28; captain; NMC"
          },
          {
            "player": "Filip Forsberg",
            "position": "LW",
            "aav": 8.5,
            "contractNote": "8yr/$68M (2022), through 2029-30"
          },
          {
            "player": "Steven Stamkos",
            "position": "LW/RW",
            "aav": 8,
            "contractNote": "4yr/$32M signed July 2024, through 2027-28; full NMC"
          },
          {
            "player": "Juuse Saros",
            "position": "G",
            "aav": 7.74,
            "contractNote": "8yr/$61.9M (2024), 2025-26 through 2032-33; full NMC"
          }
        ],
        "fact": "Josi's deal runs through 2027-28 (two seasons left), not 2026-27; Stamkos and Saros added",
        "source": "https://capwages.com/teams/nashville_predators"
      }
    ],
    "analystNotes": "Forbes valued the Predators at $1.5B in December 2024 on $195M of revenue, a Sun Belt number built on Bridgestone Arena's Lower Broadway event calendar and Nashville's growth rather than the roster, and the roster has confirmed that: 30-44-8 in 2024-25 and 38-34-10 in 2025-26, no playoffs either year, and Barry Trotz retired in February 2026 with Chris MacFarland named GM in June. Local media landed cleanly, with a multi-year Scripps deal on the new WNPX-TV from 2026-27 after FanDuel Sports Network South closed in April. The Haslam group's number moves when Josi, Forsberg, Stamkos and Saros, all signed through at least 2027-28, produce a playoff series again.",
    "unverifiedAsOf": {}
  },
  "st-louis-blues": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports Midwest (Diamond Sports Group) — facing Diamond's Chapter 11 disruption; Blues pursuing post-Bally options including direct streaming and potential new RSN arrangement with Sinclair successor entity",
        "new": "From 2026-27 about 70 regional games are produced with NHL Productions through the league hub and sold direct to distributors by the Blues, who control distribution and ad sales, with Amazon Prime Video in-market streaming; FanDuel Sports Network Midwest went dark April 30, 2026",
        "fact": "FanDuel Sports Network closed April 30, 2026; St. Louis moved to the NHL hub direct-to-distributor model with Prime Video streaming",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_NHL_season ; https://en.wikipedia.org/wiki/FanDuel_Sports_Network ; data/forbes-proxies.js (verified)"
      },
      {
        "field": "media.streamingNotes",
        "old": "ESPN+/Hulu for national games; Blues Direct streaming offered for local games as Bally backup; RSN transition risk exists through 2025-26",
        "new": "Amazon Prime Video in-market streaming from 2026-27; ESPN+/Hulu and TNT/Max national",
        "fact": "Prime Video in-market streaming for hub-produced teams",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_NHL_season"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Jordan Kyrou — 8yr/$65M ($8.125M AAV) signed 2023, through 2030-31; breakout star after Ryan O'Reilly trade; becomes face of franchise in rebuild",
        "new": "Robert Thomas, captain, 8yr/$65M ($8.125M AAV) through 2030-31; Jordan Kyrou was traded to Washington and Brayden Schenn to the Islanders, with Mason McTavish ($7M) acquired from Anaheim",
        "fact": "Kyrou appears on Washington's 2026-27 sheet and Schenn on the Islanders'; Thomas is listed as Blues captain",
        "source": "https://capwages.com/teams/st_louis_blues ; https://capwages.com/teams/washington_capitals ; https://capwages.com/teams/new_york_islanders ; https://en.wikipedia.org/wiki/St._Louis_Blues"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Jordan Kyrou",
            "position": "RW",
            "aav": 8.125,
            "contractNote": "8yr/$65M signed 2023, through 2030-31; franchise building block after O'Reilly and Perron departures"
          },
          {
            "player": "Brayden Schenn",
            "position": "C",
            "aav": 6.5,
            "contractNote": "7yr/$45.5M through 2026-27; veteran franchise center; contract approaching expiry"
          },
          {
            "player": "Robert Thomas",
            "position": "C",
            "aav": 8.125,
            "contractNote": "8yr/$65M signed 2023, through 2030-31; elite playmaker; forms new-era core with Kyrou"
          }
        ],
        "new": [
          {
            "player": "Robert Thomas",
            "position": "C",
            "aav": 8.125,
            "contractNote": "8yr/$65M (2023), through 2030-31; captain"
          },
          {
            "player": "Pavel Buchnevich",
            "position": "LW",
            "aav": 8,
            "contractNote": "6yr/$48M (2024), through 2030-31"
          },
          {
            "player": "Philip Broberg",
            "position": "D",
            "aav": 8,
            "contractNote": "$8M AAV extension (2026), six seasons; full NTC through 2029-30"
          },
          {
            "player": "Dylan Holloway",
            "position": "LW",
            "aav": 7.75,
            "contractNote": "$7.75M AAV extension (2026)"
          },
          {
            "player": "Mason McTavish",
            "position": "C",
            "aav": 7,
            "contractNote": "6yr/$42M (2025), acquired from Anaheim"
          }
        ],
        "fact": "CapWages 2026-27: Thomas $8.125M, Buchnevich $8M, Broberg $8M, Holloway $7.75M, McTavish $7M, Parayko $6.5M, Binnington $6M; Kyrou and Schenn are gone",
        "source": "https://capwages.com/teams/st_louis_blues"
      }
    ],
    "analystNotes": "Forbes valued the Blues at $1.45B in December 2024 on $192M of revenue and under $10M of operating income, a mid-market number in a city-owned building, and the year since was a reset: St. Louis took Winnipeg to seven games in the 2025 first round, missed in 2026, then traded Kyrou to Washington and Schenn to the Islanders while paying Broberg, Holloway and Buchnevich $7.75M to $8M each around captain Robert Thomas. The revenue risk in the Forbes print resolved on April 30, 2026 when FanDuel Sports Network Midwest closed and the Blues took control of distribution and ad sales for roughly 70 hub-produced games with Prime Video streaming. What moves the number now is whether that direct model out-earns the old RSN check in a 2.8M-person market with no growth premium.",
    "unverifiedAsOf": {}
  },
  "winnipeg-jets": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 4,
        "new": 3,
        "fact": "Playoffs in 2023, 2024 and 2025 (first Presidents' Trophy with 116 points, then a second-round loss to Dallas in six); missed 2026 at 35-35-12",
        "source": "https://en.wikipedia.org/wiki/Winnipeg_Jets ; https://en.wikipedia.org/wiki/2025_Stanley_Cup_playoffs ; https://en.wikipedia.org/wiki/2026_Stanley_Cup_playoffs"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Mark Scheifele — 8yr/$49.6M ($6.125M AAV, signed 2016) through 2023-24 + new extension; franchise captain and all-time leading scorer",
        "new": "Kyle Connor, 8yr/$96M ($12M AAV) signed October 8, 2025, 2026-27 through 2033-34; Mark Scheifele $8.5M through 2030-31; Connor Hellebuyck $8.5M; Adam Lowry captain",
        "fact": "Connor extension October 8, 2025: eight years, $96M, $12M cap hit, through 2033-34",
        "source": "https://en.wikipedia.org/wiki/Kyle_Connor ; https://capwages.com/teams/winnipeg_jets"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Mark Scheifele",
            "position": "C",
            "aav": 8.5,
            "contractNote": "Multi-year extension; franchise captain and all-time scorer; aging core but still productive"
          },
          {
            "player": "Kyle Connor",
            "position": "LW",
            "aav": 7.25,
            "contractNote": "7yr/$50.75M through 2027-28; consistent 30-40 goal scorer; key complementary star"
          },
          {
            "player": "Josh Morrissey",
            "position": "D",
            "aav": 9,
            "contractNote": "8yr/$72M signed 2022, through 2029-30; All-Star defenseman; franchise defensive cornerstone"
          }
        ],
        "new": [
          {
            "player": "Kyle Connor",
            "position": "LW",
            "aav": 12,
            "contractNote": "8yr/$96M signed Oct 8, 2025, 2026-27 through 2033-34; full NMC"
          },
          {
            "player": "Mark Scheifele",
            "position": "C",
            "aav": 8.5,
            "contractNote": "7yr/$59.5M (2023), through 2030-31"
          },
          {
            "player": "Connor Hellebuyck",
            "position": "G",
            "aav": 8.5,
            "contractNote": "7yr/$59.5M (2023), through 2030-31; 2024 and 2025 Vezina"
          },
          {
            "player": "Josh Morrissey",
            "position": "D",
            "aav": 6.25,
            "contractNote": "8yr/$50M (2022), through 2027-28"
          }
        ],
        "fact": "Connor is now $12M; Morrissey's cap hit is $6.25M (not $9M); Scheifele is not captain (Adam Lowry is)",
        "source": "https://capwages.com/teams/winnipeg_jets ; https://en.wikipedia.org/wiki/Winnipeg_Jets"
      },
      {
        "field": "media.nationalShareNote",
        "old": "Canadian teams (including Jets) receive meaningful premium from Rogers Sportsnet 12yr/$5.2B national Canadian rights deal (through 2025-26); total Canadian national contribution estimated $40-60M/team/year vs ~$19M for US teams; new Canadian deal post-2026 under negotiation",
        "new": "~$19M/team/year from US national deals (ESPN/TNT through 2027-28). Canadian national rights: new 12-year Rogers deal worth C$11B (announced April 2, 2025) runs 2026-27 through 2037-38, nearly double the C$5.2B 2013 deal; the seven Canadian clubs share the national pool on top of their own regional rights; Amazon Prime Video sublicenses Wednesday Night Hockey and CBC's Hockey Night in Canada partnership ended after 2025-26.",
        "fact": "Rogers extended Canadian national NHL rights for 12 years (2026-27 to 2037-38) at C$11B, announced April 2, 2025; Prime Video keeps Wednesday nights and CBC dropped off after 2025-26",
        "source": "https://en.wikipedia.org/wiki/NHL_on_Sportsnet"
      }
    ],
    "analystNotes": "Forbes valued the Jets at $1.05B in December 2024 on $170M of revenue, 31st in the league, and the season that followed was the best in franchise history: a first Presidents' Trophy at 116 points in 2024-25 before a second-round loss to Dallas, followed by a 35-35-12 collapse and a 2026 miss. True North answered by paying Kyle Connor $12M a year through 2033-34 (signed October 8, 2025), locking Connor, Scheifele and Hellebuyck through at least 2030-31 in the NHL's smallest building. The C$11B Rogers national deal starting 2026-27 is the one revenue line that grows regardless of a 950,000-person metro, and it is what lifts this floor.",
    "unverifiedAsOf": {}
  },
  "anaheim-ducks": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 0,
        "new": 1,
        "fact": "Ducks qualified in 2026, beat Edmonton in six in the first round and lost to Vegas in six in the second round",
        "source": "https://en.wikipedia.org/wiki/2026_Stanley_Cup_playoffs ; https://en.wikipedia.org/wiki/Anaheim_Ducks"
      },
      {
        "field": "media.localTVDeal",
        "old": "KCAL (CBS/KCAL, LA); historically on Bally Sports SoCal (Diamond Sports Group, bankrupt 2023); transitioning to direct-to-consumer or new local deal post-RSN collapse",
        "new": "Amazon Prime Video holds Ducks regional streaming rights for 2026-27 with over-the-air games on KCOP (Fox 11 Plus) and KTTV (Fox 11), after FanDuel Sports Network West went dark April 30, 2026",
        "fact": "For 2026-27 the Ducks moved regional rights to Amazon Prime Video while keeping a broadcast package; Wikipedia infobox lists Prime Video, KCOP and KTTV",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_NHL_season ; https://en.wikipedia.org/wiki/Anaheim_Ducks ; https://en.wikipedia.org/wiki/FanDuel_Sports_Network"
      },
      {
        "field": "media.streamingNotes",
        "old": "ESPN+/Hulu NHL streaming; NHL.tv League Pass; impacted by Diamond Sports bankruptcy",
        "new": "Amazon Prime Video in-market streaming from 2026-27; ESPN+/Hulu and TNT/Max national",
        "fact": "Prime Video regional rights from 2026-27",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_NHL_season"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Trevor Zegras — entry-level deal expired; RFA 2023; Mason McTavish emerging as co-franchise core",
        "new": "Leo Carlsson, 5yr/$90M ($18M AAV) from 2026-27 after Anaheim matched Philadelphia's July 3, 2026 offer sheet; Cutter Gauthier $13.5M AAV; Mikael Granlund captain; Zegras (Philadelphia) and McTavish (St. Louis) have been traded",
        "fact": "Philadelphia tendered Carlsson a five-year, $90M offer sheet July 3, 2026; Carlsson appears on Anaheim's 2026-27 sheet at $18M",
        "source": "https://capwages.com/articles/leo-carlsson-offer-sheet-sign-and-trade ; https://capwages.com/teams/anaheim_ducks ; https://en.wikipedia.org/wiki/Anaheim_Ducks"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Mason McTavish",
            "position": "C",
            "aav": 6.625,
            "contractNote": "7yr/$46.375M signed 2024, through 2030-31; part of youth rebuild"
          },
          {
            "player": "Trevor Zegras",
            "position": "C/LW",
            "aav": 5.75,
            "contractNote": "3yr/$17.25M bridge deal signed 2023; UFA after 2025-26"
          }
        ],
        "new": [
          {
            "player": "Leo Carlsson",
            "position": "C",
            "aav": 18,
            "contractNote": "5yr/$90M matched offer sheet (July 2026), 2026-27 through 2030-31"
          },
          {
            "player": "Cutter Gauthier",
            "position": "LW",
            "aav": 13.5,
            "contractNote": "$13.5M AAV, six seasons remaining per CapWages; modified NTC"
          },
          {
            "player": "Jackson LaCombe",
            "position": "D",
            "aav": 9,
            "contractNote": "8yr/$72M (2025), through 2033-34; full NTC to 2031"
          },
          {
            "player": "Troy Terry",
            "position": "RW",
            "aav": 7,
            "contractNote": "7yr/$49M (2023), through 2029-30"
          }
        ],
        "fact": "CapWages 2026-27: Carlsson $18M, Gauthier $13.5M, LaCombe $9M, Terry $7M; McTavish and Zegras no longer on the roster",
        "source": "https://capwages.com/teams/anaheim_ducks"
      }
    ],
    "analystNotes": "Forbes valued the Ducks at $1.3B in December 2024 on $175M of revenue, the cheapest franchise in a top-two market, and 2025-26 was the first year the hockey caught up to the real estate: Anaheim made the playoffs, beat Edmonton in the first round and took Vegas to six games. The Samuelis then paid to keep the core, matching Philadelphia's five-year, $90M offer sheet for Leo Carlsson in July 2026 ($18M a year, the highest cap hit of any forward except Kaprizov) on top of Gauthier at $13.5M and LaCombe at $9M, while regional rights moved to Amazon Prime Video with Fox 11 over-the-air games. With the Honda Center renovation and OCVibe district behind a contender for the first time, a second straight playoff run is what turns $1.3B into an LA-market number.",
    "unverifiedAsOf": {
      "arena.newArenaPlans": "May 2026"
    }
  },
  "calgary-flames": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "arena.newArenaPlans",
        "old": "Scotia Place: new $1.2B total arena project; City of Calgary $537M + Province of Alberta $330M + CSEC $356M (29%); groundbreaking 2024; target opening 2026-27; 35-year commitment by CSEC to keep Flames in Calgary",
        "new": "Scotia Place: C$1.223B project; City of Calgary $537.3M upfront, Province of Alberta $330M over three years, CSEC $748.3M over 35 years (about $356M in 2024 dollars); groundbreaking July 22, 2024; opening before the 2027-28 season, so 2026-27 is the final Saddledome year; 18,400 hockey capacity with 52 suites; Scotiabank holds naming rights",
        "fact": "Scotia Place is planned to open prior to the 2027-28 NHL season; 2026-27 is the Flames' last season at the Saddledome",
        "source": "https://en.wikipedia.org/wiki/Scotia_Place ; https://en.wikipedia.org/wiki/2026%E2%80%9327_NHL_season ; https://en.wikipedia.org/wiki/Calgary_Flames"
      },
      {
        "field": "arena.ownershipModel",
        "old": "owned by Calgary Sports and Entertainment Corporation (CSEC); built in 1983 as Olympics venue; aging facility; to be replaced by Scotia Place (2026-27 target)",
        "new": "Scotiabank Saddledome, built 1983 for the 1988 Olympics, hosts its final Flames season in 2026-27; Scotia Place (City-owned, CSEC-operated under a 35-year agreement) opens for 2027-28",
        "fact": "Saddledome final season 2026-27; Scotia Place opens 2027-28",
        "source": "https://en.wikipedia.org/wiki/Scotia_Place ; https://en.wikipedia.org/wiki/2026%E2%80%9327_NHL_season"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 2,
        "new": 1,
        "fact": "Only the 2022 playoffs fall in the window; Calgary missed 2023 through 2026 (34-39-9, 77 points in 2025-26)",
        "source": "https://en.wikipedia.org/wiki/Calgary_Flames ; https://en.wikipedia.org/wiki/2026_Stanley_Cup_playoffs"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Nazem Kadri — 7yr/$49M ($7M AAV), signed July 2022, through 2028-29",
        "new": "Jonathan Huberdeau, 8yr/$84M ($10.5M AAV) through 2030-31, is the top cap hit; goalie Dustin Wolf at $7.5M AAV; Mikael Backlund captain; Nazem Kadri was traded to Colorado with Calgary retaining $1.4M",
        "fact": "CapWages 2026-27: Huberdeau $10.5M, Wolf $7.5M, Nemec $7.25M, Coronato $6.5M; Kadri appears in Calgary's retained salary and on Colorado's roster at $5.6M",
        "source": "https://capwages.com/teams/calgary_flames ; https://capwages.com/teams/colorado_avalanche ; https://en.wikipedia.org/wiki/Calgary_Flames"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Nazem Kadri",
            "position": "C",
            "aav": 7,
            "contractNote": "7yr/$49M signed July 2022, through 2028-29; Colorado Cup winner brought as leadership signing"
          },
          {
            "player": "Rasmus Andersson",
            "position": "D",
            "aav": 4.55,
            "contractNote": "7yr/$31.85M through 2027-28"
          },
          {
            "player": "Jonathan Huberdeau",
            "position": "LW",
            "aav": 10.5,
            "contractNote": "8yr/$84M signed 2022 (largest deal in Flames history); underperformed vs. contract so far"
          }
        ],
        "new": [
          {
            "player": "Jonathan Huberdeau",
            "position": "LW",
            "aav": 10.5,
            "contractNote": "8yr/$84M (2022), through 2030-31; full NMC"
          },
          {
            "player": "Dustin Wolf",
            "position": "G",
            "aav": 7.5,
            "contractNote": "$7.5M AAV, seven seasons remaining per CapWages"
          },
          {
            "player": "Simon Nemec",
            "position": "D",
            "aav": 7.25,
            "contractNote": "$7.25M AAV; acquired from New Jersey"
          },
          {
            "player": "Matt Coronato",
            "position": "RW",
            "aav": 6.5,
            "contractNote": "7yr/$45.5M (2025), through 2031-32"
          }
        ],
        "fact": "Kadri (Colorado) and Andersson (Vegas, $8.5M) are gone; Wolf, Nemec and Coronato are the new top cap hits",
        "source": "https://capwages.com/teams/calgary_flames ; https://capwages.com/teams/vegas_golden_knights"
      },
      {
        "field": "media.nationalShareNote",
        "old": "Canadian teams receive substantially higher national revenue via Rogers/Bell TV deal than the ~$19M US average; Rogers Canadian deal ~$5.2B over 12 years through 2025-26 (~$80M+/Canadian team/year estimated)",
        "new": "~$19M/team/year from US national deals (ESPN/TNT through 2027-28). Canadian national rights: new 12-year Rogers deal worth C$11B (announced April 2, 2025) runs 2026-27 through 2037-38, nearly double the C$5.2B 2013 deal; the seven Canadian clubs share the national pool on top of their own regional rights; Amazon Prime Video sublicenses Wednesday Night Hockey and CBC's Hockey Night in Canada partnership ended after 2025-26.",
        "fact": "Rogers extended Canadian national NHL rights for 12 years (2026-27 to 2037-38) at C$11B, announced April 2, 2025; Prime Video keeps Wednesday nights and CBC dropped off after 2025-26",
        "source": "https://en.wikipedia.org/wiki/NHL_on_Sportsnet"
      },
      {
        "field": "media.localTVDeal",
        "old": "Sportsnet (Rogers Media) regional broadcasts; Rogers holds national Canadian rights for the NHL through 2025-26",
        "new": "Sportsnet West (Rogers) regional broadcasts; Rogers' national Canadian rights renewed for 12 years from 2026-27 at C$11B",
        "fact": "Sportsnet West regional; national deal renewed through 2037-38",
        "source": "https://en.wikipedia.org/wiki/Calgary_Flames ; https://en.wikipedia.org/wiki/NHL_on_Sportsnet"
      },
      {
        "field": "ownership.institutionalInvestors",
        "old": "Minority stake sale explored in 2024 per reports; no deal announced",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source on a CSEC minority stake sale)",
        "source": null
      }
    ],
    "analystNotes": "Forbes valued the Flames at $1.65B in December 2024 on $191M of revenue and $37M of operating income, and the two largest inputs to the next print are now dated: Scotia Place, the C$1.223B arena with $867M of public money, opens for 2027-28 after a one-year slip, making 2026-27 the last season in the 1983 Saddledome, and the C$11B Rogers national deal starts paying in 2026-27. The roster has been the drag, with four straight playoff misses and 77 points in 2025-26, Kadri and Andersson traded away, and Huberdeau's $10.5M through 2030-31 still the top cap hit. The number moves on the first full season in Scotia Place with 18,400 seats and 52 suites, whatever the standings say.",
    "unverifiedAsOf": {}
  },
  "edmonton-oilers": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 4,
        "new": 5,
        "fact": "Playoffs every year 2022-2026; lost the 2025 Stanley Cup Final to Florida in six (second straight Final loss); lost the 2026 first round to Anaheim in six",
        "source": "https://en.wikipedia.org/wiki/2025_Stanley_Cup_playoffs ; https://en.wikipedia.org/wiki/2026_Stanley_Cup_playoffs ; https://en.wikipedia.org/wiki/Edmonton_Oilers"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Connor McDavid",
            "position": "C",
            "aav": 12.5,
            "contractNote": "2yr/$25M signed 2025; runs through 2027-28; below-market deal by McDavid's choice to enable team building; makes him UFA after 2027-28"
          },
          {
            "player": "Leon Draisaitl",
            "position": "C/LW",
            "aav": 14,
            "contractNote": "8yr/$112M signed 2023; through 2030-31; highest AAV in NHL at signing; German connection"
          },
          {
            "player": "Evan Bouchard",
            "position": "D",
            "aav": 7.5,
            "contractNote": "7yr/$52.5M signed 2024, through 2030-31"
          }
        ],
        "new": [
          {
            "player": "Leon Draisaitl",
            "position": "C/LW",
            "aav": 14,
            "contractNote": "8yr/$112M (2024), 2025-26 through 2032-33; NMC"
          },
          {
            "player": "Connor McDavid",
            "position": "C",
            "aav": 12.5,
            "contractNote": "2yr/$25M (2025), 2026-27 through 2027-28; full NMC; UFA July 2028"
          },
          {
            "player": "Evan Bouchard",
            "position": "D",
            "aav": 10.5,
            "contractNote": "4yr/$42M signed July 2025, through 2028-29"
          }
        ],
        "fact": "Bouchard's cap hit is $10.5M on a four-year deal signed in 2025; McDavid has two seasons left at $12.5M",
        "source": "https://capwages.com/teams/edmonton_oilers"
      },
      {
        "field": "media.nationalShareNote",
        "old": "Canadian teams receive substantially higher national revenue via Rogers/Bell TV deal; Rogers 12-year ~$5.2B Canadian NHL deal through 2025-26 (~$80M+/Canadian team/year estimated); Oilers among top-earning Canadian franchises given market and product quality",
        "new": "~$19M/team/year from US national deals (ESPN/TNT through 2027-28). Canadian national rights: new 12-year Rogers deal worth C$11B (announced April 2, 2025) runs 2026-27 through 2037-38, nearly double the C$5.2B 2013 deal; the seven Canadian clubs share the national pool on top of their own regional rights; Amazon Prime Video sublicenses Wednesday Night Hockey and CBC's Hockey Night in Canada partnership ended after 2025-26. Oilers remain among the top Canadian earners on regional Sportsnet rights.",
        "fact": "Rogers extended Canadian national NHL rights for 12 years (2026-27 to 2037-38) at C$11B, announced April 2, 2025; Prime Video keeps Wednesday nights and CBC dropped off after 2025-26",
        "source": "https://en.wikipedia.org/wiki/NHL_on_Sportsnet"
      }
    ],
    "analystNotes": "Forbes valued the Oilers at $2.65B in December 2024 on $388M of revenue and $213M of operating income, the highest profit in hockey, on the McDavid-Draisaitl core, Rogers Place and the ICE District; the on-ice story since is a second straight Stanley Cup Final loss to Florida in June 2025 and a first-round exit to Anaheim in 2026. The cap sheet is set: Draisaitl $14M through 2032-33, Bouchard $10.5M on a four-year deal, and McDavid's two-year, $25M bridge running 2026-27 and 2027-28. The C$11B Rogers deal adds to the revenue line from 2026-27, but the only number that matters for this valuation is McDavid's July 2028 decision.",
    "unverifiedAsOf": {}
  },
  "los-angeles-kings": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 2,
        "new": 5,
        "fact": "Playoffs every year 2022-2026; first-round losses to Edmonton in 2025 (2-4) and a sweep by Colorado in 2026",
        "source": "https://en.wikipedia.org/wiki/2025_Stanley_Cup_playoffs ; https://en.wikipedia.org/wiki/2026_Stanley_Cup_playoffs ; https://en.wikipedia.org/wiki/Los_Angeles_Kings"
      },
      {
        "field": "media.localTVDeal",
        "old": "Scripps Sports/KCAL (CBS, LA); previously Bally Sports West (Diamond Sports, bankrupt 2023); Kings signed direct broadcast deal with Scripps/KCAL in 2024 — among first NHL teams to exit RSN model post-Diamond collapse",
        "new": "Angels Broadcast Television (ABTV, the former FanDuel Sports Network West channel bought by the Angels in March 2026) carries Kings games from 2026-27, with a standalone DAZN streaming service; the 2024-25 Scripps/KCAL arrangement has ended",
        "fact": "FanDuel Sports Network West became Angels Broadcast Television in March 2026; Kings moved to ABTV plus DAZN for 2026-27",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_NHL_season ; https://en.wikipedia.org/wiki/FanDuel_Sports_Network ; data/forbes-proxies.js (verified) ; https://en.wikipedia.org/wiki/Los_Angeles_Kings"
      },
      {
        "field": "media.streamingNotes",
        "old": "ESPN+/Hulu NHL; Scripps/KCAL on connected TV; NHL.tv",
        "new": "Standalone DAZN streaming service for in-market Kings games from 2026-27; ESPN+/Hulu and TNT/Max national",
        "fact": "DAZN listed as the Kings' streaming outlet",
        "source": "https://en.wikipedia.org/wiki/Los_Angeles_Kings ; https://en.wikipedia.org/wiki/2026%E2%80%9327_NHL_season"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Anze Kopitar — 8yr/$80M ($10M AAV) signed 2016, nearing end; Quinton Byfield emerging as franchise heir",
        "new": "Anze Kopitar retired after 2025-26 (announced September 18, 2025; final game April 26, 2026; jersey retirement February 24, 2027); Drew Doughty named captain September 16, 2026 in the final year of his $11M deal; Adrian Kempe signed 8yr/$85M ($10.625M AAV) on November 17, 2025 through 2033-34",
        "fact": "Kopitar retirement dates and Kempe extension from Wikipedia; Doughty captaincy from the Kings page",
        "source": "https://en.wikipedia.org/wiki/An%C5%BEe_Kopitar ; https://en.wikipedia.org/wiki/Adrian_Kempe ; https://en.wikipedia.org/wiki/Los_Angeles_Kings"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Anze Kopitar",
            "position": "C",
            "aav": 10,
            "contractNote": "8yr/$80M through 2025-26; 18-year King, 2x Stanley Cup winner; winding down elite years"
          },
          {
            "player": "Drew Doughty",
            "position": "D",
            "aav": 11,
            "contractNote": "8yr/$88M through 2026-27; highest-paid King in history at signing; missed significant time to injury"
          },
          {
            "player": "Quinton Byfield",
            "position": "C",
            "aav": 8.15,
            "contractNote": "8yr/$65.2M signed 2023, through 2030-31; heir-apparent franchise center"
          }
        ],
        "new": [
          {
            "player": "Drew Doughty",
            "position": "D",
            "aav": 11,
            "contractNote": "8yr/$88M (2018), final season 2026-27; captain from Sept 16, 2026"
          },
          {
            "player": "Adrian Kempe",
            "position": "RW",
            "aav": 10.625,
            "contractNote": "8yr/$85M signed Nov 17, 2025, 2026-27 through 2033-34"
          },
          {
            "player": "Kevin Fiala",
            "position": "LW",
            "aav": 7.875,
            "contractNote": "7yr/$55.1M (2022), through 2028-29"
          },
          {
            "player": "Brandt Clarke",
            "position": "D",
            "aav": 7.4,
            "contractNote": "$7.4M AAV (2026 extension)"
          },
          {
            "player": "Quinton Byfield",
            "position": "C",
            "aav": 6.25,
            "contractNote": "5yr/$31.25M (2024), through 2028-29 (CapWages depth chart shows $6.3M rounded)"
          }
        ],
        "fact": "CapWages depth chart 2026-27: Doughty $11.0M, Kempe $10.6M, Fiala $7.9M, Clarke $7.4M, Byfield $6.3M; Kopitar absent (retired)",
        "source": "https://capwages.com/teams/los_angeles_kings/depth-charts ; https://en.wikipedia.org/wiki/Adrian_Kempe"
      }
    ],
    "analystNotes": "Forbes valued the Kings at $2.9B in December 2024, fourth in the NHL, on $344M of revenue and $143M of operating income, a number that belongs to AEG's Crypto.com Arena and its $700M naming deal more than to the roster. The Kopitar era ended with his retirement after the 2025-26 season and a fifth straight first-round exit (swept by Colorado), Doughty was named captain in September 2026 for the last year of his $11M contract, and Kempe became the new anchor at $10.625M through 2033-34. Local media landed at Angels Broadcast Television plus a DAZN stream for 2026-27 after FanDuel Sports Network West was sold in March 2026; the valuation lever is whether Peter Laviolette's group wins a round for the first time since 2014.",
    "unverifiedAsOf": {}
  },
  "san-jose-sharks": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Macklin Celebrini — #1 overall pick 2024 NHL Draft; entry-level contract $3.875M AAV; franchise cornerstone of rebuild",
        "new": "Macklin Celebrini, named captain before 2026-27, broke Joe Thornton's franchise single-season record with 115 points on April 16, 2026; entry-level contract ($975K cap hit, up to $3.5M in bonuses) runs through 2026-27 with an RFA extension due in 2027",
        "fact": "Celebrini passed Thornton's 114-point record on April 16, 2026 and was named captain for 2026-27; CapWages shows a $975K ELC cap hit",
        "source": "https://en.wikipedia.org/wiki/San_Jose_Sharks ; https://capwages.com/teams/san_jose_sharks"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Macklin Celebrini",
            "position": "C",
            "aav": 3.875,
            "contractNote": "#1 overall pick 2024; entry-level 3yr contract; franchise rebuild centerpiece"
          },
          {
            "player": "Tomas Hertl",
            "position": "C",
            "aav": 8,
            "contractNote": "8yr/$65.875M signed 2022, through 2029-30; veteran franchise player bridging rebuild"
          },
          {
            "player": "Nico Sturm",
            "position": "C",
            "aav": 3,
            "contractNote": "placeholder depth; Sharks in full rebuild mode"
          }
        ],
        "new": [
          {
            "player": "Darnell Nurse",
            "position": "D",
            "aav": 9.25,
            "contractNote": "8yr/$74M (2021), through 2029-30; acquired from Edmonton (Sharks 2026-27 sheet)"
          },
          {
            "player": "Logan Couture",
            "position": "C",
            "aav": 8,
            "contractNote": "8yr/$64M (2018), final season 2026-27"
          },
          {
            "player": "Mason Marchment",
            "position": "LW",
            "aav": 6.75,
            "contractNote": "$6.75M AAV, five seasons remaining per CapWages"
          },
          {
            "player": "Macklin Celebrini",
            "position": "C",
            "aav": 0.975,
            "contractNote": "3yr ELC (2024), $975K cap hit plus up to $3.5M bonuses, through 2026-27; captain"
          }
        ],
        "fact": "Hertl was traded to Vegas in 2024 (San Jose retains $1.39M); Nurse, Couture and Marchment are the top 2026-27 cap hits",
        "source": "https://capwages.com/teams/san_jose_sharks ; https://capwages.com/teams/vegas_golden_knights"
      }
    ],
    "analystNotes": "Forbes valued the Sharks at $1.35B in December 2024 on $169M of revenue and almost no operating income, a rebuild number in a 6.6M-person Bay Area market with the highest household income in the league. The rebuild now has a face: Macklin Celebrini put up 115 points in 2025-26 to break Joe Thornton's franchise record, was named captain at 20, and plays 2026-27 on a $975K entry-level cap hit before an RFA extension that will land in the Bedard-to-Carlsson range of $15M to $18M. NBC Sports California and the SAP Center management deal are stable, so the number moves on the first playoff berth since 2019, which a 39-35-8 team with Celebrini and Will Smith is close to.",
    "unverifiedAsOf": {}
  },
  "seattle-kraken": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.primaryOwner",
        "old": "David Bonderman (chairman) / Jerry Bruckheimer / Tod Leiweke (CEO)",
        "new": "Seattle Hockey Partners, led by Jerry Bruckheimer, Tod Leiweke (CEO) and Samantha Holloway (David Bonderman's daughter)",
        "fact": "Wikipedia lists the Kraken's ownership group as led by Bruckheimer, Leiweke and Holloway; Bonderman is no longer named as the lead",
        "source": "https://en.wikipedia.org/wiki/Seattle_Kraken"
      },
      {
        "field": "ownership.ownershipGroup",
        "old": [
          {
            "name": "David Bonderman",
            "role": "chairman / principal owner",
            "pct": null
          },
          {
            "name": "Jerry Bruckheimer",
            "role": "partner / minority owner",
            "pct": null
          },
          {
            "name": "Tod Leiweke",
            "role": "CEO / operating partner",
            "pct": null
          },
          {
            "name": "Samantha Holloway",
            "role": "partner (Bonderman's daughter)",
            "pct": null
          }
        ],
        "new": [
          {
            "name": "Samantha Holloway",
            "role": "co-owner and lead of Seattle Hockey Partners (Bonderman family)",
            "pct": null
          },
          {
            "name": "Jerry Bruckheimer",
            "role": "co-owner",
            "pct": null
          },
          {
            "name": "Tod Leiweke",
            "role": "CEO / co-owner",
            "pct": null
          },
          {
            "name": "Adrian Hanauer",
            "role": "minority owner (Sounders FC majority owner)",
            "pct": null
          },
          {
            "name": "Andy Jassy",
            "role": "minority owner (Amazon CEO)",
            "pct": null
          },
          {
            "name": "Tim Leiweke",
            "role": "minority owner (Oak View Group)",
            "pct": null
          },
          {
            "name": "Melinda French Gates",
            "role": "minority owner (joined 2026)",
            "pct": null
          },
          {
            "name": "Marshawn Lynch and Macklemore",
            "role": "minority owners (2022)",
            "pct": null
          }
        ],
        "fact": "Group members per Wikipedia: Hanauer, Jassy, Tim Leiweke, Lynch and Macklemore (2022), Melinda French Gates (2026)",
        "source": "https://en.wikipedia.org/wiki/Seattle_Kraken"
      },
      {
        "field": "arena.ownershipModel",
        "old": "Kraken acquired majority stake in Climate Pledge Arena in 2023; One Roof Sports & Entertainment LLC formed; arena is the world's first carbon-neutral arena per NHL; built on footprint of former KeyArena (1962 World's Fair venue) — historic roof preserved; privately financed renovation",
        "new": "Climate Pledge Arena is owned by the City of Seattle and was rebuilt privately by Oak View Group, which operates it under a long-term lease; the Kraken are the anchor tenant and do not own the arena; the 1962 KeyArena roof was preserved and the building is carbon-neutral certified",
        "fact": "Wikipedia: the arena is not owned by the Kraken; forbes-proxies teamOwned is false",
        "source": "https://en.wikipedia.org/wiki/Seattle_Kraken ; data/forbes-proxies.js (verified)"
      },
      {
        "field": "media.localTVDeal",
        "old": "ROOT Sports Northwest (AT&T SportsNet Northwest); ROOT survived Diamond Sports Group bankruptcy as separate RSN; Kraken's local TV situation more stable than many NHL counterparts",
        "new": "Kraken Hockey Network (KHN), over-the-air on KING-TV and KONG with Amazon Prime Video in-market streaming; ROOT Sports Northwest carried the team only for its first three seasons (2021-24)",
        "fact": "KHN over-the-air plus Prime Video since 2024-25; ROOT through 2023-24",
        "source": "https://en.wikipedia.org/wiki/Seattle_Kraken"
      },
      {
        "field": "media.streamingNotes",
        "old": "ESPN+/Hulu NHL; ROOT Sports+ streaming; Kraken direct digital content",
        "new": "Amazon Prime Video in-market streaming under KHN; ESPN+/Hulu and TNT/Max national",
        "fact": "Prime Video carries KHN games locally",
        "source": "https://en.wikipedia.org/wiki/Seattle_Kraken"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Matty Beniers — 2024 Calder Trophy winner (2021-22); entry-level through 2023-24; RFA extension in progress",
        "new": "Matty Beniers, 2023 Calder Trophy winner, 7yr/$50M ($7.14M AAV) through 2030-31; Jordan Eberle captain since October 2024",
        "fact": "Beniers $7,142,857 cap hit with five seasons left; Eberle captain",
        "source": "https://capwages.com/teams/seattle_kraken ; https://en.wikipedia.org/wiki/Seattle_Kraken"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Vince Dunn",
            "position": "D",
            "aav": 7.35,
            "contractNote": "5yr/$36.75M signed 2022, through 2026-27; defensive anchor"
          },
          {
            "player": "Matty Beniers",
            "position": "C",
            "aav": 7.1,
            "contractNote": "8yr/$56.8M signed 2023, through 2030-31; franchise center"
          },
          {
            "player": "Jared McCann",
            "position": "C/LW",
            "aav": 5,
            "contractNote": "5yr/$25M through 2026-27; offensive depth"
          }
        ],
        "new": [
          {
            "player": "Vince Dunn",
            "position": "D",
            "aav": 7.35,
            "contractNote": "4yr/$29.4M (2023), final season 2026-27"
          },
          {
            "player": "Matty Beniers",
            "position": "C",
            "aav": 7.143,
            "contractNote": "7yr/$50M (2024), through 2030-31; 12-team no-trade list from 2029-30"
          },
          {
            "player": "Brandon Montour",
            "position": "D",
            "aav": 7.143,
            "contractNote": "7yr/$50M (2024), through 2030-31"
          },
          {
            "player": "Chandler Stephenson",
            "position": "C",
            "aav": 6.25,
            "contractNote": "7yr/$43.75M (2024), through 2030-31; NMC"
          },
          {
            "player": "Jared McCann",
            "position": "LW",
            "aav": 5,
            "contractNote": "5yr/$25M (2022), final season 2026-27"
          }
        ],
        "fact": "CapWages 2026-27: Dunn $7.35M, Beniers and Montour $7.143M, Stephenson $6.25M, Grubauer $5.9M, McCann $5M",
        "source": "https://capwages.com/teams/seattle_kraken"
      }
    ],
    "analystNotes": "Forbes valued the Kraken at $1.6B in December 2024 on $194M of revenue, 2.5 times the $650M expansion fee in six years, and the ownership map has been redrawn: Seattle Hockey Partners is now led by Jerry Bruckheimer, Tod Leiweke and Samantha Holloway, with Melinda French Gates added as a minority owner in 2026 alongside Andy Jassy and Adrian Hanauer. Two structural corrections cut the other way: the Kraken do not own Climate Pledge Arena (the City of Seattle does, with Oak View Group operating), and local rights sit on the over-the-air Kraken Hockey Network with Prime Video streaming rather than an RSN check. Three playoff misses in four years is the drag; a second postseason for the Beniers, Montour and Stephenson group is what earns the next step up.",
    "unverifiedAsOf": {}
  },
  "vancouver-canucks": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 2,
        "new": 1,
        "fact": "Only the 2024 playoffs fall in the 2022-2026 window; Vancouver was not among the 2025 or 2026 qualifiers",
        "source": "https://en.wikipedia.org/wiki/2025_Stanley_Cup_playoffs ; https://en.wikipedia.org/wiki/2026_Stanley_Cup_playoffs"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Quinn Hughes — franchise defenseman; Elias Pettersson — 8yr/$92.8M ($11.6M AAV) signed 2024 extension, through 2031-32",
        "new": "Elias Pettersson, 8yr/$92.8M ($11.6M AAV) through 2031-32; Quinn Hughes was traded to Minnesota on December 12, 2025 for Marco Rossi, Zeev Buium, Liam Öhgren and a 2026 first-round pick; captaincy vacant",
        "fact": "Quinn Hughes trade December 12, 2025; Canucks captaincy listed as vacant",
        "source": "https://en.wikipedia.org/wiki/Quinn_Hughes ; https://en.wikipedia.org/wiki/Vancouver_Canucks"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Elias Pettersson",
            "position": "C",
            "aav": 11.6,
            "contractNote": "8yr/$92.8M extension signed 2024, through 2031-32; face of franchise"
          },
          {
            "player": "Quinn Hughes",
            "position": "D",
            "aav": 7.85,
            "contractNote": "6yr/$47.1M signed 2021, through 2026-27; Norris Trophy contender annually"
          },
          {
            "player": "J.T. Miller",
            "position": "C/LW",
            "aav": 8,
            "contractNote": "7yr/$56M signed 2022, through 2028-29"
          }
        ],
        "new": [
          {
            "player": "Elias Pettersson",
            "position": "C",
            "aav": 11.6,
            "contractNote": "8yr/$92.8M (2024), through 2031-32"
          },
          {
            "player": "Thatcher Demko",
            "position": "G",
            "aav": 8.5,
            "contractNote": "$8.5M AAV three-year extension (2025), through 2028-29"
          },
          {
            "player": "Brock Boeser",
            "position": "RW",
            "aav": 7.25,
            "contractNote": "7yr/$50.75M signed July 2025, through 2031-32"
          },
          {
            "player": "Filip Hronek",
            "position": "D",
            "aav": 7.25,
            "contractNote": "8yr/$58M (2024), through 2031-32"
          }
        ],
        "fact": "Hughes (Minnesota) and Miller (Rangers, January 2025) are gone; Demko, Boeser and Hronek follow Pettersson on the 2026-27 sheet",
        "source": "https://capwages.com/teams/vancouver_canucks ; https://en.wikipedia.org/wiki/Quinn_Hughes ; https://en.wikipedia.org/wiki/New_York_Rangers"
      },
      {
        "field": "media.nationalShareNote",
        "old": "Canadian teams receive substantially higher national revenue via Rogers/Bell TV deal than the ~$19M US average; Rogers 12-year Canadian NHL deal through 2025-26 (~$80M+/Canadian team/year estimated)",
        "new": "~$19M/team/year from US national deals (ESPN/TNT through 2027-28). Canadian national rights: new 12-year Rogers deal worth C$11B (announced April 2, 2025) runs 2026-27 through 2037-38, nearly double the C$5.2B 2013 deal; the seven Canadian clubs share the national pool on top of their own regional rights; Amazon Prime Video sublicenses Wednesday Night Hockey and CBC's Hockey Night in Canada partnership ended after 2025-26.",
        "fact": "Rogers extended Canadian national NHL rights for 12 years (2026-27 to 2037-38) at C$11B, announced April 2, 2025; Prime Video keeps Wednesday nights and CBC dropped off after 2025-26",
        "source": "https://en.wikipedia.org/wiki/NHL_on_Sportsnet"
      }
    ],
    "analystNotes": "Forbes valued the Canucks at $1.95B in December 2024 on $226M of revenue, a number that rests on the Aquilini family owning Rogers Arena outright with zero public money in one of Canada's three big hockey markets. The hockey side has been torn down since: J.T. Miller went to the Rangers in January 2025, Quinn Hughes was traded to Minnesota on December 12, 2025 for Rossi, Buium, Öhgren and a first, the captaincy is vacant, and Vancouver missed the playoffs in 2025 and 2026 with Pettersson's $11.6M through 2031-32 as the only marquee contract left. The C$11B Rogers national deal lifts the revenue floor from 2026-27 regardless; what moves the valuation is whether the Hughes return becomes a contender before Pettersson's deal turns into an anchor.",
    "unverifiedAsOf": {}
  },
  "vegas-golden-knights": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Jack Eichel — 8yr/$80M ($10M AAV) signed 2022, through 2029-30; franchise center acquired via trade from Buffalo",
        "new": "Jack Eichel signed an 8yr/$108M ($13.5M AAV) extension October 8, 2025 running 2026-27 through 2033-34; Mitch Marner, 8yr/$96M ($12M AAV), arrived by sign-and-trade from Toronto June 30, 2025 and scored the fastest hat trick in Cup Final history in Game 3 of the 2026 Final; Mark Stone captain",
        "fact": "Eichel extension October 8, 2025; Marner sign-and-trade June 30, 2025 for Nicolas Roy",
        "source": "https://en.wikipedia.org/wiki/Jack_Eichel ; https://en.wikipedia.org/wiki/Mitch_Marner ; https://capwages.com/teams/vegas_golden_knights"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Jack Eichel",
            "position": "C",
            "aav": 10,
            "contractNote": "8yr/$80M through 2029-30; franchise cornerstone; underwent artificial disc replacement surgery (first in NHL history) after departure from Buffalo"
          },
          {
            "player": "Alex Pietrangelo",
            "position": "D",
            "aav": 8.8,
            "contractNote": "7yr/$61.6M through 2026-27; Stanley Cup-winning captain; aging but still effective"
          },
          {
            "player": "William Karlsson",
            "position": "C",
            "aav": 5.9,
            "contractNote": "8yr/$47.25M through 2025-26; 2018 expansion hero ('Wild Bill')"
          }
        ],
        "new": [
          {
            "player": "Jack Eichel",
            "position": "C",
            "aav": 13.5,
            "contractNote": "8yr/$108M signed Oct 8, 2025, 2026-27 through 2033-34; full NMC"
          },
          {
            "player": "Mitch Marner",
            "position": "RW",
            "aav": 12,
            "contractNote": "8yr/$96M via sign-and-trade June 30, 2025, through 2032-33; full NMC"
          },
          {
            "player": "Alex Pietrangelo",
            "position": "D",
            "aav": 8.8,
            "contractNote": "7yr/$61.6M (2020), final season 2026-27; on season-ending LTIR"
          },
          {
            "player": "Rasmus Andersson",
            "position": "D",
            "aav": 8.5,
            "contractNote": "$8.5M AAV, seven seasons remaining per CapWages; acquired from Calgary; NTC to June 2031"
          },
          {
            "player": "Shea Theodore",
            "position": "D",
            "aav": 7.425,
            "contractNote": "7yr/$52M (2024), through 2031-32"
          },
          {
            "player": "Tomas Hertl",
            "position": "C",
            "aav": 6.75,
            "contractNote": "8yr/$65.875M (2022), through 2029-30; San Jose retains $1.39M"
          }
        ],
        "fact": "CapWages 2026-27: Eichel $13.5M, Marner $12M, Pietrangelo $8.8M (LTIR), Andersson $8.5M, Theodore $7.425M, Hertl $6.75M, Hill $6.25M, Karlsson $5.9M (final season)",
        "source": "https://capwages.com/teams/vegas_golden_knights"
      },
      {
        "field": "media.localTVDeal",
        "old": "Vegas 34 (KLAS, CBS affiliate); historically on AT&T SportsNet Rocky Mountain; transitioning post-RSN collapse to direct deals and streaming",
        "new": "KMCC (Vegas 34), a Scripps Sports station, is the flagship of the team-produced Golden Knights television network under a multi-year deal that began in 2023-24",
        "fact": "Wikipedia: KMCC (Scripps Sports division) multi-year deal from 2023-24 as flagship of the Golden Knights' network",
        "source": "https://en.wikipedia.org/wiki/Vegas_Golden_Knights"
      }
    ],
    "analystNotes": "Forbes valued the Golden Knights at $1.85B in December 2024 on $231M of revenue and $59M of operating income, and Foley has since bought the two most expensive pieces on the market: Mitch Marner by sign-and-trade from Toronto at $12M a year (June 30, 2025) and an eight-year, $108M extension for Eichel (October 8, 2025) that starts in 2026-27. The result was a fourth straight playoff year and a run to the 2026 Stanley Cup Final, lost to Carolina in six, with Marner posting 29 playoff points and the fastest hat trick in Final history. The Strip location and a Scripps over-the-air network keep the revenue base insulated; the number now rides on converting a $13.5M-plus-$12M core into a second Cup before Pietrangelo's LTIR year and Karlsson's final season come off the books.",
    "unverifiedAsOf": {}
  },
  "atlanta-united-fc": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.streamingNotes",
        "old": "All MLS matches available via Apple TV+ MLS Season Pass (10yr $2.5B deal 2023-2032)",
        "new": "All MLS matches on Apple TV; MLS Season Pass was folded into the base Apple TV subscription for 2026, and the Apple deal was amended in Nov 2025 to end after the 2028-29 season",
        "fact": "MLS and Apple scrapped the Season Pass add-on for 2026 and shortened the $2.5B deal to run through 2028-29 with higher payments",
        "source": "https://www.espn.com/soccer/story/_/id/46954801/mls-apple-tv-scrapping-season-pass-26-season-sources"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$8M/team/year from MLS-Apple deal (~$250M/yr ÷ 30 teams); plus selective Fox Sports Sunday games",
        "new": "Apple pays $200M for 2026 (~$6.7M/team), $107.5M for the Feb-May 2027 transition season and $275M for each of 2027-28 and 2028-29 (~$9.2M/team); plus Fox Sports linear package",
        "fact": "Revised Apple payment schedule under the Nov 2025 amendment, $50M more than the original terms over the same period",
        "source": "https://www.sportspro.com/news/mls-apple-tv-broadcast-deal-season-pass-contract-november-2025/"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Emmanuel Latte Lath — DP striker signed Feb 2025 from Middlesbrough for ~$22M club-record incoming transfer",
        "new": "Breel Embolo, Swiss DP striker signed Aug 23, 2026 from Rennes for a reported $18M, contract through 2029-30; Latte Lath loaned to Union Berlin",
        "fact": "Atlanta signed Embolo as a DP on Aug 23, 2026 for a reported $18M; Latte Lath is on loan at Union Berlin",
        "source": "https://www.atlutd.com/news/breel-embolo-designated-player-transfer-switzerland-august-2026"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Thiago Almada",
            "position": "AM",
            "aav": 1.5,
            "contractNote": "Young DP from 2022; transferred to Botafogo July 2024 for MLS-record $21M (up to $30M) — opened DP slot"
          },
          {
            "player": "Miguel Almirón",
            "position": "AM",
            "aav": 4,
            "contractNote": "Returned to Atlanta from Newcastle as DP for 2025; club legend reacquired"
          },
          {
            "player": "Brad Guzan",
            "position": "GK",
            "aav": 1.5,
            "contractNote": "Veteran USMNT keeper, franchise face since 2017"
          }
        ],
        "new": [
          {
            "player": "Breel Embolo",
            "position": "ST",
            "aav": null,
            "contractNote": "DP signed Aug 2026 from Rennes for reported $18M, through 2029-30; scored twice at the 2026 World Cup for Switzerland"
          },
          {
            "player": "Miguel Almirón",
            "position": "AM",
            "aav": 4,
            "contractNote": "Returned from Newcastle as DP for 2025; still a DP in 2026"
          },
          {
            "player": "Alexey Miranchuk",
            "position": "AM",
            "aav": null,
            "contractNote": "Russian DP; one of three DPs in 2026 alongside Embolo and Almirón"
          },
          {
            "player": "Emmanuel Latte Lath",
            "position": "ST",
            "aav": null,
            "contractNote": "Club-record ~$22M signing Feb 2025; on loan at Union Berlin for 2026-27"
          }
        ],
        "fact": "2026 DPs are Embolo, Almirón and Miranchuk; Latte Lath is on loan; Almada left in 2024",
        "source": "https://www.atlutd.com/news/starting-xi-roster-notes-brennan-embolo-new-york-city-fc-september-26-2026"
      },
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports South / Gray Television regional broadcasts; transitioning post-Diamond Sports collapse",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source on the post-Bally regional arrangement)",
        "source": null
      }
    ],
    "analystNotes": "Atlanta United carries a $1.0B Forbes 2025 mark on the strength of Mercedes-Benz Stadium and Arthur Blank's AMB platform, not on results: the club sits 27th of 30 in the 2026 table after finishing outside the 2025 playoffs. Ownership keeps writing checks anyway, paying a reported $18M for Breel Embolo in August 2026 on top of the $22M Latte Lath fee, while the amended Apple deal lifts the national payout to $275M a year from 2027-28. The number moves when attendance returns toward the 65,520 that filled the building for the 2025 opener against Montreal, which needs a playoff team.",
    "unverifiedAsOf": {
      "ownership.ownerNetWorth": "May 2026"
    }
  },
  "charlotte-fc": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.streamingNotes",
        "old": "All MLS matches available via Apple TV+ MLS Season Pass (10yr $2.5B deal 2023-2032)",
        "new": "All MLS matches on Apple TV; MLS Season Pass was folded into the base Apple TV subscription for 2026, and the Apple deal was amended in Nov 2025 to end after the 2028-29 season",
        "fact": "MLS and Apple scrapped the Season Pass add-on for 2026 and shortened the deal to run through 2028-29",
        "source": "https://www.espn.com/soccer/story/_/id/46954801/mls-apple-tv-scrapping-season-pass-26-season-sources"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$8M/team/year from MLS-Apple deal (~$250M/yr ÷ 30 teams); plus selective Fox Sports Sunday games",
        "new": "Apple pays $200M for 2026 (~$6.7M/team), $107.5M for the Feb-May 2027 transition season and $275M for each of 2027-28 and 2028-29 (~$9.2M/team); plus Fox Sports linear package",
        "fact": "Revised Apple payment schedule under the Nov 2025 amendment",
        "source": "https://www.sportspro.com/news/mls-apple-tv-broadcast-deal-season-pass-contract-november-2025/"
      },
      {
        "field": "stadium.ownershipModel",
        "old": "owned by Tepper Sports & Entertainment (privately by David Tepper); shared with Carolina Panthers (NFL); reduced lower-bowl-only configuration for MLS matches (~38K capped); $800M renovation 2024-27 with $650M public subsidy",
        "new": "owned by Tepper Sports & Entertainment (privately by David Tepper); shared with Carolina Panthers (NFL); reduced lower-bowl-only configuration for MLS matches (~38K capped); renovation expanded to $1.3B through 2030 with $650M from the City of Charlotte and TSE covering the rest plus overages; lease commitment keeps Panthers and Charlotte FC in the stadium through 2045",
        "fact": "TSE raised the renovation to more than $1.3B in July 2026, with the city's share fixed at $650M and completion in 2030",
        "source": "https://www.wcnc.com/article/sports/nfl/panthers/bank-of-america-stadium-renovations-updated-renderings-tepper-sports-investment/275-56ef1a11-aa30-45cb-bc7c-239b385e1c5a"
      },
      {
        "field": "stadium.privateFinancing",
        "old": 688,
        "new": 650,
        "fact": "TSE covers the balance of the $1.3B project beyond the city's $650M, so private financing is at least $650M plus overages",
        "source": "https://www.wcnc.com/article/sports/nfl/panthers/bank-of-america-stadium-renovations-updated-renderings-tepper-sports-investment/275-56ef1a11-aa30-45cb-bc7c-239b385e1c5a"
      },
      {
        "field": "stadium.namingRightsDeal",
        "old": {
          "sponsor": "Bank of America",
          "annualValue_M": 7,
          "totalValue_M": 140,
          "expiryYear": 2034,
          "notes": "Original 20-year deal signed 2004 (~$140M); inherited by Charlotte FC as co-tenant"
        },
        "new": {
          "sponsor": "Bank of America",
          "annualValue_M": null,
          "totalValue_M": null,
          "expiryYear": null,
          "notes": "Long-term extension announced July 23, 2026 alongside the $1.3B renovation; terms not disclosed. Original 20-year, $140M deal signed 2004"
        },
        "fact": "Bank of America and the Panthers extended the naming rights on July 23, 2026 without releasing terms",
        "source": "https://www.panthers.com/news/bank-of-america-and-carolina-panthers-extend-naming-rights-for-bank-of-america-stadium-reinforcing-long-term-commitment-to-charlotte-and-the-carolinas"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "$800M renovation underway through 2027; no plans for soccer-specific stadium given dual-use synergies with Panthers",
        "new": "$1.3B renovation underway: back-of-house work began 2026, fan-facing phases 2027-2030; no plans for a soccer-specific stadium",
        "fact": "Fan-facing renovation work starts in 2027 with completion scheduled for 2030",
        "source": "https://www.axios.com/local/charlotte/2026/07/23/bank-of-america-stadium-renovation-renderings"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 1,
        "new": 3,
        "fact": "Charlotte qualified in 2023, 2024 and 2025 (4th seed East in 2025 with 59 points); window is 2021-2025",
        "source": "https://en.wikipedia.org/wiki/2025_MLS_Cup_playoffs"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Pep Biel — DP signed January 2024 as creative midfielder; key playmaker post-Świderski",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source checked)",
        "source": null
      },
      {
        "field": "media.localTVDeal",
        "old": "WCNC / Telemundo Charlotte regional broadcasts",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source)",
        "source": null
      }
    ],
    "analystNotes": "Charlotte FC's $780M Forbes 2025 value is a Bank of America Stadium story: Tepper Sports lifted the renovation to $1.3B in July 2026 with the city capped at $650M, extended the Bank of America naming rights, and locked both tenants in through 2045. The club has now made three straight playoffs, finishing fourth in the East with 59 points in 2025, and sits ninth in the 2026 table. The gap to the $1B tier closes only if the renovated bowl converts the NFL-sized market into MLS-specific premium revenue rather than borrowed Panthers infrastructure.",
    "unverifiedAsOf": {}
  },
  "chicago-fire-fc": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.streamingNotes",
        "old": "All MLS matches available via Apple TV+ MLS Season Pass (10yr $2.5B deal 2023-2032)",
        "new": "All MLS matches on Apple TV; MLS Season Pass was folded into the base Apple TV subscription for 2026, and the Apple deal was amended in Nov 2025 to end after the 2028-29 season",
        "fact": "MLS and Apple scrapped the Season Pass add-on for 2026 and shortened the deal to run through 2028-29",
        "source": "https://www.espn.com/soccer/story/_/id/46954801/mls-apple-tv-scrapping-season-pass-26-season-sources"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$8M/team/year from MLS-Apple deal (~$250M/yr ÷ 30 teams); plus selective Fox Sports Sunday games",
        "new": "Apple pays $200M for 2026 (~$6.7M/team), $107.5M for the Feb-May 2027 transition season and $275M for each of 2027-28 and 2028-29 (~$9.2M/team); plus Fox Sports linear package",
        "fact": "Revised Apple payment schedule under the Nov 2025 amendment",
        "source": "https://www.sportspro.com/news/mls-apple-tv-broadcast-deal-season-pass-contract-november-2025/"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "Mansueto unveiled June 2025 plans for $650-750M, 22,000-seat soccer-specific stadium at 'The 78' development site in South Loop in partnership with Related Midwest; targeted opening late 2020s",
        "new": "McDonald's Park: $750M privately funded 22,000-seat stadium at The 78 in the South Loop; groundbreaking March 3, 2026; opening targeted for the 2028 MLS season; McDonald's naming rights announced May 13, 2026",
        "fact": "Construction began March 3, 2026 with no taxpayer money; McDonald's naming rights announced May 13, 2026; opening ahead of the 2028 season",
        "source": "https://news.wttw.com/2026/03/03/chicago-fire-break-ground-new-750m-stadium-site-amid-gentrification-concerns"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 0,
        "new": 1,
        "fact": "Chicago qualified as the 8th seed in the East in 2025 and won its wild card 3-1 over Orlando; window is 2021-2025",
        "source": "https://en.wikipedia.org/wiki/2025_MLS_Cup_playoffs"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Hugo Cuypers — DP striker signed Feb 2024 from KAA Gent for club-record $12M+$2M; team top scorer 2024 with 10 goals; contract through 2026 + 2027 option",
        "new": "Robert Lewandowski, DP striker signed June 29, 2026 as a free agent from Barcelona, contract through the 2027-28 season; six goals in his first seven league starts",
        "fact": "Chicago signed Lewandowski on June 29, 2026 through 2027-28 as a Designated Player",
        "source": "https://www.mlssoccer.com/news/chicago-fire-sign-iconic-striker-robert-lewandowski"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Hugo Cuypers",
            "position": "ST",
            "aav": 3.5,
            "contractNote": "Designated Player Feb 2024; club-record $12M+$2M transfer fee; 2025 guaranteed $3.53M"
          },
          {
            "player": "Jonathan Bamba",
            "position": "LW",
            "aav": 4,
            "contractNote": "DP signed July 2024 from Celta Vigo on free transfer"
          },
          {
            "player": "Brian Gutiérrez",
            "position": "AM",
            "aav": 0.6,
            "contractNote": "Homegrown midfielder; USMNT call-up; building block"
          }
        ],
        "new": [
          {
            "player": "Robert Lewandowski",
            "position": "ST",
            "aav": null,
            "contractNote": "DP signed June 2026 on a free transfer from Barcelona through 2027-28; drew a club-record 63,094 to Soldier Field vs Inter Miami on Sept 9, 2026"
          },
          {
            "player": "Hugo Cuypers",
            "position": "ST",
            "aav": 3.5,
            "contractNote": "Designated Player Feb 2024; club-record $12M+$2M transfer fee; 2025 guaranteed $3.53M"
          },
          {
            "player": "Jonathan Bamba",
            "position": "LW",
            "aav": 4,
            "contractNote": "DP signed July 2024 from Celta Vigo on free transfer"
          },
          {
            "player": "Brian Gutiérrez",
            "position": "AM",
            "aav": 0.6,
            "contractNote": "Homegrown midfielder; USMNT call-up; building block"
          }
        ],
        "fact": "Lewandowski added as the headline DP in June 2026",
        "source": "https://www.mlssoccer.com/news/chicago-fire-fc-set-club-attendance-record-vs-inter-miami-cf"
      },
      {
        "field": "media.localTVDeal",
        "old": "WGN-TV / NBC Sports Chicago regional broadcasts; transitioning post-Diamond Sports collapse",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source)",
        "source": null
      }
    ],
    "analystNotes": "Chicago Fire's $720M Forbes 2025 mark is priced on Soldier Field tenancy, and the catalyst is now in the ground: Mansueto broke ground on the $750M, 22,000-seat McDonald's Park on March 3, 2026, fully private, opening for 2028. Robert Lewandowski's June 2026 arrival has done the marketing work early, with a club-record 63,094 at Soldier Field against Inter Miami in September and the Fire in tenth place after the 2025 playoff return. The number rerates when the club moves from renting Soldier Field dates to owning every dollar of a South Loop building.",
    "unverifiedAsOf": {}
  },
  "fc-cincinnati": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.streamingNotes",
        "old": "All MLS matches available via Apple TV+ MLS Season Pass (10yr $2.5B deal 2023-2032)",
        "new": "All MLS matches on Apple TV; MLS Season Pass was folded into the base Apple TV subscription for 2026, and the Apple deal was amended in Nov 2025 to end after the 2028-29 season",
        "fact": "MLS and Apple scrapped the Season Pass add-on for 2026 and shortened the deal to run through 2028-29",
        "source": "https://www.espn.com/soccer/story/_/id/46954801/mls-apple-tv-scrapping-season-pass-26-season-sources"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$8M/team/year from MLS-Apple deal (~$250M/yr ÷ 30 teams); plus selective Fox Sports Sunday games",
        "new": "Apple pays $200M for 2026 (~$6.7M/team), $107.5M for the Feb-May 2027 transition season and $275M for each of 2027-28 and 2028-29 (~$9.2M/team); plus Fox Sports linear package",
        "fact": "Revised Apple payment schedule under the Nov 2025 amendment",
        "source": "https://www.sportspro.com/news/mls-apple-tv-broadcast-deal-season-pass-contract-november-2025/"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 3,
        "new": 4,
        "fact": "Cincinnati qualified in 2022, 2023, 2024 and 2025 (2nd seed East with 65 points in 2025); window is 2021-2025",
        "source": "https://en.wikipedia.org/wiki/2025_MLS_Cup_playoffs"
      },
      {
        "field": "media.localTVDeal",
        "old": "WSTR/CW Cincinnati regional broadcasts",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source)",
        "source": null
      }
    ],
    "analystNotes": "FC Cincinnati's $780M Forbes 2025 value rests on TQL Stadium sellouts and a player-trading engine that turned the $150M expansion fee into a top-half MLS asset. The 2025 season delivered 65 points and the second seed in the East, a fourth straight playoff berth, before a 2026 slide to 19th with Evander injured early. Sustaining the mark depends on the Denkey and Evander outlay producing a deep playoff run, because the West End building is already at capacity and the Apple payout only steps up to $275M a year in 2027-28.",
    "unverifiedAsOf": {}
  },
  "columbus-crew-sc": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.streamingNotes",
        "old": "All MLS matches available via Apple TV+ MLS Season Pass (10yr $2.5B deal 2023-2032)",
        "new": "All MLS matches on Apple TV; MLS Season Pass was folded into the base Apple TV subscription for 2026, and the Apple deal was amended in Nov 2025 to end after the 2028-29 season",
        "fact": "MLS and Apple scrapped the Season Pass add-on for 2026 and shortened the deal to run through 2028-29",
        "source": "https://www.espn.com/soccer/story/_/id/46954801/mls-apple-tv-scrapping-season-pass-26-season-sources"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$8M/team/year from MLS-Apple deal (~$250M/yr ÷ 30 teams); plus selective Fox Sports Sunday games",
        "new": "Apple pays $200M for 2026 (~$6.7M/team), $107.5M for the Feb-May 2027 transition season and $275M for each of 2027-28 and 2028-29 (~$9.2M/team); plus Fox Sports linear package",
        "fact": "Revised Apple payment schedule under the Nov 2025 amendment",
        "source": "https://www.sportspro.com/news/mls-apple-tv-broadcast-deal-season-pass-contract-november-2025/"
      },
      {
        "field": "stadium.name",
        "old": "Lower.com Field",
        "new": "ScottsMiracle-Gro Field",
        "fact": "Lower.com let its naming rights expire; the stadium was renamed ScottsMiracle-Gro Field on Nov 25, 2025",
        "source": "https://www.nbc4i.com/sports/mls/columbus-crew-stadium-lower-com-field-to-get-new-name-for-2026/"
      },
      {
        "field": "stadium.namingRightsDeal",
        "old": {
          "sponsor": "Lower.com (mortgage tech)",
          "annualValue_M": null,
          "totalValue_M": null,
          "expiryYear": 2031,
          "notes": "10-year naming rights signed 2021; financial terms undisclosed but estimated $50-80M total"
        },
        "new": {
          "sponsor": "Scotts Miracle-Gro",
          "annualValue_M": null,
          "totalValue_M": null,
          "expiryYear": null,
          "notes": "Naming rights moved to Columbus-area Scotts Miracle-Gro from the 2026 season after Lower.com allowed its 2021 deal to lapse; terms undisclosed"
        },
        "fact": "Scotts Miracle-Gro holds the naming rights from 2026",
        "source": "https://en.wikipedia.org/wiki/ScottsMiracle-Gro_Field"
      },
      {
        "field": "ownership.primaryOwner",
        "old": "Haslam Sports Group (Jimmy and Dee Haslam) — 70% / Edwards family — 30%",
        "new": "Haslam Sports Group (Jimmy and Dee Haslam), 40% control owner / Nationwide Mutual Insurance, 37% / Edwards family, 23%",
        "fact": "Nationwide bought 37% (30% from Haslam, 7% from Edwards) at a $900M mark, announced May 29, 2026 and approved June 25, 2026; Haslams remain control owners at 40%",
        "source": "https://www.sportico.com/business/team-sales/2026/mls-columbus-crew-nationwide-stake-sale-1234901712/"
      },
      {
        "field": "ownership.ownershipGroup",
        "old": [
          {
            "name": "Haslam Sports Group",
            "role": "majority owner",
            "pct": 70
          },
          {
            "name": "Edwards family",
            "role": "minority partner",
            "pct": 30
          }
        ],
        "new": [
          {
            "name": "Haslam Sports Group",
            "role": "control owner",
            "pct": 40
          },
          {
            "name": "Nationwide Mutual Insurance",
            "role": "minority owner (June 2026); also jersey sponsor",
            "pct": 37
          },
          {
            "name": "Edwards family",
            "role": "minority partner",
            "pct": 23
          }
        ],
        "fact": "Per data/transactions.js: Nationwide 37% at $900M implied; Haslams 40%; Edwards family reduced from 30% to 23%",
        "source": "https://news.nationwide.com/nationwide-joins-columbus-crew-ownership-group/"
      },
      {
        "field": "ownership.institutionalInvestors",
        "old": "Privately held by Haslam and Edwards family offices",
        "new": "Nationwide Mutual Insurance holds a 37% minority stake (2026); balance held by Haslam and Edwards family offices",
        "fact": "Nationwide joined the ownership group in June 2026",
        "source": "https://news.nationwide.com/nationwide-joins-columbus-crew-ownership-group/"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 4,
        "new": 3,
        "fact": "Columbus qualified in 2023, 2024 and 2025 (7th seed East in 2025) and missed 2021 and 2022; window is 2021-2025",
        "source": "https://en.wikipedia.org/wiki/2025_MLS_Cup_playoffs"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Diego Rossi — DP forward; led 2024 with high goal/assist totals after Cucho Hernández departure",
        "new": "Santiago Rodríguez, Uruguayan DP playmaker acquired from Botafogo on Sept 2, 2026 (formerly NYCFC)",
        "fact": "Columbus acquired Santiago Rodríguez as a Designated Player from Botafogo on Sept 2, 2026",
        "source": "https://www.hudsonriverblue.com/nycfc-transfer-tracker-rodriguez/"
      },
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports Ohio successor (Sinclair regional sports network)",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source)",
        "source": null
      }
    ],
    "analystNotes": "Columbus Crew's $900M mark, set twice in twelve months by the Edwards family's July 2025 buy-in and Nationwide's 37% purchase approved June 25, 2026, clears the $780M Forbes 2025 value by 15% for a club that paid $150M in 2018. The Haslams keep control at 40% while Nationwide, already the jersey sponsor, becomes a corporate co-owner, and Scotts Miracle-Gro took over the stadium name for 2026. The 2026 season is the problem, 28th of 30 with Santiago Rodríguez brought in as a September DP, and the next number depends on whether a small-market club can hold a $900M comp without a playoff team.",
    "unverifiedAsOf": {}
  },
  "d-c-united": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.streamingNotes",
        "old": "All MLS matches available via Apple TV+ MLS Season Pass (10yr $2.5B deal 2023-2032)",
        "new": "All MLS matches on Apple TV; MLS Season Pass was folded into the base Apple TV subscription for 2026, and the Apple deal was amended in Nov 2025 to end after the 2028-29 season",
        "fact": "MLS and Apple scrapped the Season Pass add-on for 2026 and shortened the deal to run through 2028-29",
        "source": "https://www.espn.com/soccer/story/_/id/46954801/mls-apple-tv-scrapping-season-pass-26-season-sources"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$8M/team/year from MLS-Apple deal (~$250M/yr ÷ 30 teams); plus selective Fox Sports Sunday games",
        "new": "Apple pays $200M for 2026 (~$6.7M/team), $107.5M for the Feb-May 2027 transition season and $275M for each of 2027-28 and 2028-29 (~$9.2M/team); plus Fox Sports linear package",
        "fact": "Revised Apple payment schedule under the Nov 2025 amendment",
        "source": "https://www.sportspro.com/news/mls-apple-tv-broadcast-deal-season-pass-contract-november-2025/"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "Feb 2025: announced Audi Field expansion plans + roof addition; capacity expansion under study",
        "new": "Audi Field roof and seating expansion proposed under the Soccer Stadium Redevelopment and Maintenance Act of 2026, seeking $300M in District funding (double the original stadium commitment); D.C. Council hearing held 2026, not yet approved",
        "fact": "Levien's roof-and-seating proposal seeks $300M from the District and went to a Council Committee of the Whole hearing in 2026",
        "source": "https://www.foxessellfaster.com/blog/dc-united-wants-a-roof-on-audi-field-but-can-the-district-afford-another-billion-dollar-sports-project/"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Christian Benteke — DP striker, 2024 MLS Golden Boot; declined 2026 option, free agent in 2025-26 cycle",
        "new": "Louis Munteanu, Romanian DP striker signed Jan 2026 from CFR Cluj for a club-record initial ~$7M (EUR 6M), contract through 2028-29 with a 2029-30 option",
        "fact": "D.C. signed Munteanu as a DP in January 2026 for a club-record fee after declining Benteke's option",
        "source": "https://www.mlssoccer.com/news/dc-united-sign-romanian-forward-louis-munteanu-in-club-record-deal"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Christian Benteke",
            "position": "ST",
            "aav": 4.5,
            "contractNote": "DP from Crystal Palace Aug 2022; 2024 MLS Golden Boot; 47G/10A in 93 league matches; option declined for 2026"
          },
          {
            "player": "Mateusz Klich",
            "position": "AM",
            "aav": 1.8,
            "contractNote": "DP from Leeds United Jan 2023; veteran Polish playmaker"
          }
        ],
        "new": [
          {
            "player": "Louis Munteanu",
            "position": "ST",
            "aav": null,
            "contractNote": "DP from CFR Cluj Jan 2026; club-record initial ~$7M fee; through 2028-29 plus option"
          },
          {
            "player": "Christian Benteke",
            "position": "ST",
            "aav": 4.5,
            "contractNote": "DP 2022-2025; 2024 MLS Golden Boot; 2026 option declined, departed"
          },
          {
            "player": "Mateusz Klich",
            "position": "AM",
            "aav": 1.8,
            "contractNote": "DP from Leeds United Jan 2023; veteran Polish playmaker"
          }
        ],
        "fact": "Munteanu replaces Benteke as the headline forward",
        "source": "https://www.dcunited.com/news/d-c-united-signs-romanian-international-louis-munteanu-from-cfr-cluj-as-a-designated-player"
      },
      {
        "field": "media.localTVDeal",
        "old": "Monumental Sports Network (MSN) regional broadcasts; Monumental owned by Ted Leonsis but DC United is independent",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source)",
        "source": null
      }
    ],
    "analystNotes": "D.C. United's $740M Forbes 2025 value is a legacy-brand-plus-owned-stadium number carried by Audi Field, not by the team, which has missed the playoffs every year since 2019 and sits 24th in the 2026 table. Levien's answer is a roof and seating expansion that asks the District for $300M under a 2026 Council bill, pitched around the winter-heavy calendar MLS adopts in 2027, alongside a club-record ~$7M for Romanian striker Louis Munteanu. The number moves on the Council vote: a subsidized all-weather Audi Field is the one lever that changes the club's economics without a winning roster.",
    "unverifiedAsOf": {}
  },
  "inter-miami-cf": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.streamingNotes",
        "old": "All MLS matches available via Apple TV+ MLS Season Pass (10yr $2.5B deal 2023-2032); Inter Miami matches drove ~50% of MLS Season Pass subscriber growth post-Messi",
        "new": "All MLS matches on Apple TV; MLS Season Pass was folded into the base Apple TV subscription for 2026, and the Apple deal was amended in Nov 2025 to end after the 2028-29 season; Inter Miami matches drove the bulk of Season Pass growth post-Messi",
        "fact": "MLS and Apple scrapped the Season Pass add-on for 2026 and shortened the deal to run through 2028-29",
        "source": "https://www.espn.com/soccer/story/_/id/46954801/mls-apple-tv-scrapping-season-pass-26-season-sources"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$8M/team/year from MLS-Apple deal (~$250M/yr ÷ 30 teams); plus selective Fox Sports Sunday games; Inter Miami matches command premium Apple TV traffic",
        "new": "Apple pays $200M for 2026 (~$6.7M/team), $107.5M for the Feb-May 2027 transition season and $275M for each of 2027-28 and 2028-29 (~$9.2M/team); plus Fox Sports linear package; Inter Miami matches command premium Apple TV traffic",
        "fact": "Revised Apple payment schedule under the Nov 2025 amendment",
        "source": "https://www.sportspro.com/news/mls-apple-tv-broadcast-deal-season-pass-contract-november-2025/"
      },
      {
        "field": "stadium.name",
        "old": "Chase Stadium (formerly DRV PNK Stadium)",
        "new": "Nu Stadium (Miami Freedom Park)",
        "fact": "Nu Stadium opened April 4, 2026 with a 2-2 draw vs Austin FC before 26,412",
        "source": "https://en.wikipedia.org/wiki/Nu_Stadium"
      },
      {
        "field": "stadium.yearBuilt",
        "old": 2020,
        "new": 2026,
        "fact": "Opened April 4, 2026",
        "source": "https://en.wikipedia.org/wiki/Nu_Stadium"
      },
      {
        "field": "stadium.capacity",
        "old": 21500,
        "new": 26700,
        "fact": "26,700 capacity; sold to capacity for Peru vs Haiti on June 5, 2026",
        "source": "https://en.wikipedia.org/wiki/Nu_Stadium"
      },
      {
        "field": "stadium.ownershipModel",
        "old": "owned by Inter Miami CF / Mas Group; built on former Lockhart Stadium site in Fort Lauderdale; team operates and controls all economics; transitional venue until Miami Freedom Park (Nu Stadium) opens 2026",
        "new": "privately built and operated by Inter Miami CF (Mas family, Beckham, Ares Management partnership) on City of Miami land at the former Melreese golf course under a long-term lease; anchor of the 131-acre, ~$1B Miami Freedom Park development with hotel, retail, office and a 58-acre public park; team controls all venue economics",
        "fact": "Stadium anchors the $1B Miami Freedom Park development on city-leased land; team is owner-operator",
        "source": "https://www.mlssoccer.com/news/inter-miami-stadium-miami-freedom-park-to-open-in-2026"
      },
      {
        "field": "stadium.privateFinancing",
        "old": 70,
        "new": 350,
        "fact": "Stadium construction cost reported at ~$350M within the ~$1B development; a $450M construction loan led by J.P. Morgan financed the build",
        "source": "https://www.brgintl.com/inter-miamis-new-stadium-scores-450m-loan-biggest-in-south-florida-this-year/"
      },
      {
        "field": "stadium.namingRightsDeal",
        "old": {
          "sponsor": "JPMorgan Chase",
          "annualValue_M": 3,
          "totalValue_M": 18,
          "expiryYear": 2026,
          "notes": "Transitional naming rights through Chase Stadium; replaces DRV PNK; ends when Nu Stadium opens 2026"
        },
        "new": {
          "sponsor": "Nu (Nubank)",
          "annualValue_M": 19,
          "totalValue_M": 190,
          "expiryYear": 2035,
          "notes": "Announced March 3, 2026; reported 10-year deal at ~$19M/yr (~$190M), one of the largest naming deals in MLS; club did not disclose terms; Nu also takes back-of-jersey branding from Aug 2026"
        },
        "fact": "Nubank naming rights announced March 3, 2026; ~$19M/yr over 10 years per reports",
        "source": "https://www.sportico.com/business/sponsorship/2026/nu-bank-inter-miami-mls-stadium-naming-rights-1234886243/"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "Miami Freedom Park ('Nu Stadium' per March 2026 Bloomberg announcement) — 25,000-seat privately financed $1B+ stadium near Miami International Airport; J.P. Morgan provided $650M financing package including $450M senior construction loan; opens 2026; Brazilian fintech Nu (Nubank) naming rights",
        "new": "Nu Stadium opened April 4, 2026; remaining Miami Freedom Park phases (retail from April 2026, civic center from July 2026, hotel and office) continue through the late 2020s",
        "fact": "Retail construction started April 2026 and the civic center in July 2026",
        "source": "https://therealdeal.com/miami/2026/07/16/miami-civic-center-construction-starts-at-miami-freedom-park/"
      },
      {
        "field": "onField.championshipsLast10Years",
        "old": 0,
        "new": 1,
        "fact": "Inter Miami won MLS Cup 2025, beating Vancouver 3-1 at Chase Stadium on Dec 6, 2025; Messi was MLS Cup MVP",
        "source": "https://www.mlssoccer.com/news/inter-miami-cf-win-2025-mls-cup-presented-by-audi"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 2,
        "new": 3,
        "fact": "Qualified in 2022, 2024 and 2025; window is 2021-2025",
        "source": "https://en.wikipedia.org/wiki/2025_MLS_Cup_playoffs"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Lionel Messi — DP since July 2023; signed 3-year contract extension Oct 2025 through 2028; total package ~$150M including club equity at retirement",
        "new": "Lionel Messi, DP since July 2023; extended Oct 2025 through 2028; 2026 base salary $25M and cap hit $28.3M, more than double any other MLS player; MLS Cup 2025 MVP",
        "fact": "2026 MLSPA salary release shows Messi at $25M base and $28.33M guaranteed",
        "source": "https://www.spotrac.com/mls/player/contracts/_/id/84437/lionel-messi"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Lionel Messi",
            "position": "RW/CAM",
            "aav": 20.5,
            "contractNote": "Originally July 2023 free transfer; extended Oct 2025 through 2028 — covers Nu Stadium opening; $20.4M guaranteed compensation 2024; Apple/Adidas equity components; equity in Inter Miami at retirement"
          },
          {
            "player": "Sergio Busquets",
            "position": "DM",
            "aav": 8.8,
            "contractNote": "DP signed 2023 alongside Messi; contract through 2025; veteran Spanish midfielder"
          },
          {
            "player": "Luis Suárez",
            "position": "ST",
            "aav": 1.5,
            "contractNote": "Signed Dec 2023 below DP threshold via TAM; rejoined Messi from Gremio; contract structured to preserve DP slot"
          },
          {
            "player": "Jordi Alba",
            "position": "LB",
            "aav": 6,
            "contractNote": "Signed July 2023 alongside Messi; not a DP slot — paid via TAM; contract through 2025"
          }
        ],
        "new": [
          {
            "player": "Lionel Messi",
            "position": "RW/CAM",
            "aav": 28.3,
            "contractNote": "Extended Oct 2025 through 2028; 2026 base $25M, guaranteed $28.33M; Apple/Adidas equity components; equity in Inter Miami at retirement"
          },
          {
            "player": "Rodrigo De Paul",
            "position": "CM",
            "aav": null,
            "contractNote": "Loan from Atlético Madrid July 2025 made permanent for ~$17M (EUR 15M), second-largest fee in MLS history at the time; DP through 2029"
          },
          {
            "player": "Luis Suárez",
            "position": "ST",
            "aav": 1.5,
            "contractNote": "Signed Dec 2023 below DP threshold via TAM; still on the 2026 roster"
          },
          {
            "player": "Sergio Busquets",
            "position": "DM",
            "aav": 8.8,
            "contractNote": "Retired after winning MLS Cup 2025"
          },
          {
            "player": "Jordi Alba",
            "position": "LB",
            "aav": 6,
            "contractNote": "Retired after winning MLS Cup 2025"
          }
        ],
        "fact": "Busquets and Alba retired after MLS Cup 2025; De Paul signed permanently for ~$17M and takes a DP slot",
        "source": "https://www.mlssoccer.com/news/inter-miami-permanently-acquire-rodrigo-de-paul-from-atletico-madrid"
      },
      {
        "field": "ownership.institutionalInvestors",
        "old": "Marcelo Claure exited 2022; Ares Management has explored minority investment; ownership remains primarily Mas/Beckham private",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (Ares Management is in the stadium financing partnership; equity stake in the club not confirmed)",
        "source": null
      }
    ],
    "analystNotes": "Inter Miami's $1.5B Forbes 2025 value, top of MLS, now has the two things it was priced on: the first MLS Cup, won 3-1 over Vancouver on Dec 6, 2025 with Messi as MVP, and Nu Stadium, opened April 4, 2026 with 26,700 seats, a reported ~$19M-a-year Nubank naming deal and every dollar of venue revenue in-house. Messi is signed through 2028 at a $28.3M cap hit, De Paul was bought for ~$17M, and the ~$1B Miami Freedom Park build-out adds hotel, retail and office income the club controls. The 2026 team is fifth in the Shield table after Busquets and Alba retired; the number moves on whether the building and the brand hold when Messi's contract ends after 2028.",
    "unverifiedAsOf": {
      "stadium.publicSubsidy": "May 2026"
    }
  },
  "cf-montreal": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.streamingNotes",
        "old": "All MLS matches available via Apple TV+ MLS Season Pass (10yr $2.5B deal 2023-2032)",
        "new": "All MLS matches on Apple TV; MLS Season Pass was folded into the base Apple TV subscription for 2026, and the Apple deal was amended in Nov 2025 to end after the 2028-29 season",
        "fact": "MLS and Apple scrapped the Season Pass add-on for 2026 and shortened the deal to run through 2028-29",
        "source": "https://www.espn.com/soccer/story/_/id/46954801/mls-apple-tv-scrapping-season-pass-26-season-sources"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$8M/team/year from MLS-Apple deal (~$250M/yr ÷ 30 teams); plus selective Fox Sports Sunday games",
        "new": "Apple pays $200M for 2026 (~$6.7M/team), $107.5M for the Feb-May 2027 transition season and $275M for each of 2027-28 and 2028-29 (~$9.2M/team); plus Fox Sports linear package",
        "fact": "Revised Apple payment schedule under the Nov 2025 amendment",
        "source": "https://www.sportspro.com/news/mls-apple-tv-broadcast-deal-season-pass-contract-november-2025/"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "Sept 2025 reports: club seeking municipal/provincial support for upgrades; not relocating but pressing for public investment in either Saputo expansion or new venue",
        "new": "Renovated premium seating and concessions unveiled at Stade Saputo before the 2026 home opener; no winterproofing, which forces early-season matches away or restricted, an issue that grows under the July-May calendar from 2027; no new-venue project announced",
        "fact": "Club unveiled upgraded premium areas for 2026; the stadium's lack of winterproofing remains the constraint ahead of the calendar change",
        "source": "https://en.cfmontreal.com/news/cf-montreal-unveils-new-and-improved-features-at-stade-saputo"
      },
      {
        "field": "media.localTVDeal",
        "old": "TVA Sports (French-language Quebec) and CTV/TSN secondary; Apple TV+ MLS Season Pass for full schedule",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source)",
        "source": null
      }
    ],
    "analystNotes": "CF Montréal's $600M Forbes 2025 value is the floor of MLS, and the 2026 season, 29th of 30, does nothing to lift it. The constraint is physical: Stade Saputo is the family's own building but it is not winterproof, so the July-to-May calendar that starts in 2027 pushes more home dates into months the stadium cannot host, and the 2026 premium-seat refresh does not solve that. The Apple step-up to $275M a year from 2027-28 helps every club equally; only a heated, covered venue or a sale by the Saputo family changes this one's relative position.",
    "unverifiedAsOf": {}
  },
  "nashville-sc": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.streamingNotes",
        "old": "All MLS matches available via Apple TV+ MLS Season Pass (10yr $2.5B deal 2023-2032)",
        "new": "All MLS matches on Apple TV; MLS Season Pass was folded into the base Apple TV subscription for 2026, and the Apple deal was amended in Nov 2025 to end after the 2028-29 season",
        "fact": "MLS and Apple scrapped the Season Pass add-on for 2026 and shortened the deal to run through 2028-29",
        "source": "https://www.espn.com/soccer/story/_/id/46954801/mls-apple-tv-scrapping-season-pass-26-season-sources"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$8M/team/year from MLS-Apple deal (~$250M/yr ÷ 30 teams); plus selective Fox Sports Sunday games",
        "new": "Apple pays $200M for 2026 (~$6.7M/team), $107.5M for the Feb-May 2027 transition season and $275M for each of 2027-28 and 2028-29 (~$9.2M/team); plus Fox Sports linear package",
        "fact": "Revised Apple payment schedule under the Nov 2025 amendment",
        "source": "https://www.sportspro.com/news/mls-apple-tv-broadcast-deal-season-pass-contract-november-2025/"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Hany Mukhtar — Designated Player ~$3M/yr; 2022 MLS MVP; rumored extension under negotiation 2025",
        "new": "Sam Surridge, DP striker, club-record 31 goals in 2025, new contract through 2027-28 makes him the club's highest-paid player; Hany Mukhtar's option triggered through 2027 at $4M base / $5.41M guaranteed",
        "fact": "Surridge signed a new deal through 2027-28 after 31 goals in 2025; Mukhtar's option was exercised through 2027",
        "source": "https://www.sixonefivesoccer.com/hany-mukhtar-contract-option-triggered-nashville-sc/"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Hany Mukhtar",
            "position": "AM",
            "aav": 3,
            "contractNote": "Designated Player; 2022 MLS MVP; central to Nashville attack"
          },
          {
            "player": "Walker Zimmerman",
            "position": "CB",
            "aav": 1.5,
            "contractNote": "TAM/DP; USMNT veteran; defensive cornerstone"
          },
          {
            "player": "Sam Surridge",
            "position": "ST",
            "aav": 2.5,
            "contractNote": "Designated Player; key signing post-Mukhtar dependency"
          }
        ],
        "new": [
          {
            "player": "Sam Surridge",
            "position": "ST",
            "aav": null,
            "contractNote": "DP; club-record 31 goals in 2025; new contract through 2027-28 with a $2.7M raise, now highest-paid at the club"
          },
          {
            "player": "Hany Mukhtar",
            "position": "AM",
            "aav": 5.4,
            "contractNote": "DP; 2022 MLS MVP; option triggered through 2027; 2026 base $4M, guaranteed $5.41M"
          },
          {
            "player": "Walker Zimmerman",
            "position": "CB",
            "aav": 1.5,
            "contractNote": "USMNT veteran; defensive cornerstone"
          }
        ],
        "fact": "2026 salary guide values for Mukhtar; Surridge new contract",
        "source": "https://sports.yahoo.com/articles/see-much-nashville-sc-players-201032433.html"
      },
      {
        "field": "media.localTVDeal",
        "old": "Streaming-only via Apple TV+ MLS Season Pass; selective games on Bally Sports South / Tennessean radio partnerships",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source)",
        "source": null
      }
    ],
    "analystNotes": "Nashville SC is the best team in MLS in 2026, 60 points and an 11-point Supporters' Shield lead on Sept 27, after winning the 2025 U.S. Open Cup and reaching the 2026 Concacaf Champions Cup semifinal, and it does it from GEODIS Park, the largest soccer-specific stadium in North America. The $780M Forbes 2025 mark still prices the club as a mid-market operation; Sam Surridge's club-record 31 goals in 2025 and a new contract through 2027-28 plus Mukhtar locked through 2027 give the roster continuity. A first MLS Cup in December 2026 is the event that moves Nashville from the $780M tier toward the $1B clubs.",
    "unverifiedAsOf": {
      "stadium.namingRightsDeal": "May 2026"
    }
  },
  "new-england-revolution": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.streamingNotes",
        "old": "All MLS matches available via Apple TV+ MLS Season Pass (10yr $2.5B deal 2023-2032)",
        "new": "All MLS matches on Apple TV; MLS Season Pass was folded into the base Apple TV subscription for 2026, and the Apple deal was amended in Nov 2025 to end after the 2028-29 season",
        "fact": "MLS and Apple scrapped the Season Pass add-on for 2026 and shortened the deal to run through 2028-29",
        "source": "https://www.espn.com/soccer/story/_/id/46954801/mls-apple-tv-scrapping-season-pass-26-season-sources"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$8M/team/year from MLS-Apple deal (~$250M/yr ÷ 30 teams); plus selective Fox Sports Sunday games",
        "new": "Apple pays $200M for 2026 (~$6.7M/team), $107.5M for the Feb-May 2027 transition season and $275M for each of 2027-28 and 2028-29 (~$9.2M/team); plus Fox Sports linear package",
        "fact": "Revised Apple payment schedule under the Nov 2025 amendment",
        "source": "https://www.sportspro.com/news/mls-apple-tv-broadcast-deal-season-pass-contract-november-2025/"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "Long-discussed Everett, MA soccer-specific stadium has stalled multiple times since 2019; Kraft Group has not committed land or capital; current expectation is Revolution remain at Gillette indefinitely; 2023 $225M Gillette renovation cements that",
        "new": "Kraft Group reached agreement with Boston and Everett in Jan 2026 for a privately funded ~$500M, 24,000-25,000-seat soccer stadium on the former Mystic River power plant site opposite Encore Boston Harbor; Kraft committed at least $100M to remediation and a waterfront park and ~$48M to Boston over 15 years; no construction start date announced; earliest opening cited as 2027",
        "fact": "Agreement with both cities announced Jan 2026; $500M cost; 24,000 seats; $100M Kraft remediation commitment",
        "source": "https://www.constructiondive.com/news/new-england-revolution-soccer-stadium-project/809039/"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 3,
        "new": 2,
        "fact": "New England qualified in 2021 and 2023 and missed 2022, 2024 and 2025; window is 2021-2025",
        "source": "https://en.wikipedia.org/wiki/2025_MLS_Cup_playoffs"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Carles Gil — Designated Player ~$3M/yr; 2021 Landon Donovan MVP",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (2026 status not checked)",
        "source": null
      }
    ],
    "analystNotes": "New England's $720M Forbes 2025 value finally has a stadium catalyst attached: in January 2026 the Kraft Group signed agreements with Boston and Everett for a privately funded ~$500M, 24,000-seat waterfront stadium, with at least $100M of Kraft money going to site remediation and a park and roughly $48M to Boston over 15 years. On the field the Revolution are fourth in the 2026 Shield table with 46 points after missing the playoffs in 2024 and 2025. The number moves the day shovels go in at Everett, because an owned soccer building in the fifth-largest US media market is the difference between a $720M tenant and a $1B club.",
    "unverifiedAsOf": {}
  },
  "new-york-city-fc": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.streamingNotes",
        "old": "All MLS matches available via Apple TV+ MLS Season Pass (10yr $2.5B deal 2023-2032)",
        "new": "All MLS matches on Apple TV; MLS Season Pass was folded into the base Apple TV subscription for 2026, and the Apple deal was amended in Nov 2025 to end after the 2028-29 season",
        "fact": "MLS and Apple scrapped the Season Pass add-on for 2026 and shortened the deal to run through 2028-29",
        "source": "https://www.espn.com/soccer/story/_/id/46954801/mls-apple-tv-scrapping-season-pass-26-season-sources"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$8M/team/year from MLS-Apple deal (~$250M/yr ÷ 30 teams); plus selective Fox Sports Sunday games",
        "new": "Apple pays $200M for 2026 (~$6.7M/team), $107.5M for the Feb-May 2027 transition season and $275M for each of 2027-28 and 2028-29 (~$9.2M/team); plus Fox Sports linear package",
        "fact": "Revised Apple payment schedule under the Nov 2025 amendment",
        "source": "https://www.sportspro.com/news/mls-apple-tv-broadcast-deal-season-pass-contract-november-2025/"
      },
      {
        "field": "stadium.name",
        "old": "Yankee Stadium (current); Etihad Park (2027)",
        "new": "Yankee Stadium and Citi Field (through the Feb-May 2027 transition season); Etihad Park (opens July 17, 2027)",
        "fact": "Etihad Park opens July 17, 2027 for the 2027-28 season; transition-season home matches at Yankee Stadium and Citi Field",
        "source": "https://www.cbsnews.com/newyork/news/etihad-park-opening-july-2027-nycfc/"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "Etihad Park: 25,000-seat soccer-specific stadium in Willets Point, Queens; $780M total cost; construction began Dec 2024; expected open for 2027 MLS season; first new sports venue in NYC five boroughs in years",
        "new": "Etihad Park: 25,000-seat, 100% privately financed, fully electric stadium in Willets Point, Queens; $780M cost; topped out March 25, 2026, first seats installed Aug 21, 2026; opening July 17, 2027 for the 2027-28 season after the club pushed the date back in Feb 2026 to match the MLS calendar change",
        "fact": "Structural frame completed March 25, 2026; opening date set for July 17, 2027",
        "source": "https://www.newyorkcityfc.com/news/a-new-era-begins-new-york-city-fc-to-start-2027-28-season-at-etihad-park"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 5,
        "new": 4,
        "fact": "NYCFC qualified in 2021, 2022, 2024 and 2025 (5th seed East, reached the 2025 Eastern Conference final) and missed 2023; window is 2021-2025",
        "source": "https://en.wikipedia.org/wiki/2025_MLS_Cup_playoffs"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Santiago Rodríguez",
            "position": "AM",
            "aav": 2.8,
            "contractNote": "Designated Player; central creative force; signed permanent 2024"
          },
          {
            "player": "Maxime Chanot",
            "position": "CB",
            "aav": 1,
            "contractNote": "TAM; longtime club captain; defensive leader"
          },
          {
            "player": "Alonso Martínez",
            "position": "ST",
            "aav": 1.5,
            "contractNote": "Young DP; Costa Rican international; key 2024 signing"
          }
        ],
        "new": [
          {
            "player": "Alonso Martínez",
            "position": "ST",
            "aav": 1.5,
            "contractNote": "Costa Rican DP; under contract for 2026"
          },
          {
            "player": "Santiago Rodríguez",
            "position": "AM",
            "aav": 2.8,
            "contractNote": "Former DP; left for Botafogo and rejoined MLS with Columbus as a DP on Sept 2, 2026"
          },
          {
            "player": "Maxime Chanot",
            "position": "CB",
            "aav": 1,
            "contractNote": "TAM; longtime club captain"
          }
        ],
        "fact": "Santiago Rodríguez is no longer with NYCFC; the club filled all three DP slots for 2026 for the first time",
        "source": "https://www.hudsonriverblue.com/nycfc-transfer-tracker-rodriguez/"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Santiago Rodríguez — Designated Player ~$2.8M/yr; Uruguayan playmaker",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (Rodríguez departed; 2026 franchise player not identified from a source)",
        "source": null
      }
    ],
    "analystNotes": "NYCFC's $850M Forbes 2025 mark is a pre-opening price for Etihad Park: the $780M, 25,000-seat, fully private Queens stadium topped out on March 25, 2026, seats went in on Aug 21, and the doors open July 17, 2027 for the first season of the new July-to-May calendar. Until then the club rents Yankee Stadium and Citi Field and sits 18th in the 2026 table after reaching the 2025 Eastern Conference final. The step-change is dated: the first full season with owned venue revenue in New York City is 2027-28, and that is when the number should cross $1B.",
    "unverifiedAsOf": {}
  },
  "new-york-red-bulls": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.streamingNotes",
        "old": "All MLS matches available via Apple TV+ MLS Season Pass (10yr $2.5B deal 2023-2032)",
        "new": "All MLS matches on Apple TV; MLS Season Pass was folded into the base Apple TV subscription for 2026, and the Apple deal was amended in Nov 2025 to end after the 2028-29 season",
        "fact": "MLS and Apple scrapped the Season Pass add-on for 2026 and shortened the deal to run through 2028-29",
        "source": "https://www.espn.com/soccer/story/_/id/46954801/mls-apple-tv-scrapping-season-pass-26-season-sources"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$8M/team/year from MLS-Apple deal (~$250M/yr ÷ 30 teams); plus selective Fox Sports Sunday games",
        "new": "Apple pays $200M for 2026 (~$6.7M/team), $107.5M for the Feb-May 2027 transition season and $275M for each of 2027-28 and 2028-29 (~$9.2M/team); plus Fox Sports linear package",
        "fact": "Revised Apple payment schedule under the Nov 2025 amendment",
        "source": "https://www.sportspro.com/news/mls-apple-tv-broadcast-deal-season-pass-contract-november-2025/"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 5,
        "new": 4,
        "fact": "Red Bulls qualified 2021-2024 and missed the 2025 playoffs, ending the league-record streak that began in 2010; window is 2021-2025",
        "source": "https://en.wikipedia.org/wiki/2025_MLS_Cup_playoffs"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Emil Forsberg",
            "position": "AM",
            "aav": 5,
            "contractNote": "Designated Player; arrived from sister-club RB Leipzig Jan 2024; central attacking force"
          },
          {
            "player": "Cory Burke",
            "position": "ST",
            "aav": 1,
            "contractNote": "TAM; veteran Jamaican international"
          }
        ],
        "new": [
          {
            "player": "Jorge Ruvalcaba",
            "position": "W",
            "aav": null,
            "contractNote": "Mexico international DP signed Feb 2, 2026 from Pumas for a club-record $6.5M; contract through 2029-30 with a 2030-31 option"
          },
          {
            "player": "Emil Forsberg",
            "position": "AM",
            "aav": 5,
            "contractNote": "Designated Player; arrived from RB Leipzig Jan 2024; captain of the 2024 MLS Cup final run"
          },
          {
            "player": "Eric Maxim Choupo-Moting",
            "position": "ST",
            "aav": null,
            "contractNote": "DP striker; on the 2026 roster"
          }
        ],
        "fact": "Ruvalcaba signed as a DP for a club-record $6.5M in Feb 2026; Choupo-Moting is a DP",
        "source": "https://www.newyorkredbulls.com/news/red-bull-new-york-completes-transfer-of-mexico-international-jorge-ruvalcaba-as-designated-player-from-unam-pumas"
      },
      {
        "field": "media.localTVDeal",
        "old": "Streaming-only via Apple TV+ MLS Season Pass; selective games on MSG Network",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source)",
        "source": null
      }
    ],
    "analystNotes": "The Red Bulls' $780M Forbes 2025 value holds up on an owned 25,000-seat stadium with a $100M-plus Sports Illustrated naming deal and Red Bull GmbH's balance sheet, but the on-field franchise that defined the club is gone: the 2025 season ended the playoff streak that ran from 2010, and the 2026 team is 17th. Ownership answered with a club-record $6.5M for Mexico winger Jorge Ruvalcaba in February 2026 alongside Forsberg and Choupo-Moting. The valuation gap to NYCFC widens in 2027 when Etihad Park opens, and only a return to the top of the East keeps Red Bull's Harrison asset from drifting.",
    "unverifiedAsOf": {}
  },
  "orlando-city-sc": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.streamingNotes",
        "old": "All MLS matches available via Apple TV+ MLS Season Pass (10yr $2.5B deal 2023-2032)",
        "new": "All MLS matches on Apple TV; MLS Season Pass was folded into the base Apple TV subscription for 2026, and the Apple deal was amended in Nov 2025 to end after the 2028-29 season",
        "fact": "MLS and Apple scrapped the Season Pass add-on for 2026 and shortened the deal to run through 2028-29",
        "source": "https://www.espn.com/soccer/story/_/id/46954801/mls-apple-tv-scrapping-season-pass-26-season-sources"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$8M/team/year from MLS-Apple deal (~$250M/yr ÷ 30 teams); plus selective Fox Sports Sunday games",
        "new": "Apple pays $200M for 2026 (~$6.7M/team), $107.5M for the Feb-May 2027 transition season and $275M for each of 2027-28 and 2028-29 (~$9.2M/team); plus Fox Sports linear package",
        "fact": "Revised Apple payment schedule under the Nov 2025 amendment",
        "source": "https://www.sportspro.com/news/mls-apple-tv-broadcast-deal-season-pass-contract-november-2025/"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 4,
        "new": 5,
        "fact": "Orlando qualified every year 2021-2025 (9th seed East in 2025, lost the wild card at Chicago); window is 2021-2025",
        "source": "https://en.wikipedia.org/wiki/2025_MLS_Cup_playoffs"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Facundo Torres — Designated Player ~$3M/yr; Uruguayan international; sold to Palmeiras 2025 for ~$15M club-record fee",
        "new": "Antoine Griezmann, French DP forward, 2018 World Cup winner, signed March 24, 2026 from Atlético Madrid; contract runs July 2026 through 2027-28 with a 2028-29 option",
        "fact": "Orlando announced Griezmann on March 24, 2026; he joined in the July 2026 window",
        "source": "https://www.orlandocitysc.com/news/global-soccer-icon-and-world-cup-winner-antoine-griezmann-to-join-orlando-city-sc"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Martín Ojeda",
            "position": "AM",
            "aav": 3,
            "contractNote": "Designated Player; Argentine playmaker; central to attack"
          },
          {
            "player": "Pedro Gallese",
            "position": "GK",
            "aav": 1.5,
            "contractNote": "TAM; Peruvian international; longtime starter"
          },
          {
            "player": "Robin Jansson",
            "position": "CB",
            "aav": 1.2,
            "contractNote": "TAM; Swedish defender; defensive captain"
          }
        ],
        "new": [
          {
            "player": "Antoine Griezmann",
            "position": "FW",
            "aav": null,
            "contractNote": "DP from Atlético Madrid, joined July 2026; through 2027-28 plus 2028-29 option"
          },
          {
            "player": "Martín Ojeda",
            "position": "AM",
            "aav": 3,
            "contractNote": "Designated Player; Argentine playmaker"
          },
          {
            "player": "Pedro Gallese",
            "position": "GK",
            "aav": 1.5,
            "contractNote": "TAM; Peruvian international; longtime starter"
          }
        ],
        "fact": "Griezmann added as the headline DP in 2026",
        "source": "https://www.espn.com/soccer/story/_/id/48287915/antoine-griezmann-completes-summer-transfer-atletico-madrid-orlando-city"
      }
    ],
    "analystNotes": "Orlando City's $750M Forbes 2025 value is about to be tested by the club's first true global signing: Antoine Griezmann, announced March 24, 2026 and on the field since July on a deal through 2027-28, playing in a team-owned downtown stadium with an NWSL sister club under the same Wilf roof. The Lions have made five straight playoffs through 2025 but sit 16th in 2026, and the Torres sale to Palmeiras showed the trading model works. Griezmann's effect on gate, jersey and Latin American reach over the next 18 months is the single input that decides whether Orlando reaches the $1B group.",
    "unverifiedAsOf": {
      "stadium.namingRightsDeal": "May 2026"
    }
  },
  "philadelphia-union": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.streamingNotes",
        "old": "All MLS matches available via Apple TV+ MLS Season Pass (10yr $2.5B deal 2023-2032)",
        "new": "All MLS matches on Apple TV; MLS Season Pass was folded into the base Apple TV subscription for 2026, and the Apple deal was amended in Nov 2025 to end after the 2028-29 season",
        "fact": "MLS and Apple scrapped the Season Pass add-on for 2026 and shortened the deal to run through 2028-29",
        "source": "https://www.espn.com/soccer/story/_/id/46954801/mls-apple-tv-scrapping-season-pass-26-season-sources"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$8M/team/year from MLS-Apple deal (~$250M/yr ÷ 30 teams); plus selective Fox Sports Sunday games",
        "new": "Apple pays $200M for 2026 (~$6.7M/team), $107.5M for the Feb-May 2027 transition season and $275M for each of 2027-28 and 2028-29 (~$9.2M/team); plus Fox Sports linear package",
        "fact": "Revised Apple payment schedule under the Nov 2025 amendment",
        "source": "https://www.sportspro.com/news/mls-apple-tv-broadcast-deal-season-pass-contract-november-2025/"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 5,
        "new": 4,
        "fact": "Philadelphia qualified in 2021, 2022, 2023 and 2025 (won the 2025 Supporters' Shield with 66 points) and missed 2024; window is 2021-2025",
        "source": "https://en.wikipedia.org/wiki/2025_Major_League_Soccer_season"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Mikael Uhre",
            "position": "ST",
            "aav": 2.5,
            "contractNote": "Designated Player; key goalscorer since 2022"
          },
          {
            "player": "Daniel Gazdag",
            "position": "AM",
            "aav": 2.2,
            "contractNote": "Designated Player; Hungarian international; 2022 MLS Cup runner-up campaign hero"
          },
          {
            "player": "Andre Blake",
            "position": "GK",
            "aav": 1.5,
            "contractNote": "TAM; multi-time MLS Goalkeeper of the Year; Jamaican international"
          }
        ],
        "new": [
          {
            "player": "Ezekiel Alladoh",
            "position": "ST",
            "aav": null,
            "contractNote": "Club-record ~$4.5M signing from IF Brommapojkarna, Dec 2025; guaranteed through 2028 with options for 2029 and 2030"
          },
          {
            "player": "Mikael Uhre",
            "position": "ST",
            "aav": 2.5,
            "contractNote": "Designated Player; key goalscorer since 2022"
          },
          {
            "player": "Andre Blake",
            "position": "GK",
            "aav": 1.5,
            "contractNote": "TAM; multi-time MLS Goalkeeper of the Year; Jamaican international"
          }
        ],
        "fact": "Alladoh is the club's record signing (Dec 2025)",
        "source": "https://www.philadelphiaunion.com/news/philadelphia-union-sign-forward-ezekiel-alladoh"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Mikael Uhre — Designated Player ~$2.5M/yr; Danish striker",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source)",
        "source": null
      }
    ],
    "analystNotes": "Philadelphia won the 2025 Supporters' Shield with 66 points, the league's best record, and did it the Union way: no marquee DP, a club-record fee of only ~$4.5M for 20-year-old Ezekiel Alladoh, and academy sales funding the roster. The $700M Forbes 2025 value prices exactly that discipline, an 18,500-seat Subaru Park on Port Authority land and a mid-tier market with no stadium catalyst. The 2026 team is 12th, and the number stays in the $700M band until Sugarman's group either expands the venue or spends on a DP the market can see.",
    "unverifiedAsOf": {}
  },
  "toronto-fc": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.streamingNotes",
        "old": "All MLS matches available via Apple TV+ MLS Season Pass (10yr $2.5B deal 2023-2032)",
        "new": "All MLS matches on Apple TV; MLS Season Pass was folded into the base Apple TV subscription for 2026, and the Apple deal was amended in Nov 2025 to end after the 2028-29 season",
        "fact": "MLS and Apple scrapped the Season Pass add-on for 2026 and shortened the deal to run through 2028-29",
        "source": "https://www.espn.com/soccer/story/_/id/46954801/mls-apple-tv-scrapping-season-pass-26-season-sources"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$8M/team/year from MLS-Apple deal (~$250M/yr ÷ 30 teams); Canadian teams receive additional Canadian Soccer Business / domestic distribution; Rogers ownership creates intracompany media leverage",
        "new": "Apple pays $200M for 2026 (~$6.7M/team), $107.5M for the Feb-May 2027 transition season and $275M for each of 2027-28 and 2028-29 (~$9.2M/team); Canadian teams receive additional domestic distribution; Rogers ownership creates intracompany media leverage",
        "fact": "Revised Apple payment schedule under the Nov 2025 amendment",
        "source": "https://www.sportspro.com/news/mls-apple-tv-broadcast-deal-season-pass-contract-november-2025/"
      },
      {
        "field": "ownership.primaryOwner",
        "old": "Maple Leaf Sports & Entertainment (MLSE) — Rogers Communications 75% / Larry Tanenbaum 25%",
        "new": "Maple Leaf Sports & Entertainment (MLSE), Rogers Communications 100% (Tanenbaum's final 25% bought for C$4.35B, announced July 6, 2026, subject to league approvals)",
        "fact": "Rogers agreed to buy Kilmer Sports' remaining 25% of MLSE for C$4.35B on July 6, 2026, implying C$17.4B for all of MLSE; close expected Q4 2026 pending league approvals",
        "source": "https://www.cbc.ca/news/business/rogers-buying-mlse-9.7259583"
      },
      {
        "field": "ownership.ownershipGroup",
        "old": [
          {
            "name": "Rogers Communications",
            "role": "majority via MLSE",
            "pct": 75
          },
          {
            "name": "Larry Tanenbaum (Kilmer Sports Inc.)",
            "role": "minority via MLSE",
            "pct": 25
          }
        ],
        "new": [
          {
            "name": "Rogers Communications",
            "role": "sole owner via MLSE (100% on close of the July 2026 Tanenbaum purchase)",
            "pct": 100
          }
        ],
        "fact": "Per data/transactions.js: Rogers buying the last 25% of MLSE from Kilmer Sports, agreed July 2026; Rogers also plans to sell a minority stake in its combined sports and media assets",
        "source": "https://ca.news.yahoo.com/rogers-completes-purchase-mlse-officially-140411877.html"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "BMO Field renovation 2024-26: expansion from 30,991 to ~45,500 capacity (17K temporary seats for World Cup), upgraded broadcast/Wi-Fi/hospitality; total cost ~C$130M; partial public funding from Ontario/federal/Toronto",
        "new": "BMO Field renovation completed for the 2026 World Cup: C$157.9M total (C$132.9M City of Toronto, C$25M MLSE); Phase 1 (LED boards, systems, premium) done Aug 2025, Phase 2 (Dec 2025-Mar 2026) added ~17,756 temporary seats and expanded player facilities",
        "fact": "Renovation cost C$157.9M with the city funding C$132.9M; temporary seats installed for the World Cup",
        "source": "https://en.wikipedia.org/wiki/BMO_Field"
      },
      {
        "field": "stadium.publicSubsidy",
        "old": 18,
        "new": 133,
        "fact": "City of Toronto funded C$132.9M of the C$157.9M World Cup renovation",
        "source": "https://en.wikipedia.org/wiki/BMO_Field"
      },
      {
        "field": "stadium.privateFinancing",
        "old": 45,
        "new": 25,
        "fact": "MLSE contributed C$25M to the World Cup renovation",
        "source": "https://en.wikipedia.org/wiki/BMO_Field"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 2,
        "new": 0,
        "fact": "Toronto missed the playoffs every year 2021-2025; window is 2021-2025",
        "source": "https://en.wikipedia.org/wiki/2025_MLS_Cup_playoffs"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Federico Bernardeschi — Designated Player ~$6.5M/yr; Italian international; under-delivered relative to contract since 2022",
        "new": "Josh Sargent, USMNT striker signed from Norwich City in 2026 for a club-record initial $22M, the largest incoming MLS fee of the 2026 windows",
        "fact": "Toronto paid an initial $22M for Sargent, the top incoming fee in MLS in 2026",
        "source": "https://www.espn.com/soccer/story/_/id/49882716/mls-league-sets-record-incoming-outgoing-transfers-2026"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Federico Bernardeschi",
            "position": "AM",
            "aav": 6.5,
            "contractNote": "Designated Player since 2022; ex-Juventus/Italy; controversial deal given output"
          },
          {
            "player": "Lorenzo Insigne",
            "position": "W",
            "aav": 15.4,
            "contractNote": "Designated Player since 2022; ex-Napoli/Italy; massive contract through 2026 — among MLS's largest; salary reset/release in 2025 widely reported"
          },
          {
            "player": "Sean Johnson",
            "position": "GK",
            "aav": 1.5,
            "contractNote": "TAM; veteran USMNT goalkeeper"
          }
        ],
        "new": [
          {
            "player": "Josh Sargent",
            "position": "ST",
            "aav": null,
            "contractNote": "Club-record initial $22M transfer from Norwich City, 2026; potentially more than GBP 20M with add-ons"
          },
          {
            "player": "Lorenzo Insigne",
            "position": "W",
            "aav": 15.4,
            "contractNote": "DP 2022-2025; contract mutually terminated in 2025 using a guaranteed-contract buyout"
          },
          {
            "player": "Federico Bernardeschi",
            "position": "AM",
            "aav": 6.5,
            "contractNote": "DP 2022-2025; bought out in 2025"
          }
        ],
        "fact": "Insigne and Bernardeschi were bought out in 2025; Sargent is the new record signing",
        "source": "https://www.torontofc.ca/news/toronto-fc-and-italian-winger-lorenzo-insigne-agree-on-mutual-contract-termination"
      }
    ],
    "analystNotes": "Toronto FC's $780M Forbes 2025 value now sits inside a 100% Rogers-owned MLSE after the July 2026 agreement to buy Tanenbaum's last 25% for C$4.35B, a C$17.4B mark for the Leafs, Raptors, TFC and Scotiabank Arena bundle. The club cleared the Insigne and Bernardeschi contracts in 2025 and put a club-record initial $22M into Josh Sargent in 2026, while a C$157.9M World Cup renovation of BMO Field was paid almost entirely by the City of Toronto. Five straight seasons outside the playoffs through 2025 and 26th place in 2026 mean the media leverage of Rogers plus Sportsnet is worth nothing until the team is watchable; Rogers' planned minority sale of its sports assets is the next price signal.",
    "unverifiedAsOf": {
      "stadium.capacity": "May 2026",
      "stadium.namingRightsDeal": "May 2026"
    }
  },
  "austin-fc": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.streamingNotes",
        "old": "All MLS matches available via Apple TV+ MLS Season Pass (10yr $2.5B deal 2023-2032)",
        "new": "All MLS matches on Apple TV; MLS Season Pass was folded into the base Apple TV subscription for 2026, and the Apple deal was amended in Nov 2025 to end after the 2028-29 season",
        "fact": "MLS and Apple scrapped the Season Pass add-on for 2026 and shortened the deal to run through 2028-29",
        "source": "https://www.espn.com/soccer/story/_/id/46954801/mls-apple-tv-scrapping-season-pass-26-season-sources"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$8M/team/year from MLS-Apple deal (~$250M/yr ÷ 30 teams); plus selective Fox Sports Sunday games",
        "new": "Apple pays $200M for 2026 (~$6.7M/team), $107.5M for the Feb-May 2027 transition season and $275M for each of 2027-28 and 2028-29 (~$9.2M/team); plus Fox Sports linear package",
        "fact": "Revised Apple payment schedule under the Nov 2025 amendment",
        "source": "https://www.sportspro.com/news/mls-apple-tv-broadcast-deal-season-pass-contract-november-2025/"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 1,
        "new": 2,
        "fact": "Austin qualified in 2022 and 2025 (6th seed West); window is 2021-2025",
        "source": "https://en.wikipedia.org/wiki/2025_MLS_Cup_playoffs"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Sebastián Driussi — Designated Player, ~$3M base/$4.5M total comp through 2026; Argentine attacking mid",
        "new": "Sebastián Driussi transferred to River Plate in Jan 2025 for $10M plus an 8.25% sell-on; no single franchise player identified for 2026",
        "fact": "Austin sold Driussi to River Plate in January 2025 for $10M with an 8.25% sell-on fee",
        "source": "https://en.wikipedia.org/wiki/2025_Austin_FC_season"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Sebastián Driussi",
            "position": "AM/CF",
            "aav": 4.5,
            "contractNote": "Designated Player through 2026; signed from Zenit St. Petersburg"
          },
          {
            "player": "Brad Stuver",
            "position": "GK",
            "aav": 0.7,
            "contractNote": "TAM-level deal; longtime starter"
          }
        ],
        "new": [
          {
            "player": "Sebastián Driussi",
            "position": "AM/CF",
            "aav": 4.5,
            "contractNote": "DP 2021-2024; sold to River Plate Jan 2025 for $10M plus 8.25% sell-on"
          },
          {
            "player": "Brad Stuver",
            "position": "GK",
            "aav": 0.7,
            "contractNote": "TAM-level deal; longtime starter"
          }
        ],
        "fact": "Driussi departed in January 2025",
        "source": "https://en.wikipedia.org/wiki/2025_Austin_FC_season"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Sebastián Driussi — Designated Player, ~$3M base/$4.5M total comp through 2026; Argentine attacking mid",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (2026 headline player not identified from a source)",
        "source": null
      },
      {
        "field": "media.localTVDeal",
        "old": "Local English-language broadcasts via CW Austin (selected matches outside Apple package)",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source)",
        "source": null
      }
    ],
    "analystNotes": "Austin FC's $950M Forbes 2025 value is anchored by the $912M enterprise value set in the July 2025 minority raise that brought in PEAK6's Jenny Just and Matt Hulsizer and later FirstTracks' Jon-Erik Borgen, with Precourt keeping control of a privately funded Q2 Stadium in a growing tech market. The club opened Nu Stadium as Inter Miami's first opponent in April 2026 and made the 2025 playoffs, but sits 23rd in 2026 after selling Driussi to River Plate for $10M. The number is a stadium-and-market number; a sustained playoff team is what turns the 2025 raise into a $1B print.",
    "unverifiedAsOf": {}
  },
  "colorado-rapids": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.streamingNotes",
        "old": "All MLS matches available via Apple TV+ MLS Season Pass (10yr $2.5B deal 2023-2032)",
        "new": "All MLS matches on Apple TV; MLS Season Pass was folded into the base Apple TV subscription for 2026, and the Apple deal was amended in Nov 2025 to end after the 2028-29 season",
        "fact": "MLS and Apple scrapped the Season Pass add-on for 2026 and shortened the deal to run through 2028-29",
        "source": "https://www.espn.com/soccer/story/_/id/46954801/mls-apple-tv-scrapping-season-pass-26-season-sources"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$8M/team/year from MLS-Apple deal (~$250M/yr ÷ 30 teams); plus selective Fox Sports Sunday games",
        "new": "Apple pays $200M for 2026 (~$6.7M/team), $107.5M for the Feb-May 2027 transition season and $275M for each of 2027-28 and 2028-29 (~$9.2M/team); plus Fox Sports linear package",
        "fact": "Revised Apple payment schedule under the Nov 2025 amendment",
        "source": "https://www.sportspro.com/news/mls-apple-tv-broadcast-deal-season-pass-contract-november-2025/"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Djordje Mihailovic — DP-level CAM acquired from CF Montréal (2024); ~$2M base, $3M total comp",
        "new": "Morgan Whittaker, English DP winger signed Sept 2026 from Middlesbrough for a club-record ~$10.7M, contract through 2029-30 with a 2030-31 option; scored twice in his first MLS start",
        "fact": "Colorado's record incoming transfer, confirmed Sept 4, 2026, topping the $8M paid for Paxten Aaronson in 2025",
        "source": "https://www.mlssoccer.com/news/morgan-whittaker-announces-himself-with-colorado-rapids-brace"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Djordje Mihailovic",
            "position": "CAM",
            "aav": 3,
            "contractNote": "Designated Player; signed from CF Montréal Jan 2024"
          },
          {
            "player": "Rafael Navarro",
            "position": "ST",
            "aav": 1.5,
            "contractNote": "TAM-level Brazilian forward"
          }
        ],
        "new": [
          {
            "player": "Morgan Whittaker",
            "position": "W",
            "aav": null,
            "contractNote": "DP; club-record ~$10.7M from Middlesbrough, Sept 2026; through 2029-30 plus option"
          },
          {
            "player": "Paxten Aaronson",
            "position": "AM",
            "aav": null,
            "contractNote": "Signed summer 2025 for a then-record $8M"
          },
          {
            "player": "Djordje Mihailovic",
            "position": "CAM",
            "aav": 3,
            "contractNote": "Designated Player; signed from CF Montréal Jan 2024"
          }
        ],
        "fact": "Whittaker and Aaronson are the two record fees; Rafael Navarro moved to St. Louis City in 2026",
        "source": "https://burgundywave.com/2026/09/04/colorado-rapids-dp-winger-morgan-whittaker-middlesborough-record-signing/"
      }
    ],
    "analystNotes": "Colorado's $620M Forbes 2025 value is the second-lowest in MLS and still reads as Kroenke's least-tended asset: a Commerce City stadium built in 2007, a $2M-a-year naming deal expiring in 2027 and no new-venue plan. The 2026 window is the first real signal of intent, a club-record ~$10.7M for Morgan Whittaker in September on top of $8M for Paxten Aaronson in 2025, and the team is 13th with a shot at the playoffs. The number moves on a Kroenke decision about a Denver-proximate development, not on any roster.",
    "unverifiedAsOf": {
      "stadium.namingRightsDeal": "May 2026"
    }
  },
  "fc-dallas": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.streamingNotes",
        "old": "All MLS matches available via Apple TV+ MLS Season Pass (10yr $2.5B deal 2023-2032)",
        "new": "All MLS matches on Apple TV; MLS Season Pass was folded into the base Apple TV subscription for 2026, and the Apple deal was amended in Nov 2025 to end after the 2028-29 season",
        "fact": "MLS and Apple scrapped the Season Pass add-on for 2026 and shortened the deal to run through 2028-29",
        "source": "https://www.espn.com/soccer/story/_/id/46954801/mls-apple-tv-scrapping-season-pass-26-season-sources"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$8M/team/year from MLS-Apple deal (~$250M/yr ÷ 30 teams); plus selective Fox Sports Sunday games",
        "new": "Apple pays $200M for 2026 (~$6.7M/team), $107.5M for the Feb-May 2027 transition season and $275M for each of 2027-28 and 2028-29 (~$9.2M/team); plus Fox Sports linear package",
        "fact": "Revised Apple payment schedule under the Nov 2025 amendment",
        "source": "https://www.sportspro.com/news/mls-apple-tv-broadcast-deal-season-pass-contract-november-2025/"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "$182M renovation underway 2025-2027 — North End enclosure, suite expansion, Hall of Fame upgrade; first phase of broader $1.1-1.3B mixed-use Frisco district (office, hotel, multifamily)",
        "new": "$182M Toyota Stadium renovation began March 26, 2026 with Moss Construction: east side reopens summer 2026 as work shifts west; added seating, shade canopy, premium clubs and suites; completion expected Q1 2028; first phase of the $1.1-1.3B Frisco mixed-use district",
        "fact": "Construction started March 26, 2026; full completion expected first quarter of 2028",
        "source": "https://therealdeal.com/texas/dallas/2026/03/05/fc-dallas-ramps-up-182m-toyota-stadium-overhaul/"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Petar Musa — Croatian DP striker signed from Benfica 2024; $5M+ AAV; emerging franchise centerpiece",
        "new": "Petar Musa, Croatian DP striker signed from Benfica 2024; 18 league goals in 2026 leads the club; contract through 2027",
        "fact": "Musa is FC Dallas's top scorer in 2026 with 18 league goals",
        "source": "https://en.wikipedia.org/wiki/2026_FC_Dallas_season"
      },
      {
        "field": "media.localTVDeal",
        "old": "Selected matches on local broadcast partners outside Apple package",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source)",
        "source": null
      }
    ],
    "analystNotes": "FC Dallas is having its best season in years, third in the 2026 Shield table with 47 points behind Petar Musa's 18 league goals, while the $182M Toyota Stadium rebuild that started March 26, 2026 reshapes the Frisco venue through early 2028 as the first piece of a $1.1-1.3B Hunt district. The $700M Forbes 2025 value gives little credit for that real estate or for the academy that keeps producing sales. The rerating comes in 2028 when the enclosed stadium, hotel and office income show up in the P&L; a 2026 playoff run would pull it forward.",
    "unverifiedAsOf": {}
  },
  "houston-dynamo-fc": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.streamingNotes",
        "old": "All MLS matches available via Apple TV+ MLS Season Pass (10yr $2.5B deal 2023-2032)",
        "new": "All MLS matches on Apple TV; MLS Season Pass was folded into the base Apple TV subscription for 2026, and the Apple deal was amended in Nov 2025 to end after the 2028-29 season",
        "fact": "MLS and Apple scrapped the Season Pass add-on for 2026 and shortened the deal to run through 2028-29",
        "source": "https://www.espn.com/soccer/story/_/id/46954801/mls-apple-tv-scrapping-season-pass-26-season-sources"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$8M/team/year from MLS-Apple deal (~$250M/yr ÷ 30 teams); plus selective Fox Sports Sunday games",
        "new": "Apple pays $200M for 2026 (~$6.7M/team), $107.5M for the Feb-May 2027 transition season and $275M for each of 2027-28 and 2028-29 (~$9.2M/team); plus Fox Sports linear package",
        "fact": "Revised Apple payment schedule under the Nov 2025 amendment",
        "source": "https://www.sportspro.com/news/mls-apple-tv-broadcast-deal-season-pass-contract-november-2025/"
      },
      {
        "field": "ownership.institutionalInvestors",
        "old": "PJT Partners hired by Segal Jan 2025 to explore NWSL Dash sale (~$120M)",
        "new": "Dash sale process relaunched in March 2026 after ~$120M talks with RHC Group ended amid NWSL approval concerns; PJT Partners advising; Dynamo ownership unchanged",
        "fact": "Talks to sell the Dash to RHC for about $120M ended; process relaunched March 2026",
        "source": "https://www.sportico.com/business/team-sales/2026/houston-dash-sale-relaunch-nwsl-rhc-group-1234886045/"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Sebastian Ferreira",
            "position": "ST",
            "aav": 3.5,
            "contractNote": "Designated Player through 2025"
          },
          {
            "player": "Héctor Herrera",
            "position": "CM",
            "aav": 5.5,
            "contractNote": "Mexican international DP signed from Atletico Madrid"
          }
        ],
        "new": [
          {
            "player": "Mateusz Bogusz",
            "position": "AM",
            "aav": null,
            "contractNote": "Signed for 2026 from Cruz Azul for reportedly up to $10M; former LAFC standout"
          },
          {
            "player": "Guilherme",
            "position": "W",
            "aav": null,
            "contractNote": "DP winger acquired from Santos FC for 2026"
          },
          {
            "player": "Héctor Herrera",
            "position": "CM",
            "aav": null,
            "contractNote": "Returned as a free agent for 2026 after a season at Toluca; reserve/leadership role"
          }
        ],
        "fact": "2026 roster overhaul: Bogusz (up to $10M), DP Guilherme, Bouzat, Halter and Herrera's return",
        "source": "https://www.mlssoccer.com/news/houston-dynamo-fc-2026-season-preview"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Sebastian Ferreira — Designated Player Paraguayan striker; club's record signing era",
        "new": "Mateusz Bogusz, Polish playmaker signed for 2026 from Cruz Azul for reportedly up to $10M",
        "fact": "Bogusz is the headline 2026 acquisition",
        "source": "https://www.mlssoccer.com/news/houston-dynamo-fc-2026-season-preview"
      },
      {
        "field": "media.localTVDeal",
        "old": "Local Spanish-language broadcast partnerships; selected matches outside Apple package",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source)",
        "source": null
      }
    ],
    "analystNotes": "Houston's $700M Forbes 2025 value already prices the Segal turnaround from a $400M 2021 purchase, and 2026 is the year the roster caught up: a rebuilt squad around Mateusz Bogusz, DP Guilherme and a returning Héctor Herrera has the Dynamo seventh in the Shield table after missing the 2025 playoffs, and Shell Energy Stadium hosted the 2026 Leagues Cup final. Segal's attempt to sell the Dash at ~$120M collapsed and was relaunched in March 2026, which keeps the NWSL asset unmonetized. A playoff run in a World Cup host city with an owned downtown stadium is what pushes this toward $800M.",
    "unverifiedAsOf": {}
  },
  "la-galaxy": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.streamingNotes",
        "old": "All MLS matches available via Apple TV+ MLS Season Pass (10yr $2.5B deal 2023-2032)",
        "new": "All MLS matches on Apple TV; MLS Season Pass was folded into the base Apple TV subscription for 2026, and the Apple deal was amended in Nov 2025 to end after the 2028-29 season",
        "fact": "MLS and Apple scrapped the Season Pass add-on for 2026 and shortened the deal to run through 2028-29",
        "source": "https://www.espn.com/soccer/story/_/id/46954801/mls-apple-tv-scrapping-season-pass-26-season-sources"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$8M/team/year from MLS-Apple deal (~$250M/yr ÷ 30 teams); plus selective Fox Sports Sunday games",
        "new": "Apple pays $200M for 2026 (~$6.7M/team), $107.5M for the Feb-May 2027 transition season and $275M for each of 2027-28 and 2028-29 (~$9.2M/team); plus Fox Sports linear package",
        "fact": "Revised Apple payment schedule under the Nov 2025 amendment",
        "source": "https://www.sportspro.com/news/mls-apple-tv-broadcast-deal-season-pass-contract-november-2025/"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 3,
        "new": 2,
        "fact": "Galaxy qualified in 2022 and 2024 (MLS Cup champions) and missed 2021, 2023 and 2025; window is 2021-2025",
        "source": "https://en.wikipedia.org/wiki/2025_MLS_Cup_playoffs"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Riqui Puig",
            "position": "AM",
            "aav": 2.5,
            "contractNote": "Designated Player through 2026; 2024 MLS Cup MVP"
          },
          {
            "player": "Joseph Paintsil",
            "position": "RW",
            "aav": 4.2,
            "contractNote": "Designated Player Ghanaian winger signed from Genk 2024"
          },
          {
            "player": "Gabriel Pec",
            "position": "LW",
            "aav": 3.8,
            "contractNote": "Designated Player Brazilian winger from Vasco da Gama"
          }
        ],
        "new": [
          {
            "player": "Riqui Puig",
            "position": "AM",
            "aav": 2.5,
            "contractNote": "Designated Player through 2026; 2024 MLS Cup MVP"
          },
          {
            "player": "Joseph Paintsil",
            "position": "RW",
            "aav": 4.2,
            "contractNote": "Designated Player Ghanaian winger signed from Genk 2024"
          },
          {
            "player": "Hirving 'Chucky' Lozano",
            "position": "W",
            "aav": null,
            "contractNote": "DP on loan from San Diego FC for the rest of 2026 with an option to buy"
          },
          {
            "player": "Gabriel Pec",
            "position": "LW",
            "aav": 3.8,
            "contractNote": "Sold to Cruzeiro July 7, 2026 for a club-record ~$12M (up to $13.5M) after a ~$10M purchase in Jan 2024"
          }
        ],
        "fact": "Pec sold for a club-record fee in July 2026; Lozano arrived on loan from San Diego as a DP",
        "source": "https://www.lagalaxy.com/news/la-galaxy-set-club-transfer-fee-record-with-forward-gabriel-pec-to-cruzeiro-esporte-clube"
      },
      {
        "field": "media.localTVDeal",
        "old": "Spectrum SportsNet (Charter) regional broadcasts; selected matches outside Apple package",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source)",
        "source": null
      }
    ],
    "analystNotes": "LA Galaxy's $1.05B Forbes 2025 value is the 2024 MLS Cup and the AEG brand, and both are fading in the rear-view: the club missed the 2025 playoffs and sits 14th in 2026. The business still works, a club-record ~$12M sale of Gabriel Pec to Cruzeiro in July 2026 on a ~$10M buy and a Chucky Lozano loan to keep the Mexican-American market engaged at Dignity Health Sports Park. What limits the number is structural: AEG owns the venue, so the campus economics do not flow to the team P&L, and the gap to LAFC's $1.55B widens each year the Galaxy are not a playoff side.",
    "unverifiedAsOf": {}
  },
  "los-angeles-fc": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.streamingNotes",
        "old": "All MLS matches available via Apple TV+ MLS Season Pass (10yr $2.5B deal 2023-2032)",
        "new": "All MLS matches on Apple TV; MLS Season Pass was folded into the base Apple TV subscription for 2026, and the Apple deal was amended in Nov 2025 to end after the 2028-29 season",
        "fact": "MLS and Apple scrapped the Season Pass add-on for 2026 and shortened the deal to run through 2028-29",
        "source": "https://www.espn.com/soccer/story/_/id/46954801/mls-apple-tv-scrapping-season-pass-26-season-sources"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$8M/team/year from MLS-Apple deal (~$250M/yr ÷ 30 teams); plus selective Fox Sports Sunday games",
        "new": "Apple pays $200M for 2026 (~$6.7M/team), $107.5M for the Feb-May 2027 transition season and $275M for each of 2027-28 and 2028-29 (~$9.2M/team); plus Fox Sports linear package",
        "fact": "Revised Apple payment schedule under the Nov 2025 amendment",
        "source": "https://www.sportspro.com/news/mls-apple-tv-broadcast-deal-season-pass-contract-november-2025/"
      },
      {
        "field": "ownership.ownershipGroup",
        "old": [
          {
            "name": "Bennett Rosenthal",
            "role": "lead managing owner / governor",
            "pct": null
          },
          {
            "name": "Larry Berg",
            "role": "co-managing owner",
            "pct": null
          },
          {
            "name": "Brandon Beck",
            "role": "co-managing owner / president",
            "pct": null
          },
          {
            "name": "Will Ferrell",
            "role": "celebrity owner / brand",
            "pct": null
          },
          {
            "name": "Magic Johnson",
            "role": "minority owner",
            "pct": null
          },
          {
            "name": "Mia Hamm / Nomar Garciaparra",
            "role": "minority owners",
            "pct": null
          },
          {
            "name": "Giorgio Chiellini",
            "role": "former player turned minority",
            "pct": null
          },
          {
            "name": "Carlos Vela",
            "role": "minority (added 2026)",
            "pct": null
          }
        ],
        "new": [
          {
            "name": "Bennett Rosenthal",
            "role": "lead managing owner / governor",
            "pct": null
          },
          {
            "name": "Larry Berg",
            "role": "co-managing owner",
            "pct": null
          },
          {
            "name": "Brandon Beck",
            "role": "co-managing owner / president",
            "pct": null
          },
          {
            "name": "Will Ferrell",
            "role": "celebrity owner / brand",
            "pct": null
          },
          {
            "name": "Magic Johnson",
            "role": "minority owner",
            "pct": null
          },
          {
            "name": "Mia Hamm / Nomar Garciaparra",
            "role": "minority owners",
            "pct": null
          },
          {
            "name": "Giorgio Chiellini",
            "role": "former player turned minority",
            "pct": null
          },
          {
            "name": "Carlos Vela",
            "role": "minority (added 2026)",
            "pct": null
          },
          {
            "name": "Juan Domingo Beckmann Legorreta (Becle CEO)",
            "role": "minority (added 2026)",
            "pct": null
          },
          {
            "name": "James Cha",
            "role": "minority (added 2026)",
            "pct": null
          }
        ],
        "fact": "Joe Tsai and Mike Mahan exited in 2026; Vela, Becle CEO Beckmann and Korean American investor James Cha bought about 6% combined at a ~$1.25B valuation",
        "source": "https://www.sportico.com/business/team-sales/2026/lafc-sale-beckmann-becle-cha-spring-oak-partners-1234941046/"
      },
      {
        "field": "ownership.institutionalInvestors",
        "old": "Ares Management partners broadly represented in LP roster; multiple HNW families",
        "new": "2026 minority sales valued LAFC at ~$1.25B: Joe Tsai and Mike Mahan sold, with Carlos Vela, Becle CEO Juan Domingo Beckmann and James Cha buying ~6% combined; Ares Management partners remain in the LP roster",
        "fact": "Sportico reported the ~$1.25B valuation and ~6% stake sale",
        "source": "https://www.sportico.com/business/team-sales/2026/lafc-sale-beckmann-becle-cha-spring-oak-partners-1234941046/"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 5,
        "new": 4,
        "fact": "LAFC qualified 2022-2025 (3rd seed West in 2025) and missed 2021; window is 2021-2025",
        "source": "https://en.wikipedia.org/wiki/2025_MLS_Cup_playoffs"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Denis Bouanga — French-Gabonese DP winger; 18+ goals/season; ~$3M base / $4.5M total",
        "new": "Son Heung-min, Korean DP forward signed Aug 2025 from Tottenham for an MLS-record ~$26M transfer fee; anchor of the club's Korean-community commercial strategy",
        "fact": "Son joined for a record ~$26M fee in Aug 2025",
        "source": "https://www.espn.com/soccer/story/_/id/45905249/son-heung-min-tottenham-hotspur-joins-lafc-mls-record-deal"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Denis Bouanga",
            "position": "LW/CF",
            "aav": 4.5,
            "contractNote": "Designated Player through 2026; one of MLS's top scorers"
          },
          {
            "player": "Hugo Lloris",
            "position": "GK",
            "aav": 3,
            "contractNote": "Former France/Tottenham captain; signed 2024 as DP"
          },
          {
            "player": "Olivier Giroud",
            "position": "CF",
            "aav": 3.5,
            "contractNote": "DP signed 2024; departed 2025 — replaced by Son Heung-min"
          },
          {
            "player": "Son Heung-min",
            "position": "LW/CF",
            "aav": 11,
            "contractNote": "Designated Player signed 2025 from Tottenham; record MLS DP salary at signing"
          }
        ],
        "new": [
          {
            "player": "Son Heung-min",
            "position": "LW/CF",
            "aav": 11,
            "contractNote": "DP signed Aug 2025 from Tottenham for an MLS-record ~$26M fee; record DP salary at signing"
          },
          {
            "player": "Denis Bouanga",
            "position": "LW/CF",
            "aav": 4.5,
            "contractNote": "Designated Player through 2026; one of MLS's top scorers"
          },
          {
            "player": "Hugo Lloris",
            "position": "GK",
            "aav": 3,
            "contractNote": "Former France captain; signed 2024"
          }
        ],
        "fact": "Giroud departed in 2025; Son is the headline DP",
        "source": "https://www.lafc.com/news/lafc-signs-global-football-icon-son-heung-min"
      },
      {
        "field": "media.localTVDeal",
        "old": "Spanish-language broadcasts via TUDN; selected matches outside Apple package",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source)",
        "source": null
      }
    ],
    "analystNotes": "LAFC's $1.55B Forbes 2025 value, the highest in MLS, was tested in 2026 by real trades: Joe Tsai and Mike Mahan sold out and Carlos Vela, Becle CEO Juan Domingo Beckmann and James Cha bought about 6% at a ~$1.25B mark, a discount to the list price that reflects minority illiquidity rather than doubt about the asset. The commercial engine is intact, BMO Stadium fully owned with a $10M-a-year naming deal and Son Heung-min bought for a record ~$26M to activate the largest Korean community outside Korea. The club reached the 2026 Concacaf semifinal but sits 11th domestically; the next number depends on Son converting into a title while the Apple payout steps up to $275M in 2027-28.",
    "unverifiedAsOf": {}
  },
  "minnesota-united-fc": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.streamingNotes",
        "old": "All MLS matches available via Apple TV+ MLS Season Pass (10yr $2.5B deal 2023-2032)",
        "new": "All MLS matches on Apple TV; MLS Season Pass was folded into the base Apple TV subscription for 2026, and the Apple deal was amended in Nov 2025 to end after the 2028-29 season",
        "fact": "MLS and Apple scrapped the Season Pass add-on for 2026 and shortened the deal to run through 2028-29",
        "source": "https://www.mnufc.com/news/major-league-soccer-moves-to-apple-tv-starting-2026"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$8M/team/year from MLS-Apple deal (~$250M/yr ÷ 30 teams); plus selective Fox Sports Sunday games",
        "new": "Apple pays $200M for 2026 (~$6.7M/team), $107.5M for the Feb-May 2027 transition season and $275M for each of 2027-28 and 2028-29 (~$9.2M/team); plus Fox Sports linear package",
        "fact": "Revised Apple payment schedule under the Nov 2025 amendment",
        "source": "https://www.sportspro.com/news/mls-apple-tv-broadcast-deal-season-pass-contract-november-2025/"
      },
      {
        "field": "media.localTVDeal",
        "old": "Bally Sports North (selected matches outside Apple package); RSN distribution disrupted by Diamond Sports bankruptcy",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source on the post-Diamond arrangement)",
        "source": null
      }
    ],
    "analystNotes": "Minnesota United's $700M Forbes 2025 value is a clean owned-stadium story: Allianz Field, a 2025 fourth seed in the West that reached the conference semifinal, and Bill McGuire's land bank around the Midway site he keeps pressing St. Paul to improve before the winter-heavy calendar arrives in 2027. The 2026 team has fallen to 25th, and the DP pair of Yeboah and Pereyra has not produced a star the market outside Minnesota recognizes. The number moves on the Midway development actually breaking ground, which is the one asset McGuire controls that rivals do not have.",
    "unverifiedAsOf": {}
  },
  "portland-timbers": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.streamingNotes",
        "old": "All MLS matches available via Apple TV+ MLS Season Pass (10yr $2.5B deal 2023-2032)",
        "new": "All MLS matches on Apple TV; MLS Season Pass was folded into the base Apple TV subscription for 2026, and the Apple deal was amended in Nov 2025 to end after the 2028-29 season",
        "fact": "MLS and Apple scrapped the Season Pass add-on for 2026 and shortened the deal to run through 2028-29",
        "source": "https://www.espn.com/soccer/story/_/id/46954801/mls-apple-tv-scrapping-season-pass-26-season-sources"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$8M/team/year from MLS-Apple deal (~$250M/yr ÷ 30 teams); plus selective Fox Sports Sunday games",
        "new": "Apple pays $200M for 2026 (~$6.7M/team), $107.5M for the Feb-May 2027 transition season and $275M for each of 2027-28 and 2028-29 (~$9.2M/team); plus Fox Sports linear package",
        "fact": "Revised Apple payment schedule under the Nov 2025 amendment",
        "source": "https://www.sportspro.com/news/mls-apple-tv-broadcast-deal-season-pass-contract-november-2025/"
      },
      {
        "field": "onField.championshipsLast10Years",
        "old": 1,
        "new": 0,
        "fact": "Portland's only MLS Cup was 2015, which falls outside the 2016-2025 window",
        "source": "https://en.wikipedia.org/wiki/MLS_Cup"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 3,
        "new": 4,
        "fact": "Portland qualified in 2021, 2023, 2024 and 2025 (8th seed West, won the wild card 3-1 over RSL); window is 2021-2025",
        "source": "https://en.wikipedia.org/wiki/2025_MLS_Cup_playoffs"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Evander — Brazilian DP attacking mid signed from FC Midtjylland 2023; club-record signing era",
        "new": "Evander was sold to FC Cincinnati in Feb 2025 for ~$12M; Kevin Kelsy, the 2026 top scorer, was sold to Rangers in Aug 2026 for a club-record $13M plus add-ons and a sell-on",
        "fact": "Kelsy sale to Rangers agreed Aug 26, 2026 for a club-record $13M; Evander went to Cincinnati in 2025",
        "source": "https://www.mlssoccer.com/news/portland-timbers-transfer-kevin-kelsy-to-rangers-fc"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Evander",
            "position": "AM",
            "aav": 3.5,
            "contractNote": "Designated Player; club-record signing; led Timbers in goals + assists 2024"
          },
          {
            "player": "Diego Chara",
            "position": "DM",
            "aav": 1.5,
            "contractNote": "Longtime franchise figure since 2011; near end of career"
          },
          {
            "player": "Felipe Mora",
            "position": "ST",
            "aav": 2,
            "contractNote": "Chilean DP striker through 2026"
          }
        ],
        "new": [
          {
            "player": "Kevin Kelsy",
            "position": "ST",
            "aav": null,
            "contractNote": "Bought Jan 2025 for just under $6M; 16 goals in 43 MLS games; sold to Rangers Aug 2026 for club-record $13M plus add-ons and sell-on"
          },
          {
            "player": "Evander",
            "position": "AM",
            "aav": 3.5,
            "contractNote": "Club-record signing 2023; sold to FC Cincinnati Feb 2025 for ~$12M"
          },
          {
            "player": "Felipe Mora",
            "position": "ST",
            "aav": 2,
            "contractNote": "Chilean DP striker through 2026"
          }
        ],
        "fact": "Two record outbound sales in 18 months",
        "source": "https://katu.com/sports/timbers/portland-timbers-sell-star-forward-kevin-kelsy-soccer-mls-local-europe-sctoland-glasgow-oregon-rose-city-futbol"
      },
      {
        "field": "media.localTVDeal",
        "old": "Local broadcast partnerships outside Apple package; KPDX (Fox affiliate) has historic relationship",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source)",
        "source": null
      }
    ],
    "analystNotes": "Portland's $780M Forbes 2025 value is the Timbers Army premium on a 100-year-old, city-owned Providence Park where Merritt Paulson has put $145M of private money and holds a lease to 2035. The club has become a seller: Evander went to Cincinnati for ~$12M in 2025 and Kevin Kelsy to Rangers for a club-record $13M in August 2026, which is good business and bad for a team now 20th after four playoff trips in five years. With no room to expand the stadium footprint, the number only moves if Paulson turns the Moda Center fight into a broader venue deal with the city.",
    "unverifiedAsOf": {}
  },
  "real-salt-lake": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.streamingNotes",
        "old": "All MLS matches available via Apple TV+ MLS Season Pass (10yr $2.5B deal 2023-2032)",
        "new": "All MLS matches on Apple TV; MLS Season Pass was folded into the base Apple TV subscription for 2026, and the Apple deal was amended in Nov 2025 to end after the 2028-29 season",
        "fact": "MLS and Apple scrapped the Season Pass add-on for 2026 and shortened the deal to run through 2028-29",
        "source": "https://www.espn.com/soccer/story/_/id/46954801/mls-apple-tv-scrapping-season-pass-26-season-sources"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$8M/team/year from MLS-Apple deal (~$250M/yr ÷ 30 teams); plus selective Fox Sports Sunday games",
        "new": "Apple pays $200M for 2026 (~$6.7M/team), $107.5M for the Feb-May 2027 transition season and $275M for each of 2027-28 and 2028-29 (~$9.2M/team); plus Fox Sports linear package",
        "fact": "Revised Apple payment schedule under the Nov 2025 amendment",
        "source": "https://www.sportspro.com/news/mls-apple-tv-broadcast-deal-season-pass-contract-november-2025/"
      },
      {
        "field": "ownership.primaryOwner",
        "old": "Smith Entertainment Group (Ryan Smith) + David Blitzer",
        "new": "Larry H. Miller family / Miller Sports + Entertainment (Gail Miller)",
        "fact": "Miller Sports + Entertainment bought controlling interest in RSL Football Holdings (RSL, Utah Royals, Real Monarchs, America First Field, Zions Bank Stadium, training center) for $600M, announced April 18, 2025; Blitzer stays as a minority investor, Smith sold out",
        "source": "https://www.espn.com/soccer/story/_/id/44732641/real-salt-lake-utah-royals-sold-miller-family-jazz-600-million"
      },
      {
        "field": "ownership.ownerNetWorth",
        "old": "Smith ~$2B (Qualtrics co-founder); Blitzer multi-billionaire (Blackstone senior MD)",
        "new": "Miller family (Larry H. Miller Company; former Utah Jazz owners); Blitzer remains a minority investor",
        "fact": "Miller family are the former Jazz owners; net worth figure not sourced",
        "source": "https://www.deseret.com/sports/2025/04/18/larry-h-miller-sports-purchase-real-salt-lake-soccer-utah-royals-david-blitzer/"
      },
      {
        "field": "ownership.acquisitionYear",
        "old": 2022,
        "new": 2025,
        "fact": "Miller purchase announced April 18, 2025",
        "source": "https://www.espn.com/soccer/story/_/id/44732641/real-salt-lake-utah-royals-sold-miller-family-jazz-600-million"
      },
      {
        "field": "ownership.acquisitionPrice",
        "old": 0.4,
        "new": 0.6,
        "fact": "$600M enterprise value for the whole RSL Football Holdings bundle (per data/transactions.js)",
        "source": "https://www.espn.com/soccer/story/_/id/44732641/real-salt-lake-utah-royals-sold-miller-family-jazz-600-million"
      },
      {
        "field": "ownership.ownershipGroup",
        "old": [
          {
            "name": "David Blitzer",
            "role": "majority / Governor",
            "pct": null
          },
          {
            "name": "Smith Entertainment Group (Ryan Smith)",
            "role": "majority / alternate Governor",
            "pct": null
          },
          {
            "name": "Arctos Sports Partners",
            "role": "institutional minority LP",
            "pct": null
          },
          {
            "name": "Dwyane Wade",
            "role": "minority investor",
            "pct": null
          }
        ],
        "new": [
          {
            "name": "Miller Sports + Entertainment (Gail Miller / Larry H. Miller family)",
            "role": "controlling owner (2025)",
            "pct": null
          },
          {
            "name": "David Blitzer",
            "role": "minority investor (retained stake after 2025 sale)",
            "pct": null
          }
        ],
        "fact": "Controlling stake to Miller; Blitzer minority; Ryan Smith exited",
        "source": "https://www.rsl.com/utahroyals/news/miller-sports-entertainment-purchases-controlling-interest-in-rsl-football-holdings"
      },
      {
        "field": "stadium.ownershipModel",
        "old": "team-owned / SEG-owned; located in Sandy, Utah on team-owned land; renamed from Rio Tinto Stadium to America First Field in March 2022",
        "new": "team-owned (Miller Sports + Entertainment via RSL Football Holdings since 2025); located in Sandy, Utah on team-owned land; renamed from Rio Tinto Stadium to America First Field in March 2022",
        "fact": "Stadium included in the $600M Miller purchase",
        "source": "https://www.rsl.com/utahroyals/news/miller-sports-entertainment-purchases-controlling-interest-in-rsl-football-holdings"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 3,
        "new": 5,
        "fact": "RSL qualified every year 2021-2025 (9th seed West in 2025); window is 2021-2025",
        "source": "https://en.wikipedia.org/wiki/2025_MLS_Cup_playoffs"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Cristian Arango",
            "position": "Forward",
            "aav": 2.5,
            "contractNote": "Designated Player; signed 2024 from LAFC; Colombian international"
          },
          {
            "player": "Diego Luna",
            "position": "Midfielder",
            "aav": 1.2,
            "contractNote": "Young Designated Player; US international; homegrown system product"
          }
        ],
        "new": [
          {
            "player": "Cristian Arango",
            "position": "Forward",
            "aav": 2.5,
            "contractNote": "Designated Player; signed 2024 from LAFC; Colombian international"
          },
          {
            "player": "Diego Luna",
            "position": "Midfielder",
            "aav": 1.2,
            "contractNote": "Young Designated Player; US international; homegrown"
          },
          {
            "player": "Zavier Gozo",
            "position": "Winger",
            "aav": null,
            "contractNote": "Homegrown; sold to Crystal Palace Aug 2026 for a club-record $15M, second-largest homegrown fee in MLS history; RSL keeps a 20-25% sell-on"
          }
        ],
        "fact": "Gozo sale completed Aug 2026 for $15M",
        "source": "https://www.mlssoccer.com/news/real-salt-lake-transfer-zavier-gozo-to-crystal-palace"
      },
      {
        "field": "ownership.institutionalInvestors",
        "old": "Arctos Sports Partners (sports-focused PE)",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (whether Arctos and Dwyane Wade kept stakes after the 2025 sale is not sourced)",
        "source": null
      },
      {
        "field": "media.localTVDeal",
        "old": "KMYU/KJZZ-TV (Sinclair) regional broadcast partner for select matches not on Apple",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source)",
        "source": null
      }
    ],
    "analystNotes": "Real Salt Lake is the cleanest control comp in MLS: the Miller family paid $600M in April 2025 for the whole RSL Football Holdings bundle, RSL plus the Utah Royals, Real Monarchs, America First Field and Zions Bank Stadium, below the $660M Forbes 2025 value for the club alone, and 50% above the ~$400M Blitzer and Smith paid in 2022. The academy is the cash engine, with Zavier Gozo sold to Crystal Palace for a club-record $15M in August 2026 after five straight playoff seasons through 2025. The 2026 team is 21st; the number moves on the Millers applying Jazz-era operating scale to a fully owned Sandy venue.",
    "unverifiedAsOf": {}
  },
  "san-diego-fc": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.streamingNotes",
        "old": "All MLS matches available via Apple TV+ MLS Season Pass (10yr $2.5B deal 2023-2032)",
        "new": "All MLS matches on Apple TV; MLS Season Pass was folded into the base Apple TV subscription for 2026, and the Apple deal was amended in Nov 2025 to end after the 2028-29 season",
        "fact": "MLS and Apple scrapped the Season Pass add-on for 2026 and shortened the deal to run through 2028-29",
        "source": "https://www.espn.com/soccer/story/_/id/46954801/mls-apple-tv-scrapping-season-pass-26-season-sources"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$8M/team/year from MLS-Apple deal (~$250M/yr ÷ 30 teams); plus selective Fox Sports Sunday games",
        "new": "Apple pays $200M for 2026 (~$6.7M/team), $107.5M for the Feb-May 2027 transition season and $275M for each of 2027-28 and 2028-29 (~$9.2M/team); plus Fox Sports linear package",
        "fact": "Revised Apple payment schedule under the Nov 2025 amendment",
        "source": "https://www.sportspro.com/news/mls-apple-tv-broadcast-deal-season-pass-contract-november-2025/"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Hirving 'Chucky' Lozano — Designated Player, Mexican international, ~$8M AAV",
        "new": "Hirving 'Chucky' Lozano was frozen out of the 2026 plans after an October 2025 dispute with the coaching staff and loaned to LA Galaxy for the rest of 2026 with a purchase option; no replacement franchise player identified",
        "fact": "Lozano last played for SDFC in Nov 2025, was declared not part of the sporting plan for 2026, and joined the Galaxy on loan in Aug 2026",
        "source": "https://www.espn.com/soccer/story/_/id/49548687/lozano-joining-galaxy-season-long-loan"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Hirving 'Chucky' Lozano",
            "position": "Forward / Winger",
            "aav": 8,
            "contractNote": "Designated Player; signed 2024 from PSV Eindhoven; Mexican national team star — anchor of cross-border marketing strategy"
          },
          {
            "player": "Onni Valakari",
            "position": "Midfielder",
            "aav": 1.5,
            "contractNote": "Designated Player; Finnish international; signed from Pafos FC"
          }
        ],
        "new": [
          {
            "player": "Hirving 'Chucky' Lozano",
            "position": "Forward / Winger",
            "aav": 8,
            "contractNote": "DP under contract through 2028; excluded from 2026 plans; loaned to LA Galaxy Aug 2026 with option to buy"
          },
          {
            "player": "Onni Valakari",
            "position": "Midfielder",
            "aav": 1.5,
            "contractNote": "Designated Player; Finnish international; signed from Pafos FC"
          },
          {
            "player": "Luca Bombino",
            "position": "Defender",
            "aav": null,
            "contractNote": "Sold in 2026 for a club-record outgoing fee"
          }
        ],
        "fact": "Lozano loaned out; Bombino was the club's record sale in 2026",
        "source": "https://www.espn.com/soccer/story/_/id/49882716/mls-league-sets-record-incoming-outgoing-transfers-2026"
      },
      {
        "field": "media.localTVDeal",
        "old": "Limited local TV — most matches on Apple TV+ MLS Season Pass; selective broadcast partnerships",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source)",
        "source": null
      }
    ],
    "analystNotes": "San Diego FC's $850M Sportico 2025 value on a $500M expansion fee was earned in one season: 63 points, the 2025 Western Conference top seed with a record for an expansion side, and a run to the conference final. Year two is the correction, 22nd in 2026 after the club pushed out its ~$8M DP Chucky Lozano and loaned him to the rival Galaxy, and Snapdragon Stadium still belongs to SDSU. The Mansour-Sycuan group and the Right to Dream pipeline give it a durable model, but the number stalls until there is a plan for a venue the club controls.",
    "unverifiedAsOf": {}
  },
  "san-jose-earthquakes": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.streamingNotes",
        "old": "All MLS matches available via Apple TV+ MLS Season Pass (10yr $2.5B deal 2023-2032)",
        "new": "All MLS matches on Apple TV; MLS Season Pass was folded into the base Apple TV subscription for 2026, and the Apple deal was amended in Nov 2025 to end after the 2028-29 season",
        "fact": "MLS and Apple scrapped the Season Pass add-on for 2026 and shortened the deal to run through 2028-29",
        "source": "https://www.espn.com/soccer/story/_/id/46954801/mls-apple-tv-scrapping-season-pass-26-season-sources"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$8M/team/year from MLS-Apple deal (~$250M/yr ÷ 30 teams); plus selective Fox Sports Sunday games",
        "new": "Apple pays $200M for 2026 (~$6.7M/team), $107.5M for the Feb-May 2027 transition season and $275M for each of 2027-28 and 2028-29 (~$9.2M/team); plus Fox Sports linear package",
        "fact": "Revised Apple payment schedule under the Nov 2025 amendment",
        "source": "https://www.sportspro.com/news/mls-apple-tv-broadcast-deal-season-pass-contract-november-2025/"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 1,
        "new": 0,
        "fact": "San Jose missed the playoffs every year 2021-2025 (the old count included 2020); window is 2021-2025",
        "source": "https://en.wikipedia.org/wiki/2025_MLS_Cup_playoffs"
      }
    ],
    "analystNotes": "San Jose is the cheapest owned soccer stadium in a top-10 US market, $600M on the Forbes 2025 list, and it has been for sale since John Fisher hired Moelis in June 2025 with no buyer announced fifteen months later. The irony is the team: after five straight seasons outside the playoffs the Quakes are sixth in the 2026 Shield table with 45 points, the best pitch to a buyer the club has made in years. The number is set by the sale print, and a playoff run in the fall of 2026 is the seller's best leverage.",
    "unverifiedAsOf": {}
  },
  "seattle-sounders-fc": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.streamingNotes",
        "old": "All MLS matches available via Apple TV+ MLS Season Pass (10yr $2.5B deal 2023-2032)",
        "new": "All MLS matches on Apple TV; MLS Season Pass was folded into the base Apple TV subscription for 2026, and the Apple deal was amended in Nov 2025 to end after the 2028-29 season",
        "fact": "MLS and Apple scrapped the Season Pass add-on for 2026 and shortened the deal to run through 2028-29",
        "source": "https://www.espn.com/soccer/story/_/id/46954801/mls-apple-tv-scrapping-season-pass-26-season-sources"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$8M/team/year from MLS-Apple deal (~$250M/yr ÷ 30 teams); plus selective Fox Sports Sunday games",
        "new": "Apple pays $200M for 2026 (~$6.7M/team), $107.5M for the Feb-May 2027 transition season and $275M for each of 2027-28 and 2028-29 (~$9.2M/team); plus Fox Sports linear package",
        "fact": "Revised Apple payment schedule under the Nov 2025 amendment",
        "source": "https://www.sportspro.com/news/mls-apple-tv-broadcast-deal-season-pass-contract-november-2025/"
      },
      {
        "field": "ownership.institutionalInvestors",
        "old": "None disclosed; 2025 Moelis-led raise specifically targeting institutional/strategic minority partner",
        "new": "Moelis-led strategic capital raise launched Oct 2025 seeking a large minority partner (majority not ruled out) to fund a possible Longacres stadium before the Lumen Field lease ends in 2032; no investor announced as of Sept 2026",
        "fact": "Sounders retained Moelis in Oct 2025 for a strategic capital raise tied to Longacres",
        "source": "https://www.espn.com/soccer/story/_/id/46788164/seattle-sounders-seek-investment-fund-potential-soccer-stadium"
      },
      {
        "field": "media.localTVDeal",
        "old": "Local broadcast rights via Apple-MLS deal exclusively for matches; pre-Apple deal had local KING-TV partnership",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source)",
        "source": null
      }
    ],
    "analystNotes": "Seattle's $850M Forbes 2025 value prices the most complete trophy case in MLS, and 2025 added to it: the Sounders beat Inter Miami 3-0 before a Leagues Cup record 69,314 at Lumen Field to become the first club to win all five domestic trophies, and made a fourth playoff in five years. The structural problem is unchanged, Lumen is a tenant deal that expires in 2032, so Hanauer hired Moelis in October 2025 to raise minority capital for a Longacres stadium. The 2026 team is 15th; the number moves when the raise closes and names a partner and a site.",
    "unverifiedAsOf": {}
  },
  "sporting-kansas-city": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.streamingNotes",
        "old": "All MLS matches available via Apple TV+ MLS Season Pass (10yr $2.5B deal 2023-2032)",
        "new": "All MLS matches on Apple TV; MLS Season Pass was folded into the base Apple TV subscription for 2026, and the Apple deal was amended in Nov 2025 to end after the 2028-29 season",
        "fact": "MLS and Apple scrapped the Season Pass add-on for 2026 and shortened the deal to run through 2028-29",
        "source": "https://www.espn.com/soccer/story/_/id/46954801/mls-apple-tv-scrapping-season-pass-26-season-sources"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$8M/team/year from MLS-Apple deal (~$250M/yr ÷ 30 teams); plus selective Fox Sports Sunday games",
        "new": "Apple pays $200M for 2026 (~$6.7M/team), $107.5M for the Feb-May 2027 transition season and $275M for each of 2027-28 and 2028-29 (~$9.2M/team); plus Fox Sports linear package",
        "fact": "Revised Apple payment schedule under the Nov 2025 amendment",
        "source": "https://www.sportspro.com/news/mls-apple-tv-broadcast-deal-season-pass-contract-november-2025/"
      },
      {
        "field": "stadium.name",
        "old": "Children's Mercy Park (reverting to 'Sporting Park' after 2025)",
        "new": "Sporting Park",
        "fact": "The Children's Mercy deal ended after 2025 and the stadium plays 2026 as Sporting Park with no naming partner",
        "source": "https://fox4kc.com/sports/sporting-kc/sporting-kc-to-rename-stadium-as-childrens-mercy-partnership-ends/"
      },
      {
        "field": "stadium.namingRightsDeal",
        "old": {
          "sponsor": "Children's Mercy Hospital (expiring entering 2026)",
          "annualValue_M": null,
          "totalValue_M": null,
          "expiryYear": 2025,
          "notes": "10-year deal signed Nov 2015 expiring entering 2026 season; club has no replacement deal announced and reverts to 'Sporting Park'; original deal financial terms undisclosed but estimated $20-30M total"
        },
        "new": {
          "sponsor": null,
          "annualValue_M": null,
          "totalValue_M": null,
          "expiryYear": null,
          "notes": "No naming partner for 2026; Children's Mercy's 10-year deal (2015-2025) expired and the venue reverted to Sporting Park"
        },
        "fact": "No naming rights deal entering 2026",
        "source": "https://en.wikipedia.org/wiki/Sporting_Park"
      },
      {
        "field": "ownership.acquisitionPrice",
        "old": 0.5,
        "new": 0.7,
        "fact": "Mallouk's ~71% purchase was at a $700M enterprise value, the highest price for an MLS majority stake, finalized Dec 2025 and public Jan 2026 (per data/transactions.js)",
        "source": "https://www.sportspro.com/news/finance-investment/sporting-kansas-city-sale-peter-mallouk-illig-ownership-valuation-mls-january-2026/"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Dániel Sallói — Hungarian international forward, longtime franchise player, ~$1.5M AAV",
        "new": "André Luiz, Brazilian DP forward signed Aug 18, 2026 from Olympiacos for a club-record $18M plus up to $4M in add-ons",
        "fact": "Club-record $18M transfer, more than double the previous $7.5M record for Alan Pulido",
        "source": "https://www.sportingkc.com/news/sporting-kc-acquires-forward-andre-luiz-in-club-record-transfer-from-olympiacos-fc"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Dániel Sallói",
            "position": "Forward",
            "aav": 1.5,
            "contractNote": "TAM/Designated Player; Hungarian international; longtime franchise scorer"
          },
          {
            "player": "Erik Thommy",
            "position": "Midfielder",
            "aav": 2,
            "contractNote": "Designated Player; German midfielder; signed 2023 from Stuttgart"
          }
        ],
        "new": [
          {
            "player": "André Luiz",
            "position": "Forward",
            "aav": null,
            "contractNote": "DP; club-record $18M (+$4M add-ons) from Olympiacos, Aug 2026"
          },
          {
            "player": "Dániel Sallói",
            "position": "Forward",
            "aav": 1.5,
            "contractNote": "Hungarian international; longtime franchise scorer"
          },
          {
            "player": "Erik Thommy",
            "position": "Midfielder",
            "aav": 2,
            "contractNote": "Designated Player; German midfielder; signed 2023 from Stuttgart"
          }
        ],
        "fact": "André Luiz added as the record DP",
        "source": "https://www.espn.com/soccer/story/_/id/49649637/sporting-kc-transfer-andre-luiz-record-olympiacos"
      },
      {
        "field": "media.localTVDeal",
        "old": "KSHB / E.W. Scripps regional partner for select matches not on Apple",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source)",
        "source": null
      }
    ],
    "analystNotes": "Sporting Kansas City's $700M Forbes 2025 value was printed by Peter Mallouk's purchase of ~71% from the Illig family at exactly that enterprise value, the highest ever for an MLS majority stake, with the Illigs keeping operations and the board seat. What Mallouk bought is a team-owned stadium with no naming partner for 2026 and the worst record in MLS, 30th with 21 points and a minus-32 goal difference, three seasons out of the playoffs. His first move was a club-record $18M for André Luiz in August 2026; the number moves on a new stadium sponsor and a roster that stops being last, and the record price already assumes both.",
    "unverifiedAsOf": {}
  },
  "st-louis-city-sc": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.streamingNotes",
        "old": "All MLS matches available via Apple TV+ MLS Season Pass (10yr $2.5B deal 2023-2032)",
        "new": "All MLS matches on Apple TV; MLS Season Pass was folded into the base Apple TV subscription for 2026, and the Apple deal was amended in Nov 2025 to end after the 2028-29 season",
        "fact": "MLS and Apple scrapped the Season Pass add-on for 2026 and shortened the deal to run through 2028-29",
        "source": "https://www.espn.com/soccer/story/_/id/46954801/mls-apple-tv-scrapping-season-pass-26-season-sources"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$8M/team/year from MLS-Apple deal (~$250M/yr ÷ 30 teams); plus selective Fox Sports Sunday games",
        "new": "Apple pays $200M for 2026 (~$6.7M/team), $107.5M for the Feb-May 2027 transition season and $275M for each of 2027-28 and 2028-29 (~$9.2M/team); plus Fox Sports linear package",
        "fact": "Revised Apple payment schedule under the Nov 2025 amendment",
        "source": "https://www.sportspro.com/news/mls-apple-tv-broadcast-deal-season-pass-contract-november-2025/"
      },
      {
        "field": "stadium.name",
        "old": "CITYPARK (Energizer Park as of 2024 — naming rights renamed)",
        "new": "Energizer Park",
        "fact": "Stadium has carried the Energizer Park name since 2024",
        "source": "https://www.mlssoccer.com/news/st-louis-city-sc-stadium-renamed-energizer-park"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Eduard Löwen",
            "position": "Midfielder",
            "aav": 2.5,
            "contractNote": "Designated Player; signed 2022 from Hertha Berlin; German Bundesliga pedigree"
          },
          {
            "player": "Cedric Teuchert",
            "position": "Forward",
            "aav": 1.5,
            "contractNote": "Designated Player; German forward; signed 2024 from Hannover"
          }
        ],
        "new": [
          {
            "player": "Carlo Holse",
            "position": "Winger",
            "aav": null,
            "contractNote": "Club-record incoming signing for 2026; scored in three straight home matches at Energizer Park"
          },
          {
            "player": "Rafael Navarro",
            "position": "Forward",
            "aav": null,
            "contractNote": "Club-record incoming signing for 2026 (from Colorado)"
          },
          {
            "player": "João Klauss",
            "position": "Forward",
            "aav": null,
            "contractNote": "Sold in 2026 for a club-record outgoing fee"
          },
          {
            "player": "Eduard Löwen",
            "position": "Midfielder",
            "aav": 2.5,
            "contractNote": "Designated Player; signed 2022 from Hertha Berlin"
          }
        ],
        "fact": "Holse and Navarro set the club's incoming records and Klauss its outgoing record in 2026 per ESPN's league summary",
        "source": "https://www.espn.com/soccer/story/_/id/49882716/mls-league-sets-record-incoming-outgoing-transfers-2026"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Eduard Löwen — German Designated Player midfielder, ~$2.5M AAV",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (2026 role not confirmed)",
        "source": null
      },
      {
        "field": "media.localTVDeal",
        "old": "FanDuel Sports Network Midwest regional partner for select matches not on Apple",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source)",
        "source": null
      }
    ],
    "analystNotes": "St. Louis City SC's $850M Forbes 2025 value on a $200M 2019 entry is the model expansion return: a fully private ~$667M downtown campus at Energizer Park, Taylor-family capital, and full venue economics. The 2025 season was a miss after the 2023 top-seed debut, and 2026 has been a rebuild that reset both transfer records, Carlo Holse and Rafael Navarro in, João Klauss out, with the team eighth in the Shield table on Sept 27 and back in playoff position. Sustaining an $850M number in a mid-sized market requires the downtown building to be a playoff venue most years, and 2026 is the first test of that since year one.",
    "unverifiedAsOf": {}
  },
  "vancouver-whitecaps-fc": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.streamingNotes",
        "old": "All MLS matches available via Apple TV+ MLS Season Pass (10yr $2.5B deal 2023-2032)",
        "new": "All MLS matches on Apple TV; MLS Season Pass was folded into the base Apple TV subscription for 2026, and the Apple deal was amended in Nov 2025 to end after the 2028-29 season",
        "fact": "MLS and Apple scrapped the Season Pass add-on for 2026 and shortened the deal to run through 2028-29",
        "source": "https://www.espn.com/soccer/story/_/id/46954801/mls-apple-tv-scrapping-season-pass-26-season-sources"
      },
      {
        "field": "media.nationalShareNote",
        "old": "~$8M/team/year from MLS-Apple deal (~$250M/yr ÷ 30 teams); plus selective Fox Sports Sunday games",
        "new": "Apple pays $200M for 2026 (~$6.7M/team), $107.5M for the Feb-May 2027 transition season and $275M for each of 2027-28 and 2028-29 (~$9.2M/team); plus Fox Sports linear package",
        "fact": "Revised Apple payment schedule under the Nov 2025 amendment",
        "source": "https://www.sportspro.com/news/mls-apple-tv-broadcast-deal-season-pass-contract-november-2025/"
      },
      {
        "field": "stadium.ownershipModel",
        "old": "owned by BC Pavilion Corporation (PavCo, BC Crown corporation); Whitecaps are tenants alongside BC Lions (CFL); club lease is widely regarded as MLS's worst — Whitecaps capture only ~12% of matchday revenue compared to ~100% for stadium-owning MLS clubs",
        "new": "owned by BC Pavilion Corporation (PavCo, BC Crown corporation); Whitecaps are tenants alongside BC Lions (CFL); lease extended only through the 2026 season and as of Sept 23, 2026 there is no formal agreement for 2027; club captures only ~12% of matchday revenue",
        "fact": "CEO Axel Schuster said on Sept 23, 2026 there is no formal BC Place agreement for 2027, only near-term security on some dates",
        "source": "https://www.tsn.ca/soccer/mls/article/whitecaps-ceo-says-sale-of-mls-team-no-closer-to-reality/"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "Long-discussed soccer-specific stadium for Whitecaps but no announced project; sale process likely conditioned on relocation or new venue plan",
        "new": "No Vancouver stadium project; the only formal bid, from Las Vegas investor Grant Gustavson (May 2026), includes a new Las Vegas stadium with an interim venue; a Vancouver-based group was reported interested but no viable local offer had emerged as of Sept 23, 2026",
        "fact": "Gustavson's formal offer includes a Las Vegas stadium commitment; the club says no viable offer to stay in Vancouver has emerged",
        "source": "https://www.espn.com/soccer/story/_/id/48640019/las-vegas-group-offer-buy-relocate-mls-vancouver-whitecaps"
      },
      {
        "field": "ownership.primaryOwner",
        "old": "Greg Kerfoot (largest shareholder; ownership group selling)",
        "new": "Greg Kerfoot (largest shareholder); Kerfoot, Luczo, Mallett and Nash have had the club for sale since Dec 2024 with over 100 parties contacted and 30-plus given financials; only formal bid is Grant Gustavson's Las Vegas relocation offer (May 2026); CEO said on Sept 23, 2026 'nothing has changed'",
        "fact": "Sale unresolved as of Sept 23, 2026; asking price not released",
        "source": "https://www.tsn.ca/soccer/mls/article/whitecaps-ceo-says-sale-of-mls-team-no-closer-to-reality/"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 3,
        "new": 4,
        "fact": "Vancouver qualified in 2021, 2023, 2024 and 2025 (2nd seed West with 63 points, reached MLS Cup 2025 and lost 3-1 at Inter Miami); window is 2021-2025",
        "source": "https://en.wikipedia.org/wiki/2025_MLS_Cup_playoffs"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Brian White — American forward, ~$1.2M AAV; club has lacked marquee Designated Player commitment",
        "new": "Thomas Müller, Bayern Munich and Germany legend signed Aug 2025; 2026 option exercised and converted to a Designated Player contract",
        "fact": "Whitecaps exercised Müller's 2026 option and made him a DP",
        "source": "https://www.mlssoccer.com/news/vancouver-whitecaps-roster-thomas-muller-contract-option-exercised"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Brian White",
            "position": "Forward",
            "aav": 1.2,
            "contractNote": "TAM contract; US international; longtime franchise scorer"
          },
          {
            "player": "Andrés Cubas",
            "position": "Defensive Midfielder",
            "aav": 1.5,
            "contractNote": "Designated Player; Paraguayan international; signed 2022 from Nîmes (Ligue 1)"
          }
        ],
        "new": [
          {
            "player": "Thomas Müller",
            "position": "AM/FW",
            "aav": null,
            "contractNote": "Signed Aug 2025; 2026 option exercised; Designated Player for 2026"
          },
          {
            "player": "Brian White",
            "position": "Forward",
            "aav": 1.2,
            "contractNote": "TAM contract; US international; longtime franchise scorer"
          },
          {
            "player": "Andrés Cubas",
            "position": "Defensive Midfielder",
            "aav": 1.5,
            "contractNote": "Designated Player; Paraguayan international; signed 2022 from Nîmes"
          }
        ],
        "fact": "Müller is the headline DP",
        "source": "https://www.mlssoccer.com/news/vancouver-whitecaps-roster-thomas-muller-contract-option-exercised"
      },
      {
        "field": "media.localTVDeal",
        "old": "TSN regional rights for select matches not on Apple",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (no 2026 source)",
        "source": null
      }
    ],
    "analystNotes": "Vancouver is the strangest asset in MLS in 2026: the $600M Forbes 2025 value is the joint-lowest in the league, yet the Whitecaps reached MLS Cup 2025 with 63 points, lead the Western Conference with 50 points on Sept 27 behind Thomas Müller, and still cannot find a buyer after 21 months, more than 100 inquiries and 30-plus data-room visits. The only formal offer is Grant Gustavson's May 2026 bid to move the club to Las Vegas with a new stadium, the BC Place tenancy captures about 12% of matchday revenue, and there is no signed 2027 lease. The number is set by whether the province and a local group produce a Vancouver stadium answer before the relocation offer becomes the only one on the table.",
    "unverifiedAsOf": {}
  },
  "manchester-united": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "stadium.newStadiumPlans",
        "old": "Ratcliffe announced March 2025 plan for new ~100,000-capacity 'world's greatest stadium' adjacent to Old Trafford; estimated £2B cost; design by Foster + Partners; would be the largest UK club stadium",
        "new": "100,000-seat new stadium confirmed for the Wharfside site about 350m north-west of Old Trafford; club secured the required land from a local freight company in July 2026 and entered Trafford Council public consultation (sessions July to September 2026); Foster + Partners umbrella design, estimated £2B, roughly five-year build; no final decision yet on the future of Old Trafford itself",
        "fact": "July 9, 2026: United confirmed the site and land acquisition for the 100,000-seat stadium; consultation sessions ran through September 2026",
        "source": "https://www.foxsports.com/articles/soccer/man-utd-reveal-where-new-100000-seater-stadium-will-be-built-as-red-devils-prepare-to-leave-old-trafford"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Bruno Fernandes — captain, ~£300K/wk, contract through 2026 with extension option",
        "new": "Bruno Fernandes, captain, contract through June 2027; 2025-26 Premier League Player of the Season and FWA Footballer of the Year, broke the Premier League single-season assists record",
        "fact": "Fernandes' deal was extended to 30 June 2027 (August 2024) and he won the 2025-26 Premier League Player of the Season award",
        "source": "https://en.wikipedia.org/wiki/Bruno_Fernandes"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Bruno Fernandes",
            "position": "AM",
            "aav": 19.5,
            "contractNote": "~£300K/wk; signed 2022 extension; 2nd-highest paid in squad"
          },
          {
            "player": "Marcus Rashford",
            "position": "FW",
            "aav": 22,
            "contractNote": "5yr extension signed 2023; ~£325K/wk; loaned to Aston Villa Feb 2025"
          },
          {
            "player": "Casemiro",
            "position": "DM",
            "aav": 18,
            "contractNote": "Signed 2022 from Real Madrid for £70M; ~£350K/wk"
          }
        ],
        "new": [
          {
            "player": "Bruno Fernandes",
            "position": "AM",
            "aav": 19.5,
            "contractNote": "~£300K/wk; captain; contract through June 2027; 2025-26 PL Player of the Season"
          },
          {
            "player": "Bryan Mbeumo",
            "position": "FW",
            "aav": null,
            "contractNote": "Signed from Brentford summer 2025 for ~£65M plus add-ons (~£71M)"
          },
          {
            "player": "Benjamin Sesko",
            "position": "FW",
            "aav": null,
            "contractNote": "Signed from RB Leipzig summer 2025 for £66.3M plus add-ons (~£73.7M)"
          },
          {
            "player": "Carlos Baleba",
            "position": "DM",
            "aav": null,
            "contractNote": "Signed from Brighton 25 Aug 2026 on a five-year deal, reported £70M including add-ons"
          }
        ],
        "fact": "Rashford (loaned to Barcelona) and Casemiro (left as a free agent summer 2026) no longer anchor the squad; Mbeumo, Sesko (2025) and Baleba (Aug 2026) are the new headline contracts",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_Manchester_United_F.C._season"
      },
      {
        "field": "media.localTVDeal",
        "old": "Premier League collective deal — UK domestic 2025-28: ~£6.7B/4yr (~£1.67B/yr); facility fee based on UK TV appearances",
        "new": "Premier League collective deal, UK domestic cycle 2025-26 to 2028-29: £6.7B over four seasons (~£1.67B/yr), Sky Sports 215+ live matches per season and TNT Sports 52; equal share ~£85M per club in 2025-26 plus facility fees and merit payments",
        "fact": "The £6.7B Sky/TNT domestic cycle runs 2025-26 through 2028-29 (four seasons), not 2025-28; 2025-26 was its first season with an equal share of about £85M per club",
        "source": "https://www.sportspro.com/news/premier-league-tv-rights-deal-sky-tnt-amazon-2025-2029/"
      }
    ],
    "analystNotes": "Manchester United is worth $7.2B on the Forbes 2026 list, the most valuable club in football, on $865M of revenue and $237M of operating income even after a decade without a league title. The 2025-26 recovery under Michael Carrick, third place and a Champions League return, restores the UEFA money that was missing from 2024-25, and the new 100,000-seat stadium moved from concept to a secured site at Wharfside in July 2026 with the Trafford Council consultation underway. The number now turns on whether the roughly £2B stadium gets financed without diluting the Glazer and Ratcliffe equity, and on Old Trafford's replacement lifting matchday revenue past the £160M it already generates.",
    "unverifiedAsOf": {
      "revenue.estimate": "May 2026",
      "ownership.ownerNetWorth": "May 2026"
    }
  },
  "manchester-city": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "stadium.capacity",
        "old": 53400,
        "new": 61000,
        "fact": "Expanded North Stand (named The Pep Guardiola Stand) opened at full capacity for the final home match of 2025-26 against Aston Villa, taking the Etihad past 61,000",
        "source": "https://www.thestadiumbusiness.com/2026/05/21/etihad-stadiums-expanded-north-stand-set-to-open-for-final-game/"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "£300M+ Etihad expansion approved 2023: North Stand expansion to ~61,000 capacity by 2026, plus hotel, museum, fan zone; financed by club / ADUG",
        "new": "£300M+ North Stand expansion complete: stand opened May 2026 as The Pep Guardiola Stand, capacity now above 61,000; hotel, museum, fan zone, new club shop and food and beverage spaces due to open late 2026",
        "fact": "North Stand expansion opened May 2026; remaining hospitality and hotel components scheduled for late 2026",
        "source": "https://stadiumdb.com/news/2026/05/england_the_pep_guardiola_stand_manchester_city_honours_its_manager_and_opens_new_north_stand"
      },
      {
        "field": "stadium.namingRightsDeal",
        "old": {
          "sponsor": "Etihad Airways",
          "annualValue_M": 28,
          "totalValue_M": 400,
          "expiryYear": 2025,
          "notes": "10-year deal signed 2011 covered stadium + Etihad Campus + sleeve + extensive UAE-linked commercial integration; PSR / fair-value scrutiny by Premier League pending in 115 charges; deal renewed/extended"
        },
        "new": {
          "sponsor": "Etihad Airways",
          "annualValue_M": 28,
          "totalValue_M": 400,
          "expiryYear": 2025,
          "notes": "10-year deal signed 2011 covered stadium + Etihad Campus + sleeve + extensive UAE-linked commercial integration; Etihad remains stadium and front-of-shirt partner in 2026-27; an independent commission reportedly found City in breach on 114 of 115 Premier League charges (reported 25 Sept 2026), sanction not yet set, club intends to appeal"
        },
        "fact": "Etihad is still the stadium and shirt sponsor for 2026-27; the 115-charges case moved from pending to a reported adverse finding in September 2026",
        "source": "https://www.beinsports.com/en-us/soccer/premier-league/articles/manchester-city-receives-verdict-on-115-premier-league-charges-2026-09-25"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Erling Haaland — 9.5yr / £390K/wk extension signed Jan 2025, contract through 2034",
        "new": "Erling Haaland, contract through 2034 (~£390K/wk); 2025-26 Premier League Golden Boot with 27 goals; Enzo Maresca replaced Pep Guardiola as manager in June 2026 on a three-year deal",
        "fact": "Haaland was 2025-26 top scorer (27); Guardiola left at the end of 2025-26 and became a City Football Group global ambassador; Maresca appointed 29 June 2026",
        "source": "https://en.wikipedia.org/wiki/Enzo_Maresca"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Erling Haaland",
            "position": "FW",
            "aav": 26.4,
            "contractNote": "Jan 2025 extension; ~£390K/wk; through 2034; record-breaking £51M release clause from Dortmund 2022"
          },
          {
            "player": "Kevin De Bruyne",
            "position": "AM",
            "aav": 26,
            "contractNote": "~£385K/wk; departing summer 2025 free transfer announced"
          },
          {
            "player": "Phil Foden",
            "position": "AM/W",
            "aav": 19,
            "contractNote": "Local academy product; ~£300K/wk; through 2027; PFA Player of Season 2023-24"
          }
        ],
        "new": [
          {
            "player": "Erling Haaland",
            "position": "FW",
            "aav": 26.4,
            "contractNote": "Jan 2025 extension; ~£390K/wk; through 2034; 27 PL goals in 2025-26"
          },
          {
            "player": "Enzo Fernandez",
            "position": "CM",
            "aav": null,
            "contractNote": "Signed from Chelsea summer 2026 for a reported £125M"
          },
          {
            "player": "Elliot Anderson",
            "position": "CM",
            "aav": null,
            "contractNote": "Signed from Nottingham Forest July 2026 for £116M on a five-year deal, then a record for an English player"
          },
          {
            "player": "Antoine Semenyo",
            "position": "RW",
            "aav": null,
            "contractNote": "Signed from Bournemouth Jan 2026 for £62.5M plus £1.5M add-ons; contract to 2031"
          },
          {
            "player": "Phil Foden",
            "position": "AM/W",
            "aav": 19,
            "contractNote": "Academy product; ~£300K/wk; through 2027"
          }
        ],
        "fact": "De Bruyne left in 2025; Rodri was sold to Barcelona in summer 2026; City spent over £400M in summer 2026 on Fernandez, Anderson and others",
        "source": "https://en.wikipedia.org/wiki/Elliot_Anderson_(footballer)"
      },
      {
        "field": "media.localTVDeal",
        "old": "Premier League collective deal — UK domestic 2025-28: ~£6.7B/4yr (~£1.67B/yr); facility fee tier 1 due to title dominance",
        "new": "Premier League collective deal, UK domestic cycle 2025-26 to 2028-29: £6.7B over four seasons (~£1.67B/yr), Sky Sports 215+ live matches per season and TNT Sports 52; equal share ~£85M per club in 2025-26 plus facility fees and merit payments",
        "fact": "The £6.7B Sky/TNT domestic cycle runs 2025-26 through 2028-29 (four seasons), not 2025-28; 2025-26 was its first season with an equal share of about £85M per club",
        "source": "https://www.sportspro.com/news/premier-league-tv-rights-deal-sky-tnt-amazon-2025-2029/"
      }
    ],
    "analystNotes": "Manchester City carries a $5.5B Forbes 2026 mark on $900M of revenue, the highest in the league, and the Etihad now seats more than 61,000 after the Pep Guardiola Stand opened in May 2026 with a hotel and fan zone following late this year. The sporting engine is being rebuilt at once: Guardiola left after ten years and 20 trophies, Enzo Maresca arrived in June 2026, and the club spent over £400M in one window on Enzo Fernandez and Elliot Anderson. The single item that moves this number is the sanction on the 115 charges: an independent commission reportedly upheld 114 of them in September 2026, the penalty is unset and City will appeal, so a points deduction or worse is the live downside against a 2025-26 domestic cup double and second place.",
    "unverifiedAsOf": {
      "ownership.ownerNetWorth": "May 2026",
      "stadium.namingRightsDeal": "May 2026",
      "revenue.estimate": "May 2026"
    }
  },
  "liverpool": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.primaryOwner",
        "old": "Fenway Sports Group (John W. Henry chairman, Tom Werner co-owner)",
        "new": "Fenway Sports Group (John W. Henry chairman, Tom Werner co-owner), majority; 1892 Holdings (Amit Bhatia, Mittal Family Trusts, Jeff Bezos via K5 Sports, Eduardo and Elaine Saverin via EE Capital) agreed August 2026 to buy 30% at a $7.445B implied valuation",
        "fact": "FSG agreed on 14 Aug 2026 to sell a 30% minority stake to 1892 Holdings for £1.65B; FSG retains control and runs sporting and financial strategy",
        "source": "https://www.liverpoolfc.com/news/fsg-announces-strategic-minority-investment-liverpool-fc"
      },
      {
        "field": "ownership.ownershipGroup",
        "old": [
          {
            "name": "Fenway Sports Group",
            "role": "majority owner of Liverpool FC",
            "pct": null
          },
          {
            "name": "RedBird Capital Partners",
            "role": "minority FSG holding-co (~11% acquired 2021 for $750M)",
            "pct": null
          },
          {
            "name": "Dynasty Equity",
            "role": "Liverpool FC direct minority injection $200M Sept 2023",
            "pct": null
          },
          {
            "name": "LeBron James",
            "role": "FSG minority partner via Maverick Carter",
            "pct": null
          }
        ],
        "new": [
          {
            "name": "Fenway Sports Group",
            "role": "majority owner of Liverpool FC",
            "pct": null
          },
          {
            "name": "1892 Holdings (Amit Bhatia; Mittal Family Trusts, K5 Sports/Jeff Bezos, EE Capital/Eduardo and Elaine Saverin)",
            "role": "30% minority agreed Aug 2026 at £1.65B ($7.445B implied); Bhatia vice-chair, board seats",
            "pct": 30
          },
          {
            "name": "RedBird Capital Partners",
            "role": "minority FSG holding-co (~11% acquired 2021 for $750M)",
            "pct": null
          },
          {
            "name": "Dynasty Equity",
            "role": "Liverpool FC direct minority injection $200M Sept 2023",
            "pct": null
          },
          {
            "name": "LeBron James",
            "role": "FSG minority partner via Maverick Carter",
            "pct": null
          }
        ],
        "fact": "1892 Holdings added as a 30% direct minority holder (agreed, per transactions.js)",
        "source": "https://www.insideworldfootball.com/2026/08/17/fsg-agrees-1-65bn-sale-of-30-of-liverpool-to-1892-holdings/"
      },
      {
        "field": "ownership.institutionalInvestors",
        "old": "RedBird Capital (US PE), Dynasty Equity (US sports PE), Salem Partners minority",
        "new": "1892 Holdings (Mittal family, Bezos, Saverin family offices) 30% at club level from Aug 2026; RedBird Capital (US PE) and Dynasty Equity (US sports PE) at FSG/club level; Salem Partners minority",
        "fact": "August 2026 minority sale brought trophy family-office capital into the club at a $7.4B mark",
        "source": "https://www.liverpoolfc.com/news/fsg-announces-strategic-minority-investment-liverpool-fc"
      },
      {
        "field": "ownership.currentValuation",
        "old": 5.37,
        "new": 7.445,
        "fact": "Implied whole-club valuation from the 1892 Holdings deal (30% for £1.65B)",
        "source": "https://www.insideworldfootball.com/2026/08/17/fsg-agrees-1-65bn-sale-of-30-of-liverpool-to-1892-holdings/"
      },
      {
        "field": "onField.championshipsLast10Years",
        "old": 1,
        "new": 2,
        "fact": "Premier League titles in the ten seasons 2016-17 to 2025-26: 2019-20 and 2024-25",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_Premier_League"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Mohamed Salah — 2yr extension signed April 2025, ~£400K/wk through 2027",
        "new": "Alexander Isak, British-record £125M signing from Newcastle (Sept 2025) on a six-year contract; Mohamed Salah left on a free transfer to Trabzonspor in July 2026 after announcing his exit in March 2026",
        "fact": "Salah departed at the end of 2025-26; Isak is the record signing; Arne Slot left 30 May 2026 and Andoni Iraola was appointed 4 June 2026 on a two-year deal",
        "source": "https://en.wikipedia.org/wiki/Mohamed_Salah"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Mohamed Salah",
            "position": "FW",
            "aav": 27,
            "contractNote": "April 2025 extension after long uncertainty; through 2027; ~£400K/wk; club's top earner"
          },
          {
            "player": "Virgil van Dijk",
            "position": "CB",
            "aav": 21,
            "contractNote": "April 2025 extension as captain; through 2027; ~£310K/wk"
          },
          {
            "player": "Trent Alexander-Arnold",
            "position": "RB",
            "aav": 0,
            "contractNote": "Departed June 2025 free transfer to Real Madrid (signed pre-bosman in May)"
          }
        ],
        "new": [
          {
            "player": "Alexander Isak",
            "position": "FW",
            "aav": null,
            "contractNote": "Signed from Newcastle 1 Sept 2025 for a British-record £125M; six-year contract; injury-hit first season"
          },
          {
            "player": "Florian Wirtz",
            "position": "AM",
            "aav": null,
            "contractNote": "Signed from Bayer Leverkusen summer 2025 for £100M rising to £116.5M"
          },
          {
            "player": "Virgil van Dijk",
            "position": "CB",
            "aav": 21,
            "contractNote": "April 2025 extension as captain; through 2027; ~£310K/wk"
          },
          {
            "player": "Mohamed Salah",
            "position": "FW",
            "aav": 0,
            "contractNote": "Left on a free transfer to Trabzonspor July 2026 after nine seasons"
          }
        ],
        "fact": "Salah and Alexander-Arnold gone; Isak and Wirtz are the new anchor contracts",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_Liverpool_F.C._season"
      },
      {
        "field": "media.localTVDeal",
        "old": "Premier League collective deal — UK domestic 2025-28: ~£6.7B/4yr (~£1.67B/yr); facility fee tier 1 (most-televised tier)",
        "new": "Premier League collective deal, UK domestic cycle 2025-26 to 2028-29: £6.7B over four seasons (~£1.67B/yr), Sky Sports 215+ live matches per season and TNT Sports 52; equal share ~£85M per club in 2025-26 plus facility fees and merit payments",
        "fact": "The £6.7B Sky/TNT domestic cycle runs 2025-26 through 2028-29 (four seasons), not 2025-28; 2025-26 was its first season with an equal share of about £85M per club",
        "source": "https://www.sportspro.com/news/premier-league-tv-rights-deal-sky-tnt-amazon-2025-2029/"
      }
    ],
    "analystNotes": "Liverpool is valued at $6.2B on the Forbes 2026 list, second in football, on a league-high $911M of revenue, and the market then went higher: FSG agreed in August 2026 to sell 30% to 1892 Holdings, the Mittal, Bezos and Saverin vehicle, for £1.65B, a $7.4B implied mark that is a 20% premium to Forbes. That price was paid after a flat 2025-26, fifth place and a Champions League quarter-final, the exit of Arne Slot and the free-transfer departure of Mohamed Salah, so it prices the brand and Anfield's 61,276 seats rather than the season. What moves the number next is whether Andoni Iraola turns £125M Alexander Isak and £100M Florian Wirtz into titles, because the buyers paid for a club that had just fallen from champion to fifth.",
    "unverifiedAsOf": {
      "ownership.ownerNetWorth": "May 2026",
      "revenue.estimate": "May 2026"
    }
  },
  "arsenal": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.championshipsLast10Years",
        "old": 0,
        "new": 1,
        "fact": "Arsenal won the 2025-26 Premier League with 85 points, seven clear of Manchester City, clinched 19 May 2026; first league title since 2003-04",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_Premier_League"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 3,
        "new": 5,
        "fact": "European qualification earned in each of 2021-22 (5th, Europa League) through 2025-26 (champions); also 2025-26 Champions League runners-up and EFL Cup runners-up",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_Arsenal_F.C._season"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Bukayo Saka — 4yr extension signed 2023, £200K/wk through 2027",
        "new": "Bukayo Saka, new five-year contract agreed January 2026 through 2031; Bruno Guimaraes signed from Newcastle August 2026 for ~£75M on a four-year deal",
        "fact": "Saka agreed a new deal to 2031 on 9 Jan 2026 (previous deal ran to 2027); Guimaraes joined 8 Aug 2026",
        "source": "https://www.skysports.com/football/news/11670/13492493/bukayo-saka-new-contract-arsenal-winger-agrees-new-long-term-deal-at-emirates-stadium"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Bukayo Saka",
            "position": "RW",
            "aav": 13.5,
            "contractNote": "Academy product; £200K/wk; through 2027; star of Arteta rebuild"
          },
          {
            "player": "Martin Ødegaard",
            "position": "AM",
            "aav": 14.2,
            "contractNote": "Captain; signed 2022 from Real Madrid £30M; £210K/wk through 2028"
          },
          {
            "player": "Declan Rice",
            "position": "DM",
            "aav": 16.2,
            "contractNote": "Signed 2023 from West Ham £105M club record; £240K/wk through 2028"
          }
        ],
        "new": [
          {
            "player": "Bukayo Saka",
            "position": "RW",
            "aav": null,
            "contractNote": "Academy product; new five-year deal agreed Jan 2026 through 2031"
          },
          {
            "player": "Declan Rice",
            "position": "DM",
            "aav": 16.2,
            "contractNote": "Signed 2023 from West Ham £105M; £240K/wk through 2028"
          },
          {
            "player": "Martin Odegaard",
            "position": "AM",
            "aav": 14.2,
            "contractNote": "Captain; £210K/wk through 2028"
          },
          {
            "player": "Bruno Guimaraes",
            "position": "CM",
            "aav": null,
            "contractNote": "Signed from Newcastle 8 Aug 2026 for ~£75M; four-year contract"
          },
          {
            "player": "Eberechi Eze",
            "position": "AM",
            "aav": null,
            "contractNote": "Signed from Crystal Palace summer 2025 for £60M plus £7.5M add-ons"
          }
        ],
        "fact": "Saka extended to 2031; Eze (2025) and Guimaraes (2026) added; Martinelli sold to Al-Hilal for a club-record £60M in summer 2026",
        "source": "https://en.wikipedia.org/wiki/Bruno_Guimar%C3%A3es"
      },
      {
        "field": "stadium.namingRightsDeal",
        "old": {
          "sponsor": "Emirates Airline",
          "annualValue_M": 31,
          "totalValue_M": 200,
          "expiryYear": 2028,
          "notes": "Emirates 5-year extension signed 2018 covered shirt + stadium combined ~£200M total; one of largest single-sponsor packages in football; predecessor 'Ashburton Grove' development name"
        },
        "new": {
          "sponsor": "Emirates Airline",
          "annualValue_M": 31,
          "totalValue_M": 200,
          "expiryYear": 2028,
          "notes": "Emirates 5-year extension signed 2018 covered shirt + stadium combined ~£200M total; in July-August 2026 the club and Emirates were reported to have agreed a renewal covering stadium naming, front-of-shirt and training kit through 2033, reported at ~£70M/yr and up to ~£500M over the term; annual and expiry figures kept at 2018 terms until the club publishes the new deal"
        },
        "fact": "Reported Emirates renewal to 2033 (summer 2026); club has not published terms so the numeric fields are unchanged and the note records the report",
        "source": "https://footballgroundguide.com/news/emirates-stadium-expansion.html"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "Kroenke considering Emirates expansion to ~70,000 capacity; planning study underway 2024-25; no firm timeline; would require redevelopment of east stand",
        "new": "Expansion of the 60,704-seat Emirates in a formal planning phase since June 2026 with advisers and original architects Populous engaged and board member Otto Maly (SoFi Stadium) overseeing; most likely option reported as roughly 5,000 additional premium seats rather than a 70,000 to 80,000 rebuild, to avoid a temporary move to Wembley; no application filed",
        "fact": "June 2026: Arsenal entered a formal planning phase; a premium-seat remodel is the reported favoured option",
        "source": "https://dailycannon.com/2026/06/emirates-stadium-expansion-options/"
      },
      {
        "field": "media.localTVDeal",
        "old": "Premier League collective deal — UK domestic 2025-28: ~£6.7B/4yr (~£1.67B/yr); facility fee tier 1",
        "new": "Premier League collective deal, UK domestic cycle 2025-26 to 2028-29: £6.7B over four seasons (~£1.67B/yr), Sky Sports 215+ live matches per season and TNT Sports 52; equal share ~£85M per club in 2025-26 plus facility fees and merit payments",
        "fact": "The £6.7B Sky/TNT domestic cycle runs 2025-26 through 2028-29 (four seasons), not 2025-28; 2025-26 was its first season with an equal share of about £85M per club",
        "source": "https://www.sportspro.com/news/premier-league-tv-rights-deal-sky-tnt-amazon-2025-2029/"
      }
    ],
    "analystNotes": "Arsenal is worth $5.4B on the Forbes 2026 list, up from $3.4B a year earlier, on $895M of revenue and $185M of operating income, the best margin of the big clubs. The 2025-26 season is the reason: a first league title since 2004 with 85 points, a Champions League final, and a January 2026 Saka contract to 2031 that locks the brand's face in place, followed by a reported Emirates renewal to 2033 at around £70M a year. The next move in the number comes from the Emirates Stadium decision, where the club entered formal planning in June 2026 and is leaning toward roughly 5,000 premium seats rather than an 80,000-seat rebuild, and from whether Kroenke ever sells a minority piece at the new price.",
    "unverifiedAsOf": {
      "ownership.ownerNetWorth": "May 2026",
      "revenue.estimate": "May 2026"
    }
  },
  "chelsea": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.primaryOwner",
        "old": "BlueCo 22 Ltd: Clearlake Capital (~61.5%) + Boehly consortium (~38.5%, includes Mark Walter, Hansjörg Wyss)",
        "new": "BlueCo 22 Ltd: Clearlake Capital (Behdad Eghbali, Jose E. Feliciano) with sole control after buying out Todd Boehly and Mark Walter's 25.6% in September 2026 at a $6.73B implied valuation; Hansjorg Wyss retains a minority",
        "fact": "Clearlake affiliates bought Boehly and Walter's stakes (closed 16 Sept 2026, ~£950M for 25.6%), ending the shared governance; Boehly left as chairman",
        "source": "https://www.chelseafc.com/en/news/article/chelsea-fc-announces-ownership-transition"
      },
      {
        "field": "ownership.ownershipGroup",
        "old": [
          {
            "name": "Clearlake Capital",
            "role": "majority equity (~61.5% via BlueCo)",
            "pct": 61.5
          },
          {
            "name": "Todd Boehly / Eldridge Industries",
            "role": "co-control / governor",
            "pct": 13
          },
          {
            "name": "Mark Walter / Guggenheim",
            "role": "minority (~13% within Boehly group)",
            "pct": 13
          },
          {
            "name": "Hansjörg Wyss",
            "role": "minority",
            "pct": 12
          }
        ],
        "new": [
          {
            "name": "Clearlake Capital",
            "role": "controlling owner via BlueCo (~87% after Sept 2026 buyout of Boehly and Walter)",
            "pct": 87.1
          },
          {
            "name": "Hansjorg Wyss",
            "role": "minority",
            "pct": 12
          },
          {
            "name": "Todd Boehly / Eldridge Industries",
            "role": "sold stake to Clearlake Sept 2026",
            "pct": 0
          },
          {
            "name": "Mark Walter / Guggenheim",
            "role": "sold stake to Clearlake Sept 2026",
            "pct": 0
          }
        ],
        "fact": "Clearlake 61.5% plus the 25.6% acquired from Boehly and Walter; Wyss's ~12% is unchanged per prior enrichment",
        "source": "https://www.insideworldfootball.com/2026/09/17/boehly-walter-sell-up-handing-control-of-chelsea-to-clearlake/"
      },
      {
        "field": "ownership.currentValuation",
        "old": 3.25,
        "new": 6.728,
        "fact": "Implied whole-club valuation from the September 2026 Clearlake buyout of 25.6%",
        "source": "https://www.insideworldfootball.com/2026/09/11/clearlake-set-to-buy-boehly-and-walters-chelsea-stakes-valuing-club-at-5bn/"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "Boehly-Clearlake exploring £2B+ new stadium or major Stamford Bridge redevelopment; site constraints from CPO ownership and West London property prices remain obstacles; Earl's Court redevelopment site one option floated",
        "new": "Decision now sits solely with Clearlake after the Sept 2026 buyout; two options remain: full demolition and rebuild of Stamford Bridge (about eight years, temporary move to Wembley) or a new £3B+ stadium at Earl's Court; stand-by-stand redevelopment ruled out; Chelsea Pitch Owners freehold, rail lines and Fulham Broadway access still constrain the site; no decision announced",
        "fact": "Clearlake's sole control removes the owner split that stalled the stadium call; options narrowed to rebuild or Earl's Court",
        "source": "https://footballgroundguide.com/news/chelseas-two-options-for-new-stadium-made-clear-as-clearlake-face-major-stamford-bridge-decision.html"
      },
      {
        "field": "onField.championshipsLast10Years",
        "old": 2,
        "new": 1,
        "fact": "Premier League titles in the ten seasons 2016-17 to 2025-26: 2016-17 only (2014-15 has dropped out of the window)",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_Premier_League"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Cole Palmer — 9yr contract through 2033, club's young franchise player",
        "new": "Cole Palmer, contract through 2033; Morgan Rogers signed from Aston Villa July 2026 for £117M, a record fee for an English player; Xabi Alonso appointed manager 1 July 2026 on a four-year contract",
        "fact": "Rogers joined 21 July 2026 for £117M; Alonso replaced the Maresca (resigned 1 Jan 2026) and Rosenior (Jan to Apr 2026) interregnum",
        "source": "https://en.wikipedia.org/wiki/Morgan_Rogers"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Cole Palmer",
            "position": "AM",
            "aav": 9.3,
            "contractNote": "Signed 9yr deal Sept 2024 (long-term amortization tactic) through 2033; ~£140K/wk; surprise £40M signing from City 2023"
          },
          {
            "player": "Enzo Fernández",
            "position": "CM",
            "aav": 11,
            "contractNote": "Signed 2023 from Benfica £107M British record at time; 8.5yr deal through 2032"
          },
          {
            "player": "Moises Caicedo",
            "position": "DM",
            "aav": 9.5,
            "contractNote": "Signed 2023 from Brighton £115M British record (eclipsing Fernández); 8yr deal through 2031"
          }
        ],
        "new": [
          {
            "player": "Cole Palmer",
            "position": "AM",
            "aav": 9.3,
            "contractNote": "Nine-year deal signed Aug 2024 through 2033"
          },
          {
            "player": "Morgan Rogers",
            "position": "AM",
            "aav": null,
            "contractNote": "Signed from Aston Villa 21 July 2026 for £117M, record for an English player"
          },
          {
            "player": "Moises Caicedo",
            "position": "DM",
            "aav": 9.5,
            "contractNote": "Signed 2023 from Brighton £115M; eight-year deal through 2031"
          },
          {
            "player": "Enzo Fernandez",
            "position": "CM",
            "aav": 0,
            "contractNote": "Sold to Manchester City summer 2026 for a reported £125M"
          }
        ],
        "fact": "Enzo Fernandez sold to City in summer 2026; Rogers is the new record signing",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_Chelsea_F.C._season"
      },
      {
        "field": "media.localTVDeal",
        "old": "Premier League collective deal — UK domestic 2025-28: ~£6.7B/4yr (~£1.67B/yr); facility fee tier 1",
        "new": "Premier League collective deal, UK domestic cycle 2025-26 to 2028-29: £6.7B over four seasons (~£1.67B/yr), Sky Sports 215+ live matches per season and TNT Sports 52; equal share ~£85M per club in 2025-26 plus facility fees and merit payments",
        "fact": "The £6.7B Sky/TNT domestic cycle runs 2025-26 through 2028-29 (four seasons), not 2025-28; 2025-26 was its first season with an equal share of about £85M per club",
        "source": "https://www.sportspro.com/news/premier-league-tv-rights-deal-sky-tnt-amazon-2025-2029/"
      }
    ],
    "analystNotes": "Chelsea's Forbes 2026 mark is $4.2B on $637M of revenue with a $26M operating loss, and in September 2026 Clearlake paid about £950M for Todd Boehly and Mark Walter's 25.6%, a $6.7B implied valuation that is 60% above Forbes and a full turn above the £4.25B 2022 purchase price. The premium bought control rights, not a better season: 10th place in 2025-26 with no European football, three managers in a year, and now Xabi Alonso on a four-year deal with a £117M Morgan Rogers as the headline hire. What moves the number is the stadium call that only Clearlake can now make, a full Stamford Bridge rebuild with a Wembley exile or a £3B Earl's Court move, because 41,631 seats cap matchday revenue near £100M against £160M-plus at Arsenal and Tottenham.",
    "unverifiedAsOf": {
      "revenue.estimate": "May 2026"
    }
  },
  "tottenham-hotspur": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.primaryOwner",
        "old": "ENIC International Ltd (Lewis Family Trust 60.7% effective + Daniel Levy 25.9% effective)",
        "new": "ENIC International Ltd (Lewis Family Trust ~60.7% effective; Daniel Levy family trust ~25.9% effective); Levy left as executive chairman 4 Sept 2025, Peter Charrington non-executive chairman, Vinai Venkatesham CEO; Eight Sports Capital claimed on 5 June 2026 to have agreed to buy 24.99% of ENIC from Levy's trust, which ENIC said it was unaware of",
        "fact": "Levy exited the board in September 2025; the June 2026 Eight Sports Capital claim on Levy's stake is disputed by ENIC and unconfirmed",
        "source": "https://www.football365.com/news/tottenham-daniel-levy-agrees-sale-of-24-99-enic-stake-group-worth-7bn-emerges"
      },
      {
        "field": "ownership.institutionalInvestors",
        "old": "None significant; ENIC actively explored minority stake sale 2023-2024 with US PE/sovereign wealth interest; no deal closed",
        "new": "None closed; club rejected two expressions of interest in Sept 2025 and stated it is not for sale; Lewis family members and separately a Ng Wing-Fai / Brooklyn Earick group pursued Levy's ~£1B stake in early 2026; Eight Sports Capital (Earick, Ng, Richard Tsai) announced a signed purchase of 24.99% of ENIC on 5 June 2026 at a reported £3B to £3.85B implied club value, which ENIC and THFC said they had no knowledge of",
        "fact": "2026 activity centres on Levy's minority stake, not the Lewis controlling stake; nothing confirmed as completed",
        "source": "https://theesk.org/2026/06/06/the-analysis-series-the-levy-stake-sale-eight-sports-capital-enic-control-and-the-future-of-spurs-ownership/"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Son Heung-min — captain, contract through 2025-26 ~£200K/wk; James Maddison ~£170K/wk through 2028",
        "new": "Sandro Tonali, signed from Newcastle July 2026 for £100M; Son Heung-min sold to LAFC in August 2025 (~£20M); Roberto De Zerbi head coach since 31 March 2026 after Thomas Frank (sacked 11 Feb 2026) and Igor Tudor (interim)",
        "fact": "Son left in 2025; Tonali is the club-record signing; three head coaches in 2025-26",
        "source": "https://en.wikipedia.org/wiki/Sandro_Tonali"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Son Heung-min",
            "position": "FW",
            "aav": 13.5,
            "contractNote": "~£200K/wk (~$13.5M USD), contract through June 2026; captain since 2023"
          },
          {
            "player": "James Maddison",
            "position": "AM",
            "aav": 11.5,
            "contractNote": "~£170K/wk; signed from Leicester 2023 for £40M; contract through 2028"
          },
          {
            "player": "Cristian Romero",
            "position": "CB",
            "aav": 10,
            "contractNote": "~£150K/wk; vice-captain; contract through 2027"
          },
          {
            "player": "Dominic Solanke",
            "position": "FW",
            "aav": 9,
            "contractNote": "~£140K/wk; signed from Bournemouth Aug 2024 for £55M club-record fee; through 2030"
          }
        ],
        "new": [
          {
            "player": "Sandro Tonali",
            "position": "CM",
            "aav": null,
            "contractNote": "Signed from Newcastle 6 July 2026 for £100M"
          },
          {
            "player": "Mohammed Kudus",
            "position": "AM/FW",
            "aav": null,
            "contractNote": "Signed from West Ham summer 2025 for £55M"
          },
          {
            "player": "Xavi Simons",
            "position": "AM",
            "aav": null,
            "contractNote": "Signed from RB Leipzig summer 2025 for £51.8M"
          },
          {
            "player": "James Maddison",
            "position": "AM",
            "aav": 11.5,
            "contractNote": "~£170K/wk; contract through 2028"
          },
          {
            "player": "Son Heung-min",
            "position": "FW",
            "aav": 0,
            "contractNote": "Sold to LAFC August 2025 for ~£20M after a decade"
          }
        ],
        "fact": "Son and Romero (to Atletico, £34.2M, summer 2026) gone; Tonali, Kudus, Simons are the current top contracts",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_Tottenham_Hotspur_F.C._season"
      },
      {
        "field": "media.localTVDeal",
        "old": "Premier League collective deal — UK domestic 2025-28: ~£6.7B/4yr (~£1.67B/yr); facility fee based on UK TV appearances",
        "new": "Premier League collective deal, UK domestic cycle 2025-26 to 2028-29: £6.7B over four seasons (~£1.67B/yr), Sky Sports 215+ live matches per season and TNT Sports 52; equal share ~£85M per club in 2025-26 plus facility fees and merit payments",
        "fact": "The £6.7B Sky/TNT domestic cycle runs 2025-26 through 2028-29 (four seasons), not 2025-28; 2025-26 was its first season with an equal share of about £85M per club",
        "source": "https://www.sportspro.com/news/premier-league-tv-rights-deal-sky-tnt-amazon-2025-2029/"
      }
    ],
    "analystNotes": "Tottenham's Forbes 2026 value is $3.0B, down from $3.4B, even though revenue of $733M and operating income of $139M show the £1.2B stadium and its NFL and concert calendar still print cash. The drop is sporting and governance risk: 17th place in 2025-26, two points from relegation, three head coaches in a season, Daniel Levy gone in September 2025 after 25 years, and a disputed June 2026 claim by Eight Sports Capital to have bought Levy's ENIC stake that the club says it knows nothing about. The number moves when the Lewis family either sells or lands a credible minority partner at the £3B-plus marks being floated, and when Roberto De Zerbi's £100M Sandro Tonali squad turns the stadium's economics back into top-six finishes.",
    "unverifiedAsOf": {
      "ownership.ownerNetWorth": "May 2026",
      "revenue.estimate": "May 2026"
    }
  },
  "newcastle-united": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "stadium.newStadiumPlans",
        "old": "Active exploration of new ~70,000-seat stadium (Leazes Park or expanded current site); early cost estimates £1.5-2B; Bloomberg reports PIF reluctant to fully fund — exploring long-term debt-financing model; decision expected 2025-26",
        "new": "Still undecided as of April 2026: options are a new 65,000 to 70,000-seat stadium (Leazes Park, Hunters Moor or Nuns Moor sites) or a constrained expansion of St James' Park; owners expected to fund only about half of any build with the rest borrowed against the club; Leazes Park faces protected-land and environmental objections; independent analysts do not expect a new or expanded ground before 2030",
        "fact": "The 'early 2025' decision promised to fans slipped through 2026 with no announcement",
        "source": "https://stadiumdb.com/news/2026/04/england_a_1_billion_opportunity_still_on_hold_what_future_awaits_st_james_park"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Bruno Guimarães — midfield captain, ~£180K/wk through 2028; Alexander Isak ~£140K/wk through 2028 (subject to summer transfer interest)",
        "new": "Squad rebuilt through sales: Isak sold to Liverpool Sept 2025 for a British-record £125M, Tonali to Tottenham July 2026 for £100M, Guimaraes to Arsenal Aug 2026 for ~£75M, Gordon to Barcelona summer 2026; Nick Woltemade (£65M from Stuttgart, 2025) leads the current group; Matthias Jaissle replaced Eddie Howe, who left 31 July 2026",
        "fact": "Newcastle sold its three biggest contracts for roughly £300M between Sept 2025 and Aug 2026 and changed head coach in July 2026",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_Newcastle_United_F.C._season"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Bruno Guimarães",
            "position": "CM",
            "aav": 12,
            "contractNote": "~£180K/wk; signed from Lyon Jan 2022 for £40M; new deal 2024 through 2028"
          },
          {
            "player": "Alexander Isak",
            "position": "FW",
            "aav": 9.5,
            "contractNote": "~£140K/wk; signed from Real Sociedad 2022 for club-record £63M; through 2028"
          },
          {
            "player": "Sandro Tonali",
            "position": "CM",
            "aav": 9,
            "contractNote": "~£135K/wk; signed from AC Milan 2023 for £55M; betting ban 2023-24 served; through 2028"
          },
          {
            "player": "Anthony Gordon",
            "position": "FW",
            "aav": 8,
            "contractNote": "~£120K/wk; signed from Everton 2023 for £45M; through 2028"
          }
        ],
        "new": [
          {
            "player": "Nick Woltemade",
            "position": "FW",
            "aav": null,
            "contractNote": "Signed from VfB Stuttgart summer 2025 for £65M plus £4.3M add-ons"
          },
          {
            "player": "Anthony Elanga",
            "position": "RW",
            "aav": null,
            "contractNote": "Signed from Nottingham Forest summer 2025 for £52M plus £3M add-ons"
          },
          {
            "player": "Yoane Wissa",
            "position": "FW",
            "aav": null,
            "contractNote": "Signed from Brentford summer 2025 for £50M plus £5M add-ons"
          },
          {
            "player": "Alexander Isak",
            "position": "FW",
            "aav": 0,
            "contractNote": "Sold to Liverpool 1 Sept 2025 for £125M, British record"
          },
          {
            "player": "Bruno Guimaraes",
            "position": "CM",
            "aav": 0,
            "contractNote": "Sold to Arsenal 8 Aug 2026 for ~£75M"
          },
          {
            "player": "Sandro Tonali",
            "position": "CM",
            "aav": 0,
            "contractNote": "Sold to Tottenham 6 July 2026 for £100M"
          }
        ],
        "fact": "Isak, Tonali, Guimaraes and Gordon all sold between Sept 2025 and Aug 2026",
        "source": "https://en.wikipedia.org/wiki/Bruno_Guimar%C3%A3es"
      },
      {
        "field": "media.localTVDeal",
        "old": "Premier League collective deal — UK domestic 2025-28: ~£6.7B/4yr (~£1.67B/yr); facility fee based on UK TV appearances",
        "new": "Premier League collective deal, UK domestic cycle 2025-26 to 2028-29: £6.7B over four seasons (~£1.67B/yr), Sky Sports 215+ live matches per season and TNT Sports 52; equal share ~£85M per club in 2025-26 plus facility fees and merit payments",
        "fact": "The £6.7B Sky/TNT domestic cycle runs 2025-26 through 2028-29 (four seasons), not 2025-28; 2025-26 was its first season with an equal share of about £85M per club",
        "source": "https://www.sportspro.com/news/premier-league-tv-rights-deal-sky-tnt-amazon-2025-2029/"
      }
    ],
    "analystNotes": "Newcastle carries a $1.25B Forbes 2026 value on $435M of revenue, roughly flat at the operating line, and the year since has been one of monetising the squad rather than growing the club: Isak (£125M), Tonali (£100M) and Guimaraes (£75M) were sold between September 2025 and August 2026, Eddie Howe left in July 2026, and the team finished 12th with no European place. The £305M PIF entry in 2021 still shows a 3x-plus mark, but the stadium decision that would justify a £1B-plus valuation, a 70,000-seat build or a St James' Park expansion, has slipped past every promised date and the owners now want half of it debt-funded. The number moves only when that decision lands and when PIF shows it will fund a squad rather than trade one.",
    "unverifiedAsOf": {
      "ownership.ownerNetWorth": "May 2026",
      "revenue.estimate": "May 2026"
    }
  },
  "aston-villa": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "stadium.newStadiumPlans",
        "old": "£100M+ North Stand redevelopment to expand Villa Park capacity from 42,682 to ~50,000 by 2027-28; planning permission secured 2023; aimed at meeting demand from Champions League / European matchday revenue uplift",
        "new": "£100M North Stand redevelopment under way: corner demolition began March 2026, the North Stand (5,000 to 12,000 seats) is closed for the whole 2026-27 season, and completion is targeted before 2027-28 to take Villa Park to about 50,000 in time for Euro 2028, where it is a host venue; architects Grimshaw and Trivandi",
        "fact": "Construction started March 2026; North Stand closed for 2026-27; completion before 2027-28",
        "source": "https://stadiumdb.com/constructions/eng/villa_park"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 2,
        "new": 4,
        "fact": "European qualification earned in 2022-23 (7th), 2023-24 (4th), 2024-25 (6th) and 2025-26 (4th, 65 pts); Villa also won the 2025-26 Europa League, beating Freiburg 3-0 on 20 May 2026, its first major trophy since 1996",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_Aston_Villa_F.C._season"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Ollie Watkins — top scorer; Emiliano Martínez (World Cup 2022 winner, Argentine #1 GK); Morgan Rogers (£8M 2024 acquisition exploded into England starter)",
        "new": "Core sold in summer 2026: Morgan Rogers to Chelsea for £117M (record fee for an English player), Ollie Watkins to Al-Hilal for ~£51M, Ezri Konsa to Arsenal (~£51M), Emiliano Martinez to Chelsea; Unai Emery remains manager; Nicolas Jackson (£47.5M) and Johan Manzambi (£52M) among the replacements",
        "fact": "Villa realised well over £250M of player sales in summer 2026 after the Europa League win and fourth place",
        "source": "https://en.wikipedia.org/wiki/Morgan_Rogers"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Ollie Watkins",
            "position": "FW",
            "aav": 8.5,
            "contractNote": "~£125K/wk; new deal Aug 2024 through 2028; club-record sale interest from Arsenal 2024 rebuffed"
          },
          {
            "player": "Emiliano Martínez",
            "position": "GK",
            "aav": 8,
            "contractNote": "~£120K/wk; through 2027; 2x World Cup Golden Glove winner"
          },
          {
            "player": "Pau Torres",
            "position": "CB",
            "aav": 7.5,
            "contractNote": "~£110K/wk; signed from Villarreal 2023 for £33M; through 2028"
          },
          {
            "player": "Morgan Rogers",
            "position": "AM",
            "aav": 5,
            "contractNote": "~£75K/wk; signed from Middlesbrough Jan 2024 for £8M; through 2030"
          }
        ],
        "new": [
          {
            "player": "Morgan Rogers",
            "position": "AM",
            "aav": 0,
            "contractNote": "Sold to Chelsea 21 July 2026 for £117M, 14x the £8M paid to Middlesbrough in Jan 2024"
          },
          {
            "player": "Ollie Watkins",
            "position": "FW",
            "aav": 0,
            "contractNote": "Sold to Al-Hilal 30 Aug 2026 for ~£51M after refusing to play the season opener"
          },
          {
            "player": "Nicolas Jackson",
            "position": "FW",
            "aav": null,
            "contractNote": "Signed from Chelsea summer 2026 for £47.5M"
          },
          {
            "player": "Johan Manzambi",
            "position": "CM",
            "aav": null,
            "contractNote": "Signed from SC Freiburg summer 2026 for £52M"
          },
          {
            "player": "Pau Torres",
            "position": "CB",
            "aav": 7.5,
            "contractNote": "~£110K/wk; signed from Villarreal 2023 for £33M; through 2028"
          }
        ],
        "fact": "Rogers, Watkins, Konsa and Martinez sold in summer 2026",
        "source": "https://en.wikipedia.org/wiki/Ollie_Watkins"
      },
      {
        "field": "media.localTVDeal",
        "old": "Premier League collective deal — UK domestic 2025-28: ~£6.7B/4yr (~£1.67B/yr); facility fee based on UK TV appearances",
        "new": "Premier League collective deal, UK domestic cycle 2025-26 to 2028-29: £6.7B over four seasons (~£1.67B/yr), Sky Sports 215+ live matches per season and TNT Sports 52; equal share ~£85M per club in 2025-26 plus facility fees and merit payments",
        "fact": "The £6.7B Sky/TNT domestic cycle runs 2025-26 through 2028-29 (four seasons), not 2025-28; 2025-26 was its first season with an equal share of about £85M per club",
        "source": "https://www.sportspro.com/news/premier-league-tv-rights-deal-sky-tnt-amazon-2025-2029/"
      }
    ],
    "analystNotes": "Aston Villa is now a $1.4B club on the Forbes 2026 list, first time on the list at that level, on $490M of revenue and a small operating loss, and the 2025-26 season is the best in 30 years: fourth place, a second Champions League qualification in three seasons and the Europa League trophy, the club's first major silverware since 1996. The owners then cashed the squad to stay inside the spending rules, selling Morgan Rogers to Chelsea for £117M, Ollie Watkins to Al-Hilal and Ezri Konsa to Arsenal for over £250M combined, while the £100M North Stand build closes a quarter of Villa Park for 2026-27 on the way to 50,000 seats and Euro 2028. The number moves on whether Emery keeps Villa in the Champions League with a rebuilt squad, and on the Atairos-backed owners finding a minority buyer at the new mark.",
    "unverifiedAsOf": {
      "ownership.ownerNetWorth": "May 2026",
      "revenue.estimate": "May 2026"
    }
  },
  "brighton-and-hove-albion": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Carlos Baleba — central midfielder, £25M+ valuation; Kaoru Mitoma — Japanese international winger; Joël Veltman — veteran defender",
        "new": "Player-trading engine continues: Carlos Baleba sold to Manchester United Aug 2026 for a reported £70M including add-ons, Jan Paul van Hecke to Tottenham for £52M, Joao Pedro to Chelsea (2025, £55M); Luka Vuskovic (£46M from Tottenham) is the record purchase; Fabian Hurzeler remains head coach",
        "fact": "Baleba (£70M) and van Hecke (£52M) sold in summer 2026",
        "source": "https://en.wikipedia.org/wiki/Carlos_Baleba"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Carlos Baleba",
            "position": "CM",
            "aav": 5.5,
            "contractNote": "~£80K/wk; signed from Lille 2023 for £23M; through 2028; reported transfer interest from top-six clubs at £80M+"
          },
          {
            "player": "Kaoru Mitoma",
            "position": "LW",
            "aav": 5,
            "contractNote": "~£75K/wk; signed from Kawasaki Frontale 2021 for ~£3M; through 2027"
          },
          {
            "player": "Lewis Dunk",
            "position": "CB",
            "aav": 4.5,
            "contractNote": "~£65K/wk; club captain, academy graduate; through 2027"
          },
          {
            "player": "Bart Verbruggen",
            "position": "GK",
            "aav": 3.5,
            "contractNote": "~£50K/wk; signed from Anderlecht 2023 for £16M; Netherlands #1; through 2028"
          }
        ],
        "new": [
          {
            "player": "Carlos Baleba",
            "position": "CM",
            "aav": 0,
            "contractNote": "Sold to Manchester United 25 Aug 2026, reported £70M including add-ons; bought from Lille 2023 for £23M"
          },
          {
            "player": "Luka Vuskovic",
            "position": "CB",
            "aav": null,
            "contractNote": "Signed from Tottenham summer 2026 for £46M, club record"
          },
          {
            "player": "Kaoru Mitoma",
            "position": "LW",
            "aav": 5,
            "contractNote": "~£75K/wk; signed from Kawasaki Frontale 2021 for ~£3M; through 2027"
          },
          {
            "player": "Bart Verbruggen",
            "position": "GK",
            "aav": 3.5,
            "contractNote": "~£50K/wk; Netherlands #1; through 2028"
          }
        ],
        "fact": "Baleba and Dunk-era core turned over; Vuskovic is the new record signing",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_Brighton_%26_Hove_Albion_F.C._season"
      },
      {
        "field": "media.localTVDeal",
        "old": "Premier League collective deal — UK domestic 2025-28: ~£6.7B/4yr (~£1.67B/yr); facility fee based on UK TV appearances",
        "new": "Premier League collective deal, UK domestic cycle 2025-26 to 2028-29: £6.7B over four seasons (~£1.67B/yr), Sky Sports 215+ live matches per season and TNT Sports 52; equal share ~£85M per club in 2025-26 plus facility fees and merit payments",
        "fact": "The £6.7B Sky/TNT domestic cycle runs 2025-26 through 2028-29 (four seasons), not 2025-28; 2025-26 was its first season with an equal share of about £85M per club",
        "source": "https://www.sportspro.com/news/premier-league-tv-rights-deal-sky-tnt-amazon-2025-2029/"
      }
    ],
    "analystNotes": "Brighton is a $910M club on the Forbes 2026 list, on $295M of revenue, and the model has not changed: buy at £3M to £25M, develop, sell at £50M-plus. The 2025-26 season produced an 8th-place finish and a Conference League place, then summer 2026 turned Carlos Baleba (£23M in, £70M out to Manchester United) and Jan Paul van Hecke (£52M to Tottenham) into the next round of reinvestment, with £46M Luka Vuskovic the record purchase. The ceiling is still the 31,876-seat Amex and Tony Bloom's sole ownership; the number moves if Bloom ever sells a piece, or if the club grows the ground.",
    "unverifiedAsOf": {
      "ownership.ownerNetWorth": "May 2026",
      "revenue.estimate": "May 2026"
    }
  },
  "west-ham-united": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.primaryOwner",
        "old": "David Sullivan (~38.8%) and Daniel Křetínský (~27%, increasing toward 38-40% as Gold shares acquired)",
        "new": "Daniel Kretinsky (~46%, largest shareholder after buying Gold family shares, Sept 2026) and David Sullivan (~40%); Sullivan resigned as chairman June 2026 after historical misconduct allegations relating to his previous businesses; Vanessa Gold chairwoman",
        "fact": "Bloomberg (4 Sept 2026) and West Ham trackers report Kretinsky at 46% and Sullivan at 40% after the Gold family's 25.1% was split between them rather than sold to Amanda Staveley's consortium; Staveley has reportedly offered ~£600M for Sullivan's stake",
        "source": "https://www.westhamzone.com/finance/west-ham-ownership-twist-on-the-cards-as-jim-white-details-interesting-development"
      },
      {
        "field": "ownership.ownershipGroup",
        "old": [
          {
            "name": "David Sullivan",
            "role": "co-chairman / majority",
            "pct": 38.8
          },
          {
            "name": "Daniel Křetínský (via 1890s Holdings)",
            "role": "vice-chairman / minority growing",
            "pct": 27
          },
          {
            "name": "Gold family estate",
            "role": "minority (selling down 2024-26)",
            "pct": 25.1
          },
          {
            "name": "Tripp Smith / Pavel Horský / others",
            "role": "minority",
            "pct": 9.1
          }
        ],
        "new": [
          {
            "name": "Daniel Kretinsky (via 1890s Holdings)",
            "role": "largest shareholder after Sept 2026 Gold share purchase",
            "pct": 46
          },
          {
            "name": "David Sullivan",
            "role": "shareholder; resigned as chairman June 2026",
            "pct": 40
          },
          {
            "name": "WHU LLC (Tripp Smith)",
            "role": "minority",
            "pct": 11
          },
          {
            "name": "Other minority holders",
            "role": "minority",
            "pct": 3
          }
        ],
        "fact": "Gold family exited; percentages per Bloomberg and westhamzone reporting Sept 2026 (Tripp Smith reported at 8% to 11% across sources)",
        "source": "https://www.bloomberg.com/news/articles/2026-09-04/west-ham-takeover-saga-sees-sullivan-and-kretinsky-raise-stakes"
      },
      {
        "field": "media.localTVDeal",
        "old": "Premier League collective deal — UK domestic 2025-28: ~£6.7B/4yr (~£1.67B/yr); facility fee based on UK TV appearances",
        "new": "Relegated to the EFL Championship for 2026-27 (18th in 2025-26, 39 pts); receives Premier League parachute payments (~£44M year one, declining over three years) on top of EFL central distribution; returns to the £6.7B Sky/TNT Premier League cycle (2025-26 to 2028-29) only on promotion",
        "fact": "West Ham finished 18th and were relegated, their first drop since 2010-11",
        "source": "https://www.nbcsports.com/premier-league-table-2025-26-season-standings"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Jarrod Bowen — England forward, captain since Declan Rice's 2023 sale; Lucas Paquetá — Brazilian international; Mohammed Kudus drew major transfer interest summer 2025",
        "new": "Jarrod Bowen, captain, in the Championship; Kudus (£55M to Tottenham, 2025), Paqueta (£35.75M to Flamengo, 2025), Mateus Fernandes (£85M to Tottenham, summer 2026) and Summerville (£55M to Al-Hilal) all sold; Nuno Espirito Santo head coach since 27 Sept 2025",
        "fact": "Post-relegation fire sale in summer 2026 after Kudus and Paqueta left in 2025",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_West_Ham_United_F.C._season"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Jarrod Bowen",
            "position": "FW",
            "aav": 8,
            "contractNote": "~£120K/wk; new deal 2024 through 2030; captain; club's all-time PL goalscorer"
          },
          {
            "player": "Lucas Paquetá",
            "position": "AM",
            "aav": 9.5,
            "contractNote": "~£140K/wk; signed from Lyon 2022 for £51M; FA spot-fixing investigation cleared 2024-25; through 2027"
          },
          {
            "player": "Mohammed Kudus",
            "position": "AM/FW",
            "aav": 8,
            "contractNote": "~£120K/wk; signed from Ajax 2023 for £38M; through 2028 (subject to ongoing transfer interest from top-six)"
          },
          {
            "player": "Niclas Füllkrug",
            "position": "FW",
            "aav": 6.5,
            "contractNote": "~£100K/wk; signed from Borussia Dortmund 2024 for £27M; through 2028"
          }
        ],
        "new": [
          {
            "player": "Jarrod Bowen",
            "position": "FW",
            "aav": 8,
            "contractNote": "~£120K/wk; deal through 2030; captain; stayed after relegation"
          },
          {
            "player": "Mateus Fernandes",
            "position": "AM",
            "aav": 0,
            "contractNote": "Signed from Southampton 2025 for £38M; sold to Tottenham summer 2026 for £85M"
          },
          {
            "player": "Mohammed Kudus",
            "position": "AM/FW",
            "aav": 0,
            "contractNote": "Sold to Tottenham summer 2025 for £55M"
          },
          {
            "player": "Lucas Paqueta",
            "position": "AM",
            "aav": 0,
            "contractNote": "Sold to Flamengo 2025 for £35.75M"
          }
        ],
        "fact": "Kudus, Paqueta, Fernandes and Summerville sold; Bowen remains",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_West_Ham_United_F.C._season"
      }
    ],
    "analystNotes": "West Ham's last Forbes mark is $1.25B from the May 2025 list, and everything since then argues for less: an 18th-place finish and relegation in 2025-26, the first since 2011, a summer 2026 sale of Mateus Fernandes (£85M), Summerville (£55M) after Kudus and Paqueta went in 2025, and a Championship season on £44M of parachute money instead of £150M-plus of Premier League television. The ownership is finally consolidating: Daniel Kretinsky bought into the Gold family's 25% to reach about 46% and became the largest shareholder in September 2026, David Sullivan resigned as chairman in June under historical misconduct allegations and sits on 40% with Amanda Staveley reportedly offering £600M for it. The number moves on immediate promotion and on whether Kretinsky, or Staveley, ends up with control and a plan for the London Stadium lease.",
    "unverifiedAsOf": {
      "revenue.estimate": "May 2026"
    }
  },
  "crystal-palace": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.institutionalInvestors",
        "old": "Harris/Blitzer hold via HBSE — institutional family office structure",
        "new": "Harris/Blitzer hold via HBSE; in June 2026 the US owners (Johnson, Harris, Blitzer) engaged Raine Group to explore options including a sale of a controlling stake of more than 50% (Financial Times, 16 June 2026)",
        "fact": "Sale process opened June 2026 after the Conference League win",
        "source": "https://www.irishtimes.com/business/2026/06/16/us-billionaire-owners-of-crystal-palace-explore-sale/"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "Main Stand redevelopment plans approved by Croydon Council 2018 — would add ~8,000 seats and modern hospitality. Project repeatedly delayed; revived under Textor; Woody Johnson era expected to refocus capital on the build (~£150-200M)",
        "new": "Main Stand redevelopment under construction: major works began January 2026 after a multi-million loan was secured in December 2025; the new stand grows from ~5,200 to ~13,500 seats, taking Selhurst Park above 34,000; completion expected during the 2027-28 season (just over two years)",
        "fact": "Construction started January 2026",
        "source": "https://www.cpfc.co.uk/news/stadium/update-on-the-main-stand-redevelopment/"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 1,
        "new": 2,
        "fact": "2024-25 FA Cup win and the 2025-26 Conference League title (1-0 v Rayo Vallecano, Leipzig, 27 May 2026) each earned European football; 15th in the 2025-26 league (45 pts); 2025 Community Shield also won",
        "source": "https://www.uefa.com/uefaconferenceleague/match/2047744--crystal-palace-vs-rayo-vallecano/final/"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Eberechi Eze — sold to Arsenal summer 2025 ~£60M; replacement core: Adam Wharton (England midfielder)",
        "new": "Jean-Philippe Mateta (scored the Conference League final winner) and Jorgen Strand Larsen (club-record £43M from Wolves, 2025); Marc Guehi sold to Manchester City Jan 2026 for ~£20M, Lacroix to Chelsea summer 2026 for £52M; Pierre Sage appointed manager summer 2026 after Oliver Glasner left for Nottingham Forest",
        "fact": "Guehi (Jan 2026) and Lacroix (summer 2026) sold; Glasner departed at contract end and joined Forest 6 July 2026",
        "source": "https://en.wikipedia.org/wiki/Oliver_Glasner"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Marc Guéhi",
            "position": "CB",
            "aav": 6,
            "contractNote": "England international centre-back; £55M+ valuation; contract negotiations ongoing 2025-26"
          },
          {
            "player": "Jean-Philippe Mateta",
            "position": "ST",
            "aav": 4.5,
            "contractNote": "France international striker; signed extension through 2027"
          },
          {
            "player": "Adam Wharton",
            "position": "CM",
            "aav": 3.5,
            "contractNote": "Signed from Blackburn 2024; long-term contract; emerging England midfielder"
          }
        ],
        "new": [
          {
            "player": "Jean-Philippe Mateta",
            "position": "ST",
            "aav": 4.5,
            "contractNote": "France international; scored the 2026 Conference League final winner; extension through 2027"
          },
          {
            "player": "Jorgen Strand Larsen",
            "position": "ST",
            "aav": null,
            "contractNote": "Signed from Wolves summer 2025 for £43M, club-record fee paid"
          },
          {
            "player": "Adam Wharton",
            "position": "CM",
            "aav": 3.5,
            "contractNote": "Signed from Blackburn 2024; long-term contract; England midfielder"
          },
          {
            "player": "Marc Guehi",
            "position": "CB",
            "aav": 0,
            "contractNote": "Sold to Manchester City Jan 2026 for ~£20M in the last six months of his contract"
          }
        ],
        "fact": "Guehi and Eze cashed; Strand Larsen and Mateta anchor the attack",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_Crystal_Palace_F.C._season"
      },
      {
        "field": "media.localTVDeal",
        "old": "Premier League collective deal — UK domestic 2025-28: ~£6.7B/4yr (~£1.67B/yr); facility fee based on UK TV appearances",
        "new": "Premier League collective deal, UK domestic cycle 2025-26 to 2028-29: £6.7B over four seasons (~£1.67B/yr), Sky Sports 215+ live matches per season and TNT Sports 52; equal share ~£85M per club in 2025-26 plus facility fees and merit payments",
        "fact": "The £6.7B Sky/TNT domestic cycle runs 2025-26 through 2028-29 (four seasons), not 2025-28; 2025-26 was its first season with an equal share of about £85M per club",
        "source": "https://www.sportspro.com/news/premier-league-tv-rights-deal-sky-tnt-amazon-2025-2029/"
      }
    ],
    "analystNotes": "Crystal Palace's last Forbes mark is $750M from 2025, and the club has since won two trophies in twelve months, the FA Cup in May 2025 and the Conference League in May 2026, making it the most decorated period in its history. Woody Johnson paid £190M for 43% in June 2025 at a $591M implied value, and by June 2026 he, Josh Harris and David Blitzer had Raine Group exploring a sale of a controlling stake, so the next print will come from a control buyer. The Main Stand rebuild that started in January 2026 lifts Selhurst Park past 34,000 seats by 2027-28, which is the one structural lever; the risk is a 15th-place league finish and the loss of Guehi, Eze and manager Oliver Glasner, all gone by summer 2026.",
    "unverifiedAsOf": {
      "revenue.estimate": "May 2026"
    }
  },
  "everton": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "stadium.capacity",
        "old": 52888,
        "new": 52769,
        "fact": "Hill Dickinson Stadium capacity listed at 52,769; 2025-26 average league attendance 52,132, peak 52,590 v Sunderland (17 May 2026)",
        "source": "https://en.wikipedia.org/wiki/Hill_Dickinson_Stadium"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "Stadium opened 2025; commissioning season 2025-26; Goodison Park redevelopment plans for women's team facility and mixed-use community space",
        "new": "First full season complete: first competitive match 24 Aug 2025 v Brighton after a Feb 2025 test-event opening; 2025-26 average attendance 52,132 (sell-out level); previous regime modelled matchday income of just under £44M in year one versus ~£20M at Goodison; Goodison Park now used by the women's team",
        "fact": "2025-26 was the first full season at Hill Dickinson Stadium with near-capacity crowds",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_Everton_F.C._season"
      },
      {
        "field": "stadium.privateFinancing",
        "old": 950,
        "new": 750,
        "fact": "Construction cost estimated at about £750M per the stadium record (prior enrichment carried a higher all-in figure)",
        "source": "https://en.wikipedia.org/wiki/Hill_Dickinson_Stadium"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Jordan Pickford — England #1 goalkeeper; signed contract through 2027 at ~£100K/week",
        "new": "Jordan Pickford, England goalkeeper, contract through 2027; Tyler Dibling (£35M from Southampton, Aug 2025) is the record signing; Iliman Ndiaye sold to Manchester City 1 Sept 2026 for a reported £60M-plus",
        "fact": "Ndiaye sold for £60M-65M in Sept 2026; Dibling bought for £35M in 2025",
        "source": "https://en.wikipedia.org/wiki/Iliman_Ndiaye"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Jordan Pickford",
            "position": "GK",
            "aav": 6.5,
            "contractNote": "England international; ~£100K/week through 2027"
          },
          {
            "player": "Iliman Ndiaye",
            "position": "AM",
            "aav": 4.5,
            "contractNote": "Senegal international; signed 2024 from Marseille for ~£15M"
          },
          {
            "player": "Beto",
            "position": "ST",
            "aav": 3.8,
            "contractNote": "Guinea-Bissau international; £25M from Udinese 2023"
          }
        ],
        "new": [
          {
            "player": "Jordan Pickford",
            "position": "GK",
            "aav": 6.5,
            "contractNote": "England international; ~£100K/week through 2027"
          },
          {
            "player": "Tyler Dibling",
            "position": "RW",
            "aav": null,
            "contractNote": "Signed from Southampton 25 Aug 2025 for £35M"
          },
          {
            "player": "Thierno Barry",
            "position": "ST",
            "aav": null,
            "contractNote": "Signed from Villarreal July 2025 for £26M"
          },
          {
            "player": "Iliman Ndiaye",
            "position": "AM",
            "aav": 0,
            "contractNote": "Sold to Manchester City 1 Sept 2026, reported £60M base fee"
          }
        ],
        "fact": "Ndiaye and Beto sold in summer 2026; Dibling, Barry, Dewsbury-Hall bought in 2025",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_Everton_F.C._season"
      },
      {
        "field": "media.localTVDeal",
        "old": "Premier League collective deal — UK domestic 2025-28: ~£6.7B/4yr (~£1.67B/yr); facility fee based on UK TV appearances",
        "new": "Premier League collective deal, UK domestic cycle 2025-26 to 2028-29: £6.7B over four seasons (~£1.67B/yr), Sky Sports 215+ live matches per season and TNT Sports 52; equal share ~£85M per club in 2025-26 plus facility fees and merit payments",
        "fact": "The £6.7B Sky/TNT domestic cycle runs 2025-26 through 2028-29 (four seasons), not 2025-28; 2025-26 was its first season with an equal share of about £85M per club",
        "source": "https://www.sportspro.com/news/premier-league-tv-rights-deal-sky-tnt-amazon-2025-2029/"
      }
    ],
    "analystNotes": "Everton debuts on the Forbes 2026 list at $930M on $255M of revenue, and the driver is the Hill Dickinson Stadium: 52,769 seats, a first full season in 2025-26 at an average of 52,132, and matchday income modelled near £44M against £20M at Goodison. The Friedkin Group's December 2024 takeover and the stadium's roughly £750M cost turned a distressed asset into a mid-table platform, and a 13th-place finish under David Moyes plus a £60M sale of Iliman Ndiaye to Manchester City in September 2026 show the club now trading from strength. The number moves when the FY2025-26 accounts land in 2027 and show what a waterfront stadium actually earns, and if Friedkin pushes the club into Europe.",
    "unverifiedAsOf": {
      "stadium.namingRightsDeal": "May 2026",
      "revenue.estimate": "May 2026"
    }
  },
  "fulham": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Raúl Jiménez — Mexico international striker; £5.5M from Wolves 2023; signed extension through 2027",
        "new": "Kevin (£34.6M from Shakhtar, 2025) and Gonzalo Garcia (£34.2M from Real Madrid, 2026) are the record-level signings; Raul Jimenez left for Wolves on a free in summer 2026; Alvaro Arbeloa replaced Marco Silva, who left 2 June 2026 at the end of his contract after five years",
        "fact": "Silva departed June 2026; Arbeloa appointed on a three-year contract",
        "source": "https://en.wikipedia.org/wiki/Marco_Silva"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Raúl Jiménez",
            "position": "ST",
            "aav": 4.5,
            "contractNote": "Mexico international; extension to 2027"
          },
          {
            "player": "Andreas Pereira",
            "position": "AM",
            "aav": 3.8,
            "contractNote": "Brazil international; signed permanently from Man United 2022"
          },
          {
            "player": "Antonee Robinson",
            "position": "LB",
            "aav": 3.5,
            "contractNote": "USMNT regular; signed extension 2024"
          }
        ],
        "new": [
          {
            "player": "Kevin",
            "position": "LW",
            "aav": null,
            "contractNote": "Signed from Shakhtar Donetsk summer 2025 for £34.6M"
          },
          {
            "player": "Gonzalo Garcia",
            "position": "FW",
            "aav": null,
            "contractNote": "Signed from Real Madrid summer 2026 for £34.2M"
          },
          {
            "player": "Antonee Robinson",
            "position": "LB",
            "aav": 3.5,
            "contractNote": "USMNT regular; extension 2024"
          },
          {
            "player": "Raul Jimenez",
            "position": "ST",
            "aav": 0,
            "contractNote": "Left for Wolves on a free transfer summer 2026"
          }
        ],
        "fact": "Pereira sold to Palmeiras (£8.65M, 2025); Jimenez left 2026",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_Fulham_F.C._season"
      },
      {
        "field": "media.localTVDeal",
        "old": "Premier League collective deal — UK domestic 2025-28: ~£6.7B/4yr (~£1.67B/yr); facility fee based on UK TV appearances",
        "new": "Premier League collective deal, UK domestic cycle 2025-26 to 2028-29: £6.7B over four seasons (~£1.67B/yr), Sky Sports 215+ live matches per season and TNT Sports 52; equal share ~£85M per club in 2025-26 plus facility fees and merit payments",
        "fact": "The £6.7B Sky/TNT domestic cycle runs 2025-26 through 2028-29 (four seasons), not 2025-28; 2025-26 was its first season with an equal share of about £85M per club",
        "source": "https://www.sportspro.com/news/premier-league-tv-rights-deal-sky-tnt-amazon-2025-2029/"
      }
    ],
    "analystNotes": "Fulham is a $920M club on the Forbes 2026 list, on $253M of revenue and a $25M operating loss, and the value is Shahid Khan's Riverside Stand: a 29,600-seat Thames-side ground with hotel rooms, restaurants and a rooftop pool that no other mid-table club can match. Five straight Premier League seasons ended with an 11th-place finish in 2025-26 and the June 2026 exit of Marco Silva after five years, with Alvaro Arbeloa hired on a three-year deal and £34M spent on Gonzalo Garcia from Real Madrid. The number moves on whether Arbeloa keeps the club up while the new signings settle, since the land value holds but the broadcast money that makes up two-thirds of revenue does not survive relegation.",
    "unverifiedAsOf": {
      "ownership.ownerNetWorth": "May 2026",
      "revenue.estimate": "May 2026"
    }
  },
  "wolverhampton-wanderers": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.primaryOwner",
        "old": "Fosun International (Guo Guangchang)",
        "new": "Fosun International (Guo Guangchang, Wang Qunbin); executive chairman Jeff Shi left 19 Dec 2025, Nathan Shi interim then permanent executive chairman from 11 May 2026",
        "fact": "Board change at Fosun-owned Wolves during the relegation season",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_Wolverhampton_Wanderers_F.C._season"
      },
      {
        "field": "media.localTVDeal",
        "old": "Premier League collective deal — UK domestic 2025-28: ~£6.7B/4yr (~£1.67B/yr); facility fee based on UK TV appearances",
        "new": "Relegated to the EFL Championship for 2026-27 (20th in 2025-26 with 20 points, relegated 20 April 2026); parachute payments (~£44M year one, declining over three years) plus EFL central distribution; rejoins the £6.7B Sky/TNT cycle (2025-26 to 2028-29) only on promotion",
        "fact": "Wolves finished bottom with 20 points after a record 19-game winless start",
        "source": "https://www.nbcsports.com/premier-league-table-2025-26-season-standings"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "Phased stadium expansion plans periodically discussed (Steve Bull stand redevelopment) but capital constrained under recent Fosun strategic review; no committed timeline",
        "new": "The 2019 plan to grow Molineux to 50,000 is shelved indefinitely; no expansion work under way after relegation",
        "fact": "Expansion shelved as of the end of 2025-26",
        "source": "https://lastwordonsports.com/football/2026/04/21/wolves-relegation-lessons-club-decline/"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Matheus Cunha — Brazil international; sold to Manchester United summer 2025 ~£62.5M; current core: Jørgen Strand Larsen (Norway striker)",
        "new": "Squad sold down: Cunha to Man United (£62.5M, 2025), Strand Larsen to Crystal Palace (£43M, 2025), Ait-Nouri to Man City (£31M, 2025), Joao Gomes to Aston Villa (~£34M to £38M, summer 2026); Cesar Peixoto head coach for the Championship after Rob Edwards left",
        "fact": "About £180M of player sales in 2025-26 and Gomes sold in 2026; three head coaches in 2025-26 (Pereira, Collins interim, Edwards)",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_Wolverhampton_Wanderers_F.C._season"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Jørgen Strand Larsen",
            "position": "ST",
            "aav": 4,
            "contractNote": "Norway international; signed permanently from Celta Vigo 2024 for ~£23M; primary striker post-Cunha"
          },
          {
            "player": "Rayan Aït-Nouri",
            "position": "LB",
            "aav": 3.5,
            "contractNote": "Algeria international; signed extension; ~£40M+ market value but recurring transfer speculation"
          },
          {
            "player": "João Gomes",
            "position": "CM",
            "aav": 3.5,
            "contractNote": "Brazil international; £15M from Flamengo 2023; emerging midfield core"
          }
        ],
        "new": [
          {
            "player": "Joao Gomes",
            "position": "CM",
            "aav": 0,
            "contractNote": "Sold to Aston Villa summer 2026 for ~£34M to £38M plus add-ons; bought from Flamengo 2023 for £15M"
          },
          {
            "player": "Jorgen Strand Larsen",
            "position": "ST",
            "aav": 0,
            "contractNote": "Sold to Crystal Palace summer 2025 for £43M, a year after the £23M purchase"
          },
          {
            "player": "Rayan Ait-Nouri",
            "position": "LB",
            "aav": 0,
            "contractNote": "Sold to Manchester City summer 2025 for £31M"
          },
          {
            "player": "Tolu Arokodare",
            "position": "ST",
            "aav": null,
            "contractNote": "Signed from Genk summer 2025 for £24M"
          }
        ],
        "fact": "Gomes, Strand Larsen and Ait-Nouri all sold",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_Wolverhampton_Wanderers_F.C._season"
      }
    ],
    "analystNotes": "Wolves' last Forbes figure is $600M from the 2024 list, and the club has since suffered the worst season in its Premier League history: bottom with 20 points, relegated on 20 April 2026 after a record 19-game winless start, with executive chairman Jeff Shi out in December 2025 and Fosun leaning on player sales, roughly £180M in 2025-26 plus Joao Gomes to Villa in 2026, to hold losses to £15M. A 2026-27 Championship season on parachute money with the 50,000-seat Molineux plan shelved is a business at maybe half the broadcast income. The number moves on immediate promotion under Cesar Peixoto, and on Fosun finally selling, which is the exit that would reprice the club against the £500M-plus paid for peers.",
    "unverifiedAsOf": {
      "revenue.estimate": "May 2026"
    }
  },
  "afc-bournemouth": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "stadium.ownershipModel",
        "old": "smallest stadium in Premier League by capacity; club-owned operations; freehold ownership history complex (long lease historically); training ground at Canford Magna",
        "new": "Ground bought back in April 2025 by Black Knight Stadium Limited (a Black Knight Football Club vehicle) from Structadene, so the club's ownership group now holds the freehold; smallest Premier League stadium until the current expansion completes",
        "fact": "Foley's group repurchased the Vitality Stadium from Structadene at the end of April 2025 to enable the expansion",
        "source": "https://www.sportcal.com/news/bournemouth-secure-local-approval-for-stadium-expansion-plans/"
      },
      {
        "field": "stadium.newStadiumPlans",
        "old": "Foley has publicly committed to expansion / new stadium evaluation since 2023; site studies for ~25,000-capacity replacement at Canford Magna training ground or expanded Dean Court ongoing; no committed timeline as of 2025",
        "new": "Vitality Stadium redevelopment under construction since 4 July 2026 after unanimous BCP Council approval: new 6,800-seat South Stand, filled-in corners and expanded North and East stands take capacity from ~11,300 to 20,196, with phased delivery around fixtures and completion expected summer 2027; south-east corner targeted for the first Europa League home tie (Sturm Graz, 15 Oct 2026)",
        "fact": "Construction began July 2026; capacity to 20,196 by summer 2027",
        "source": "https://stadiumdb.com/news/2026/07/england_afc_bournemouth_begins_historic_redevelopment_of_vitality_stadium"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 0,
        "new": 1,
        "fact": "6th in 2025-26 (57 pts), the club's highest finish, qualifying for the Europa League league phase, its first European competition",
        "source": "https://www.nbcsports.com/premier-league-table-2025-26-season-standings"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Antoine Semenyo — Ghana international winger; signed extension through 2030; transfer interest at £60M+",
        "new": "Antoine Semenyo sold to Manchester City Jan 2026 for £62.5M plus £1.5M add-ons, the club-record sale; head coach Andoni Iraola left for Liverpool June 2026 after taking the club to 6th; Bafode Diakite (£34.6M from Lille, 2025) is the record purchase",
        "fact": "Semenyo (Jan 2026), Huijsen (£50M), Zabarnyi (£54.5M), Kerkez (£40M) and Ouattara (£42.5M) all sold in 2025-26; Iraola departed June 2026",
        "source": "https://www.skysports.com/football/news/11095/13491956/antoine-semenyo-joins-man-city-bournemouth-forward-signs-in-lb64m-transfer-to-take-city-spending-over-lb425m-in-12-months"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Antoine Semenyo",
            "position": "RW",
            "aav": 4.5,
            "contractNote": "Ghana international; new long-term deal 2025; £60M+ transfer interest from Liverpool/Spurs"
          },
          {
            "player": "Evanilson",
            "position": "ST",
            "aav": 4,
            "contractNote": "Brazil international; £40M from Porto 2024 (club record)"
          },
          {
            "player": "Justin Kluivert",
            "position": "AM",
            "aav": 3.5,
            "contractNote": "Netherlands international; signed from Roma 2024"
          }
        ],
        "new": [
          {
            "player": "Antoine Semenyo",
            "position": "RW",
            "aav": 0,
            "contractNote": "Sold to Manchester City Jan 2026 for £62.5M plus £1.5M add-ons and a 10% sell-on; club-record sale"
          },
          {
            "player": "Evanilson",
            "position": "ST",
            "aav": 4,
            "contractNote": "Brazil international; £40M from Porto 2024"
          },
          {
            "player": "Bafode Diakite",
            "position": "CB",
            "aav": null,
            "contractNote": "Signed from Lille summer 2025 for £34.6M"
          },
          {
            "player": "Justin Kluivert",
            "position": "AM",
            "aav": 3.5,
            "contractNote": "Netherlands international; signed from Roma 2024"
          }
        ],
        "fact": "Semenyo, Huijsen, Zabarnyi and Kerkez sold for over £200M combined",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_AFC_Bournemouth_season"
      },
      {
        "field": "media.localTVDeal",
        "old": "Premier League collective deal — UK domestic 2025-28: ~£6.7B/4yr (~£1.67B/yr); facility fee based on UK TV appearances",
        "new": "Premier League collective deal, UK domestic cycle 2025-26 to 2028-29: £6.7B over four seasons (~£1.67B/yr), Sky Sports 215+ live matches per season and TNT Sports 52; equal share ~£85M per club in 2025-26 plus facility fees and merit payments",
        "fact": "The £6.7B Sky/TNT domestic cycle runs 2025-26 through 2028-29 (four seasons), not 2025-28; 2025-26 was its first season with an equal share of about £85M per club",
        "source": "https://www.sportspro.com/news/premier-league-tv-rights-deal-sky-tnt-amazon-2025-2029/"
      }
    ],
    "analystNotes": "Bournemouth's last Forbes figure is $420M from the 2024 list, and the club has since delivered the two things that reprice a small ground: a 6th-place finish in 2025-26, the best in its history, with a first European campaign in the Europa League, and a stadium finally under construction, with the Vitality growing from 11,300 to 20,196 seats by summer 2027 after Bill Foley's group bought back the freehold in April 2025. The player-trading side funded it, with Semenyo (£64M to Manchester City), Zabarnyi, Huijsen and Kerkez sold for over £200M in one season, though head coach Andoni Iraola left for Liverpool in June 2026. The number moves on whether the club stays European-level without Iraola and on the extra 9,000 seats turning a £16M matchday line into something closer to peers.",
    "unverifiedAsOf": {
      "revenue.estimate": "May 2026",
      "ownership.ownerNetWorth": "May 2026"
    }
  },
  "brentford": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "ownership.primaryOwner",
        "old": "Matthew Benham (100% via Best Intentions Analytics)",
        "new": "Matthew Benham, majority owner via Best Intentions Analytics; minority investors Gary Lubner and Sir Matthew Vaughn (10% combined, July 2025, $536M implied), who increased their holdings in March 2026 when Prakash Melwani (Blackstone) and Sir Lucian Grainge (Universal Music) also bought in and joined the board",
        "fact": "Benham is no longer the sole owner; two rounds of minority investment in July 2025 and March 2026",
        "source": "https://www.brentfordfc.com/en/news/club-news-brentford-announces-further-investment-prakash-melwani-sir-lucian-grainge-cbe"
      },
      {
        "field": "ownership.ownershipGroup",
        "old": [
          {
            "name": "Matthew Benham (Best Intentions Analytics)",
            "role": "100% owner / chairman",
            "pct": 100
          }
        ],
        "new": [
          {
            "name": "Matthew Benham (Best Intentions Analytics)",
            "role": "majority owner",
            "pct": null
          },
          {
            "name": "Gary Lubner (This Day Sports and Media)",
            "role": "minority since July 2025; increased March 2026",
            "pct": null
          },
          {
            "name": "Sir Matthew Vaughn (MARV Bee)",
            "role": "minority since July 2025; increased March 2026",
            "pct": null
          },
          {
            "name": "Prakash Melwani",
            "role": "minority and board member since March 2026",
            "pct": null
          },
          {
            "name": "Sir Lucian Grainge",
            "role": "minority and board member since March 2026",
            "pct": null
          }
        ],
        "fact": "Lubner and Vaughn took 10% combined in July 2025; stakes after the March 2026 round were not disclosed",
        "source": "https://www.sportspro.com/news/brentford-investment-gary-lubner-matthew-vaughn-benham-july-2025/"
      },
      {
        "field": "ownership.institutionalInvestors",
        "old": "None as of 2025; Rothschild engaged late 2023 to source minority or majority investors at £400-500M valuation",
        "new": "Minority capital from Lubner, Vaughn (July 2025, 10% at a $536M implied value), Melwani and Grainge (March 2026); Benham retains majority control",
        "fact": "The 2023 Rothschild process ended in minority rounds rather than a control sale",
        "source": "https://www.brentfordfc.com/en/news/club-news-brentford-announces-further-investment-prakash-melwani-sir-lucian-grainge-cbe"
      },
      {
        "field": "ownership.currentValuation",
        "old": 0.5,
        "new": 0.536,
        "fact": "Implied by the July 2025 Lubner/Vaughn 10% investment",
        "source": "https://www.insideworldfootball.com/2025/07/16/lubner-vaughn-take-minority-stakes-brentford/"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Bryan Mbeumo — Cameroon international forward; key player in Brentford's recruitment-driven model; sold to Manchester United summer 2025 for ~£65M",
        "new": "Mbeumo (£65M to Man United) and Wissa (£50M plus £5M to Newcastle) both sold in summer 2025; Dango Ouattara (£42.5M from Bournemouth, 2025) and Mamadou Sangare (£41M from Lens, 2026) are the record purchases; Keith Andrews head coach since summer 2025 after Thomas Frank left for Tottenham",
        "fact": "Wissa sold 2025; Ouattara and Sangare bought; Andrews in second season",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_Brentford_F.C._season"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Bryan Mbeumo",
            "position": "FW",
            "aav": 5.5,
            "contractNote": "~£90K/wk wages; ~£65M sale to Man Utd summer 2025"
          },
          {
            "player": "Yoane Wissa",
            "position": "FW",
            "aav": 4.5,
            "contractNote": "Congolese forward; high goal output post-Toney"
          },
          {
            "player": "Ivan Toney",
            "position": "FW",
            "aav": null,
            "contractNote": "Sold to Al-Ahli (Saudi Pro League) August 2024 for ~£40M after 8-month FA betting ban"
          }
        ],
        "new": [
          {
            "player": "Bryan Mbeumo",
            "position": "FW",
            "aav": 0,
            "contractNote": "Sold to Manchester United summer 2025 for ~£65M plus add-ons"
          },
          {
            "player": "Yoane Wissa",
            "position": "FW",
            "aav": 0,
            "contractNote": "Sold to Newcastle summer 2025 for £50M plus £5M add-ons"
          },
          {
            "player": "Dango Ouattara",
            "position": "FW",
            "aav": null,
            "contractNote": "Signed from Bournemouth summer 2025 for £42.5M"
          },
          {
            "player": "Mamadou Sangare",
            "position": "CM",
            "aav": null,
            "contractNote": "Signed from RC Lens summer 2026 for £41M"
          }
        ],
        "fact": "Toney, Mbeumo and Wissa converted into about £155M of sales across 2024-25",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_Brentford_F.C._season"
      },
      {
        "field": "media.localTVDeal",
        "old": "Premier League collective deal — UK domestic 2025-28: ~£6.7B/4yr (~£1.67B/yr); facility fee based on UK TV appearances",
        "new": "Premier League collective deal, UK domestic cycle 2025-26 to 2028-29: £6.7B over four seasons (~£1.67B/yr), Sky Sports 215+ live matches per season and TNT Sports 52; equal share ~£85M per club in 2025-26 plus facility fees and merit payments",
        "fact": "The £6.7B Sky/TNT domestic cycle runs 2025-26 through 2028-29 (four seasons), not 2025-28; 2025-26 was its first season with an equal share of about £85M per club",
        "source": "https://www.sportspro.com/news/premier-league-tv-rights-deal-sky-tnt-amazon-2025-2029/"
      }
    ],
    "analystNotes": "Brentford has no Forbes mark; the reference price is the July 2025 sale of 10% to Gary Lubner and Sir Matthew Vaughn at a $536M implied value, followed by a March 2026 round that brought Blackstone's Prakash Melwani and Universal Music's Sir Lucian Grainge onto the board while Matthew Benham kept control. The model keeps working without Thomas Frank: 9th place in 2025-26 under Keith Andrews after selling Mbeumo (£65M) and Wissa (£55M) and buying Ouattara and Sangare at £41M to £42.5M. The 17,250-seat Gtech is the ceiling; the number moves if Benham sells control, since the two minority rounds have now set a floor around £400M to £450M.",
    "unverifiedAsOf": {
      "revenue.estimate": "May 2026",
      "ownership.ownerNetWorth": "May 2026"
    }
  },
  "nottingham-forest": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "stadium.newStadiumPlans",
        "old": "£200M+ redevelopment proposed to expand capacity from ~30K to ~52K via new Peter Taylor Stand; planning application in detailed stage 2024-25; alternative new-build site explored if council freehold dispute unresolved",
        "new": "Rushcliffe Borough Council granted planning permission on 16 Sept 2026 (subject to Section 106) to rebuild the Peter Taylor Stand and fill in corners, taking the City Ground to about 45,000; the club describes a £550M construction investment over three years and £63.6M a year of economic output; freehold purchase from Nottingham City Council still not completed",
        "fact": "Planning approval September 2026 for a ~45,000-seat City Ground",
        "source": "https://www.vavel.com/en/football/2026/09/16/premier-league/1271719-nottingham-forest-stadium-expansion-plans-approved.html"
      },
      {
        "field": "onField.playoffAppearancesLast5Years",
        "old": 0,
        "new": 1,
        "fact": "7th in 2024-25 earned European football (played the 2025-26 Europa League, reaching the semi-final, lost 0-4 to Aston Villa); 16th in 2025-26 (44 pts), no Europe for 2026-27",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_Nottingham_Forest_F.C._season"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Murillo — Brazilian centre-back; signed from Corinthians 2023 for ~£10M; reportedly subject of 2025 Bayern Munich interest at £60M+ valuation",
        "new": "Morgan Gibbs-White, captain, signed a new three-year deal July 2025 after Tottenham triggered his £60M release clause; Elliot Anderson sold to Manchester City July 2026 for £116M; Oliver Glasner head coach since 6 July 2026, the fifth in 13 months after Nuno, Postecoglou, Dyche and Pereira",
        "fact": "Anderson sale is the club-record fee received; Glasner is the fifth head coach since Sept 2025",
        "source": "https://en.wikipedia.org/wiki/Elliot_Anderson_(footballer)"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Anthony Elanga",
            "position": "RW/FW",
            "aav": null,
            "contractNote": "Sold to Newcastle summer 2025 for £52M + £3M add-ons (£55M total); had joined from Man Utd 2023 on 5-year deal"
          },
          {
            "player": "Morgan Gibbs-White",
            "position": "AM",
            "aav": 6.5,
            "contractNote": "Signed from Wolves 2022 for ~£42M; long-running club captain; subject of Spurs interest summer 2025"
          },
          {
            "player": "Nikola Milenković",
            "position": "CB",
            "aav": 5,
            "contractNote": "Signed from Fiorentina 2024 for ~£12M; key 2024-25 defensive performer"
          }
        ],
        "new": [
          {
            "player": "Elliot Anderson",
            "position": "CM",
            "aav": 0,
            "contractNote": "Sold to Manchester City July 2026 for £116M, then a record for an English player"
          },
          {
            "player": "Morgan Gibbs-White",
            "position": "AM",
            "aav": 6.5,
            "contractNote": "Captain; new three-year contract 26 July 2025 after Spurs triggered his £60M clause"
          },
          {
            "player": "Liam Delap",
            "position": "FW",
            "aav": null,
            "contractNote": "Signed from Chelsea summer 2026 for £50M"
          },
          {
            "player": "Omari Hutchinson",
            "position": "AM/RW",
            "aav": null,
            "contractNote": "Signed from Ipswich summer 2025 for £37.5M"
          },
          {
            "player": "Anthony Elanga",
            "position": "RW",
            "aav": 0,
            "contractNote": "Sold to Newcastle summer 2025 for £52M plus £3M add-ons"
          }
        ],
        "fact": "Anderson and Elanga sold for £171M; Delap, Hutchinson, Ndoye, Kalimuendo bought",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_Nottingham_Forest_F.C._season"
      },
      {
        "field": "media.localTVDeal",
        "old": "Premier League collective deal — UK domestic 2025-28: ~£6.7B/4yr (~£1.67B/yr); facility fee based on UK TV appearances",
        "new": "Premier League collective deal, UK domestic cycle 2025-26 to 2028-29: £6.7B over four seasons (~£1.67B/yr), Sky Sports 215+ live matches per season and TNT Sports 52; equal share ~£85M per club in 2025-26 plus facility fees and merit payments",
        "fact": "The £6.7B Sky/TNT domestic cycle runs 2025-26 through 2028-29 (four seasons), not 2025-28; 2025-26 was its first season with an equal share of about £85M per club",
        "source": "https://www.sportspro.com/news/premier-league-tv-rights-deal-sky-tnt-amazon-2025-2029/"
      }
    ],
    "analystNotes": "Nottingham Forest has no Forbes mark; the enrichment carries a $900M 2025 estimate made after Champions League-level finishes, and the year since has cut both ways. The club went from 7th to 16th in 2025-26 through five head coaches in 13 months, finishing with Oliver Glasner hired from Crystal Palace in July 2026, but reached a Europa League semi-final and then sold Elliot Anderson to Manchester City for £116M, the largest fee ever received by an English club for an English player at that date. The real asset event is the City Ground: planning permission arrived on 16 September 2026 for a rebuilt Peter Taylor Stand taking capacity to about 45,000 at a cited £550M, though the council freehold is still unsettled, and that is what moves the number next.",
    "unverifiedAsOf": {
      "revenue.estimate": "May 2026",
      "ownership.ownerNetWorth": "May 2026"
    }
  },
  "ipswich-town": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.localTVDeal",
        "old": "Premier League collective deal 2024-25 only; relegation back to Championship returns club to EFL deal (~£15M central distribution + parachute payments)",
        "new": "Promoted back to the Premier League for 2026-27 as 2025-26 Championship runners-up (84 pts, clinched 2 May 2026); rejoins the £6.7B Sky/TNT domestic cycle (2025-26 to 2028-29) with an equal share of about £85M per club plus facility and merit payments",
        "fact": "Ipswich finished 2nd behind Coventry and went straight back up after one Championship season",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_EFL_Championship"
      },
      {
        "field": "media.nationalShareNote",
        "old": "EPL distributes via equal share + facility fee + merit payment; relegated clubs receive parachute payments (~£44M Y1, declining over 3yrs) — Ipswich relegated 2025 after one EPL season",
        "new": "EPL distributes via equal share + facility fee + merit payment; Ipswich relegated 2025 after one EPL season, promoted again for 2026-27 so parachute payments stop and full Premier League distribution resumes",
        "fact": "Promotion in May 2026",
        "source": "https://www.premierleague.com/en/news/4673099/the-202627-premier-league-season-officially-starts/"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Liam Delap — sold to Chelsea June 2025 for £30M (six-year deal); had been club's top scorer with 12 goals in first EPL season",
        "new": "Promotion built on Jack Clarke (16 Championship goals) and Sindre Walle Egeli (£17.5M from Nordsjaelland); Omari Hutchinson sold to Nottingham Forest for £37.5M (2025) after Delap's £30M sale to Chelsea; Kieran McKenna stepped down 10 June 2026 and Gary O'Neil was appointed 23 June 2026 on a three-year deal; about £176M spent in summer 2026 including Julio Enciso (£26.1M) and Exequiel Palacios (£19.2M)",
        "fact": "McKenna left after a third promotion in four seasons; O'Neil hired from Strasbourg",
        "source": "https://en.wikipedia.org/wiki/Kieran_McKenna"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Liam Delap",
            "position": "FW",
            "aav": null,
            "contractNote": "Sold to Chelsea June 2025 for £30M; had been signed from Manchester City in July 2024 for ~£20M with sell-on"
          },
          {
            "player": "Omari Hutchinson",
            "position": "AM/RW",
            "aav": 4,
            "contractNote": "Signed permanently from Chelsea 2024 for £20M after promotion-season loan"
          },
          {
            "player": "Jack Clarke",
            "position": "LW",
            "aav": 3.5,
            "contractNote": "Signed from Sunderland 2024 for £15M+"
          }
        ],
        "new": [
          {
            "player": "Omari Hutchinson",
            "position": "AM/RW",
            "aav": 0,
            "contractNote": "Sold to Nottingham Forest summer 2025 for £37.5M, a year after the £20M purchase from Chelsea"
          },
          {
            "player": "Liam Delap",
            "position": "FW",
            "aav": 0,
            "contractNote": "Sold to Chelsea June 2025 for £30M"
          },
          {
            "player": "Julio Enciso",
            "position": "FW",
            "aav": null,
            "contractNote": "Signed from Strasbourg summer 2026 for £26.1M"
          },
          {
            "player": "Jack Clarke",
            "position": "LW",
            "aav": 3.5,
            "contractNote": "Signed from Sunderland 2024 for £15M+; 16 Championship goals in 2025-26"
          }
        ],
        "fact": "Hutchinson and Delap sold for £67.5M; 2026 spending funded the return",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_Ipswich_Town_F.C._season"
      },
      {
        "field": "ownership.primaryOwner",
        "old": "Portman Holdings LLC (US consortium consolidated December 2025)",
        "new": null,
        "fact": "Removed: not verifiable as of September 2026 (enrichment says 'Portman Holdings LLC (US consortium consolidated December 2025)'; the 2025-26 and 2026-27 season records list the club owner as Gamechanger 20 Ltd with Mark Ashton as chairman and no ownership change; could not verify the December 2025 restructuring)",
        "source": null
      }
    ],
    "analystNotes": "Ipswich has no Forbes mark; the enrichment carries a $350M 2025 figure from the Portman Holdings restructuring, and the club has since done the one thing that doubles a Championship valuation: gone straight back up, finishing 2nd in 2025-26 with 84 points and clinching promotion on 2 May 2026. Kieran McKenna then stepped down in June after three promotions in four years, Gary O'Neil arrived from Strasbourg on a three-year deal, and the owners spent about £176M in the summer window after banking £67.5M for Hutchinson and Delap. A freehold 30,311-seat Portman Road and a 2026-27 season on roughly £85M of equal-share television money put the club back at Premier League economics; the number moves on survival, since a second immediate relegation would reset it to parachute-payment value.",
    "unverifiedAsOf": {
      "revenue.estimate": "May 2026"
    }
  },
  "leicester-city": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.localTVDeal",
        "old": "EFL Championship deal 2024+ (~£8M central distribution) post-relegation; Sky Sports primary; one of largest parachute-payment recipients",
        "new": "Relegated to EFL League One for 2026-27 after finishing 23rd in the 2025-26 Championship (46 pts after a six-point PSR deduction imposed 5 Feb 2026); final year of Premier League parachute payments in 2026-27 on League One central distribution",
        "fact": "Second relegation in two seasons; League One for the first time since 2008-09",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_Leicester_City_F.C._season"
      },
      {
        "field": "media.nationalShareNote",
        "old": "EPL distributes via equal share + facility fee + merit payment; relegated clubs receive parachute payments (~£44M Y1, declining over 3yrs) — Leicester relegated 2023, promoted 2024, relegated 2025",
        "new": "EPL distributes via equal share + facility fee + merit payment; relegated clubs receive parachute payments (~£44M Y1, declining over 3yrs); Leicester relegated 2023, promoted 2024, relegated 2025, relegated again to League One 2026 with a six-point PSR deduction",
        "fact": "Back-to-back relegations 2025 and 2026",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_EFL_Championship"
      },
      {
        "field": "onField.championshipsLast10Years",
        "old": 1,
        "new": 0,
        "fact": "The 2015-16 title falls outside the ten seasons 2016-17 to 2025-26",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_Premier_League"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Wilfred Ndidi — Nigerian midfielder; long-tenured club captain figure; major asset-sale candidate post-relegation",
        "new": "Squad stripped: Ndidi sold to Besiktas (£8M, 2025), Hermansen to West Ham (£20M, 2025), Vardy left on a free (2025), Abdul Fatawu to Ipswich (£20M, 2026), El Khannouss to Stuttgart (£15.3M, 2026); Russell Martin appointed manager 15 June 2026 on a three-year deal, the fifth manager since June 2025",
        "fact": "Player sales and five managers in a year (van Nistelrooy, Cifuentes, King interim, Rowett, Martin)",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_Leicester_City_F.C._season"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Mads Hermansen",
            "position": "GK",
            "aav": 3,
            "contractNote": "Signed from Brøndby 2023 for £5M; key 2023-24 promotion player"
          },
          {
            "player": "Wilfred Ndidi",
            "position": "DM",
            "aav": 4.5,
            "contractNote": "Long-term club fixture; contract running"
          },
          {
            "player": "Stephy Mavididi",
            "position": "LW",
            "aav": 3.5,
            "contractNote": "Signed from Montpellier 2023 for £8M"
          }
        ],
        "new": [
          {
            "player": "Mads Hermansen",
            "position": "GK",
            "aav": 0,
            "contractNote": "Sold to West Ham summer 2025 for £20M"
          },
          {
            "player": "Wilfred Ndidi",
            "position": "DM",
            "aav": 0,
            "contractNote": "Sold to Besiktas summer 2025 for £8M"
          },
          {
            "player": "Abdul Fatawu",
            "position": "RW",
            "aav": 0,
            "contractNote": "Sold to Ipswich summer 2026 for £20M"
          },
          {
            "player": "Bilal El Khannouss",
            "position": "AM",
            "aav": 0,
            "contractNote": "Sold to VfB Stuttgart summer 2026 for £15.3M"
          }
        ],
        "fact": "All prior star contracts sold",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_Leicester_City_F.C._season"
      }
    ],
    "analystNotes": "Leicester has no Forbes mark; the enrichment carries a $400M 2025 estimate, and the club has since fallen through the floor of that number: a six-point PSR deduction on 5 February 2026, a 23rd-place Championship finish and relegation to League One on 21 April 2026, ten years to the month after the Premier League title. The King Power family still owns the club and the freehold 32,259-seat stadium, but 2026-27 is a third-tier season on the last year of parachute money, with Ndidi, Hermansen, Fatawu and El Khannouss sold and Russell Martin the fifth manager in twelve months. The number moves only on an immediate promotion and a stabilised cost base; until then the stadium and the 40,000-seat expansion consent are the value, not the football.",
    "unverifiedAsOf": {
      "revenue.estimate": "May 2026",
      "ownership.ownerNetWorth": "May 2026"
    }
  },
  "southampton": {
    "asOf": "2026-09",
    "changes": [
      {
        "field": "media.localTVDeal",
        "old": "Premier League collective 2024-25 then EFL Championship 2025-26+ post-relegation",
        "new": "EFL Championship for 2026-27 (second season since relegation) with year-two parachute payments; finished 4th in 2025-26 but was expelled from the play-offs by the EFL in May 2026 for unauthorised filming of opponents' training, with a four-point deduction applied to the 2026-27 table and an appeal dismissed 20 May 2026",
        "fact": "Play-off expulsion cost a promotion shot; four-point deduction carried into 2026-27",
        "source": "https://www.skysports.com/football/news/11095/13544383/southamptons-appeal-against-championship-play-off-final-explusion-dismissed-after-spygate-scandal"
      },
      {
        "field": "onField.currentFranchisePlayer",
        "old": "Tyler Dibling — sold to Everton summer 2025 for £42M (record sale of a Saints academy product)",
        "new": "Tyler Dibling sold to Everton Aug 2025 (reported £35M); Mateus Fernandes sold to West Ham for £38M (2025); Tonda Eckert head coach since Nov 2025 (contract to 2027) after Will Still was sacked 2 Nov 2025; James Ward-Prowse returned from West Ham summer 2026",
        "fact": "Two record academy and squad sales in 2025; Eckert replaced Still",
        "source": "https://en.wikipedia.org/wiki/2025%E2%80%9326_Southampton_F.C._season"
      },
      {
        "field": "onField.starContracts",
        "old": [
          {
            "player": "Tyler Dibling",
            "position": "RW",
            "aav": null,
            "contractNote": "Sold to Everton summer 2025 for £42M; had been homegrown academy graduate, became one of EPL's most-watched teen prospects in 2024-25"
          },
          {
            "player": "Mateus Fernandes",
            "position": "AM",
            "aav": 3.5,
            "contractNote": "Signed from Sporting Lisbon 2024 for £15M"
          },
          {
            "player": "Aaron Ramsdale",
            "position": "GK",
            "aav": 5.5,
            "contractNote": "Signed from Arsenal 2024 for £25M; loaned out 2025 post-relegation"
          }
        ],
        "new": [
          {
            "player": "Tyler Dibling",
            "position": "RW",
            "aav": 0,
            "contractNote": "Sold to Everton 25 Aug 2025; reported £35M (Everton record); academy product"
          },
          {
            "player": "Mateus Fernandes",
            "position": "AM",
            "aav": 0,
            "contractNote": "Sold to West Ham summer 2025 for £38M; West Ham resold him to Tottenham in 2026 for £85M"
          },
          {
            "player": "Adam Armstrong",
            "position": "FW",
            "aav": 0,
            "contractNote": "11 Championship goals in 2025-26 then sold to Wolves 2 Feb 2026"
          },
          {
            "player": "James Ward-Prowse",
            "position": "CM",
            "aav": null,
            "contractNote": "Returned from West Ham summer 2026"
          }
        ],
        "fact": "Dibling and Fernandes sales; Armstrong sold Feb 2026",
        "source": "https://en.wikipedia.org/wiki/2026%E2%80%9327_Southampton_F.C._season"
      }
    ],
    "analystNotes": "Southampton has no Forbes mark; the enrichment carries a $450M 2025 estimate that assumed a quick return to the Premier League, and the club came within a play-off final of it before the EFL expelled it in May 2026 for filming opponents' training, then docked four points from the 2026-27 table. The assets are unchanged, a freehold 32,384-seat St Mary's, year-two parachute money and an academy that sold Tyler Dibling to Everton and Mateus Fernandes to West Ham for over £70M in 2025, and Tonda Eckert has the side competitive again. The number moves on promotion in 2026-27 despite the deduction; a second full Championship cycle would pull the mark toward the £200M level of a mid-table EFL club.",
    "unverifiedAsOf": {
      "revenue.estimate": "May 2026",
      "ownership.ownerNetWorth": "May 2026"
    }
  }
}
